(function () {
  'use strict';

  angular.module('app.customer', []);
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('CreateProductModalController', CreateProductModalController);

   CreateProductModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateProductModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         CustomerService.createProduct(vm.data, customerDependent.customer.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('UpdateImportantPersonModalController', UpdateImportantPersonModalController);

   UpdateImportantPersonModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UpdateImportantPersonModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.importantPerson = customerDependent.importantPerson;
      vm.constants       = constants;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      vm.importantPerson.is_key_person = vm.importantPerson.is_key_person ? true : false;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         console.log(typeof vm.importantPerson.is_key_person);

         if (typeof vm.importantPerson.is_key_person == 'undefined') {
            vm.importantPerson.is_key_person = 0;
         }

         var data = {
            name: vm.importantPerson.name,
            position: vm.importantPerson.position,
            id_card_number: vm.importantPerson.id_card_number,
            is_key_person: vm.importantPerson.is_key_person
         };
         
         CustomerService.updateImportantPerson(data, customerDependent.customer.hash_id, vm.importantPerson.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();
(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('CreateImportantPersonModalController', CreateImportantPersonModalController);

   CreateImportantPersonModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateImportantPersonModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         if (typeof vm.data.is_key_person == 'undefined') {
            vm.data.is_key_person = 0;
         }

         CustomerService.createImportantPerson(vm.data, customerDependent.customer.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.user', []);
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UploadUserModalController', UploadUserModalController);

   UploadUserModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'UserService',
      'userDependent',
      'constants',
      'validator'
   ];

   function UploadUserModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      UserService,
      userDependent,
      constants,
      validator
   ) {
      var vm = this;

      // params
      vm.user      = userDependent.user;
      vm.constants = constants;
      vm.image     = null;

      // methods
      vm.cancel = cancel;
      vm.upload = upload;

      $scope.fileChanged = fileChanged;

      function upload(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Mengunggah gambar...');

         if ($scope.myFile) {
            var formData = new FormData();

            formData.append('image', $scope.myFile);   

            UserService.uploadImage(formData, vm.user.hash_id, function(status, data) {
               if (status) {
                  $uibModalInstance.dismiss('cancel');
                  $rootScope.$broadcast(constants.BROADCAST.DETAIL_USER, {user: data});
               } else {
                  $uibModalInstance.dismiss('cancel');
                  validator.validateAlert(data);
               }

               form.find('button').prop('disabled', false);
               submitButton.html('<i class="fa fa-save"></i> Simpan');
            });
         }
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

         if ($scope.myFile) {
            $('.image-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
               $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.image-container');
            };

            reader.readAsDataURL($scope.myFile);
        }
      }
   }
})();

(function () {
  'use strict';

  angular
    .module('app.setting', []);

})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateTransportModalController', UpdateTransportModalController);

   UpdateTransportModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'TransportService',
      'constants',
      'validator',
      'requestHelper',
      'transportDependent',
      'globalState'
   ];

   function UpdateTransportModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      TransportService,
      constants,
      validator,
      requestHelper,
      transportDependent,
      globalState
   ) {
      var vm = this;

      // params
      vm.transport  = transportDependent.transport;
      vm.constants = constants;

      vm.data = {
         name: angular.copy(vm.transport.name),
         price_per_kg: angular.copy(vm.transport.transport_type_fees.price_per_kg)
      };

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         vm.data.is_active = globalState.decBool(vm.data.is_active);
         
         requestHelper.before(event, 'Menyimpan data');

         TransportService.updateTransport(vm.transport.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_TRANSPORT);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('TransportGuideModalController', TransportGuideModalController);

   TransportGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function TransportGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CreateTransportModalController', CreateTransportModalController);

   CreateTransportModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'TransportService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateTransportModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      TransportService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         TransportService.storeTransport(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_TRANSPORT);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateQuotationTermModalController', UpdateQuotationTermModalController);

   UpdateQuotationTermModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationTermService',
      'constants',
      'validator',
      'requestHelper',
      'quotationTermDependent',
      'globalState'
   ];

   function UpdateQuotationTermModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationTermService,
      constants,
      validator,
      requestHelper,
      quotationTermDependent,
      globalState
   ) {
      var vm = this;

      // params
      vm.quotationTerm  = quotationTermDependent.quotationTerm;
      vm.constants = constants;

      vm.data = {
         description: angular.copy(vm.quotationTerm.description),
         is_required: angular.copy(globalState.encBool(vm.quotationTerm.is_required))
      };

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         vm.data.is_active = globalState.decBool(vm.data.is_active);
         
         requestHelper.before(event, 'Menyimpan data');

         QuotationTermService.updateQuotationTerm(vm.quotationTerm.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION_TERM);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('QuotationTermGuideModalController', QuotationTermGuideModalController);

   QuotationTermGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function QuotationTermGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CreateQuotationTermModalController', CreateQuotationTermModalController);

   CreateQuotationTermModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationTermService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateQuotationTermModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationTermService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {
         is_required: true
      };
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         QuotationTermService.storeQuotationTerm(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION_TERM);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateQuotationSettingModalController', UpdateQuotationSettingModalController);

   UpdateQuotationSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper',
      'settingDependent'
   ];

   function UpdateQuotationSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper,
      settingDependent
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;
      vm.setting   = settingDependent.quotationSetting;

      vm.data = {
         value: angular.copy(vm.setting.quotation_setting_histories.value)
      }

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.updateQuotationSetting(vm.setting.code, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION_SETTING);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateMaterialSettingModalController', UpdateMaterialSettingModalController);

   UpdateMaterialSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper',
      'settingDependent'
   ];

   function UpdateMaterialSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper,
      settingDependent
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;
      vm.setting   = settingDependent.materialSetting;

      vm.data = {
         value: angular.copy(vm.setting.material_constant_histories.conversion.value)
      }

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.updateMaterialSetting(vm.setting.code, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_SETTING);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateCommissionTimelineSettingModalController', UpdateCommissionTimelineSettingModalController);

   UpdateCommissionTimelineSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper',
      'settingDependent'
   ];

   function UpdateCommissionTimelineSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper,
      settingDependent
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;
      vm.commission = settingDependent.commission;

      vm.data = {
         min_days_late: angular.copy(vm.commission.min_days_late),
         commission_percentage_multiplier: angular.copy(vm.commission.conversion.commission_percentage_multiplier)
      }

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.updateCommissionTimeline(vm.commission.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_SETTING_COMMISSION_TIMELINE);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CommissionTimelineSettingGuideModalController', CommissionTimelineSettingGuideModalController);

   CommissionTimelineSettingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CommissionTimelineSettingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CreateCommissionTimelineSettingModalController', CreateCommissionTimelineSettingModalController);

   CreateCommissionTimelineSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateCommissionTimelineSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.storeCommissionTimeline(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_SETTING_COMMISSION_TIMELINE);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('UpdateCommissionSettingModalController', UpdateCommissionSettingModalController);

   UpdateCommissionSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper',
      'settingDependent'
   ];

   function UpdateCommissionSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper,
      settingDependent
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;
      vm.commission = settingDependent.commission;

      vm.data = {
         min_gross_profit_percentage: angular.copy(vm.commission.conversion.min_gross_profit_percentage),
         commission_percentage: angular.copy(vm.commission.conversion.commission_percentage),
         commission_referral_percentage: angular.copy(vm.commission.conversion.commission_referral_percentage)
      }

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.updateCommission(vm.commission.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_SETTING_COMMISSION);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CommissionSettingGuideModalController', CommissionSettingGuideModalController);

   CommissionSettingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CommissionSettingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CreateCommissionSettingModalController', CreateCommissionSettingModalController);

   CreateCommissionSettingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'SettingService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateCommissionSettingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      SettingService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         SettingService.storeCommission(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_SETTING_COMMISSION);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UploadUserModalController', UploadUserModalController);

   UploadUserModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'UserService',
      'userDependent',
      'constants',
      'validator'
   ];

   function UploadUserModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      UserService,
      userDependent,
      constants,
      validator
   ) {
      var vm = this;

      // params
      vm.user      = userDependent.user;
      vm.constants = constants;
      vm.image     = null;

      // methods
      vm.cancel = cancel;
      vm.upload = upload;

      $scope.fileChanged = fileChanged;

      function upload(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Mengunggah gambar...');

         if ($scope.myFile) {
            var formData = new FormData();

            formData.append('image', $scope.myFile);   

            UserService.uploadImage(formData, vm.user.hash_id, function(status, data) {
               if (status) {
                  $uibModalInstance.dismiss('cancel');
                  $rootScope.$broadcast(constants.BROADCAST.DETAIL_USER, {user: data});
               } else {
                  $uibModalInstance.dismiss('cancel');
                  validator.validateAlert(data);
               }

               form.find('button').prop('disabled', false);
               submitButton.html('<i class="fa fa-save"></i> Simpan');
            });
         }
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

         if ($scope.myFile) {
            $('.image-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
               $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.image-container');
            };

            reader.readAsDataURL($scope.myFile);
        }
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.quotation', []);
})();

(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseTermModalController', ChooseTermModalController);

	ChooseTermModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'QuotationTermService'
	];

	/* @ngInject */
	function ChooseTermModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			QuotationTermService
	) {
		var vm = this;

		// Params
		vm.constants = constants;
		vm.terms     = [];
		vm.term      = null;
		
		// Methods
		vm.add     = add;
		vm.cancel  = cancel;
		vm.getTerm = getTerm;

		function getTerm(search) {
         var params = {
            search: search
         }

         QuotationTermService.getQuotationTerm(params, function(status, response) {
            if (status) {
               vm.terms = response.data;
            } else {
               validator.validateAlert(response);
            }
         });
      }

		function add() {

			$rootScope.$broadcast('ADD_TERM_FROM_TEMPLATE', {term: vm.term});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseSlittingMaterialModalController', ChooseSlittingMaterialModalController);

	ChooseSlittingMaterialModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'MaterialService'
	];

	/* @ngInject */
	function ChooseSlittingMaterialModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			MaterialService
	) {
		var vm = this;

		// Params
		vm.constants        = constants;
		vm.data             = {};
		vm.materialSlitting = MaterialService.materialSlitting;

		// HOOKS
		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
			vm.materialSlitting = MaterialService.materialSlitting;
		});
		
		// Methods
		vm.add    = add;
		vm.cancel = cancel;

		function add() {
			var material = JSON.parse(vm.data.material);

			var payload = {
				material: material,
				hash_id: material.hash_id,
				slitting_length: vm.data.slitting_length
			}

			$rootScope.$broadcast('ADD_MATERIAL_SLITTING_QUOTATION', {material: payload});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
  "use-strict";

  angular
    .module("app.quotation")
    .controller(
      "ChooseLaminatingMaterialModalController",
      ChooseLaminatingMaterialModalController
    );

  ChooseLaminatingMaterialModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "constants",
    "MaterialService"
  ];

  /* @ngInject */
  function ChooseLaminatingMaterialModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    constants,
    MaterialService
  ) {
    var vm = this;

    // Params
    vm.constants = constants;
    vm.data = {};
    vm.materialLaminating = MaterialService.materialLaminating;

    // HOOKS
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_LAMINATING, function() {
      vm.materialLaminating = MaterialService.materialLaminating;
    });

    // Methods
    vm.add = add;
    vm.cancel = cancel;

    function add() {
      var material = JSON.parse(vm.data.material);

      var payload = {
        material: material,
        hash_id: material.hash_id,
        thickness: vm.data.thickness,
        adhesive_usage_per_m2: vm.data.adhesive_usage_per_m2
      };

      $rootScope.$broadcast("ADD_MATERIAL_LAMINATING_QUOTATION", {
        material: payload
      });
      cancel();
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseCustomTermModalController', ChooseCustomTermModalController);

	ChooseCustomTermModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'QuotationTermService'
	];

	/* @ngInject */
	function ChooseCustomTermModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			QuotationTermService
	) {
		var vm = this;

		// Params
		vm.constants = constants;
		vm.term      = null;
		
		// Methods
		vm.add     = add;
		vm.cancel  = cancel;

		function add() {

			$rootScope.$broadcast('ADD_CUSTOM_TERM', {term: vm.term});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseTermModalController', ChooseTermModalController);

	ChooseTermModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'QuotationTermService'
	];

	/* @ngInject */
	function ChooseTermModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			QuotationTermService
	) {
		var vm = this;

		// Params
		vm.constants = constants;
		vm.terms     = [];
		vm.term      = null;
		
		// Methods
		vm.add     = add;
		vm.cancel  = cancel;
		vm.getTerm = getTerm;

		function getTerm(search) {
         var params = {
            search: search,
            filter: {
            	is_required: 0
            }
         }

         QuotationTermService.getQuotationTerm(params, function(status, response) {
            if (status) {
               vm.terms = response.data;
            } else {
               validator.validateAlert(response);
            }
         });
      }

		function add() {
			$rootScope.$broadcast('ADD_TERM_FROM_TEMPLATE', {term: vm.term});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseSlittingMaterialModalController', ChooseSlittingMaterialModalController);

	ChooseSlittingMaterialModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'MaterialService'
	];

	/* @ngInject */
	function ChooseSlittingMaterialModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			MaterialService
	) {
		var vm = this;

		// Params
		vm.constants        = constants;
		vm.data             = {};
		vm.materialSlitting = MaterialService.materialSlitting;

		// HOOKS
		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
			vm.materialSlitting = MaterialService.materialSlitting;
		});
		
		// Methods
		vm.add    = add;
		vm.cancel = cancel;

		function add() {
			var material = JSON.parse(vm.data.material);

			var payload = {
				material: material,
				hash_id: material.hash_id,
				slitting_length: vm.data.slitting_length
			}

			$rootScope.$broadcast('ADD_MATERIAL_SLITTING_QUOTATION', {material: payload});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
  "use-strict";

  angular
    .module("app.quotation")
    .controller(
      "ChooseLaminatingMaterialModalController",
      ChooseLaminatingMaterialModalController
    );

  ChooseLaminatingMaterialModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "constants",
    "MaterialService",
    "SettingService"
  ];

  /* @ngInject */
  function ChooseLaminatingMaterialModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    constants,
    MaterialService,
    SettingService
  ) {
    var vm = this;

    // Params
    vm.constants = constants;
    vm.data = {};
    vm.materialLaminating = MaterialService.materialLaminating;

    // HOOKS
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_LAMINATING, function() {
      vm.materialLaminating = MaterialService.materialLaminating;
    });

    // Methods
    vm.add = add;
    vm.cancel = cancel;

    SettingService.showQuotationSetting('default_adhesive_usage', function(status, response) {
      if (status) {
        vm.data.adhesive_usage_per_m2 = response.quotation_setting_histories.value;
      } else {
        validator.validateAlert(response);
      }
    });

    function add() {
      var material = JSON.parse(vm.data.material);

      var payload = {
        material: material,
        hash_id: material.hash_id,
        thickness: vm.data.thickness,
        adhesive_usage_per_m2: vm.data.adhesive_usage_per_m2
      };

      $rootScope.$broadcast("ADD_MATERIAL_LAMINATING_QUOTATION", {
        material: payload
      });
      cancel();
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('ChooseCustomTermModalController', ChooseCustomTermModalController);

	ChooseCustomTermModalController.$inject = [
		'$scope',
		'$rootScope',
		'$uibModalInstance',
		'constants',
		'QuotationTermService'
	];

	/* @ngInject */
	function ChooseCustomTermModalController(
			$scope,
			$rootScope,
			$uibModalInstance,
			constants,
			QuotationTermService
	) {
		var vm = this;

		// Params
		vm.constants = constants;
		vm.term      = null;
		
		// Methods
		vm.add     = add;
		vm.cancel  = cancel;

		function add() {
			$rootScope.$broadcast('ADD_CUSTOM_TERM', {term: vm.term});
			cancel();
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function () {
  'use strict';

  angular.module('app.material', []);
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('UpdateMaterialSlittingModalController', UpdateMaterialSlittingModalController);

   UpdateMaterialSlittingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'MaterialService',
      'materialDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UpdateMaterialSlittingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      MaterialService,
      materialDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data = {
         name: materialDependent.material.name,
         length: materialDependent.material.conversion.length,
         price: materialDependent.material.slitting_material_prices.conversion.price
      };

      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         var params     = {
            name: vm.data.name,
            length: vm.data.length,
            price: vm.data.price
         };
         
         requestHelper.before(event, 'Menyimpan data');
         
         MaterialService.updateMaterialSlitting(params, materialDependent.material.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('SlittingGuideModalController', SlittingGuideModalController);

   SlittingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function SlittingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('CreateMaterialSlittingModalController', CreateMaterialSlittingModalController);

   CreateMaterialSlittingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'MaterialService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateMaterialSlittingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      MaterialService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data = {};

      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         var params     = {
            name: vm.data.name,
            price: vm.data.price,
            length: vm.data.length
         };
         
         requestHelper.before(event, 'Menyimpan data');
         
         MaterialService.createMaterialSlitting(params, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "UpdateMaterialPrintingModalController",
      UpdateMaterialPrintingModalController
    );

  UpdateMaterialPrintingModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "materialDependent",
    "constants",
    "validator",
    "requestHelper"
  ];

  function UpdateMaterialPrintingModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    materialDependent,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {
      name: materialDependent.material.name,
      density: materialDependent.material.conversion.density,
      price:
        materialDependent.material.printing_material_prices.conversion.price
    };

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.update = update;

    function update(event) {
      var params = {
        name: vm.data.name,
        density: vm.data.density,
        price: vm.data.price
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.updateMaterialPrinting(
        params,
        materialDependent.material.hash_id,
        function(status, data) {
          if (status) {
            $uibModalInstance.dismiss("cancel");
          } else {
            validator.validateAlert(data);
          }

          requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('PrintingGuideModalController', PrintingGuideModalController);

   PrintingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function PrintingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "CreateMaterialPrintingModalController",
      CreateMaterialPrintingModalController
    );

  CreateMaterialPrintingModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "constants",
    "validator",
    "requestHelper"
  ];

  function CreateMaterialPrintingModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {};

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.create = create;

    function create(event) {
      var params = {
        name: vm.data.name,
        density: vm.data.density,
        price: vm.data.price
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.createMaterialPrinting(params, function(status, data) {
        if (status) {
          $uibModalInstance.dismiss("cancel");
        } else {
          validator.validateAlert(data);
        }

        requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
      });
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('UpdateMaterialPackingModalController', UpdateMaterialPackingModalController);

   UpdateMaterialPackingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'MaterialService',
      'materialDependent',
      'constants',
      'validator',
      'requestHelper',
      'globalState'
   ];

   function UpdateMaterialPackingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      MaterialService,
      materialDependent,
      constants,
      validator,
      requestHelper,
      globalState
   ) {
      var vm = this;

      // params
      vm.data = {
         name: materialDependent.material.name,
         price: materialDependent.material.packing_material_prices.conversion.price,
         kg_per_price: materialDependent.material.kg_per_price,
         is_required: globalState.encBool(materialDependent.material.is_required)
      };

      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         var params     = {
            name: vm.data.name,
            price: vm.data.price,
            kg_per_price: vm.data.kg_per_price,
            is_required: vm.data.is_required
         };
         
         requestHelper.before(event, 'Menyimpan data');
         
         MaterialService.updateMaterialPacking(params, materialDependent.material.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('PackingGuideModalController', PackingGuideModalController);

   PackingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function PackingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('CreateMaterialPackingModalController', CreateMaterialPackingModalController);

   CreateMaterialPackingModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'MaterialService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateMaterialPackingModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      MaterialService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data = {};

      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         var params     = {
            name: vm.data.name,
            price: vm.data.price,
            kg_per_price: vm.data.kg_per_price,
            is_required: vm.data.is_required
         };
         
         requestHelper.before(event, 'Menyimpan data');
         
         MaterialService.createMaterialPacking(params, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "UpdateMaterialLaminatingModalController",
      UpdateMaterialLaminatingModalController
    );

  UpdateMaterialLaminatingModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "materialDependent",
    "constants",
    "validator",
    "requestHelper"
  ];

  function UpdateMaterialLaminatingModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    materialDependent,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {
      name: materialDependent.material.name,
      density: materialDependent.material.conversion.density,
      price:
        materialDependent.material.laminating_material_prices.conversion.price,
      hardener_density: materialDependent.material.conversion.hardener_density,
      solvent_density: materialDependent.material.conversion.solvent_density,
      adhesive_density: materialDependent.material.conversion.adhesive_density,
      hardener_thickness:
        materialDependent.material.conversion.hardener_thickness,
      solvent_thickness:
        materialDependent.material.conversion.solvent_thickness,
      adhesive_thickness:
        materialDependent.material.conversion.adhesive_thickness
    };

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.update = update;

    function update(event) {
      var params = {
        name: vm.data.name,
        density: vm.data.density,
        price: vm.data.price,
        hardener_density: vm.data.hardener_density,
        solvent_density: vm.data.solvent_density,
        adhesive_density: vm.data.adhesive_density,
        hardener_thickness: vm.data.hardener_thickness,
        solvent_thickness: vm.data.solvent_thickness,
        adhesive_thickness: vm.data.adhesive_thickness
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.updateMaterialLaminating(
        params,
        materialDependent.material.hash_id,
        function(status, data) {
          if (status) {
            $uibModalInstance.dismiss("cancel");
          } else {
            validator.validateAlert(data);
          }

          requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('LaminatingGuideModalController', LaminatingGuideModalController);

   LaminatingGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function LaminatingGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "CreateMaterialLaminatingModalController",
      CreateMaterialPrintingModalController
    );

  CreateMaterialPrintingModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "constants",
    "validator",
    "requestHelper"
  ];

  function CreateMaterialPrintingModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {};

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.create = create;

    function create(event) {
      var params = {
        name: vm.data.name,
        density: vm.data.density,
        price: vm.data.price,
        hardener_density: vm.data.hardener_density,
        solvent_density: vm.data.solvent_density,
        adhesive_density: vm.data.adhesive_density,
        hardener_thickness: vm.data.hardener_thickness,
        solvent_thickness: vm.data.solvent_thickness,
        adhesive_thickness: vm.data.adhesive_thickness
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.createMaterialLaminating(params, function(status, data) {
        if (status) {
          $uibModalInstance.dismiss("cancel");
        } else {
          validator.validateAlert(data);
        }

        requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
      });
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "UpdateMaterialInkModalController",
      UpdateMaterialInkModalController
    );

  UpdateMaterialInkModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "materialDependent",
    "constants",
    "validator",
    "requestHelper"
  ];

  function UpdateMaterialInkModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    materialDependent,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {
      name: materialDependent.material.name,
      surface_density: materialDependent.material.conversion.surface_density,
      price: materialDependent.material.printing_ink_prices.conversion.price,
      solvent: materialDependent.material.conversion.solvent,
      hardener: materialDependent.material.conversion.hardener,
      usage_per_m2: materialDependent.material.conversion.usage_per_m2
    };

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.update = update;

    function update(event) {
      var params = {
        name: vm.data.name,
        surface_density: vm.data.surface_density,
        price: vm.data.price,
        solvent: vm.data.solvent,
        hardener: vm.data.hardener,
        usage_per_m2: vm.data.usage_per_m2
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.updateMaterialInk(
        params,
        materialDependent.material.hash_id,
        function(status, data) {
          if (status) {
            $uibModalInstance.dismiss("cancel");
          } else {
            validator.validateAlert(data);
          }

          requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('InkGuideModalController', InkGuideModalController);

   InkGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function InkGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
  "use strict";

  angular
    .module("app.material")
    .controller(
      "CreateMaterialInkModalController",
      CreateMaterialInkModalController
    );

  CreateMaterialInkModalController.$inject = [
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "MaterialService",
    "constants",
    "validator",
    "requestHelper"
  ];

  function CreateMaterialInkModalController(
    $scope,
    $rootScope,
    $uibModalInstance,
    MaterialService,
    constants,
    validator,
    requestHelper
  ) {
    var vm = this;

    // params
    vm.data = {};

    vm.constants = constants;

    // methods
    vm.cancel = cancel;
    vm.create = create;

    function create(event) {
      var params = {
        name: vm.data.name,
        surface_density: vm.data.surface_density,
        price: vm.data.price,
        solvent: vm.data.solvent,
        hardener: vm.data.hardener,
        usage_per_m2: vm.data.usage_per_m2
      };

      requestHelper.before(event, "Menyimpan data");

      MaterialService.createMaterialInk(params, function(status, data) {
        if (status) {
          $uibModalInstance.dismiss("cancel");
        } else {
          validator.validateAlert(data);
        }

        requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
      });
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('UpdateCustomerModalController', UpdateCustomerModalController);

   UpdateCustomerModalController.$inject = [
      '$scope',
      '$state',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UpdateCustomerModalController(
      $scope,
      $state,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.user      = customerDependent.user;
      vm.customer  = customerDependent.customer;
      vm.constants = constants;

      // methods
      vm.cancel      = cancel;
      vm.update      = update;

      vm.privileges = {
         admin: false
      }

      $scope.deedOfIncorporationDateChanged = deedOfIncorporationDateChanged;
      $scope.lastDeedDateChanged            = lastDeedDateChanged;

      checkCustomerPrivileges();


      function checkCustomerPrivileges() {
         vm.privileges = {
            admin: false
         }
         
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if(val.name === constants.PRIVILEGES.CUSTOMER_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function deedOfIncorporationDateChanged() {
         vm.customer.deed_of_incorporation_date = vm.customer.deed_of_incorporation_date.format('YYYY-MM-DD');
      }

      function lastDeedDateChanged() {
         vm.customer.last_deed_date = vm.customer.last_deed_date.format('YYYY-MM-DD');
      }

      function update(event) {
         var data = {
            type: vm.customer.type,
            name: vm.customer.name,
            email: vm.customer.email,
            npwp_address: vm.customer.npwp_address,
            npwp_number: vm.customer.npwp_number,
            deed_of_incorporation: vm.customer.deed_of_incorporation,
            deed_of_incorporation_date: vm.customer.deed_of_incorporation_date,
            last_deed: vm.customer.last_deed,
            last_deed_date: vm.customer.last_deed_date,
            phone: vm.customer.phone,
            phone_2: vm.customer.phone_2,
            fax: vm.customer.fax,
            code: vm.customer.code,
            description: vm.customer.description,
            purchaser_name: vm.customer.purchaser_name,
            purchaser_phone: vm.customer.purchaser_phone,
            qc_name: vm.customer.qc_name,
            qc_phone: vm.customer.qc_phone,
            production_head_name: vm.customer.production_head_name,
            production_head_phone: vm.customer.production_head_phone,
            projection_revenue: vm.customer.projection_revenue
         };

         if (vm.customer.term_of_payment) {
            data.term_of_payment = vm.customer.term_of_payment
         }

         if (vm.customer.days_of_payable) {
            data.days_of_payable = vm.customer.days_of_payable
         }

         if (vm.customer.credit_limit) {
            data.credit_limit = vm.customer.credit_limit
         }

         requestHelper.before(event, 'Menyimpan data');
         
         CustomerService.update(data, vm.customer.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);

               if (customerDependent.isFromDetail) {
                  $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
               }
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('CreateCustomerModalController', CreateCustomerModalController);

   CreateCustomerModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateCustomerModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.user = customerDependent.user;

      // methods
      vm.cancel      = cancel;
      vm.create      = create;

      $scope.deedOfIncorporationDateChanged = deedOfIncorporationDateChanged;
      $scope.lastDeedDateChanged            = lastDeedDateChanged;

      function deedOfIncorporationDateChanged() {
         vm.customer.deed_of_incorporation_date = vm.customer.deed_of_incorporation_date.format('YYYY-MM-DD');
      }

      function lastDeedDateChanged() {
         vm.customer.last_deed_date = vm.customer.last_deed_date.format('YYYY-MM-DD');
      }

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');
         
         CustomerService.create(vm.customer, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('UploadModalController', UploadModalController);

   UploadModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UploadModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.image     = customerDependent.image;
      vm.title     = '';
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.upload = upload;

      $scope.fileChanged = fileChanged;

      function upload(event) {

         if ($scope.myFile) {
            var formData = new FormData();
            var type     = ''; ['NPWP', 'Deed Of Incorporation', 'Last Deed', 'Logo']

            formData.append('image', $scope.myFile);

            requestHelper.before(event, 'Mengunggah');

            if (customerDependent.type === constants.CUSTOMER_UPLOAD_TYPE.LOGO) {
               type = 'Logo';
            } else if(customerDependent.type === constants.CUSTOMER_UPLOAD_TYPE.NPWP) {
               type = 'NPWP';
            } else if(customerDependent.type === constants.CUSTOMER_UPLOAD_TYPE.DEED) {
               type = 'Deed Of Incorporation';
            } else if(customerDependent.type === constants.CUSTOMER_UPLOAD_TYPE.LAST_DEED) {
               type = 'Last Deed';
            }

            formData.append('type', type);

            if (customerDependent.type === constants.CUSTOMER_UPLOAD_TYPE.ID_CARD) {
               CustomerService.uploadIdCard(formData, customerDependent.customer.hash_id, customerDependent.importantPerson.hash_id, function(status, data) {
                  if (status) {
                     $uibModalInstance.dismiss('cancel');
                     $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
                     $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
                  } else {
                     $uibModalInstance.dismiss('cancel');
                     validator.validateAlert(data);
                  }
               }); 
            } else {
               CustomerService.upload(formData, customerDependent.customer.hash_id, function(status, data) {
                  if (status) {
                     $uibModalInstance.dismiss('cancel');
                     $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
                     $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
                  } else {
                     $uibModalInstance.dismiss('cancel');
                     validator.validateAlert(data);
                  }
               }); 
            }  
         }
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

         if ($scope.myFile) {
            $('.image-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
               $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.image-container');
            };

            reader.readAsDataURL($scope.myFile);
        }
      }
   }
})();

(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerUpdateAddressModalController', CustomerUpdateAddressModalController);

	CustomerUpdateAddressModalController.$inject = [
		'$rootScope',
		'$uibModalInstance',
		'CustomerService',
		'customerDependent',
		'requestHelper',
		'validator',
		'constants'
	];

	function CustomerUpdateAddressModalController (
		$rootScope,
		$uibModalInstance,
		CustomerService,
		customerDependent,
		requestHelper,
		validator,
		constants
	){
		var vm = this;

		// PARAMS
		vm.customer  = customerDependent.customer;
		vm.address   = angular.copy(customerDependent.address);
		vm.constants = constants;

		// HOOKS

		// METHODS
		vm.update = update;
		vm.cancel = cancel;

		vm.address.is_billing_address = vm.address.is_billing_address ? true : false;

		function update() {
			var params = {
				address: vm.address.address,
				type: vm.address.type,
				is_billing_address: vm.address.is_billing_address ? vm.address.is_billing_address : false
			}

			requestHelper.before(event, 'Menyimpan data');

			CustomerService.updateAddress(vm.customer.hash_id, vm.address.hash_id, params, function(status, data) {
				if (status) {
					$uibModalInstance.dismiss('cancel');

	                $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
				} else {
					validator.validateAlert(data);
				}

				requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
			});
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('ReassignCustomerModalController', ReassignCustomerModalController);

	ReassignCustomerModalController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'constants',
		'validator',
		'SweetAlert',
		'customerDependent',
		'UserService',
		'CustomerService',
		'RoleService'
	];

	function ReassignCustomerModalController(
		$rootScope,
		$scope,
		$uibModalInstance,
		constants,
		validator,
		SweetAlert,
		customerDependent,
		UserService,
		CustomerService,
		RoleService
	) {
		var vm = this;

		// PARAMS
		vm.user  = null;
		vm.users = [];

		// HOOKS

		// METHODS
		vm.getUser = getUser;
		vm.save    = save;
		vm.cancel  = cancel;

		function getUser(search) {
			var params = {
				search: search,
				filter: {
					role: constants.ROLE.SALES
				}
			}

			UserService.getUsers(params, function(status, data) {
				if (status) {
					vm.users = data.data;
				} else {
					validator.validateAlert(data);
				}
			});
		}

		function save() {
			SweetAlert.swal({
	           title: 'Reassign customer ke sales ' +vm.user.name+ ' ?',
	           type: 'warning',
	           showCancelButton: true,
	           confirmButtonColor: constants.COLOR.DANGER,
	           confirmButtonText: "Reassign",
	           cancelButtonText: 'Batalkan',
	           closeOnConfirm: false,
	           showLoaderOnConfirm: true,
	         },
	         function(isConfirm){
	            if (isConfirm) {
	            	var params = {
	            		user_hash_id: vm.user.hash_id
	            	}

	               	CustomerService.reassign(customerDependent.customer.hash_id, params, function(status, data) {
	               		if (status) {
	               			$rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
	               			SweetAlert.swal('Sukses', 'Berhasil reassign customer!', 'success');
	               			cancel();
	               		} else {
	               			validator.validateAlert(data);
	               		}
	               	});
	            }
	         });
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerRankHistoryModalController', CustomerRankHistoryModalController);

	CustomerRankHistoryModalController.$inject = [
		'$rootScope',
		'$uibModalInstance',
		'constants'
	];

	function CustomerRankHistoryModalController(
		$rootScope,
		$uibModalInstance,
		constants
	) {
		var vm = this;

		// PARAMS

		// HOOKS

		// METHODS
		vm.cancel = cancel;

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerEditRankModalController', CustomerEditRankModalController);

	CustomerEditRankModalController.$inject = [
		'$rootScope',
		'$uibModalInstance',
		'constants'
	];

	function CustomerEditRankModalController(
		$rootScope,
		$uibModalInstance,
		constants
	) {
		var vm = this;

		// PARAMS

		// HOOKS

		// METHODS
		vm.cancel     = cancel;
		vm.updateRank = updateRank;

		function updateRank() {
			
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerImageModalController', CustomerImageModalController);

	CustomerImageModalController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'CustomerService',
		'customerDependent',
		'SweetAlert',
		'constants',
		'validator'
	];

	function CustomerImageModalController(
		$rootScope,
		$scope,
		$uibModalInstance,
		CustomerService,
		customerDependent,
		SweetAlert,
		constants,
		validator
	){
		var vm = this;

		// PARAMS
		vm.customer       = customerDependent.customer;
		vm.privileges     = customerDependent.privileges;
		vm.data           = customerDependent.data;
		vm.additionalData = customerDependent.additionalData;
		vm.image_url      = customerDependent.image;
		vm.type           = customerDependent.type;
		vm.isEditButton   = customerDependent.isEditable;
		vm.isRemoveButton = customerDependent.isRemoveable;
		vm.isEditable     = false;
		vm.constants      = constants;

		// HOOKS

		// METHODS
		vm.editImage               = editImage;
		vm.cancelEdit              = cancelEdit;
		vm.updateImageConfirmation = updateImageConfirmation;
		vm.deleteImageConfirmation = deleteImageConfirmation;
		vm.cancel                  = cancel;

		$scope.fileChanged = fileChanged;

		function editImage() {
			vm.isEditable = true;
		}

		function cancelEdit() {
			vm.isEditable = false;
		}

		function deleteImageConfirmation() {
			SweetAlert.swal({
				title: 'Hapus gambar?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Hapus",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					deleteImage();
				}
			});
		}

		function deleteImage() {
			CustomerService.deleteImage(vm.customer.hash_id, vm.data.hash_id, function(status, data) {
				if (status) {
	               	$rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
               		SweetAlert.swal('Sukses', 'Gambar berhasil dihapus!', 'success');
	                $uibModalInstance.dismiss('cancel');
               } else {
                  $uibModalInstance.dismiss('cancel');
                  validator.validateAlert(data);
               }
			});
		}

		function updateImageConfirmation(event) {
			SweetAlert.swal({
				title: 'Ubah data gambar?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Simpan",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					updateImage(event);
				}
			});
		}

		function updateImage(event) {
			var form         = $(event.target);
			var submitButton = form.find('button[type=submit]');

         	form.find('button').prop('disabled', true);
         	submitButton.html('<i class="fa fa-spin fa-spinner"></i> Mengunggah gambar...');

         	if ($scope.myFile) {
         		var formData = new FormData();
         		var isImage = true;

		        formData.append('image', $scope.myFile);
		        formData.append('type', vm.type);

		        if (vm.type === constants.CUSTOMER_UPLOAD_TYPE.ID_CARD) {
		        	CustomerService.uploadIdCard(formData, vm.data.hash_id, vm.additionalData.hash_id, function(status, data) {
	                  if (status) {
	                     $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
	               		 SweetAlert.swal('Sukses', 'Data gambar berhasil diubah!', 'success');
		                 $uibModalInstance.dismiss('cancel');
	                  } else {
	                     $uibModalInstance.dismiss('cancel');
	                     validator.validateAlert(data);
	                  }

	                  form.find('button').prop('disabled', false);
		              submitButton.html('<i class="fa fa-save"></i> Simpan');
	               });
		        } else {
		        	CustomerService.upload(formData, vm.data.hash_id, function(status, data) {
		               if (status) {
			               	$rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
		               		SweetAlert.swal('Sukses', 'Data gambar berhasil diubah!', 'success');
			                $uibModalInstance.dismiss('cancel');
		               } else {
		                  $uibModalInstance.dismiss('cancel');
		                  validator.validateAlert(data);
		               }

		               form.find('button').prop('disabled', false);
		               submitButton.html('<i class="fa fa-save"></i> Simpan');
		            });
		        }
         	} else {
         		SweetAlert.swal('Warning', 'Harap pilih gambar yang akan diupload', 'warning');
         	}
      	}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function fileChanged(event) {

         	if ($scope.myFile) {
            	$('.image-container').html('');

	            var reader = new FileReader();

	            reader.onload = function(e){
	               $($.parseHTML('<img class="img-responsive">')).attr('src', e.target.result).appendTo('.image-container');
	            };

            	reader.readAsDataURL($scope.myFile);
        	}
	    }
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerCreateImageModalController', CustomerCreateImageModalController);

	CustomerCreateImageModalController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'CustomerService',
		'customerDependent',
		'SweetAlert',
		'constants'
	];

	function CustomerCreateImageModalController(
		$rootScope,
		$scope,
		$uibModalInstance,
		CustomerService,
		customerDependent,
		SweetAlert,
		constants
	){
		var vm = this;

		// PARAMS
		vm.customer = customerDependent.customer;
		vm.image = {
			image: '',
			description: ''
		}

		// HOOKS

		// METHODS
		vm.createImageConfirmation = createImageConfirmation;
		vm.cancel                  = cancel;

		$scope.fileChanged = fileChanged;

		function createImageConfirmation(event) {
			SweetAlert.swal({
				title: 'Simpan data gambar?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Simpan",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					createImage(event);
				}
			});
		}

		function createImage(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Mengunggah gambar...');

         if ($scope.myFile) {
			var formData    = new FormData();

            formData.append('image', $scope.myFile);
            formData.append('description', vm.image.description);

            CustomerService.createImage(vm.customer.hash_id, formData, function(status, data) {
               if (status) {
	               	$rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
               		SweetAlert.swal('Sukses', 'Data gambar berhasil disimpan!', 'success');
	                $uibModalInstance.dismiss('cancel');
               } else {
                  $uibModalInstance.dismiss('cancel');
                  validator.validateAlert(data);
               }

               form.find('button').prop('disabled', false);
               submitButton.html('<i class="fa fa-save"></i> Simpan');
            });
         }
      	}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function fileChanged(event) {

         	if ($scope.myFile) {
            	$('.image-container').html('');

	            var reader = new FileReader();

	            reader.onload = function(e){
	               $($.parseHTML('<img class="img-responsive">')).attr('src', e.target.result).appendTo('.image-container');
	            };

            	reader.readAsDataURL($scope.myFile);
        	}
	    }
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.customer')
		.controller('CustomerCreateAddressModalController', CustomerCreateAddressModalController);

	CustomerCreateAddressModalController.$inject = [
		'$rootScope',
		'$uibModalInstance',
		'CustomerService',
		'customerDependent',
		'requestHelper',
		'validator',
		'constants'
	];

	function CustomerCreateAddressModalController (
		$rootScope,
		$uibModalInstance,
		CustomerService,
		customerDependent,
		requestHelper,
		validator,
		constants
	){
		var vm = this;

		// PARAMS
		vm.customer  = customerDependent.customer;
		vm.constants = constants;

		vm.data = {
			address: '',
			type: '',
			is_billing_address: false
		};

		// HOOKS

		// METHODS
		vm.create = create;
		vm.cancel = cancel;

		console.log(vm.customer);

		function create() {
			var params = {
				address: vm.data.address,
				type: vm.data.type,
				is_billing_address: vm.data.is_billing_address ? vm.data.is_billing_address : false
			}

			requestHelper.before(event, 'Menyimpan data');

			CustomerService.createAddress(vm.customer.hash_id, params, function(status, data) {
				if (status) {
					$uibModalInstance.dismiss('cancel');

	                $rootScope.$broadcast(constants.BROADCAST.DETAIL_CUSTOMER, {customer: data});
				} else {
					validator.validateAlert(data);
				}

				requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
			});
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UpdateCommissionPaymentModalController', UpdateCommissionPaymentModalController);

   UpdateCommissionPaymentModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CommissionService',
      'commissionDependent',
      'constants',
      'validator'
   ];

   function UpdateCommissionPaymentModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CommissionService,
      commissionDependent,
      constants,
      validator
   ) {
      var vm = this;

      // params
      vm.commission = commissionDependent.data;
      vm.payment = commissionDependent.payment;
      vm.constants  = constants;
      vm.isCustomerPaidDate = vm.payment.paid_at ? true : false;
      vm.data       = {
         description: vm.payment.description,
         invoice_number: vm.payment.invoice_number,
         invoice_amount: vm.payment.invoice_amount,
         invoice_date: vm.payment.invoice_date,
         paid_at: vm.payment.paid_at
      };

      // methods
      vm.cancel = cancel;
      vm.update = update;

      $scope.invoiceDateChanged = invoiceDateChanged;
      $scope.paidDateChanged    = paidDateChanged;

      function invoiceDateChanged() {
         vm.data.invoice_date = vm.data.invoice_date.format('YYYY-MM-DD');
      }

      function paidDateChanged() {
         vm.data.paid_at = vm.data.paid_at.format('YYYY-MM-DD');
      }

      function update(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Menambahkan payment...');

         if (!vm.isCustomerPaidDate) {
            vm.data.paid_at = null;
         }

         CommissionService.updateCommissionPayment(vm.commission.hash_id, vm.payment.hash_id, vm.data, function(status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_COMMISSION, {commission: data});
            } else {
               $uibModalInstance.dismiss('cancel');
               validator.validateAlert(data);
            }

            form.find('button').prop('disabled', false);
            submitButton.html('<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CreateCommissionPaymentModalController', CreateCommissionPaymentModalController);

   CreateCommissionPaymentModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CommissionService',
      'commissionDependent',
      'constants',
      'validator'
   ];

   function CreateCommissionPaymentModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CommissionService,
      commissionDependent,
      constants,
      validator
   ) {
      var vm = this;

      // params
      vm.isCustomerPaidDate = false;
      vm.commission         = commissionDependent.data;
      vm.constants          = constants;
      vm.data               = {};

      // methods
      vm.cancel = cancel;
      vm.create = create;

      $scope.invoiceDateChanged = invoiceDateChanged;
      $scope.paidDateChanged    = paidDateChanged;

      vm.data.invoice_date = null;
      vm.data.paid_at      = null;

      function invoiceDateChanged() {
         vm.data.invoice_date = vm.data.invoice_date.format('YYYY-MM-DD');
      }

      function paidDateChanged() {
         vm.data.paid_at = vm.data.paid_at.format('YYYY-MM-DD');
      }

      function create(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Menambahkan payment...');

         if (!vm.isCustomerPaidDate) {
            vm.data.paid_at = null;
         }

         CommissionService.createCommissionPayment(vm.commission.hash_id, vm.data, function(status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_COMMISSION, {commission: data});
            } else {
               $uibModalInstance.dismiss('cancel');
               validator.validateAlert(data);
            }

            form.find('button').prop('disabled', false);
            submitButton.html('<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.amg', []);
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('UpdateAmgProductModalController', UpdateAmgProductModalController);

   UpdateAmgProductModalController.$inject = [
      '$scope',
      '$rootScope',
      '$compile',
      '$uibModalInstance',
      'AmgService',
      'constants',
      'validator',
      'requestHelper',
      'productDependent'
   ];

   function UpdateAmgProductModalController(
      $scope,
      $rootScope,
      $compile,
      $uibModalInstance,
      AmgService,
      constants,
      validator,
      requestHelper,
      productDependent
   ) {
      var vm = this;

      // params
      vm.product = {
         name: '',
         profit_margin: '',
         inner_percentage: '',
         middle_percentage: '',
         outer_percentage: '',
         inner_materials: [],
         middle_materials: [],
         outer_materials: []
      };
      vm.materials = {};
      vm.constants = constants;
      vm.loader    = true;

      // methods
      vm.cancel         = cancel;
      vm.addMaterial    = addMaterial;
      vm.removeMaterial = removeMaterial
      vm.update         = update;

      initializeProduct();
      getMaterial();

      function initializeProduct() {
         var product = angular.copy(productDependent.product);

         vm.product.name              = product.name;
         vm.product.profit_margin     = product.profit_margin;
         vm.product.inner_percentage  = product.inner_percentage;
         vm.product.middle_percentage = product.middle_percentage;
         vm.product.outer_percentage  = product.outer_percentage;

         angular.forEach(product.materials, function(value, key) {
            var material = {};

            material.material_name = value.name;
            material.percentage    = value.pivot.percentage;

            if (value.pivot.extruder_type === 'inner') {
               vm.product.inner_materials.push(material);
            } else if (value.pivot.extruder_type === 'middle') {
               vm.product.middle_materials.push(material);
            } else if (value.pivot.extruder_type === 'outer') {
               vm.product.outer_materials.push(material);
            }
         });
      }

      function getMaterial() {
         AmgService.getMaterial(null, function(status, data) {
            if (status) {
               vm.loader    = false;
               vm.materials = data.result;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function addMaterial(event, type) {
         if (type === 'inner') {
            vm.product.inner_materials.push({
               material_name: null,
               percentage: null
            });            
         } else if (type === 'middle') {
            vm.product.middle_materials.push({
               material_name: null,
               percentage: null
            });            
         } else if (type === 'outer') {
            vm.product.outer_materials.push({
               material_name: null,
               percentage: null
            });            
         }
      }

      function removeMaterial(event) {
         var element = $(event.currentTarget).closest('.material-form');
         element.remove();
      }

      function update(event) {
         var data = angular.copy(vm.product);

         // percentage to decimal
         data.inner_percentage  = data.inner_percentage;
         data.middle_percentage = data.middle_percentage;
         data.outer_percentage  = data.outer_percentage;

         var inner_materials  = [];
         var middle_materials = [];
         var outer_materials  = [];

         $('#inner-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            inner_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         $('#middle-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            middle_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         $('#outer-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            outer_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         data.inner_materials  = inner_materials;
         data.middle_materials = middle_materials;
         data.outer_materials  = outer_materials;

         requestHelper.before(event, 'Menyimpan data');

         AmgService.createProduct(data, function(status, data) {
            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
            
            if (status) {
               $rootScope.$broadcast(constants.BROADCAST.INDEX_AMG_PRODUCT);
               cancel();
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('CreateAmgProductModalController', CreateAmgProductModalController);

   CreateAmgProductModalController.$inject = [
      '$scope',
      '$rootScope',
      '$compile',
      '$uibModalInstance',
      'AmgService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateAmgProductModalController(
      $scope,
      $rootScope,
      $compile,
      $uibModalInstance,
      AmgService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.materials = {};
      vm.constants = constants;
      vm.loader    = true;

      // methods
      vm.cancel         = cancel;
      vm.addMaterial    = addMaterial;
      vm.removeMaterial = removeMaterial
      vm.create         = create;

      getMaterial();

      function getMaterial() {
         AmgService.getMaterial(null, function(status, data) {
            if (status) {
               vm.loader    = false;
               vm.materials = data.result;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function generateTemplate() {
         var template = '';
         var options  = '';

         angular.forEach(vm.materials, function(value, key) {
            options += '<option value="'+ value.name +'">'+ value.name +'</option>';
         });

         template += '<div class="material-form">';
         template += '<div class="row">';

         template += '<div class="col-md-6">';
         template += '<div class="form-group">';
         template += '<select class="form-control" required>';
         template += '<option value="">-Pilih Material-</option>';
         template += options;
         template += '</select>';
         template += '</div>';
         template += '</div>';

         template += '<div class="col-md-4">';
         template += '<div class="form-group">';
         template += '<div class="input-group">';
         template += '<input required placeholder="Percentage" type="number" min="0" max="100" step="any" class="form-control" />'
         template += '<span class="input-group-addon">%</span>';
         template += '</div>';
         template += '</div>';
         template += '</div>';

         template += '<div class="col-md-2">';
         template += '<div class="form-group">';
         template += '<button class="btn btn-danger" ng-click="vm.removeMaterial($event)"><i class="fa fa-times"></i> Batal</button>';
         template += '</div>';
         template += '</div>';

         template += '</div>';
         template += '</div>';

         return template;
      }

      function addMaterial(event, type) {
         var template = generateTemplate();
         var wrapper  = $(event.currentTarget).siblings('.material-wrapper');
         var target   = type + '-material-wrapper';

         angular.element(document.getElementById(target)).append( $compile(template)($scope) );
      }

      function removeMaterial(event) {
         var element = $(event.currentTarget).closest('.material-form');
         element.remove();
      }

      function create(event) {
         var data = angular.copy(vm.data);

         // percentage to decimal
         data.inner_percentage  = data.inner_percentage;
         data.middle_percentage = data.middle_percentage;
         data.outer_percentage  = data.outer_percentage;

         data.inner_materials  = [];
         data.middle_materials = [];
         data.outer_materials  = [];

         $('#inner-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            data.inner_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         $('#middle-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            data.middle_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         $('#outer-material-wrapper').find('.material-form').each(function(index, el) {
            var material   = $(el).find('select').val();
            var percentage = $(el).find('input').val();

            data.outer_materials.push({
               material_name: material,
               percentage: percentage
            });
         });

         requestHelper.before(event, 'Menyimpan data');

         AmgService.createProduct(data, function(status, data) {
            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
            
            if (status) {
               $rootScope.$broadcast(constants.BROADCAST.INDEX_AMG_PRODUCT);
               cancel();
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('UpdateAmgMaterialModalController', UpdateAmgMaterialModalController);

   UpdateAmgMaterialModalController.$inject = [
      '$scope',
      '$rootScope',
      '$compile',
      '$uibModalInstance',
      'AmgService',
      'constants',
      'validator',
      'requestHelper',
      'materialDependent'
   ];

   function UpdateAmgMaterialModalController(
      $scope,
      $rootScope,
      $compile,
      $uibModalInstance,
      AmgService,
      constants,
      validator,
      requestHelper,
      materialDependent
   ) {
      var vm = this;

      // params
      vm.material  = {
         name: angular.copy(materialDependent.material.name),
         spot_price: angular.copy(materialDependent.material.spot_price),
         import_price: angular.copy(materialDependent.material.import_price)
      };

      vm.constants = constants;
      vm.loader    = true;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         requestHelper.before(event, 'Menyimpan data');

         AmgService.createMaterial(vm.material, function(status, data) {
            if (status) {
               $rootScope.$broadcast(constants.BROADCAST.INDEX_AMG_MATERIAL);
               requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
               cancel();
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('CreateAmgMaterialModalController', CreateAmgMaterialModalController);

   CreateAmgMaterialModalController.$inject = [
      '$scope',
      '$rootScope',
      '$compile',
      '$uibModalInstance',
      'AmgService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateAmgMaterialModalController(
      $scope,
      $rootScope,
      $compile,
      $uibModalInstance,
      AmgService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data = {};

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         AmgService.createMaterial(vm.data, function(status, data) {
            if (status) {
               $rootScope.$broadcast(constants.BROADCAST.INDEX_AMG_MATERIAL);
               requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
               cancel();
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UploadUserModalController', UploadUserModalController);

   UploadUserModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'UserService',
      'userDependent',
      'constants',
      'validator'
   ];

   function UploadUserModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      UserService,
      userDependent,
      constants,
      validator
   ) {
      var vm = this;

      // params
      vm.user      = userDependent.user;
      vm.constants = constants;
      vm.image     = null;

      // methods
      vm.cancel = cancel;
      vm.upload = upload;

      $scope.fileChanged = fileChanged;

      function upload(event) {
         var form         = $(event.target);
         var submitButton = form.find('button[type=submit]');

         form.find('button').prop('disabled', true);
         submitButton.html('<i class="fa fa-spin fa-spinner"></i> Mengunggah gambar...');

         if ($scope.myFile) {
            var formData = new FormData();

            formData.append('image', $scope.myFile);   

            UserService.uploadImage(formData, vm.user.hash_id, function(status, data) {
               if (status) {
                  $uibModalInstance.dismiss('cancel');
                  $rootScope.$broadcast(constants.BROADCAST.INDEX_USER);
               } else {
                  $uibModalInstance.dismiss('cancel');
                  validator.validateAlert(data);
               }

               form.find('button').prop('disabled', false);
               submitButton.html('<i class="fa fa-save"></i> Simpan');
            });
         }
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

         if ($scope.myFile) {
            $('.image-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
               $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.image-container');
            };

            reader.readAsDataURL($scope.myFile);
        }
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UpdateUserModalController', UpdateUserModalController);

   UpdateUserModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'UserService',
      'RoleService',
      'userDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UpdateUserModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      UserService,
      RoleService,
      userDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.user      = userDependent.user;
      vm.roles     = RoleService.roles;
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      $scope.$on(constants.BROADCAST.INDEX_ROLE, function() {
         vm.roles = RoleService.roles;
      });

      $scope.birthDateChanged            = birthDateChanged;

      function birthDateChanged() {
         vm.user.birth_date = vm.user.birth_date.format('YYYY-MM-DD');
      }

      function update(event) {
         var data = {
            name: vm.user.name,
            email: vm.user.email,
            role: vm.user.role.hash_id,
            id_card_number: vm.user.id_card_number,
            employee_card_number: vm.user.employee_card_number,
            gender: vm.user.gender,
            marital_status: vm.user.marital_status,
            birth_date: vm.user.birth_date,
            phone: vm.user.phone,
            address: vm.user.address
         };

         requestHelper.before(event, 'Menyimpan data');
         
         UserService.update(data, vm.user.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_USER);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'user.index',
         config: {
            url: '?search&filter_gender&filter_role&page',
            templateUrl: 'app/user/index/index.html',
            controllerAs: 'UserController as vm',
            title: 'User'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UserController', UserController);

   UserController.$inject = [
      '$location',
      '$stateParams',
      '$state',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'RoleService',
      'globalState'
   ];

   /* @ngInject */
   function UserController(
      $location,
      $stateParams,
      $state,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      RoleService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.users       = [];
      vm.roles       = RoleService.roles;
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         create: false,
         update: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         filter: {
            gender: $stateParams.filter_gender ? $stateParams.filter_gender : '',
            role: $stateParams.filter_role ? $stateParams.filter_role : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.INDEX_ROLE, function() {
         vm.roles = RoleService.roles;
      });

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_USER, function() {
         var params = {
            page: vm.pagination.currentPage,
            search: vm.filtering.search,
         }

         getUsers(params);
      });

      // METHODS
      vm.refresh          = refresh;
      vm.getUsers         = getUsers;
      vm.editUser         = editUser;
      vm.createUser       = createUser;
      vm.uploadUserImage  = uploadUserImage;
      vm.changeUserStatus = changeUserStatus;
      vm.filter           = filter;
      vm.showUser         = showUser;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getUsers(vm.filtering);
      checkUserPrivileges();

      function getUsers(params) {
         UserService.getUsers(params, getData);

         function getData(status, data) {
            if (status) {
               vm.users  = data.data;

               vm.pagination.currentPage  = data.current_page;
               vm.pagination.totalItems   = data.total;
               vm.pagination.itemsPerPage = data.per_page;
            } else {
               validator.validateAlert(data);
            }
         }
      }

      function showUser(user) {
         $state.go('user.detail', {'userHashId': user.hash_id, 'user': user});
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            update: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(val, opt) {
               if (val.name === constants.PRIVILEGES.USER_READ) {
                  vm.privileges.read = true;
               } else if (val.name === constants.PRIVILEGES.USER_CREATE) {
                  vm.privileges.create = true;
               } else if(val.name === constants.PRIVILEGES.USER_UPDATE) {
                  vm.privileges.update = true;
               }
            });
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/user/guide-modal/guide-modal.html',
            controller: 'UserGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editUser(user) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/user/update-modal/update-modal.html',
            controller: 'UpdateUserModalController',
            controllerAs: 'vm',
            resolve: {
               userDependent: function () {
                  return {
                     user: user
                  };
               }
            }
         });
      }

      function createUser(user) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/user/create-modal/create-modal.html',
            controller: 'CreateUserModalController',
            controllerAs: 'vm'
         });
      }

      function uploadUserImage(user) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/user/upload-modal/upload-modal.html',
            controller: 'UploadUserModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
               userDependent: function () {
                  return {
                     user: user
                  };
               }
            }
         });
      }

      function changeUserStatus(user, event) {
         var switcher   = $(event.currentTarget);
         var value      = switcher.prop('checked') ? 1 : 0;
         var statusName = value ? 'Aktifkan' : "Nonaktifkan";

         switcher.prop('checked', !value);

         SweetAlert.swal({
            title: statusName + ' user ' + user.name + '?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: statusName,
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var parameters = {
                  is_active : value
               }

               UserService.changeStatus(user.hash_id, parameters, function(status, data) {
                  if (status) {
                     switcher.prop('checked', value);
                     SweetAlert.swal('Sukses', 'User ' + user.name + ' berhasil di-' +statusName, 'success');
                  } else {
                     validator.validateAlert(data);
                  }
               })
            }
         });
      }

      function refresh() {
         vm.users  = [];

         getUsers(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function filter() {
         $location.url('/user?search=' + vm.filtering.search + '&filter_gender=' + vm.filtering.filter.gender + '&filter_role=' + vm.filtering.filter.role + '&page=' + vm.filtering.page);
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('UserGuideModalController', UserGuideModalController);

   UserGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UserGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'user.detail',
         config: {
            url: '/:userHashId',
            params: {'user': null},
            templateUrl: 'app/user/detail/detail.html',
            controllerAs: 'DetailUserController as vm',
            title: 'User Detail'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('DetailUserController', DetailUserController);

   DetailUserController.$inject = [
      '$state',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'globalState'
   ];

   /* @ngInject */
   function DetailUserController(
      $state,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.user    = $stateParams.user;
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         update: false,
         admin: false
      }

      // HOOKS
      if (!vm.user) {
         if ($stateParams.userHashId) {
            showUser($stateParams.userHashId);
         } else {
            $state.go('user.index');
         }
      }

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;
      });

      $scope.$on(constants.BROADCAST.DETAIL_USER, function(event, args) {
         vm.user = args.user;
      });

      // METHODS
      vm.uploadImage  = uploadImage;
      vm.resetPassword = resetPassword;

      function showUser(userHashId) {
         UserService.showDetailUser(userHashId, function(status, data) {
            if (status) {
               vm.user = data;
            } else {
               validator.validateAlert(data);
               $state.go('user.index');
            }
         });
      }

      function uploadImage() {

         $uibModal.open({
            animation: true,
            templateUrl: 'app/user/detail/upload-modal/upload-modal.html',
            controller: 'UploadUserModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
               userDependent: function () {
                  return {
                     user: vm.user,
                  };
               }
            }
         });
      }

      function resetPassword() {
         SweetAlert.swal({
            title: 'Reset Password',
            text: 'Apakah anda ingin reset password?',
            html: true,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: constants.COLOR.DANGER,
            confirmButtonText: "Reset Password",
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm) {
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               UserService.resetPassword(vm.user.hash_id, function(status, response) {
                  if (status) {
                     SweetAlert.swal('Sukses', 'Silahkan cek email user ini.', 'success');
                     showUser($stateParams.userHashId);
                  }
               });
            }
         });
      }

   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CreateUserModalController', CreateUserModalController);

   CreateUserModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'UserService',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateUserModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      UserService,
      RoleService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {};
      vm.roles     = RoleService.roles;
      vm.constants = constants;

      // methods
      vm.cancel           = cancel;
      vm.create           = create;

      $scope.$on(constants.BROADCAST.INDEX_ROLE, function() {
         vm.roles = RoleService.roles;
      });

      $scope.birthDateChanged            = birthDateChanged;

      function birthDateChanged() {
         vm.data.birth_date = vm.data.birth_date.format('YYYY-MM-DD');
      }

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         UserService.create(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_USER);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.transport',
         config: {
            url: '/transport?search&sort_transportTypesCreatedAt&page',
            templateUrl: 'app/setting/transport/transport.html',
            controllerAs: 'TransportController as vm',
            title: 'Transport Types'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('TransportController', TransportController);

   TransportController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'TransportService',
      'globalState'
   ];

   /* @ngInject */
   function TransportController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      TransportService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.transports  = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         sort: {
            'transport_types.created_at': $stateParams.sort_transportTypesCreatedAt ? $stateParams.sort_transportTypesCreatedAt : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_TRANSPORT, function() {
         getTransports(vm.filtering);
      });

      // METHODS
      vm.refresh                     = refresh;
      vm.getTransports               = getTransports;
      vm.createTransport             = createTransport;
      vm.editTransport               = editTransport;
      vm.sortDate                    = sortDate;
      vm.deleteTransportConfirmation = deleteTransportConfirmation;
      vm.filter                      = filter;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getTransports(vm.filtering);
      checkUserPrivileges();

      function getTransports(params) {
         TransportService.getTransport(params, getData);

         function getData(status, response) {
            if (status) {
               vm.transports  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/transport/guide-modal/guide-modal.html',
            controller: 'TransportGuideModalController',
            controllerAs: 'vm'
         });
      }

      function createTransport() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/transport/create-modal/create-modal.html',
            controller: 'CreateTransportModalController',
            controllerAs: 'vm'
         });
      }

      function editTransport(transport) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/transport/update-modal/update-modal.html',
            controller: 'UpdateTransportModalController',
            controllerAs: 'vm',
            resolve: {
               transportDependent: function () {
                  return {
                     transport: transport
                  };
               }
            }
         });
      }

      function deleteTransportConfirmation(transport, event) {
         SweetAlert.swal({
           title: 'Hapus Transport ' + transport.name + '?',
           text: 'Role ' + transport.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteTransport(transport, event);
            }
         });
      }

      function deleteTransport(transport, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         TransportService.removeTransport(transport.hash_id, function(status, data) {
            if (status) {
               getTransports(vm.filtering);
               SweetAlert.swal('Sukses', 'Transport berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.TRANSPORT_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.TRANSPORT_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.transports = [];

         getTransports(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortDate(value) {
        if (value === 'desc') {
          vm.filtering.sort['transport_types.created_at'] = 'asc';
        } else {
          vm.filtering.sort['transport_types.created_at'] = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/setting/transport?search=' + vm.filtering.search +
            '&sort_transportTypesCreatedAt=' + vm.filtering.sort['transport_types.created_at'] +
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.quotationTermTemplate',
         config: {
            url: '/quotation-term-template?search&filter_isRequired&sort_quotationTermTemplatesCreatedAt&page',
            templateUrl: 'app/setting/quotation-term/quotation-term.html',
            controllerAs: 'QuotationTermController as vm',
            title: 'Quotation Term Templates'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('QuotationTermController', QuotationTermController);

   QuotationTermController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'QuotationTermService',
      'globalState'
   ];

   /* @ngInject */
   function QuotationTermController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      QuotationTermService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.quotationTerms  = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         filter: {
            is_required: $stateParams.filter_isRequired ? $stateParams.filter_isRequired : ''
         },
         sort: {
            // 'quotation_term_templates.created_at': $stateParams.sort_quotationTermTemplatesCreatedAt ? $stateParams.sort_quotationTermTemplatesCreatedAt : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_QUOTATION_TERM, function() {
         getQuotationTerms(vm.filtering);
      });

      // METHODS
      vm.refresh                         = refresh;
      vm.getQuotationTerms               = getQuotationTerms;
      vm.createQuotationTerm             = createQuotationTerm;
      vm.editQuotationTerm               = editQuotationTerm;
      vm.sortDate                        = sortDate;
      vm.deleteQuotationTermConfirmation = deleteQuotationTermConfirmation;
      vm.filter                          = filter;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getQuotationTerms(vm.filtering);
      checkUserPrivileges();

      function getQuotationTerms(params) {
         QuotationTermService.getQuotationTerm(params, getData);

         function getData(status, response) {
            if (status) {
               vm.quotationTerms  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/quotation-term/guide-modal/guide-modal.html',
            controller: 'QuotationTermGuideModalController',
            controllerAs: 'vm'
         });
      }

      function createQuotationTerm() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/quotation-term/create-modal/create-modal.html',
            controller: 'CreateQuotationTermModalController',
            controllerAs: 'vm'
         });
      }

      function editQuotationTerm(quotationTerm) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/quotation-term/update-modal/update-modal.html',
            controller: 'UpdateQuotationTermModalController',
            controllerAs: 'vm',
            resolve: {
               quotationTermDependent: function () {
                  return {
                     quotationTerm: quotationTerm
                  };
               }
            }
         });
      }

      function deleteQuotationTermConfirmation(quotationTerm, event) {
         SweetAlert.swal({
           title: 'Hapus Quotation Term ' + quotationTerm.description + '?',
           text: quotationTerm.description + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteQuotationTerm(quotationTerm, event);
            }
         });
      }

      function deleteQuotationTerm(quotationTerm, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         QuotationTermService.removeQuotationTerm(quotationTerm.hash_id, function(status, data) {
            if (status) {
               getQuotationTerms(vm.filtering);
               SweetAlert.swal('Sukses', 'Quotation Term berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {

            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.QUOTATION_TERM_TEMPLATE_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.QUOTATION_TERM_TEMPLATE_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.quotationTerms = [];

         getQuotationTerms(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortDate(value) {
        if (value === 'desc') {
          vm.filtering.sort['quotation_term_templates.created_at'] = 'asc';
        } else {
          vm.filtering.sort['quotation_term_templates.created_at'] = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/setting/quotation-term?search=' + vm.filtering.search +
            '&filter_isRequired=' + vm.filtering.filter.is_required +
            '&sort_quotationTermTemplatesCreatedAt=' + vm.filtering.sort['quotation_term_templates.created_at'] +
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.quotation',
         config: {
            url: '/quotation-setting?page',
            templateUrl: 'app/setting/quotation/quotation-setting.html',
            controllerAs: 'QuotationSettingController as vm',
            title: 'Quotation Settings'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('QuotationSettingController', QuotationSettingController);

   QuotationSettingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'SettingService',
      'globalState'
   ];

   /* @ngInject */
   function QuotationSettingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      SettingService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.settings    = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_QUOTATION_SETTING, function() {
         getQuotationSettings(vm.filtering);
      });

      // METHODS
      vm.refresh                     = refresh;
      vm.getQuotationSettings        = getQuotationSettings;
      vm.editQuotationSetting        = editQuotationSetting;
      vm.filter                      = filter;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getQuotationSettings(vm.filtering);
      checkUserPrivileges();

      function getQuotationSettings(params) {
         SettingService.getQuotationSettings(params, getData);

         function getData(status, response) {
            if (status) {
               vm.settings  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function editQuotationSetting(quotationSetting) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/quotation/update-modal/update-modal.html',
            controller: 'UpdateQuotationSettingModalController',
            controllerAs: 'vm',
            resolve: {
               settingDependent: function () {
                  return {
                     quotationSetting: quotationSetting
                  };
               }
            }
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.TRANSPORT_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.TRANSPORT_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.settings = [];

         getQuotationSettings(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function filter() {
         $location.url(
            '/setting/quotation-setting?page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.material',
         config: {
            url: '/material-setting',
            templateUrl: 'app/setting/material/material-setting.html',
            controllerAs: 'MaterialSettingController as vm',
            title: 'Material Settings'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('MaterialSettingController', MaterialSettingController);

   MaterialSettingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'SettingService',
      'globalState'
   ];

   /* @ngInject */
   function MaterialSettingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      SettingService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.settings    = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_SETTING, function() {
         getMaterialSettings(vm.filtering);
      });

      // METHODS
      vm.refresh             = refresh;
      vm.getMaterialSettings = getMaterialSettings;
      vm.editMaterialSetting = editMaterialSetting;

      getMaterialSettings(vm.filtering);
      checkUserPrivileges();

      function getMaterialSettings(params) {
         SettingService.getMaterialSettings(params, getData);

         function getData(status, response) {
            if (status) {
               vm.settings  = response;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function editMaterialSetting(setting) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/material/update-modal/update-modal.html',
            controller: 'UpdateMaterialSettingModalController',
            controllerAs: 'vm',
            resolve: {
               settingDependent: function () {
                  return {
                     materialSetting: setting
                  };
               }
            }
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.read = true;
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.settings = [];

         getMaterialSettings(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function filter() {
         $location.url(
            '/setting/material-setting?page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.commission-timeline',
         config: {
            url: '/commission-timeline?search&sort_minDaysLate&page',
            templateUrl: 'app/setting/commission-timeline/commission-timeline.html',
            controllerAs: 'CommissionTimelineSettingController as vm',
            title: 'Commission Timeline Setting'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CommissionTimelineSettingController', CommissionTimelineSettingController);

   CommissionTimelineSettingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'SettingService',
      'globalState'
   ];

   /* @ngInject */
   function CommissionTimelineSettingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      SettingService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.commissions = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         sort: {
            min_days_late: $stateParams.sort_minDaysLate ? $stateParams.sort_minDaysLate : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_SETTING_COMMISSION_TIMELINE, function() {
         getIndex(vm.filtering);
      });

      // METHODS
      vm.refresh            = refresh;
      vm.getIndex           = getIndex;
      vm.create             = create;
      vm.edit               = edit;
      vm.sortMinDaysLate    = sortMinDaysLate;
      vm.deleteConfirmation = deleteConfirmation;
      vm.filter             = filter;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getIndex(vm.filtering);
      checkUserPrivileges();

      function getIndex(params) {
         SettingService.getCommissionTimeline(params, getData);

         function getData(status, response) {
            if (status) {
               vm.commissions  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission-timeline/guide-modal/guide-modal.html',
            controller: 'CommissionTimelineSettingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function create() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission-timeline/create-modal/create-modal.html',
            controller: 'CreateCommissionTimelineSettingModalController',
            controllerAs: 'vm'
         });
      }

      function edit(commission) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission-timeline/update-modal/update-modal.html',
            controller: 'UpdateCommissionTimelineSettingModalController',
            controllerAs: 'vm',
            resolve: {
               settingDependent: function () {
                  return {
                     commission: commission
                  };
               }
            }
         });
      }

      function deleteConfirmation(commission, event) {
         SweetAlert.swal({
           title: 'Hapus commission timeline setting?',
           text: '',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteSetting(commission, event);
            }
         });
      }

      function deleteSetting(commission, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         SettingService.removeCommissionTimeline(commission.hash_id, function(status, data) {
            if (status) {
               getIndex(vm.filtering);
               SweetAlert.swal('Sukses', 'Commission timeline setting berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.COMMISSION_TIMELINE_SETTING_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.COMMISSION_TIMELINE_SETTING_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.commissions = [];

         getIndex(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortMinDaysLate(value) {
        if (value === 'desc') {
          vm.filtering.sort.min_days_late = 'asc';
        } else {
          vm.filtering.sort.min_days_late = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/setting/commission-timeline?search=' + vm.filtering.search +
            '&sort_minDaysLate=' + vm.filtering.sort.min_days_late +
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'setting.commission',
         config: {
            url: '/commission?search&sort_minGrossProfitPercentage&page',
            templateUrl: 'app/setting/commission/commission.html',
            controllerAs: 'CommissionSettingController as vm',
            title: 'Commission Setting'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .controller('CommissionSettingController', CommissionSettingController);

   CommissionSettingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'SettingService',
      'globalState'
   ];

   /* @ngInject */
   function CommissionSettingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      SettingService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.commissions = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         sort: {
            min_gross_profit_percentage: $stateParams.sort_minGrossProfitPercentage ? $stateParams.sort_minGrossProfitPercentage : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_SETTING_COMMISSION, function() {
         getIndex(vm.filtering);
      });

      // METHODS
      vm.refresh                      = refresh;
      vm.getIndex                     = getIndex;
      vm.create                       = create;
      vm.edit                         = edit;
      vm.sortMinGrossProfitPercentage = sortMinGrossProfitPercentage;
      vm.deleteConfirmation           = deleteConfirmation;
      vm.filter                       = filter;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getIndex(vm.filtering);
      checkUserPrivileges();

      function getIndex(params) {
         SettingService.getCommission(params, getData);

         function getData(status, response) {
            if (status) {
               vm.commissions  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission/guide-modal/guide-modal.html',
            controller: 'CommissionSettingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function create() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission/create-modal/create-modal.html',
            controller: 'CreateCommissionSettingModalController',
            controllerAs: 'vm'
         });
      }

      function edit(commission) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/setting/commission/update-modal/update-modal.html',
            controller: 'UpdateCommissionSettingModalController',
            controllerAs: 'vm',
            resolve: {
               settingDependent: function () {
                  return {
                     commission: commission
                  };
               }
            }
         });
      }

      function deleteConfirmation(commission, event) {
         SweetAlert.swal({
           title: 'Hapus commission setting?',
           text: '',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteSetting(commission, event);
            }
         });
      }

      function deleteSetting(commission, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         SettingService.removeCommission(commission.hash_id, function(status, data) {
            if (status) {
               getIndex(vm.filtering);
               SweetAlert.swal('Sukses', 'Commission setting berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.COMMISSION_SETTING_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.COMMISSION_SETTING_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function refresh() {
         vm.commissions = [];

         getIndex(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortMinGrossProfitPercentage(value) {
        if (value === 'desc') {
          vm.filtering.sort.min_gross_profit_percentage = 'asc';
        } else {
          vm.filtering.sort.min_gross_profit_percentage = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/setting/commission?search=' + vm.filtering.search +
            '&sort_minGrossProfitPercentage=' + vm.filtering.sort.min_gross_profit_percentage +
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.role', []);
})();

(function() {
   'use strict';

   angular
      .module('app.role')
      .controller('UpdateRoleModalController', UpdateRoleModalController);

   UpdateRoleModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'roleDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function UpdateRoleModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      RoleService,
      roleDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data = {
         name: roleDependent.role.name,
         role_privileges: roleDependent.role.role_privileges
      };

      vm.privileges = RoleService.privileges;
      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.update = update;

      $scope.$on(constants.BROADCAST.INDEX_PRIVILEGE, function() {
         vm.privileges = RoleService.privileges;
      });

      function update(event) {
         var params     = {
            name: vm.data.name,
            role_privileges: []
         };
         var privileges = [];
console.log(vm.data.role_privileges)
         angular.forEach(vm.data.role_privileges, function(value, key) {
            privileges.push(value.hash_id);
         });

         params.role_privileges = privileges;
         
         requestHelper.before(event, 'Menyimpan data');
         
         RoleService.updateRole(params, roleDependent.role.hash_id, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_ROLE);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.role')
      .controller('RoleGuideModalController', RoleGuideModalController);

   RoleGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function RoleGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      RoleService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      getPrivilegesGuide();

      function getPrivilegesGuide() {
         RoleService.getPrivileges(null, function(status, data) {
            if (status) {
               vm.guides = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.role')
      .controller('CreateRoleModalController', CreateRoleModalController);

   CreateRoleModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateRoleModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      RoleService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data       = {};
      vm.privileges = RoleService.privileges;
      vm.constants  = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      console.log(vm.privileges);

      $scope.$on(constants.BROADCAST.INDEX_PRIVILEGE, function() {
         vm.privileges = RoleService.privileges;
      });

      function create(event) {
         var params     = {
            name: vm.data.name,
            role_privileges: []
         };
         var privileges = [];

         angular.forEach(vm.data.role_privileges, function(value, key) {
            privileges.push(value.hash_id);
         });

         params.role_privileges = privileges;
         
         requestHelper.before(event, 'Menyimpan data');
         
         RoleService.createRole(params, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_ROLE);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.referral', []);
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .controller('UpdateReferralModalController', UpdateReferralModalController);

   UpdateReferralModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'ReferralService',
      'constants',
      'validator',
      'requestHelper',
      'referralDependent',
      'globalState'
   ];

   function UpdateReferralModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      ReferralService,
      constants,
      validator,
      requestHelper,
      referralDependent,
      globalState
   ) {
      var vm = this;

      // params
      vm.referral  = referralDependent.referral;
      vm.constants = constants;

      vm.data = {
         name: angular.copy(vm.referral.name),
         email: angular.copy(vm.referral.email),
         phone: angular.copy(vm.referral.phone),
         address: angular.copy(vm.referral.address),
         description: angular.copy(vm.referral.description),
         bank_name: angular.copy(vm.referral.bank_name),
         bank_account_number: angular.copy(vm.referral.bank_account_number),
         bank_account_name: angular.copy(vm.referral.bank_account_name),
         commission_percentage: angular.copy(vm.referral.conversion.commission_percentage),
         is_active: globalState.encBool(vm.referral.is_active),
      };

      // methods
      vm.cancel = cancel;
      vm.update = update;

      function update(event) {
         vm.data.is_active = globalState.decBool(vm.data.is_active);
         
         requestHelper.before(event, 'Menyimpan data');

         ReferralService.updateReferral(vm.referral.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_REFERRAL);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'referral.index',
         config: {
            url: '?search&filter_isActive&sort_referralsCreatedAt&sort_referralsIsActive&page',
            templateUrl: 'app/referral/index/index.html',
            controllerAs: 'ReferralController as vm',
            title: 'Referral'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .controller('ReferralController', ReferralController);

   ReferralController.$inject = [
      '$state',
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'ReferralService',
      'globalState'
   ];

   /* @ngInject */
   function ReferralController(
      $state,
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      ReferralService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.referrals   = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         create: false,
         update: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         filter: {
            is_active: $stateParams.filter_isActive ? $stateParams.filter_isActive : ''
         },
         sort: {
            'referrals.created_at': $stateParams.sort_referralsCreatedAt ? $stateParams.sort_referralsCreatedAt : '',
            'referrals.is_active': $stateParams.sort_referralsIsActive ? $stateParams.sort_referralsIsActive : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_REFERRAL, function() {
         getReferrals(vm.filtering);
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getReferrals               = getReferrals;
      vm.createReferral             = createReferral;
      vm.editReferral               = editReferral;
      vm.sortStatus                 = sortStatus;
      vm.sortDate                   = sortDate;
      vm.deleteReferralConfirmation = deleteReferralConfirmation;
      vm.filter                     = filter;
      vm.showDetail                 = showDetail;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getReferrals(vm.filtering);
      checkUserPrivileges();

      function getReferrals(params) {
         ReferralService.getReferral(params, getData);

         function getData(status, response) {
            if (status) {
               vm.referrals  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/referral/guide-modal/guide-modal.html',
            controller: 'ReferralGuideModalController',
            controllerAs: 'vm'
         });
      }

      function showDetail(referral) {
         $state.go('referral.detail', {'referralHashId': referral.hash_id, 'referral': referral});
      }

      function createReferral() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/referral/create-modal/create-modal.html',
            controller: 'CreateReferralModalController',
            controllerAs: 'vm'
         });
      }

      function editReferral(referral) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/referral/update-modal/update-modal.html',
            controller: 'UpdateReferralModalController',
            controllerAs: 'vm',
            resolve: {
               referralDependent: function () {
                  return {
                     referral: referral
                  };
               }
            }
         });
      }

      function deleteReferralConfirmation(referral, event) {
         SweetAlert.swal({
           title: 'Hapus Referral ' + referral.name + '?',
           text: 'Role ' + referral.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteReferral(referral, event);
            }
         });
      }

      function deleteReferral(referral, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         ReferralService.removeReferral(referral.hash_id, function(status, data) {
            if (status) {
               getReferrals(vm.filtering);
               SweetAlert.swal('Sukses', 'Referral berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            update: false
         }
      
         if (vm.user && vm.user.role && vm.user.role.name === constants.ROLE.SUPER_ADMIN) {
            vm.privileges.read   = true;
            vm.privileges.create = true;
            vm.privileges.update = true;
         }
      }

      function refresh() {
         vm.referrals = [];

         getReferrals(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortDate(value) {
        if (value === 'desc') {
          vm.filtering.sort['referrals.created_at'] = 'asc';
        } else {
          vm.filtering.sort['referrals.created_at'] = 'desc';
        }

        vm.filter();
      }

      function sortStatus(value) {
        if (value === 'desc') {
          vm.filtering.sort['referrals.is_active'] = 'asc';
        } else {
          vm.filtering.sort['referrals.is_active'] = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/referral?search=' + vm.filtering.search +
            '&filter_isActive=' + vm.filtering.filter.is_active + 
            '&sort_referralsCreatedAt=' + vm.filtering.sort['referrals.created_at'] + 
            '&sort_referralsIsActive=' + vm.filtering.sort['referrals.is_active'] + 
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('ReferralGuideModalController', ReferralGuideModalController);

   ReferralGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function ReferralGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'referral.detail',
         config: {
            url: '/:referralHashId',
            params: {'referral': null},
            templateUrl: 'app/referral/detail/detail.html',
            controllerAs: 'DetailReferralController as vm',
            title: 'Referral Detail'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('DetailReferralController', DetailReferralController);

   DetailReferralController.$inject = [
      '$filter',
      '$state',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'ReferralService',
      'globalState'
   ];

   /* @ngInject */
   function DetailReferralController(
      $filter,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      ReferralService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.referral    = $stateParams.referral;
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         admin: false
      }

      // HOOKS
      if (!vm.referral) {
         if ($stateParams.referralHashId) {
            showReferral($stateParams.referralHashId);
         } else {
            $state.go('referral.index');
         }
      }

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.DETAIL_REFERRAL, function(event, args) {
         vm.referral = args.referral;
      });

      // METHODS
      vm.payReferralCommission = payReferralCommission;

      checkUserPrivileges();

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(val, opt) {
               if (val.name === constants.PRIVILEGES.REFERRAL_READ) {
                  vm.privileges.read = true;
               } else if (val.name === constants.PRIVILEGES.REFERRAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function showReferral(referralHashId) {
         ReferralService.showReferral(referralHashId, function(status, data) {
            if (status) {
               vm.referral = data;
            } else {
               validator.validateAlert(data);
               $state.go('referral.index');
            }
         });
      }

      function payReferralCommission(commission, event) {

         SweetAlert.swal({
            title: 'Bayar Komisi?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Bayar',
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var today = new Date();
               var formattedDate = $filter('date')(today, 'yyyy-MM-dd');

               var parameters = {
                  commission_paid_at : formattedDate
               }

               ReferralService.payCommission(vm.referral.hash_id, commission.hash_id, parameters, function(status, data) {
                  if (status) {
                     SweetAlert.swal('Sukses', 'Komisi berhasil dibayarkan', 'success');
                     showReferral(vm.referral.hash_id);
                  } else {
                     validator.validateAlert(data);
                  }
               })
            }
         });
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .controller('CreateReferralModalController', CreateReferralModalController);

   CreateReferralModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'ReferralService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CreateReferralModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      ReferralService,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.data      = {
         is_active: true
      };
      vm.constants = constants;

      // methods
      vm.cancel = cancel;
      vm.create = create;

      function create(event) {
         requestHelper.before(event, 'Menyimpan data');

         ReferralService.storeReferral(vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_REFERRAL);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-save"></i> Simpan');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('ViewImageModalController', ViewImageModalController);

   ViewImageModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'quotationDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function ViewImageModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      quotationDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.image     = quotationDependent.image;
      vm.title     = quotationDependent.title;
      vm.constants = constants;

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'quotation.update',
         config: {
            url: '/update/:hashId',
            templateUrl: 'app/quotation/update/update.html',
            controllerAs: 'UpdateQuotationController as vm',
            title: 'Update Quotation'
         }
      }];
   }
})();

(function() {
  "use strict";

  angular
    .module("app.quotation")
    .controller("UpdateQuotationController", UpdateQuotationController);

  UpdateQuotationController.$inject = [
    "$state",
    "$rootScope",
    "$stateParams",
    "$scope",
    "$uibModal",
    "constants",
    "validator",
    "SweetAlert",
    "requestHelper",
    "QuotationService",
    "MaterialService",
    "UserService",
    "ReferralService",
    "TransportService",
    "globalState"
  ];

  /* @ngInject */
  function UpdateQuotationController(
    $state,
    $rootScope,
    $stateParams,
    $scope,
    $uibModal,
    constants,
    validator,
    SweetAlert,
    requestHelper,
    QuotationService,
    MaterialService,
    UserService,
    ReferralService,
    TransportService,
    globalState
  ) {
    var vm = this;

    // PARAMS
    vm.user = UserService.loggedInUser;
    vm.referrals = [];
    vm.transports = [];
    vm.referral = null;
    vm.quotation = null;
    vm.materialInk = MaterialService.materialInk;
    vm.materialPrinting = MaterialService.materialPrinting;
    vm.materialSlitting = MaterialService.materialSlitting;
    vm.materialPacking = MaterialService.materialPacking;
    vm.requiredMaterialPacking = [];
    vm.constants = constants;

    vm.data = {
      taxable: true,
      transport_cost_in_product: true,
      adjusted_price_in_product: true,
      quotation_terms: [],
      referral_hash_id: null,
      transport_type_hash_id: null,
      requested_price: null,
      quotation_products: []
    };

    vm.privileges = {
      update: false
    };

    vm._createProduct = {
      name: null,
      quantity: 1,
      width: null,
      length: null,
      printing_waste: null,
      laminating_waste: null,
      slitting_waste: null,
      printing_overhead_cost: null,
      laminating_overhead_cost: null,
      slitting_overhead_cost: null,
      notes: null,
      need_printing: 0,
      need_laminating: 0,
      need_slitting: 1,
      need_packing: 1,
      need_bag_making: 0,
      bag_width: 0,
      bag_length: 0,
      bag_overhead_cost: 0,
      price_per_bag: 0,
      is_cylinder: 0,
      cylinder_cost: 0,
      printing_material: {
        material: null,
        hash_id: null,
        thickness: null
      },
      printing_inks: [],
      inks_name: [],
      laminating_materials: [],
      slitting_materials: [],
      packing_materials: [],
      packing_materials_name: []
    };

    // HOOKS
    $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
      vm.user = UserService.loggedInUser;

      checkQuotationPrivileges();
    });

    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_INK, function() {
      vm.materialInk = MaterialService.materialInk;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PRINTING, function() {
      vm.materialPrinting = MaterialService.materialPrinting;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
      vm.materialSlitting = MaterialService.materialSlitting;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PACKING, function() {
      vm.requiredMaterialPacking = [];
      angular.forEach(MaterialService.materialPacking, function(value, key) {
        if (value.is_required) {
          vm.requiredMaterialPacking.push(value);
        }
      });

      vm.materialPacking = MaterialService.materialPacking;
    });

    $scope.$on(constants.BROADCAST.ADD_MATERIAL_LAMINATING_QUOTATION, function(
      event,
      args
    ) {
      vm._createProduct.laminating_materials.push(args.material);
    });

    $scope.$on(constants.BROADCAST.ADD_MATERIAL_SLITTING_QUOTATION, function(
      event,
      args
    ) {
      vm._createProduct.slitting_materials.push(args.material);
    });

    $scope.$on("ADD_TERM_FROM_TEMPLATE", function(event, args) {
      vm.data.quotation_terms.push({
        quotation_term_template_hash_id: args.term.hash_id,
        description: args.term.description
      });
    });

    $scope.$on("ADD_CUSTOM_TERM", function(event, args) {
      vm.data.quotation_terms.push({
        quotation_term_template_hash_id: null,
        description: args.term
      });
    });

    // METHODS
    vm.materialPrintingOnChange = materialPrintingOnChange;
    vm.materialSlittingOnChange = materialSlittingOnChange;
    vm.materialPackingOnChange = materialPackingOnChange;
    vm.inkOnChange = inkOnChange;
    vm.adjustedPriceOnChange = adjustedPriceOnChange;
    vm.addLaminatingMaterial = addLaminatingMaterial;
    vm.addSlittingMaterial = addSlittingMaterial;
    vm.referralOnSelect = referralOnSelect;
    vm.createProduct = createProduct;
    vm.deleteSelectedLaminatingMaterial = deleteSelectedLaminatingMaterial;
    vm.removeLaminatingMaterial = removeLaminatingMaterial;
    vm.removeSlittingMaterial = removeSlittingMaterial;
    vm.removeProductConfirmation = removeProductConfirmation;
    vm.editProduct = editProduct;
    vm.saveEditProduct = saveEditProduct;
    vm.cancelEditProduct = cancelEditProduct;
    vm.removeTerm = removeTerm;
    vm.getReferral = getReferral;
    vm.getTransport = getTransport;
    vm.updateQuotation = updateQuotation;
    vm.addTerm = addTerm;
    vm.addCustomTerm = addCustomTerm;
    vm.resetSlitting = resetSlitting;

    checkQuotationPrivileges();
    showQuotation();

    function resetSlitting() {
      vm._createProduct.slitting_materials[0].hash_id = "";
    }

    function editProduct(product, index) {
      var packing_materials = [];
      var packing_materials_name = [];
      vm.editedProductIndex = index;

      angular.forEach(product.packing_materials_name, function(value, key) {
        if (!value.is_required) {
          packing_materials.push(value.hash_id);
          packing_materials_name.push(value);
        }
      });

      vm._createProduct = angular.copy(product);
      vm._createProduct.packing_materials = packing_materials;
      vm._createProduct.packing_materials_name = packing_materials_name;

      $("#editProduct").removeClass("hidden");
      $("#addProductButton").addClass("hidden");
    }

    function saveEditProduct(event) {
      var element = $(event.currentTarget);
      var form = element.closest("form");

      angular.forEach(vm.requiredMaterialPacking, function(value, key) {
        vm._createProduct.packing_materials.push(value.hash_id);
        vm._createProduct.packing_materials_name.push(value);
      });

      vm.data.quotation_products[vm.editedProductIndex] = vm._createProduct;
      resetProduct();
    }

    function cancelEditProduct() {
      $("#editProduct").addClass("hidden");
      $("#addProductButton").removeClass("hidden");

      vm.editedProductIndex = null;
      resetProduct();
    }

    function checkQuotationPrivileges() {
      vm.privileges = {
        update: false
      };

      if (vm.user && vm.user.role) {
        var privileges = vm.user.role.role_privileges;

        $.each(privileges, function(index, val) {
          if (val.name === constants.PRIVILEGES.QUOTATION_UPDATE) {
            vm.privileges.update = true;
          }
        });
      }
    }

    function showQuotation() {
      QuotationService.showQuotation($stateParams.hashId, function(
        status,
        response
      ) {
        if (status) {
          vm.quotation = response;
          vm.referral = vm.quotation.quotation_informations.referral;

          vm.data.taxable = globalState.encBool(
            vm.quotation.quotation_informations.taxable
          );
          vm.data.transport_cost_in_product = globalState.encBool(
            vm.quotation.quotation_informations.transport_cost_in_product
          );
          vm.data.adjusted_price_in_product = globalState.encBool(
            vm.quotation.quotation_informations.adjusted_price_in_product
          );
          vm.data.transport_type_hash_id = vm.quotation.quotation_informations
            .transport_type
            ? vm.quotation.quotation_informations.transport_type.hash_id
            : null;
          vm.data.referral_hash_id = vm.quotation.quotation_informations
            .referral
            ? vm.quotation.quotation_informations.referral.hash_id
            : null;
          vm.data.requested_price =
            vm.quotation.quotation_informations.total_price;

          angular.forEach(
            vm.quotation.quotation_informations.quotation_terms,
            function(value, key) {
              vm.data.quotation_terms.push({
                quotation_term_template_hash_id: value.quotation_term_template
                  ? value.quotation_term_template.hash_id
                  : null,
                description: value.description,
                is_required: value.is_required
              });
            }
          );

          angular.forEach(
            vm.quotation.quotation_informations.quotation_products,
            function(value, key) {
              var product = angular.copy(vm._createProduct);

              product.name = value.name;
              product.total_price = value.total_price;
              product.quantity = value.quantity;
              product.width = value.conversion.width;
              product.length = value.conversion.length;
              product.printing_waste = value.conversion.printing_waste;
              product.laminating_waste = value.conversion.laminating_waste;
              product.slitting_waste = value.conversion.slitting_waste;
              product.printing_overhead_cost = value.conversion.printing_overhead_cost;
              product.laminating_overhead_cost = value.conversion.laminating_overhead_cost;
              product.slitting_overhead_cost = value.conversion.slitting_overhead_cost;
              product.notes = value.notes;
              product.is_cylinder = value.is_cylinder;
              product.cylinder_cost = value.cylinder_cost;
              product.bag_width = value.conversion.bag_width;
              product.bag_length = value.conversion.bag_length;
              product.bag_overhead_cost = value.conversion.bag_overhead_cost;
              product.price_per_bag = value.conversion.price_per_bag;
              product.need_printing = value.quotation_product_printing_materials
                .length
                ? true
                : false;
              product.need_laminating = value
                .quotation_product_laminating_materials.length
                ? true
                : false;
              product.need_slitting = value.quotation_product_slitting_materials
                .length
                ? true
                : false;
              product.need_packing = value.quotation_product_packing_materials
                .length
                ? true
                : false;
              product.need_bag_making = value.bag_width || value.bag_length || value.bag_overhead_cost || value.price_per_bag
                ? true
                : false;
              product.is_cylinder = value.is_cylinder
                ? true
                : false;

              if (product.need_printing) {
                angular.forEach(
                  value.quotation_product_printing_materials,
                  function(material, keyMaterial) {
                    product.printing_material.material =
                      material.printing_material;
                    product.printing_material.hash_id =
                      material.printing_material.hash_id;
                    product.printing_material.thickness =
                      material.conversion.thickness;
                  }
                );

                angular.forEach(value.quotation_product_printing_inks, function(
                  material,
                  keyMaterial
                ) {
                  product.printing_inks.push(material.printing_ink.hash_id);
                  product.inks_name.push(material.printing_ink);
                });
              }

              console.log(value.quotation_product_laminating_materials);

              if (product.need_laminating) {
                angular.forEach(
                  value.quotation_product_laminating_materials,
                  function(material, keyMaterial) {
                    product.laminating_materials.push({
                      material: material.laminating_material,
                      hash_id: material.laminating_material.hash_id,
                      thickness: material.conversion.thickness,
                      adhesive_usage_per_m2: material.conversion.adhesive_usage_per_m2
                    });
                  }
                );
              }

              if (product.need_slitting) {
                angular.forEach(
                  value.quotation_product_slitting_materials,
                  function(material, keyMaterial) {
                    product.slitting_materials.push({
                      material: material.slitting_material,
                      hash_id: material.slitting_material.hash_id,
                      slitting_length: material.slitting_length
                    });
                  }
                );
              }

              if (product.need_packing) {
                angular.forEach(
                  value.quotation_product_packing_materials,
                  function(material, keyMaterial) {
                    product.packing_materials.push(
                      material.packing_material.hash_id
                    );
                    product.packing_materials_name.push(
                      material.packing_material
                    );
                  }
                );
              }

              vm.data.quotation_products.push(product);
            }
          );
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function referralOnSelect(referral) {
      vm.referral = referral;
      vm.data.referral_hash_id = referral.hash_id;
    }

    function materialPrintingOnChange(item) {
      vm._createProduct.printing_material.hash_id = item.hash_id;
    }

    function materialSlittingOnChange(item) {
      vm._createProduct.slitting_materials[0].material = item;
    }

    function materialPackingOnChange(item) {
      vm._createProduct.packing_materials = [];

      angular.forEach(vm._createProduct.packing_materials_name, function(
        value,
        key
      ) {
        vm._createProduct.packing_materials.push(value.hash_id);
      });
    }

    function inkOnChange(item) {
      vm._createProduct.printing_inks = [];

      angular.forEach(vm._createProduct.inks_name, function(value, key) {
        vm._createProduct.printing_inks.push(value.hash_id);
      });
    }

    function adjustedPriceOnChange(item) {
      console.log(item);
    }

    function addTerm() {
      $uibModal.open({
        animation: true,
        templateUrl: "app/quotation/create/term-modal/term-modal.html",
        controller: "ChooseTermModalController",
        controllerAs: "vm"
      });
    }

    function addCustomTerm() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/custom-term-modal/custom-term-modal.html",
        controller: "ChooseCustomTermModalController",
        controllerAs: "vm"
      });
    }

    function addLaminatingMaterial() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/laminating-material-modal/laminating-material-modal.html",
        controller: "ChooseLaminatingMaterialModalController",
        controllerAs: "vm"
      });
    }

    function addSlittingMaterial() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/slitting-material-modal/slitting-material-modal.html",
        controller: "ChooseSlittingMaterialModalController",
        controllerAs: "vm"
      });
    }

    function deleteSelectedLaminatingMaterial(material) {
      for (
        var i = vm._createProduct.laminating_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.laminating_materials[i].hash_id == material.hash_id
        ) {
          vm._createProduct.laminating_materials.splice(i, 1);
        }
      }
    }

    function removeLaminatingMaterial(material) {
      for (
        var i = vm._createProduct.laminating_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.laminating_materials[i].material.hash_id ===
          material.material.hash_id
        ) {
          vm._createProduct.laminating_materials.splice(i, 1);
          break;
        }
      }
    }

    function removeSlittingMaterial(material) {
      for (
        var i = vm._createProduct.slitting_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.slitting_materials[i].material.hash_id ===
          material.material.hash_id
        ) {
          vm._createProduct.slitting_materials.splice(i, 1);
          break;
        }
      }
    }

    function removeTerm(term) {
      for (var i = vm.data.quotation_terms.length - 1; i >= 0; i--) {
        if (
          vm.data.quotation_terms[i].quotation_term_template_hash_id ===
          term.quotation_term_template_hash_id
        ) {
          vm.data.quotation_terms.splice(i, 1);
          break;
        }
      }
    }

    function createProduct(event) {
      angular.forEach(vm.requiredMaterialPacking, function(value, key) {
        vm._createProduct.packing_materials.push(value.hash_id);
        vm._createProduct.packing_materials_name.push(value);
      });

      vm.data.quotation_products.push(vm._createProduct);
      SweetAlert.swal(
        "Sukses",
        "Berhasil menambahkan produk. Silahkan lihat di bagian atas kiri.",
        "success"
      );
      resetProduct();
    }

    function resetProduct() {
      vm._createProduct = {
        name: null,
        quantity: 1,
        width: null,
        length: null,
        printing_waste: null,
        laminating_waste: null,
        slitting_waste: null,
        printing_overhead_cost: null,
        laminating_overhead_cost: null,
        slitting_overhead_cost: null,
        notes: null,
        need_printing: 0,
        need_laminating: 0,
        need_slitting: 1,
        need_packing: 1,
        need_bag_making: 0,
        bag_width: 0,
        bag_length: 0,
        bag_overhead_cost: 0,
        price_per_bag: 0,
        is_cylinder: 0,
        cylinder_cost: 0,
        printing_material: {
          material: null,
          hash_id: null,
          thickness: null
        },
        printing_inks: [],
        inks_name: [],
        laminating_materials: [],
        slitting_materials: [],
        packing_materials: [],
        packing_materials_name: []
      };
    }

    function removeProductConfirmation(product, index) {
      SweetAlert.swal(
        {
          title: "Hapus Produk " + product.name + "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: constants.COLOR.DANGER,
          confirmButtonText: "Hapus!",
          cancelButtonText: "Batalkan",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        },
        function(isConfirm) {
          if (isConfirm) {
            removeProduct(index);
          }
        }
      );
    }

    function removeProduct(index) {
      vm.data.quotation_products.splice(index, 1);
      SweetAlert.swal("Sukses", "Produk berhasil dihapus!", "success");
    }

    function getReferral(search) {
      var params = {
        search: search,
        filter: { is_active: 1 }
      };

      ReferralService.getReferral(params, function(status, response) {
        if (status) {
          vm.referrals = response.data;
          vm.referrals.unshift({
            name: "None",
            code: "None",
            hash_id: null
          });
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function getTransport(search) {
      var params = {
        search: search
      };

      TransportService.getTransport(params, function(status, response) {
        if (status) {
          vm.transports = response.data;
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function updateQuotation() {
      SweetAlert.swal(
        {
          title: "Simpan perubahan quotation?",
          text: "Status quotation akan kembali menjadi draft.",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Simpan!",
          cancelButtonText: "Batalkan",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        },
        function(isConfirm) {
          if (isConfirm) {
            QuotationService.updateQuotation(
              vm.quotation.hash_id,
              vm.data,
              function(status, data) {
                if (status) {
                  var quotation = data;

                  swal.close();
                  setTimeout(function(){ 
                    SweetAlert.swal(
                      "Sukses",
                      "Berhasil mengubah quotation.",
                      "success"
                    );
                    $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
                    $state.go("quotation.detail", {
                      quotationHashId: quotation.hash_id,
                      quotation: quotation
                    });
                  }, 500, constants, quotation);

                  SweetAlert.swal(
                    "Sukses",
                    "Berhasil mengubah quotation.",
                    "success"
                  );
                  $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
                  $state.go("quotation.detail", {
                    quotationHashId: quotation.hash_id,
                    quotation: quotation
                  });
                } else {
                  validator.validateAlert(data);
                }
              }
            );
          }
        }
      );
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('QuotationSubmitPOConfirmationModalController', QuotationSubmitPOConfirmationModalController);

   QuotationSubmitPOConfirmationModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationService',
      'quotationDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function QuotationSubmitPOConfirmationModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationService,
      quotationDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.title         = '';
      vm.constants     = constants;
      vm.contractImage = null;
      vm.poImage       = null;

      // methods
      vm.cancel      = cancel;
      vm.upload      = upload;
      vm.fileChanged = fileChanged;

      $scope.fileChanged = fileChanged;

      function upload(event) {
         var formData = new FormData();

         formData.append('image', $scope.poFile);

         requestHelper.before(event, 'Mengunggah');

         QuotationService.quotationSubmitPOConfirmation(quotationDependent.quotation.hash_id, formData, function(status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');
               $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
               $rootScope.$broadcast(constants.BROADCAST.DETAIL_QUOTATION);
            } else {
               $uibModalInstance.dismiss('cancel');
               validator.validateAlert(data);
            }
         }); 
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

        if ($scope.poFile) {
          if ($scope.poFile.type === 'application/pdf') {
            $($.parseHTML('<p>'+$scope.poFile.name+'</p>')).appendTo('div.poImage-container');
          } else {
            $('.poImage-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
              $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.poImage-container');
            };

            reader.readAsDataURL($scope.poFile);
          }
        }
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('QuotationLinkToPoModalController', QuotationLinkToPoModalController);

   QuotationLinkToPoModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationService',
      'quotationDependent',
      'constants',
      'validator',
      'requestHelper',
      'SweetAlert'
   ];

   function QuotationLinkToPoModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationService,
      quotationDependent,
      constants,
      validator,
      requestHelper,
      SweetAlert
   ) {
      var vm = this;

      // params
      vm.title         = '';
      vm.constants     = constants;
      vm.contractImage = null;
      vm.poImage       = null;
      vm.poNumber      = quotationDependent.quotation.purchase_order_number;

      // methods
      vm.cancel      = cancel;
      vm.upload      = upload;
      vm.fileChanged = fileChanged;

      $scope.fileChanged = fileChanged;

      function upload(event) {
         SweetAlert.swal({
            title: 'Submit PO?',
            text: 'Pastikan untuk update Quotation agar sama dengan PO yang diupload.',
            html: true,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: constants.COLOR.DANGER,
            confirmButtonText: "Submit PO",
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var formData = new FormData();

               formData.append('image', $scope.poFile);
               formData.append('purchase_order_number', vm.poNumber);

               requestHelper.before(event, 'Mengunggah');

               QuotationService.quotationSubmitPO(quotationDependent.quotation.hash_id, formData, function(status, data) {
                  if (status) {
                     $uibModalInstance.dismiss('cancel');
                     SweetAlert.swal('Sukses', 'PO berhasil disubmit!', 'success');
                     $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
                     $rootScope.$broadcast(constants.BROADCAST.DETAIL_QUOTATION);
                  } else {
                     $uibModalInstance.dismiss('cancel');
                     validator.validateAlert(data);
                  }
               });    
            }
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }

      function fileChanged(event) {

        if ($scope.poFile) {
          console.log($scope.poFile);
          if ($scope.poFile.type === 'application/pdf') {
            $($.parseHTML('<p>'+$scope.poFile.name+'</p>')).appendTo('div.poImage-container');
          } else {
            $('.poImage-container').html('');

            var reader = new FileReader();

            reader.onload = function(e){
              $($.parseHTML('<img class="m-b-xs" style="max-width: 100%; display: inline-block;">')).attr('src', e.target.result).appendTo('div.poImage-container');
            };

            reader.readAsDataURL($scope.poFile);
          }
        }
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'quotation.index',
         config: {
            url: '?search&filter_status&sort_quotationInformationsCreatedAt&sort_quotationInformationsStatus&page',
            templateUrl: 'app/quotation/index/index.html',
            controllerAs: 'IndexQuotationController as vm',
            title: 'Quotation'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('IndexQuotationController', IndexQuotationController);

   IndexQuotationController.$inject = [
      '$location',
      '$stateParams',
      '$state',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'globalState',
      'QuotationService',
      'UserService'
   ];

   /* @ngInject */
   function IndexQuotationController(
      $location,
      $stateParams,
      $state,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      globalState,
      QuotationService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user       = UserService.loggedInUser;
      vm.quotations = [];
      vm.constants  = constants;

      vm.privileges = {
        read: false,
        create: false,
        update: false,
        delete: false,
        submit: false,
        approveQuotation: false,
        approvePO: false
      }

      vm.filtering  = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         filter: {
            status: $stateParams.filter_status ? $stateParams.filter_status : ''
         },
         sort: {
            'quotation_informations.created_at': $stateParams.sort_quotationInformationsCreatedAt ? $stateParams.sort_quotationInformationsCreatedAt : '',
            'quotation_informations.status': $stateParams.sort_quotationInformationsStatus ? $stateParams.sort_quotationInformationsStatus : ''
         },
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkQuotationPrivileges();
      });
      $scope.$on(constants.BROADCAST.INDEX_QUOTATION, function() {
         getQuotations(vm.filtering);
      });

      // METHODS
      vm.setTime = globalState.setTime;

      vm.refresh               = refresh;
      vm.getQuotations         = getQuotations;
      vm.createQuotation       = createQuotation;
      vm.editQuotation         = editQuotation;
      vm.showQuotation         = showQuotation;
      vm.submit                = submit;
      vm.approve               = approve;
      vm.linkToPo              = linkToPo;
      vm.approvePO             = approvePO;
      vm.submitPOCOnfirmation  = submitPOCOnfirmation;
      vm.approvePOCOnfirmation = approvePOCOnfirmation;
      vm.rejectPO              = rejectPO;
      vm.reject                = reject;
      vm.sortDate              = sortDate;
      vm.sortStatus            = sortStatus;
      vm.filter                = filter;
      vm.deleteQuotation       = deleteQuotation;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getQuotations(vm.filtering);
      checkQuotationPrivileges();

      function checkQuotationPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            update: false,
            delete: false,
            submit: false,
            approveQuotation: false,
            approvePO: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.QUOTATION_READ) {
                  vm.privileges.read = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_CREATE) {
                  vm.privileges.create = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_UPDATE) {
                  vm.privileges.update = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_DELETE) {
                  vm.privileges.delete = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_SUBMIT) {
                  vm.privileges.submit = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_APPROVE_QUOTATION) {
                  vm.privileges.approveQuotation = true;
               } else if(val.name === constants.PRIVILEGES.QUOTATION_APPROVE_PO) {
                  vm.privileges.approvePO = true;
               }
            });
         }
      }

      function getQuotations(params) {
         QuotationService.getQuotations(params, function(status, response) {
            if (status) {
               vm.quotations  = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/quotation/guide-modal/guide-modal.html',
            controller: 'QuotationGuideModalController',
            controllerAs: 'vm'
         });
      }

      function createQuotation(user) {
         $state.go('quotation.create');
      }

      function editQuotation(quotation) {
         $state.go('quotation.update', {'hashId': quotation.hash_id, 'quotation': quotation});
      }

      function showQuotation(quotation) {
         $state.go('quotation.detail', {'quotationHashId': quotation.hash_id, 'quotation': quotation});
      }

      function submit(quotation) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/quotation/customer-modal/customer-modal.html',
            controller: 'ChooseCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               quotationDependent: function () {
                  return {
                     quotation: quotation
                  };
               }
            }
         });
      }

      function approve(quotation) {
         SweetAlert.swal({
           title: 'Approve Quotation?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Approve",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               QuotationService.approveQuotation(quotation.hash_id, params, function(status, response) {
                  if (status) {
                    SweetAlert.swal('Sukses', 'Quotation berhasil diapprove!', 'success');
                     getQuotations(vm.filtering);
                  }
               });
            }
         });
      }

      function reject(quotation) {
         SweetAlert.swal({
           title: 'Reject Quotation?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Reject",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               QuotationService.rejectQuotation(quotation.hash_id, params, function(status, response) {
                  if (status) {
                    SweetAlert.swal('Sukses', 'Quotation berhasil direject!', 'success');
                     getQuotations(vm.filtering);
                  }
               });
            }
         });
      }

      function linkToPo(quotation) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/quotation/link-to-po/link-to-po.html',
            controller: 'QuotationLinkToPoModalController',
            controllerAs: 'vm',
            resolve: {
               quotationDependent: function () {
                  return {
                     quotation: quotation
                  };
               }
            }
         });
      }

      function approvePO(quotation) {
         SweetAlert.swal({
           title: 'Approve PO?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Approve PO",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               QuotationService.quotationApprovePO(quotation.hash_id, params, function(status, response) {
                  if (status) {
                    SweetAlert.swal('Sukses', 'PO berhasil diapprove!', 'success');
                     getQuotations(vm.filtering);
                  }
               });
            }
         });
      }

      function submitPOCOnfirmation(quotation) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/quotation/submit-po-confirmation/submit-po-confirmation.html',
            controller: 'QuotationSubmitPOConfirmationModalController',
            controllerAs: 'vm',
            resolve: {
               quotationDependent: function () {
                  return {
                     quotation: quotation
                  };
               }
            }
         });
      }

      function approvePOCOnfirmation(quotation) {
         SweetAlert.swal({
           title: 'Approve PO Confirmation?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Approve PO Confirmation",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               QuotationService.quotationApprovePOConfirmation(quotation.hash_id, params, function(status, response) {
                  if (status) {
                    SweetAlert.swal('Sukses', 'PO Confirmation berhasil diapprove!', 'success');
                     getQuotations(vm.filtering);
                  }
               });
            }
         });
      }

      function rejectPO(quotation) {
        console.log('asdasd');
         SweetAlert.swal({
           title: 'Reject PO?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Reject PO",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var params = {
                  discussion_description: $('#swal-description').val()
               }
               QuotationService.quotationRejectPO(quotation.hash_id, params, function(status, response) {
                  if (status) {
                    SweetAlert.swal('Sukses', 'PO berhasil direject!', 'success');
                     getQuotations(vm.filtering);
                  }
               });
            }
         });
      }

      function deleteQuotation(quotation) {
        SweetAlert.swal({
          title: 'Hapus Quotation?',
          text: '',
          html: true,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: constants.COLOR.DANGER,
          confirmButtonText: "Hapus",
          cancelButtonText: 'Batalkan',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function(isConfirm){
          if (isConfirm) {
            QuotationService.deleteQuotation(quotation.hash_id, function(status, response) {
              if (status) {

                SweetAlert.swal('Sukses', 'Quotation berhasil dihapus!', 'success');
                getQuotations(vm.filtering);
                $state.go('quotation.index');
              }
            });
          }
        });
      }

      function refresh() {
         vm.quotations = [];

         getQuotations(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function sortDate(value) {
        if (value === 'desc') {
          vm.filtering.sort['quotation_informations.created_at'] = 'asc';
        } else {
          vm.filtering.sort['quotation_informations.created_at'] = 'desc';
        }

        vm.filter();
      }

      function sortStatus(value) {
        if (value === 'desc') {
          vm.filtering.sort['quotation_informations.status'] = 'asc';
        } else {
          vm.filtering.sort['quotation_informations.status'] = 'desc';
        }

        vm.filter();
      }

      function filter() {
         $location.url(
            '/quotation?search=' + vm.filtering.search +
            '&filter_status=' + vm.filtering.filter.status + 
            '&sort_quotationInformationsCreatedAt=' + vm.filtering.sort['quotation_informations.created_at'] + 
            '&sort_quotationInformationsStatus=' + vm.filtering.sort['quotation_informations.status'] + 
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('QuotationGuideModalController', QuotationGuideModalController);

   QuotationGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function QuotationGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('QuotationDownloadPOConfirmationModalController', QuotationDownloadPOConfirmationModalController);

   QuotationDownloadPOConfirmationModalController.$inject = [
      '$http',
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationService',
      'quotationDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function QuotationDownloadPOConfirmationModalController(
      $http,
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationService,
      quotationDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.quotation = quotationDependent.quotation;
      vm.constants = constants;
      vm.data      = {
         type: 'kg',
         purchase_order_date: null
      };

      // methods
      vm.cancel      = cancel;
      vm.download    = download;

      $scope.PODateChanged = PODateChanged;

      // 27 Nov 2017
      // ga jadi pake date, di .html dicommented
      function PODateChanged() {
         vm.data.purchase_order_date = vm.data.purchase_order_date.format('YYYY-MM-DD');
      }

      function download(event) {
         
         requestHelper.before(event, 'Downloading...');

         // https://stackoverflow.com/a/27442914
         $http({
            url: constants.API_URL + '/quotation/' + vm.quotation.hash_id + '/download/purchase-order-confirmation',
            method: "POST",
            data: vm.data, //this is your json data string
            headers: {
               'Authorization': window.localStorage.getItem(constants.AUTHORIZATION_ADMIN_HEADER)
            },
            responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
            var blob = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(blob);
            var a         = document.createElement('a');
            a.href        = fileURL; 
            a.target      = '_self';
            a.download    = 'Innapack-PO-Confirmation-' + vm.quotation.quotation_revision_number + '.pdf';
            document.body.appendChild(a);
            a.click();
         
            requestHelper.after(event, '<i class="fa fa-save"></i> Download');
            cancel();
        }).error(function (data, status, headers, config) {
            //upload failed
        });

      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .controller('QuotationDownloadQuotationModalController', QuotationDownloadQuotationModalController);

   QuotationDownloadQuotationModalController.$inject = [
      '$http',
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'QuotationService',
      'quotationDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function QuotationDownloadQuotationModalController(
      $http,
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      QuotationService,
      quotationDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.quotation = quotationDependent.quotation;
      vm.constants = constants;
      vm.data      = {
        type: 'kg'
      };

      // methods
      vm.cancel      = cancel;
      vm.download    = download;

      function download(event) {
         
         requestHelper.before(event, 'Downloading...');

         // https://stackoverflow.com/a/27442914
         $http({
            url: constants.API_URL + '/quotation/' + vm.quotation.hash_id + '/download/quotation',
            method: "POST",
            data: vm.data, //this is your json data string
            headers: {
               'Authorization': window.localStorage.getItem(constants.AUTHORIZATION_ADMIN_HEADER)
            },
            responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
            var blob = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(blob);
            var a         = document.createElement('a');
            a.href        = fileURL; 
            a.target      = '_self';
            a.download    = 'Innapack-Quotation-' + vm.quotation.quotation_revision_number + '.pdf';
            document.body.appendChild(a);
            a.click();
         
            requestHelper.after(event, '<i class="fa fa-save"></i> Download');
            cancel();
        }).error(function (data, status, headers, config) {
            //upload failed
        });

      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'quotation.detail',
         config: {
            url: '/detail/:quotationHashId',
            params: {'quotation': null},
            templateUrl: 'app/quotation/detail/detail.html',
            controllerAs: 'DetailQuotationController as vm',
            title: 'Quotation Detail'
         }
      }];
   }
})();

(function() {
	'use-strict';

	angular
	.module('app.quotation')
	.controller('DetailQuotationController', DetailQuotationController);

	DetailQuotationController.$inject = [
	'$http',
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$uibModal',
	'validator',
	'SweetAlert',
	'constants',
	'MaterialService',
	'QuotationService',
	'UserService',
	'globalState'
	];

	function DetailQuotationController(
		$http,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$uibModal,
		validator,
		SweetAlert,
		constants,
		MaterialService,
		QuotationService,
		UserService,
		globalState
		) {
		var vm = this;

		// PARAMS
		vm.user             = UserService.loggedInUser;
		vm.quotation        = $stateParams.quotation;
		vm.constants        = constants;
		vm.globalState      = globalState;
		vm.customer         = null;
		vm.materialInk      = MaterialService.materialInk;
		vm.materialPrinting = MaterialService.materialPrinting;
		vm.materialSlitting = MaterialService.materialSlitting;
		vm.materialPacking  = MaterialService.materialPacking;

		vm.privileges = {
			read: false,
	        create: false,
	        update: false,
	        delete: false,
	        submit: false,
	        approveQuotation: false,
	        approvePO: false
		}

		vm._createProduct = {
			product_name: null,
			width: null,
			length: null,
			slitting_length: null,
			need_printing: 0,
			need_laminating: 0,
			need_slitting: 0,
			need_packing: 0,
			printing_materials: {
				hash_id: null,
				thickness: null
			},
			inks: [],
			laminating_materials: [],
			slitting_materials: null,
			packing_materials: []
		}

		// HOOKS
		if (!vm.quotation) {
			if ($stateParams.quotationHashId) {
				showQuotation($stateParams.quotationHashId);
			} else {
				$state.go('quotation.index');
			}
		} else {
			showQuotation($stateParams.quotationHashId);
		}

		$scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
			vm.user = UserService.loggedInUser;

			checkQuotationPrivileges();
		});

		$scope.$on(constants.BROADCAST.DETAIL_QUOTATION, function() {
			showQuotation($stateParams.quotationHashId);
		});

		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_INK, function() {
			vm.materialInk = MaterialService.materialInk;
		});
		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_PRINTING, function() {
			vm.materialPrinting = MaterialService.materialPrinting;
		});
		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
			vm.materialSlitting = MaterialService.materialSlitting;
		});
		$scope.$on(constants.BROADCAST.INDEX_MATERIAL_PACKING, function() {
			vm.materialPacking = MaterialService.materialPacking;

			var material = MaterialService.material;

			angular.forEach(material, function(value, key) {
				if (value === vm.materialPacking.hash_id) {
					vm.materialPacking.name   = value.name;
					vm.materialPacking.length = value.length;
					vm.materialPacking.width  = value.width;
				}
			});
		});

		$scope.$on(constants.BROADCAST.ADD_MATERIAL_LAMINATING_QUOTATION, function(event, args) {
			vm._createProduct.laminating_materials.push(args.material);
		});
		$scope.$on(constants.BROADCAST.CHOOSE_CUSTOMER, function(event, args) {
			vm.customer = args.customer;

			saveQuotationConfirmation();
		});

		// Methods
		vm.confirmCreateProduct     = confirmCreateProduct;
		vm.addLaminatingMaterial    = addLaminatingMaterial;
		vm.removeLaminatingMaterial = removeLaminatingMaterial;
		vm.saveQuotationStep        = saveQuotationStep;
		vm.submit                   = submit;
		vm.approve                  = approve;
		vm.linkToPo                 = linkToPo;
		vm.approvePO                = approvePO;
		vm.submitPOCOnfirmation     = submitPOCOnfirmation;
		vm.approvePOCOnfirmation    = approvePOCOnfirmation;
		vm.rejectPO                 = rejectPO;
		vm.reject                   = reject;
		vm.editQuotation            = editQuotation;
		vm.deleteQuotation          = deleteQuotation;
		vm.downloadQuotation        = downloadQuotation;
		vm.downloadPOConfirmation   = downloadPOConfirmation;
		vm.showImage                = showImage;

		function downloadQuotation(event) {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/download-quotation/download-quotation.html',
				controller: 'QuotationDownloadQuotationModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							quotation: vm.quotation
						};
					}
				}
			});
		}

		// function downloadQuotation(event) {
		// 	var element = $(event.currentTarget);

		// 	// https://stackoverflow.com/a/27442914
		// 	$http({
		// 	    url: constants.API_URL + '/quotation/' + vm.quotation.hash_id + '/download/quotation',
		// 	    method: "POST",
		// 	    data: {}, //this is your json data string
		// 	    headers: {
		// 	       'Authorization': window.localStorage.getItem(constants.AUTHORIZATION_ADMIN_HEADER)
		// 	    },
		// 	    responseType: 'arraybuffer'
		// 	}).success(function (data, status, headers, config) {
		// 	    var blob = new Blob([data], { type: 'application/pdf' });
		// 	    var fileURL = URL.createObjectURL(blob);
		// 	    var a         = document.createElement('a');
		// 	    a.href        = fileURL; 
		// 	    a.target      = '_self';
		// 	    a.download    = 'Innapack-Quotation-' + vm.quotation.quotation_revision_number + '.pdf';
		// 	    document.body.appendChild(a);
		// 	    a.click();
		// 	}).error(function (data, status, headers, config) {
		// 	    //upload failed
		// 	});
		// }

		function downloadPOConfirmation(event) {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/download-po-confirmation/download-po-confirmation.html',
				controller: 'QuotationDownloadPOConfirmationModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							quotation: vm.quotation
						};
					}
				}
			});
		}

		function editQuotation() {
			$state.go('quotation.update', {'hashId': vm.quotation.hash_id, 'quotation': vm.quotation});
		}

		function submit() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/customer-modal/customer-modal.html',
				controller: 'ChooseCustomerModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							quotation: vm.quotation
						};
					}
				}
			});
		}

		function showImage(image, title) {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/view-image-modal/view-image-modal.html',
				controller: 'ViewImageModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							image: image,
							title: title
						};
					}
				}
			});
		}

		function approve() {
			SweetAlert.swal({
				title: 'Approve Quotation?',
				text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Approve",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					var params = {
						discussion_description: $('#swal-description').val()
					}
					QuotationService.approveQuotation(vm.quotation.hash_id, params, function(status, response) {
						if (status) {
							SweetAlert.swal('Sukses', 'Quotation berhasil diapprove!', 'success');
							showQuotation($stateParams.quotationHashId);
						}
					});
				}
			});
		}

		function reject() {
			SweetAlert.swal({
				title: 'Reject Quotation?',
				text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Reject",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm) {
				if (isConfirm) {
					var params = {
						discussion_description: $('#swal-description').val()
					}
					QuotationService.rejectQuotation(vm.quotation.hash_id, params, function(status, response) {
						if (status) {
							SweetAlert.swal('Sukses', 'Quotation berhasil direject!', 'success');
							showQuotation($stateParams.quotationHashId);
						}
					});
				}
			});
		}

		function linkToPo() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/link-to-po/link-to-po.html',
				controller: 'QuotationLinkToPoModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							quotation: vm.quotation
						};
					}
				}
			});
		}

		function approvePO() {
			SweetAlert.swal({
				title: 'Approve PO?',
				text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Approve PO",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					var params = {
						discussion_description: $('#swal-description').val()
					}
					QuotationService.quotationApprovePO(vm.quotation.hash_id, params, function(status, response) {
						if (status) {
							SweetAlert.swal('Sukses', 'PO berhasil diapprove!', 'success');
							showQuotation($stateParams.quotationHashId);
						}
					});
				}
			});
		}

		function submitPOCOnfirmation() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/submit-po-confirmation/submit-po-confirmation.html',
				controller: 'QuotationSubmitPOConfirmationModalController',
				controllerAs: 'vm',
				resolve: {
					quotationDependent: function () {
						return {
							quotation: vm.quotation
						};
					}
				}
			});
		}

		function approvePOCOnfirmation() {
			SweetAlert.swal({
				title: 'Approve PO Confirmation?',
				text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Approve PO Confirmation",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					var params = {
						discussion_description: $('#swal-description').val()
					}
					QuotationService.quotationApprovePOConfirmation(vm.quotation.hash_id, params, function(status, response) {
						if (status) {
							SweetAlert.swal('Sukses', 'PO Confirmation berhasil diapprove!', 'success');
							showQuotation($stateParams.quotationHashId);
						}
					});
				}
			});
		}

		function rejectPO() {
			console.log('asdasd');
			SweetAlert.swal({
				title: 'Reject PO?',
				text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Reject PO",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					var params = {
						discussion_description: $('#swal-description').val()
					}
					QuotationService.quotationRejectPO(vm.quotation.hash_id, params, function(status, response) {
						if (status) {
							SweetAlert.swal('Sukses', 'PO berhasil direject!', 'success');
							showQuotation($stateParams.quotationHashId);
						}
					});
				}
			});
		}

		function deleteQuotation() {
			SweetAlert.swal({
				title: 'Hapus Quotation?',
				text: '',
				html: true,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: constants.COLOR.DANGER,
				confirmButtonText: "Hapus",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					QuotationService.deleteQuotation(vm.quotation.hash_id, function(status, response) {
						if (status) {

							SweetAlert.swal('Sukses', 'Quotation berhasil dihapus!', 'success');
							$state.go('quotation.index');
						}
					});
				}
			});
		}

		function checkQuotationPrivileges() {
			vm.privileges = {
				read: false,
		        create: false,
		        update: false,
		        delete: false,
		        submit: false,
		        approveQuotation: false,
		        approvePO: false
			}

			if (vm.user && vm.user.role) {
				var privileges = vm.user.role.role_privileges;

				$.each(privileges, function(index, val) {
	               if (val.name === constants.PRIVILEGES.QUOTATION_READ) {
	                  vm.privileges.read = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_CREATE) {
	                  vm.privileges.create = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_UPDATE) {
	                  vm.privileges.update = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_DELETE) {
	                  vm.privileges.delete = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_SUBMIT) {
	                  vm.privileges.submit = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_APPROVE_QUOTATION) {
	                  vm.privileges.approveQuotation = true;
	               } else if(val.name === constants.PRIVILEGES.QUOTATION_APPROVE_PO) {
	                  vm.privileges.approvePO = true;
	               }
	            });
			}
		}

		function showQuotation(quotationHashId) {
			QuotationService.showQuotation(quotationHashId, function(status, data) {
				if (status) {
					vm.quotation = data;
					checkQuotationPrivileges();
				} else {
					validator.validateAlert(data);
					$state.go('quotation.index');
				}
			});
		}

		function addLaminatingMaterial() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/create/laminating-material-modal/laminating-material-modal.html',
				controller: 'ChooseLaminatingMaterialModalController',
				controllerAs: 'vm'
			});
		}

		function removeLaminatingMaterial(material) {
			for (var i = vm._createProduct.laminating_materials.length - 1; i >= 0; i--) {
				if (vm._createProduct.laminating_materials[i].material.hash_id === material.material.hash_id) {
					vm._createProduct.laminating_materials.splice(i,1);
					break;
				}
			}
		}

		function confirmCreateProduct(event) {
			SweetAlert.swal({
				title: 'Simpan Produk ' + vm._createProduct.product_name + '?',
				text: 'Produk ini akan ditambahkan pada quotation #' + vm.quotation.hash_id,
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Simpan",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					createProduct(event);
				}
			});
		}

		function createProduct(event) {
			QuotationService.createProduct(vm._createProduct, vm.quotation.hash_id, function(status, data) {
				if (status) {
					SweetAlert.swal('Sukses', 'Produk berhasil ditambahkan!', 'success');

					vm._createProduct = {
						product_name: null,
						width: null,
						length: null,
						slitting_length: null,
						need_printing: 0,
						need_laminating: 0,
						need_slitting: 0,
						need_packing: 0,
						printing_materials: {
							hash_id: null,
							thickness: null
						},
						inks: [],
						laminating_materials: [],
						slitting_materials: null,
						packing_materials: []
					}

					showQuotation(vm.quotation.hash_id);
				} else {
					validator.validateAlert(data);
				}
			});
		}

		function saveQuotationStep() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/quotation/create/customer-modal/customer-modal.html',
				controller: 'ChooseCustomerModalController',
				controllerAs: 'vm'
			});
		}

		function saveQuotationConfirmation() {
			SweetAlert.swal({
				title: 'Simpan Quotation ' + vm.quotation.hash_id + '?',
				text: 'setelah disimpan, status quotation #' + vm.quotation.hash_id + ' akan berubah menjadi saved dan tidak bisa di tambahkan produk baru.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Simpan",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					saveQuotation();
				}
			});
		}

		function saveQuotation() {
			var parameters = {
				customer: vm.customer ? vm.customer.hash_id : ''
			}

			QuotationService.saveQuotation(parameters, vm.quotation.hash_id, function(status, data) {
				if (status) {
					SweetAlert.swal('Sukses', 'Quotation berhasil ditambahkan!', 'success');
					$rootScope.$broadcast(constants.BROADCAST.SAVE_QUOTATION_SUCCESS, {quotation: data.result});
				} else {
					validator.validateAlert(data);
				}
			});
		}
	}
})();
(function() {
	'use-strict';

	angular
		.module('app.quotation')
		.controller('ChooseCustomerModalController', ChooseCustomerModalController);

	ChooseCustomerModalController.$inject = [
		'$rootScope',
		'$scope',
		'$state',
		'$uibModalInstance',
		'validator',
		'constants',
		'CustomerService',
		'QuotationService',
		'requestHelper',
		'quotationDependent'
	];

	/* @ngInject */
	function ChooseCustomerModalController(
		$rootScope,
		$scope,
		$state,
		$uibModalInstance,
		validator,
		constants,
		CustomerService,
		QuotationService,
		requestHelper,
		quotationDependent
	){
		var vm = this;

		// Params
		vm.quotation        = quotationDependent.quotation;
		vm.customers        = [];

		vm.data = {
			customer_hash_id: null
		}

		// Methods
		vm.getCustomer = getCustomer;
		vm.submit      = submit;
		vm.cancel      = cancel;

		function getCustomer(search) {
			var params = {
				search: search,
				filter: { is_active: 1 }
			}

			CustomerService.getCustomers(params, function(status, response) {
				if (status) {
					vm.customers = response.data;
				} else {
					validator.validateAlert(response);
				}
			});
		}

		function submit(event) {
			requestHelper.before(event, 'submitting...');
			
			QuotationService.submitQuotation(vm.quotation.hash_id, vm.data, function(status, response) {
				requestHelper.after(event, 'Submit')
				
				if (status) {
					$rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
					$rootScope.$broadcast(constants.BROADCAST.DETAIL_QUOTATION);
					cancel();
				}
			});
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
   'use strict';

   angular
      .module('app.quotation')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'quotation.create',
         config: {
            url: '/create',
            templateUrl: 'app/quotation/create/create.html',
            controllerAs: 'CreateQuotationController as vm',
            title: 'Create Quotation'
         }
      }];
   }
})();

(function() {
  "use strict";

  angular
    .module("app.quotation")
    .controller("CreateQuotationController", CreateQuotationController);

  CreateQuotationController.$inject = [
    "$state",
    "$rootScope",
    "$scope",
    "$uibModal",
    "constants",
    "validator",
    "SweetAlert",
    "requestHelper",
    "QuotationService",
    "MaterialService",
    "UserService",
    "ReferralService",
    "TransportService",
    "QuotationTermService",
    "SettingService"
  ];

  /* @ngInject */
  function CreateQuotationController(
    $state,
    $rootScope,
    $scope,
    $uibModal,
    constants,
    validator,
    SweetAlert,
    requestHelper,
    QuotationService,
    MaterialService,
    UserService,
    ReferralService,
    TransportService,
    QuotationTermService,
    SettingService
  ) {
    var vm = this;

    // PARAMS
    vm.user = UserService.loggedInUser;
    vm.referrals = [];
    vm.transports = [];
    vm.customer = null;
    vm.materialInk = MaterialService.materialInk;
    vm.materialPrinting = MaterialService.materialPrinting;
    vm.materialSlitting = MaterialService.materialSlitting;
    vm.materialPacking = MaterialService.materialPacking;
    vm.requiredMaterialPacking = [];
    vm.constants = constants;
    vm.requiredTerms = [];
    vm.optionalTerms = [];
    vm.editedProductIndex = null;

    vm.data = {
      taxable: true,
      transport_cost_in_product: true,
      quotation_terms: [],
      referral_hash_id: null,
      transport_type_hash_id: null,
      quotation_products: []
    };

    vm.privileges = {
      create: false
    };

    vm._createProduct = {
      name: null,
      quantity: 1,
      width: null,
      length: null,
      printing_waste: null,
      laminating_waste: null,
      slitting_waste: null,
      printing_overhead_cost: null,
      laminating_overhead_cost: null,
      slitting_overhead_cost: null,
      notes: null,
      need_printing: 0,
      need_laminating: 0,
      need_slitting: 1,
      need_packing: 1,
      need_bag_making: 0,
      bag_width: 0,
      bag_length: 0,
      bag_overhead_cost: 0,
      price_per_bag: 0,
      is_cylinder: 0,
      cylinder_cost: 0,
      printing_material: {
        material: null,
        hash_id: null,
        thickness: null
      },
      printing_inks: [],
      inks_name: [],
      laminating_materials: [],
      slitting_materials: [
        {
          material: null,
          hash_id: null,
          slitting_length: null
        }
      ],
      packing_materials: [],
      packing_materials_name: []
    };

    // HOOKS
    $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
      vm.user = UserService.loggedInUser;

      checkQuotationPrivileges();
    });

    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_INK, function() {
      vm.materialInk = MaterialService.materialInk;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PRINTING, function() {
      vm.materialPrinting = MaterialService.materialPrinting;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
      vm.materialSlitting = MaterialService.materialSlitting;
    });
    $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PACKING, function() {
      vm.requiredMaterialPacking = [];
      angular.forEach(MaterialService.materialPacking, function(value, key) {
        if (value.is_required) {
          vm.requiredMaterialPacking.push(value);
        }
      });

      vm.materialPacking = MaterialService.materialPacking;
    });

    $scope.$on(constants.BROADCAST.ADD_MATERIAL_LAMINATING_QUOTATION, function(
      event,
      args
    ) {
      vm._createProduct.laminating_materials.push(args.material);

      fillThickness();
    });

    $scope.$on(constants.BROADCAST.ADD_MATERIAL_SLITTING_QUOTATION, function(
      event,
      args
    ) {
      vm._createProduct.slitting_materials.push(args.material);
    });

    $scope.$on("ADD_TERM_FROM_TEMPLATE", function(event, args) {
      vm.optionalTerms.push({
        quotation_term_template_hash_id: args.term.hash_id,
        description: args.term.description
      });
    });

    $scope.$on("ADD_CUSTOM_TERM", function(event, args) {
      vm.optionalTerms.push({
        quotation_term_template_hash_id: null,
        description: args.term
      });
    });

    // METHODS
    vm.materialPrintingOnChange = materialPrintingOnChange;
    vm.materialSlittingOnChange = materialSlittingOnChange;
    vm.materialPackingOnChange = materialPackingOnChange;
    vm.inkOnChange = inkOnChange;
    vm.fillThickness = fillThickness;
    vm.addLaminatingMaterial = addLaminatingMaterial;
    vm.addSlittingMaterial = addSlittingMaterial;
    vm.createProduct = createProduct;
    vm.deleteSelectedLaminatingMaterial = deleteSelectedLaminatingMaterial;
    vm.removeLaminatingMaterial = removeLaminatingMaterial;
    vm.removeSlittingMaterial = removeSlittingMaterial;
    vm.removeProductConfirmation = removeProductConfirmation;
    vm.editProduct = editProduct;
    vm.saveEditProduct = saveEditProduct;
    vm.cancelEditProduct = cancelEditProduct;
    vm.removeTerm = removeTerm;
    vm.getReferral = getReferral;
    vm.addTerm = addTerm;
    vm.addCustomTerm = addCustomTerm;
    vm.getTransport = getTransport;
    vm.createQuotation = createQuotation;
    vm.resetSlitting = resetSlitting;

    checkQuotationPrivileges();
    getRequiredTerms(1);
    setDefaultValue();

    function setDefaultValue() {
      SettingService.showQuotationSetting('default_waste_percentage', function(status, response) {
        if (status) {
          vm._createProduct.printing_waste = response.quotation_setting_histories.value;
          vm._createProduct.laminating_waste = response.quotation_setting_histories.value;
          vm._createProduct.slitting_waste = response.quotation_setting_histories.value;
        } else {
          validator.validateAlert(response);
        }
      });

      SettingService.showQuotationSetting('default_printing_overhead_cost', function(status, response) {
        if (status) {
          vm._createProduct.printing_overhead_cost = response.quotation_setting_histories.value;
        } else {
          validator.validateAlert(response);
        }
      });

      SettingService.showQuotationSetting('default_laminating_overhead_cost', function(status, response) {
        if (status) {
          vm._createProduct.laminating_overhead_cost = response.quotation_setting_histories.value;
        } else {
          validator.validateAlert(response);
        }
      });

      SettingService.showQuotationSetting('default_slitting_overhead_cost', function(status, response) {
        if (status) {
          vm._createProduct.slitting_overhead_cost = response.quotation_setting_histories.value;
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function resetSlitting() {
      vm._createProduct.slitting_materials[0].hash_id = "";
    }

    function editProduct(product, index) {
      var packing_materials = [];
      var packing_materials_name = [];
      vm.editedProductIndex = index;

      angular.forEach(product.packing_materials_name, function(value, key) {
        if (!value.is_required) {
          packing_materials.push(value.hash_id);
          packing_materials_name.push(value);
        }
      });

      vm._createProduct = angular.copy(product);
      vm._createProduct.packing_materials = packing_materials;
      vm._createProduct.packing_materials_name = packing_materials_name;

      $("#editProduct").removeClass("hidden");
      $("#addProductButton").addClass("hidden");
    }

    function saveEditProduct(event) {
      var element = $(event.currentTarget);
      var form = element.closest("form");

      angular.forEach(vm.requiredMaterialPacking, function(value, key) {
        vm._createProduct.packing_materials.push(value.hash_id);
        vm._createProduct.packing_materials_name.push(value);
      });

      vm.data.quotation_products[vm.editedProductIndex] = vm._createProduct;
      resetProduct();
    }

    function cancelEditProduct() {
      $("#editProduct").addClass("hidden");
      $("#addProductButton").removeClass("hidden");

      vm.editedProductIndex = null;
      resetProduct();
    }

    function fillThickness() {
      var laminatingMaterialThickness = 0;

      angular.forEach(vm._createProduct.laminating_materials, function(
        value,
        key
      ) {
        laminatingMaterialThickness += value.thickness;
      });

      vm._createProduct.thickness =
        vm._createProduct.printing_material.thickness +
        laminatingMaterialThickness;
    }

    function checkQuotationPrivileges() {
      vm.privileges = {
        create: false
      };

      if (vm.user && vm.user.role) {
        var privileges = vm.user.role.role_privileges;

        $.each(privileges, function(index, val) {
          if (val.name === constants.PRIVILEGES.QUOTATION_CREATE) {
            vm.privileges.create = true;
          }
        });
      }
    }

    function getRequiredTerms(page) {
      var params = {
        page: page,
        filter: {
          is_required: 1
        }
      };

      QuotationTermService.getQuotationTerm(params, function(status, response) {
        if (status) {
          angular.forEach(response.data, function(value, key) {
            vm.requiredTerms.push(value);
          });

          if (response.current_page < response.last_page) {
            getRequiredTerms(response.current_page + 1);
          }
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function materialPrintingOnChange(item) {
      vm._createProduct.printing_material.hash_id = item.hash_id;
    }

    function materialSlittingOnChange(item) {
      vm._createProduct.slitting_materials[0].material = item;
    }

    function materialPackingOnChange(item) {
      vm._createProduct.packing_materials = [];

      angular.forEach(vm._createProduct.packing_materials_name, function(
        value,
        key
      ) {
        vm._createProduct.packing_materials.push(value.hash_id);
      });
    }

    function inkOnChange(item) {
      vm._createProduct.printing_inks = [];

      angular.forEach(vm._createProduct.inks_name, function(value, key) {
        vm._createProduct.printing_inks.push(value.hash_id);
      });
    }

    function addTerm() {
      $uibModal.open({
        animation: true,
        templateUrl: "app/quotation/create/term-modal/term-modal.html",
        controller: "ChooseTermModalController",
        controllerAs: "vm"
      });
    }

    function addCustomTerm() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/custom-term-modal/custom-term-modal.html",
        controller: "ChooseCustomTermModalController",
        controllerAs: "vm"
      });
    }

    function addLaminatingMaterial() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/laminating-material-modal/laminating-material-modal.html",
        controller: "ChooseLaminatingMaterialModalController",
        controllerAs: "vm"
      });
    }

    function addSlittingMaterial() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/quotation/create/slitting-material-modal/slitting-material-modal.html",
        controller: "ChooseSlittingMaterialModalController",
        controllerAs: "vm"
      });
    }

    function deleteSelectedLaminatingMaterial(material) {
      for (
        var i = vm._createProduct.laminating_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.laminating_materials[i].hash_id == material.hash_id
        ) {
          vm._createProduct.laminating_materials.splice(i, 1);
        }
      }
    }

    function removeLaminatingMaterial(material) {
      for (
        var i = vm._createProduct.laminating_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.laminating_materials[i].material.hash_id ===
          material.material.hash_id
        ) {
          vm._createProduct.laminating_materials.splice(i, 1);
          break;
        }
      }

      fillThickness();
    }

    function removeTerm(term) {
      for (var i = vm.optionalTerms.length - 1; i >= 0; i--) {
        if (
          vm.optionalTerms[i].quotation_term_template_hash_id ===
          term.quotation_term_template_hash_id
        ) {
          vm.optionalTerms.splice(i, 1);
          break;
        }
      }
    }

    function removeSlittingMaterial(material) {
      for (
        var i = vm._createProduct.slitting_materials.length - 1;
        i >= 0;
        i--
      ) {
        if (
          vm._createProduct.slitting_materials[i].material.hash_id ===
          material.material.hash_id
        ) {
          vm._createProduct.slitting_materials.splice(i, 1);
          break;
        }
      }
    }

    function createProduct(event) {
      angular.forEach(vm.requiredMaterialPacking, function(value, key) {
        vm._createProduct.packing_materials.push(value.hash_id);
        vm._createProduct.packing_materials_name.push(value);
      });

      console.log(vm._createProduct);

      vm.data.quotation_products.push(vm._createProduct);
      SweetAlert.swal(
        "Sukses",
        "Berhasil menambahkan produk. Silahkan lihat di bagian atas kanan.",
        "success"
      );
      resetProduct();
    }

    function resetProduct() {
      vm._createProduct = {
        name: null,
        quantity: 1,
        width: null,
        length: null,
        printing_waste: null,
        laminating_waste: null,
        slitting_waste: null,
        printing_overhead_cost: null,
        laminating_overhead_cost: null,
        slitting_overhead_cost: null,
        notes: null,
        need_printing: 0,
        need_laminating: 0,
        need_slitting: 1,
        need_packing: 1,
        need_bag_making: 0,
        bag_width: 0,
        bag_length: 0,
        bag_overhead_cost: 0,
        price_per_bag: 0,
        is_cylinder: 0,
        cylinder_cost: 0,
        printing_material: {
          material: null,
          hash_id: null,
          thickness: null
        },
        printing_inks: [],
        inks_name: [],
        laminating_materials: [],
        slitting_materials: [],
        packing_materials: [],
        packing_materials_name: []
      };
    }

    function removeProductConfirmation(product, index) {
      SweetAlert.swal(
        {
          title: "Hapus Produk " + product.name + "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: constants.COLOR.DANGER,
          confirmButtonText: "Hapus!",
          cancelButtonText: "Batalkan",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        },
        function(isConfirm) {
          if (isConfirm) {
            removeProduct(index);
          }
        }
      );
    }

    function removeProduct(index) {
      vm.data.quotation_products.splice(index, 1);
      SweetAlert.swal("Sukses", "Produk berhasil dihapus!", "success");
    }

    function getReferral(search) {
      var params = {
        search: search,
        filter: { is_active: 1 }
      };

      ReferralService.getReferral(params, function(status, response) {
        if (status) {
          vm.referrals = response.data;
          vm.referrals.unshift({
            name: "None",
            code: "None",
            hash_id: null
          });
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function getTransport(search) {
      var params = {
        search: search
      };

      TransportService.getTransport(params, function(status, response) {
        if (status) {
          vm.transports = response.data;
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function createQuotation() {
      SweetAlert.swal(
        {
          title: "Simpan quotation?",
          text: "Quotation akan disimpan sebagai draft.",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Simpan!",
          cancelButtonText: "Batalkan",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        },
        function(isConfirm) {
          if (isConfirm) {
            vm.data.quotation_terms = [];
            angular.forEach(vm.requiredTerms, function(value, key) {
              vm.data.quotation_terms.push({
                quotation_term_template_hash_id: value.hash_id,
                description: value.description
              });
            });
            angular.forEach(vm.optionalTerms, function(value, key) {
              vm.data.quotation_terms.push({
                quotation_term_template_hash_id: value.hash_id,
                description: value.description
              });
            });

            if (vm.data.referral_hash_id === "None") {
              vm.data.referral_hash_id = null;
            }

            QuotationService.storeQuotation(vm.data, function(status, data) {
              if (status) {
                var quotation = data;

                swal.close();
                setTimeout(function(){ 
                  SweetAlert.swal(
                    "Sukses",
                    "Berhasil menyimpan quotation.",
                    "success"
                  );
                  $rootScope.$broadcast(constants.BROADCAST.INDEX_QUOTATION);
                  $state.go("quotation.detail", {
                    quotationHashId: quotation.hash_id,
                    quotation: quotation
                  });
                }, 500, constants, quotation);
              } else {
                validator.validateAlert(data);
              }
            });
          }
        }
      );
    }
  }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material.slitting',
         config: {
            url: '/slitting?search',
            templateUrl: 'app/material/slitting/slitting.html',
            controllerAs: 'MaterialSlittingController as vm',
            title: 'Material Slitting'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('MaterialSlittingController', MaterialSlittingController);

   MaterialSlittingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'MaterialService',
      'UserService'
   ];

   /* @ngInject */
   function MaterialSlittingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      MaterialService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.materials = MaterialService.materialSlitting;
      vm.constants = constants;

      vm.privileges = {
         admin: false
      }

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function(){
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_SLITTING, function() {
         vm.materials = MaterialService.materialSlitting;
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getMaterial                = getMaterial;
      vm.editMaterial               = editMaterial;
      vm.createMaterial             = createMaterial;
      vm.deleteMaterialConfirmation = deleteMaterialConfirmation;
      vm.filter                     = filter;
      vm.showGuide        = showGuide;

      checkMaterialPrivileges();

      function checkMaterialPrivileges() {
         vm.privileges = {
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getMaterial(params) {
         MaterialService.getMaterialSlitting(params, function(status, data) {
            if (status) {
               vm.materials = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/slitting/guide-modal/guide-modal.html',
            controller: 'SlittingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/slitting/update-modal/update-modal.html',
            controller: 'UpdateMaterialSlittingModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/slitting/create-modal/create-modal.html',
            controller: 'CreateMaterialSlittingModalController',
            controllerAs: 'vm'
         });
      }

      function deleteMaterialConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         MaterialService.deleteMaterialSlitting(material.hash_id, function(status, data) {
            if (status) {
               getMaterial(vm.filtering);
               SweetAlert.swal('Sukses', 'Material berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.materials = [];

         getMaterial(vm.filtering);
      }

      function filter() {
         $location.url(
            '/material/slitting?search=' + vm.filtering.search
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material.printing',
         config: {
            url: '/printing?search',
            templateUrl: 'app/material/printing/printing.html',
            controllerAs: 'MaterialPrintingController as vm',
            title: 'Material Printing'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('MaterialPrintingController', MaterialPrintingController);

   MaterialPrintingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'MaterialService',
      'UserService'
   ];

   /* @ngInject */
   function MaterialPrintingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      MaterialService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.materials = MaterialService.materialPrinting;
      vm.constants = constants;

      vm.privileges = {
         admin: false
      }

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function(){
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PRINTING, function() {
         vm.materials = MaterialService.materialPrinting;
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getMaterial                = getMaterial;
      vm.editMaterial               = editMaterial;
      vm.createMaterial             = createMaterial;
      vm.deleteMaterialConfirmation = deleteMaterialConfirmation;
      vm.filter                     = filter;
      vm.showGuide        = showGuide;

      checkMaterialPrivileges();

      function checkMaterialPrivileges() {
         vm.privileges = {
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getMaterial(params) {
         MaterialService.getMaterialPrinting(params, function(status, response) {
            if (status) {
               vm.materials = response;
            } else {
               validator.validateAlert(response);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/printing/guide-modal/guide-modal.html',
            controller: 'PrintingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/printing/update-modal/update-modal.html',
            controller: 'UpdateMaterialPrintingModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/printing/create-modal/create-modal.html',
            controller: 'CreateMaterialPrintingModalController',
            controllerAs: 'vm'
         });
      }

      function deleteMaterialConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         MaterialService.deleteMaterialPrinting(material.hash_id, function(status, data) {
            if (status) {
               getMaterial(vm.filtering);
               SweetAlert.swal('Sukses', 'Material berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.materials = [];

         getMaterial(vm.filtering);
      }

      function filter() {
         $location.url(
            '/material/printing?search=' + vm.filtering.search
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material.packing',
         config: {
            url: '/packing?search',
            templateUrl: 'app/material/packing/packing.html',
            controllerAs: 'MaterialPackingController as vm',
            title: 'Material Packing'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('MaterialPackingController', MaterialPackingController);

   MaterialPackingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'MaterialService',
      'UserService'
   ];

   /* @ngInject */
   function MaterialPackingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      MaterialService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.materials = MaterialService.materialPacking;
      vm.constants = constants;

      vm.privileges = {
         admin: false
      }

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_PACKING, function() {
         vm.materials = MaterialService.materialPacking;
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getMaterial                = getMaterial;
      vm.editMaterial               = editMaterial;
      vm.createMaterial             = createMaterial;
      vm.deleteMaterialConfirmation = deleteMaterialConfirmation;
      vm.filter                     = filter;
      vm.showGuide        = showGuide;

      checkMaterialPrivileges();

      function checkMaterialPrivileges() {
         vm.privileges = {
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getMaterial(params) {
         MaterialService.getMaterialPacking(params, function(status, data) {
            if (status) {
               vm.materials = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/packing/guide-modal/guide-modal.html',
            controller: 'PackingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/packing/update-modal/update-modal.html',
            controller: 'UpdateMaterialPackingModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/packing/create-modal/create-modal.html',
            controller: 'CreateMaterialPackingModalController',
            controllerAs: 'vm'
         });
      }

      function deleteMaterialConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         MaterialService.deleteMaterialPacking(material.hash_id, function(status, data) {
            if (status) {
               getMaterial(vm.filtering);
               SweetAlert.swal('Sukses', 'Material berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.materials = [];

         getMaterial(vm.filtering);
      }

      function filter() {
         $location.url(
            '/material/packing?search=' + vm.filtering.search
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material.laminating',
         config: {
            url: '/laminating?search',
            templateUrl: 'app/material/laminating/laminating.html',
            controllerAs: 'MaterialLaminatingController as vm',
            title: 'Material Laminating'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('MaterialLaminatingController', MaterialLaminatingController);

   MaterialLaminatingController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'MaterialService',
      'UserService'
   ];

   /* @ngInject */
   function MaterialLaminatingController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      MaterialService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.materials = MaterialService.materialLaminating;
      vm.constants = constants;
      vm.filter    = filter;

       vm.privileges = {
         admin: false
      }

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_LAMINATING, function() {
         vm.materials = MaterialService.materialLaminating;
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getMaterial                = getMaterial;
      vm.editMaterial               = editMaterial;
      vm.createMaterial             = createMaterial;
      vm.deleteMaterialConfirmation = deleteMaterialConfirmation;
      vm.showGuide        = showGuide;

      checkMaterialPrivileges();

      function checkMaterialPrivileges() {
         vm.privileges = {
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getMaterial(params) {
         MaterialService.getMaterialLaminating(params, function(status, data) {
            if (status) {
               vm.materials = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/laminating/guide-modal/guide-modal.html',
            controller: 'LaminatingGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/laminating/update-modal/update-modal.html',
            controller: 'UpdateMaterialLaminatingModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/laminating/create-modal/create-modal.html',
            controller: 'CreateMaterialLaminatingModalController',
            controllerAs: 'vm'
         });
      }

      function deleteMaterialConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         MaterialService.deleteMaterialLaminating(material.hash_id, function(status, data) {
            if (status) {
               getMaterial(vm.filtering);
               SweetAlert.swal('Sukses', 'Material berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.materials = [];

         getMaterial(vm.filtering);
      }

      function filter() {
         $location.url(
            '/material/laminating?search=' + vm.filtering.search
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material.ink',
         config: {
            url: '/ink?search',
            templateUrl: 'app/material/ink/ink.html',
            controllerAs: 'MaterialInkController as vm',
            title: 'Material Ink'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.material')
      .controller('MaterialInkController', MaterialInkController);

   MaterialInkController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'MaterialService',
      'UserService'
   ];

   /* @ngInject */
   function MaterialInkController(
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      MaterialService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.materials = MaterialService.materialInk;
      vm.constants = constants;

      vm.privileges = {
         admin: false
      }

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function(){
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_MATERIAL_INK, function() {
         vm.materials = MaterialService.materialInk;
      });

      // METHODS
      vm.refresh                    = refresh;
      vm.getMaterial                = getMaterial;
      vm.editMaterial               = editMaterial;
      vm.createMaterial             = createMaterial;
      vm.deleteMaterialConfirmation = deleteMaterialConfirmation;
      vm.filter                     = filter;
      vm.showGuide        = showGuide;

      checkMaterialPrivileges();

      function checkMaterialPrivileges() {
         vm.privileges = {
            admin: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getMaterial(params) {
         MaterialService.getMaterialInk(params, function(status, data) {
            if (status) {
               vm.materials = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/ink/guide-modal/guide-modal.html',
            controller: 'InkGuideModalController',
            controllerAs: 'vm'
         });
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/ink/update-modal/update-modal.html',
            controller: 'UpdateMaterialInkModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/material/ink/create-modal/create-modal.html',
            controller: 'CreateMaterialInkModalController',
            controllerAs: 'vm'
         });
      }

      function deleteMaterialConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         MaterialService.deleteMaterialInk(material.hash_id, function(status, data) {
            if (status) {
               getMaterial(vm.filtering);
               SweetAlert.swal('Sukses', 'Material berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.materials = [];

         getMaterial(vm.filtering);
      }

      function filter() {
         $location.url(
            '/material/ink?search=' + vm.filtering.search
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'customer.index',
         config: {
            url: '?search=&filter_type=&sort_name=&page',
            templateUrl: 'app/customer/index/index.html',
            controllerAs: 'IndexCustomerController as vm',
            title: 'Customer'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('IndexCustomerController', IndexCustomerController);

   IndexCustomerController.$inject = [
      '$location',
      '$stateParams',
      '$state',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'CustomerService',
      'UserService'
   ];

   /* @ngInject */
   function IndexCustomerController(
      $location,
      $stateParams,
      $state,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      CustomerService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user      = UserService.loggedInUser;
      vm.customers = [];
      vm.constants = constants;

      vm.privileges = {
         read: false,
         create: false,
         update: false,
         submit: false,
         admin: false
      }

      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : '',
         filter: {
            type: $stateParams.filter_type ? $stateParams.filter_type : ''
         },
         sort: {
            name: $stateParams.sort_name ? $stateParams.sort_name : ''
         }
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkCustomerPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_CUSTOMER, function() {
         getCustomers(vm.filtering);
      });

      // METHODS
      vm.refresh        = refresh;
      vm.getCustomers   = getCustomers;
      vm.editCustomer   = editCustomer;
      vm.createCustomer = createCustomer;
      vm.showCustomer   = showCustomer;
      vm.toggleActive   = toggleActive;
      vm.showGuide        = showGuide;

      vm.submitCustomerConfirmation = submitCustomerConfirmation;
      vm.approve                    = approve;
      vm.rejectCustomerConfirmation = rejectCustomerConfirmation;

      vm.filter      = filter;
      vm.sortName    = sortName;
      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getCustomers(vm.filtering);
      checkCustomerPrivileges();

      function checkCustomerPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            update: false,
            submit: false,
            admin: false
         }
         
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.CUSTOMER_READ) {
                  vm.privileges.read = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_CREATE) {
                  vm.privileges.create = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_UPDATE) {
                  vm.privileges.update = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_SUBMIT) {
                  vm.privileges.submit = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function getCustomers(params) {
         CustomerService.getCustomers(params, getData);

         function getData(status, data) {
            if (status) {
               vm.customers  = data.data;

               vm.pagination.currentPage  = data.current_page;
               vm.pagination.totalItems   = data.total;
               vm.pagination.itemsPerPage = data.per_page;
            } else {
               validator.validateAlert(data);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/guide-modal/guide-modal.html',
            controller: 'CustomerGuideModalController',
            controllerAs: 'vm'
         });
      }

      function toggleActive(customer, event) {
         var switcher   = $(event.currentTarget);
         var value      = switcher.prop('checked') ? 1 : 0;
         var statusName = value ? 'Aktifkan' : "Nonaktifkan";

         switcher.prop('checked', !value);

         SweetAlert.swal({
            title: statusName + ' customer ' + customer.name + '?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: statusName,
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var parameters = {
                  is_active : value
               }

               CustomerService.changeStatus(customer.hash_id, parameters, function(status, data) {
                  if (status) {
                     switcher.prop('checked', value);
                     SweetAlert.swal('Sukses', 'Customer ' + customer.name + ' berhasil di-' +statusName, 'success');
                  } else {
                     validator.validateAlert(data);
                  }
               })
            }
         });
      }

      function editCustomer(customer) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/index/update-modal/update-modal.html',
            controller: 'UpdateCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: customer,
                     isFromDetail: false
                  };
               }
            }
         });
      }

      function createCustomer(user) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/index/create-modal/create-modal.html',
            controller: 'CreateCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user
                  };
               }
            }
         });
      }

      function showCustomer(customer) {
         $state.go('customer.detail', {'customerHashId': customer.hash_id, 'customer': customer});
      }

      function submitCustomerConfirmation(customer) {
         SweetAlert.swal({
           title: 'Submit Customer '+customer.name+' ?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: "warning",
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Submit",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               submitCustomer(customer);
            }
         });
      }

      function approve(customer) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/approve-modal/approve-modal.html',
            controller: 'ApproveCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     customer: customer
                  };
               }
            }
         });
      }

      function rejectCustomerConfirmation(customer) {
         SweetAlert.swal({
           title: 'Reject Customer '+customer.name+' ?',
           text: '<div class="form-group text-left"><label>Deskripsi</label><textarea class="form-control" id="swal-description"></textarea></div>',
           html: true,
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Reject",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               rejectCustomer(customer);
            }
         });  
      }

      function submitCustomer(customer){
         var params = {
            discussion_description: $('#swal-description').val()
         }

         CustomerService.submit(customer.hash_id, params, function(status, data) {
            if (status) {
               SweetAlert.swal('Sukses', 'Customer berhasil di-submit!', 'success');
               getCustomers(vm.filtering);
            } else {
               validator.validateAlert(data);
            }
         });            
      }

      function approveCustomer(customer){
         var params = {
            discussion_description: $('#swal-description').val()
         }

         CustomerService.approve(customer.hash_id, params, function(status, data) {
            if (status) {
               SweetAlert.swal('Sukses', 'Customer berhasil di-approve!', 'success');
               getCustomers(vm.filtering);
            } else {
               validator.validateAlert(data);
            }
         });            
      }

      function rejectCustomer(customer){
         var params = {
            discussion_description: $('#swal-description').val()
         }

         CustomerService.reject(customer.hash_id, params, function(status, data) {
            if (status) {
               SweetAlert.swal('Sukses', 'Customer berhasil di-reject!', 'success');
               getCustomers(vm.filtering);
            } else {
               validator.validateAlert(data);
            }
         });            
      }

      function refresh() {
         vm.customers = [];

         getCustomers(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function filter() {
         $location.url(
          '/customer?sort_name=' + vm.filtering.sort.name + 
          '&search=' + vm.filtering.search + 
          '&filter_type=' + vm.filtering.filter.type + 
          '&page=' + vm.filtering.page
        );
      }

      function sortName(value) {
        if (value === 'desc') {
          vm.filtering.sort.name = 'asc';
        } else {
          vm.filtering.sort.name = 'desc';
        }

        vm.filter();
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CustomerGuideModalController', CustomerGuideModalController);

   CustomerGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CustomerGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'customer.detail',
         config: {
            url: '/:customerHashId',
            params: {'customer': null},
            templateUrl: 'app/customer/detail/detail.html',
            controllerAs: 'DetailCustomerController as vm',
            title: 'Customer Detail'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('DetailCustomerController', DetailCustomerController);

   DetailCustomerController.$inject = [
      '$state',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'CustomerService',
      'UserService',
      'globalState'
   ];

   /* @ngInject */
   function DetailCustomerController(
      $state,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      CustomerService,
      UserService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.customer    = $stateParams.customer;
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         update: false,
         admin: false
      }

      // HOOKS
      if (!vm.customer) {
         if ($stateParams.customerHashId) {
            showCustomer($stateParams.customerHashId);
         } else {
            $state.go('customer.index');
         }
      }

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkCustomerPrivileges();
      });

      $scope.$on(constants.BROADCAST.DETAIL_CUSTOMER, function(event, args) {
         vm.customer = args.customer;
      });

      // METHODS
      vm.editCustomer = editCustomer;
      vm.uploadImage  = uploadImage;

      vm.addImportantPerson                = addImportantPerson;
      vm.editImportantPerson               = editImportantPerson;
      vm.deleteImportantPersonConfirmation = deleteImportantPersonConfirmation;

      vm.addProduct                = addProduct;
      vm.deleteProductConfirmation = deleteProductConfirmation;

      vm.showImage   = showImage;
      vm.createImage = createImage;

      vm.createAddress             = createAddress;
      vm.editAddress               = editAddress;
      vm.deleteAddressConfirmation = deleteAddressConfirmation;

      vm.editRank        = editRank;
      vm.showRankHistory = showRankHistory;

      vm.reassignCustomer = reassignCustomer;

      checkCustomerPrivileges();

      function checkCustomerPrivileges() {
         vm.privileges = {
            read: false,
            update: false,
            admin: false
         }
         
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            $.each(privileges, function(index, val) {
               if (val.name === constants.PRIVILEGES.CUSTOMER_READ) {
                  vm.privileges.read = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_UPDATE) {
                  vm.privileges.update = true;
               } else if(val.name === constants.PRIVILEGES.CUSTOMER_ADMIN) {
                  vm.privileges.admin = true;
               }
            });
         }
      }

      function showCustomer(customerHashId) {
         CustomerService.show(customerHashId, function(status, data) {
            if (status) {
               vm.customer = data;
            } else {
               validator.validateAlert(data);
               $state.go('customer.index');
            }
         });
      }

      function editCustomer() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/index/update-modal/update-modal.html',
            controller: 'UpdateCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     customer: vm.customer,
                     user: vm.user,
                     isFromDetail: true
                  };
               }
            }
         });
      }

      function uploadImage(type, importantPerson) {
         var image = null;

         if (type === constants.CUSTOMER_UPLOAD_TYPE.LOGO) {
            image = vm.customer.image
         } else if(type === constants.CUSTOMER_UPLOAD_TYPE.NPWP) {
            image = vm.customer.npwp_image
         } else if(type === constants.CUSTOMER_UPLOAD_TYPE.DEED) {
            image = vm.customer.deed_of_incorporation_image
         } else if(type === constants.CUSTOMER_UPLOAD_TYPE.LAST_DEED) {
            image = vm.customer.last_deed_image
         } else if(type === constants.CUSTOMER_UPLOAD_TYPE.ID_CARD) {
            image = importantPerson.id_card_image
         }

         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/upload-modal/upload-modal.html',
            controller: 'UploadModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer,
                     type: type,
                     image: image,
                     importantPerson: importantPerson
                  };
               }
            }
         });
      }

      function addImportantPerson() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/important-person/create-modal/create-modal.html',
            controller: 'CreateImportantPersonModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer
                  };
               }
            }
         });
      }

      function editImportantPerson(importantPerson) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/important-person/update-modal/update-modal.html',
            controller: 'UpdateImportantPersonModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer,
                     importantPerson: importantPerson
                  };
               }
            }
         });
      }

      function deleteImportantPersonConfirmation(importantPerson, event) {
         SweetAlert.swal({
           title: 'Hapus Important Person?',
           text: 'Important Person akan dihapus dari database.',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteImportantPerson(importantPerson, event);
            }
         });
      }

      function deleteImportantPerson(importantPerson, event) {
         var button = $(event.target);

         button.closest('p').find('button').prop('disabled', true);
         button.html('Menghapus...');

         CustomerService.deleteImportantPerson(vm.customer.hash_id, importantPerson.hash_id, function(status, data) {
            if (status) {
               vm.customer = data;
               SweetAlert.swal('Sukses', 'Important person berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('p').find('button').prop('disabled', false);
            button.html('Hapus Important Person');
         });
      }

      function addProduct() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/product/create-modal/create-modal.html',
            controller: 'CreateProductModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer
                  };
               }
            }
         });
      }

      function deleteProductConfirmation(product, event) {
         SweetAlert.swal({
           title: 'Hapus Product?',
           text: 'Product akan dihapus dari database.',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteProduct(product, event);
            }
         });
      }

      function deleteProduct(product, event) {
         var button = $(event.target);

         button.closest('.ibox').find('button').prop('disabled', true);
         button.html('Menghapus...');

         CustomerService.deleteProduct(vm.customer.hash_id, product.hash_id, function(status, data) {
            if (status) {
               vm.customer = data;
               SweetAlert.swal('Sukses', 'Product berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('.ibox').find('button').prop('disabled', false);
            button.html('Hapus Product');
         });
      }

      function showImage(data, image_url, type, isEditable, isRemoveable, additionalData) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/customer-image-modal/customer-image-modal.html',
            controller: 'CustomerImageModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     privileges: vm.privileges,
                     customer: vm.customer,
                     data: data,
                     additionalData: additionalData,
                     image: image_url,
                     type: type,
                     isEditable: isEditable,
                     isRemoveable: isRemoveable
                  };
               }
            }
         });
      }

      function createImage(image) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/create-image-modal/create-image-modal.html',
            controller: 'CustomerCreateImageModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer
                  };
               }
            }
         });
      }

      function createAddress() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/create-address-modal/create-address-modal.html',
            controller: 'CustomerCreateAddressModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer
                  };
               }
            }
         });
      }

      function editAddress(address) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/update-address-modal/update-address-modal.html',
            controller: 'CustomerUpdateAddressModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     user: vm.user,
                     customer: vm.customer,
                     address: address
                  };
               }
            }
         });
      }

      function deleteAddressConfirmation(address) {
         SweetAlert.swal({
           title: 'Hapus Alamat?',
           text: 'Alamat akan dihapus dari database.',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteAddress(address);
            }
         });
      }

      function deleteAddress(address) {

         CustomerService.deleteAddress(vm.customer.hash_id, address.hash_id, function(status, data) {
            if (status) {
               SweetAlert.swal('Sukses', 'Alamat berhasil dihapus!', 'success');

               vm.customer = data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function reassignCustomer() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/reassign-customer-modal/reassign-customer-modal.html',
            controller: 'ReassignCustomerModalController',
            controllerAs: 'vm',
            resolve: {
               customerDependent: function () {
                  return {
                     customer: vm.customer
                  };
               }
            }
         });
      }

      // CUSTOMER RANK (MAYBE USED IN FEATURE)
      function editRank() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/edit-rank-modal/edit-rank-modal.html',
            controller: 'CustomerEditRankModalController',
            controllerAs: 'vm'
         });
      }
      function showRankHistory() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/customer/detail/rank-history-modal/rank-history-modal.html',
            controller: 'CustomerRankHistoryModalController',
            controllerAs: 'vm',
         });
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('ApproveCustomerModalController', ApproveCustomerModalController);

   ApproveCustomerModalController.$inject = [
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'CustomerService',
      'customerDependent',
      'constants',
      'validator',
      'requestHelper'
   ];

   function ApproveCustomerModalController(
      $scope,
      $rootScope,
      $uibModalInstance,
      CustomerService,
      customerDependent,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.customer  = customerDependent.customer;
      vm.data      = {};

      // methods
      vm.cancel  = cancel;
      vm.approve = approve;

      function approve(event) {
         requestHelper.before(event, 'Approve...');
         
         CustomerService.approve(vm.customer.hash_id, vm.data, function (status, data) {
            if (status) {
               $uibModalInstance.dismiss('cancel');

               $rootScope.$broadcast(constants.BROADCAST.INDEX_CUSTOMER);
            } else {
               validator.validateAlert(data);
            }

            requestHelper.after(event, '<i class="fa fa-check"></i> Approve');
         });
      }

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.commission', []);
})();

(function() {
   'use strict';

   angular
      .module('app.commission')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'commission.index',
         config: {
            url: '?search&page',
            templateUrl: 'app/commission/index/index.html',
            controllerAs: 'CommissionController as vm',
            title: 'Commission'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.commission')
      .controller('CommissionController', CommissionController);

   CommissionController.$inject = [
      '$state',
      '$location',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'CommissionService',
      'globalState'
   ];

   /* @ngInject */
   function CommissionController(
      $state,
      $location,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      CommissionService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.commissions = [];
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         payment: false
      }
      
      vm.filtering = {
         page: $stateParams.page ? $stateParams.page : 1,
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_COMMISSION, function() {
         getIndex(vm.filtering);
      });

      // METHODS
      vm.refresh    = refresh;
      vm.getIndex   = getIndex;
      vm.filter     = filter;
      vm.showDetail = showDetail;
      vm.showGuide        = showGuide;

      vm.pagination  = {};
      vm.pageChanged = pageChanged;

      getIndex(vm.filtering);
      checkUserPrivileges();

      function getIndex(params) {
         CommissionService.getCommission(params, getData);

         function getData(status, response) {
            if (status) {
               vm.commissions = response.data;

               vm.pagination.currentPage  = response.current_page;
               vm.pagination.totalItems   = response.total;
               vm.pagination.itemsPerPage = response.per_page;
            } else {
               validator.validateAlert(response);
            }
         }
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/commission/guide-modal/guide-modal.html',
            controller: 'CommissionGuideModalController',
            controllerAs: 'vm'
         });
      }

      function showDetail(commission) {
            $state.go('commission.detail', {'commissionHashId': commission.hash_id, 'commission': commission});
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            payment: false
         }
      
         if (vm.user && vm.user.role) {
            angular.forEach(vm.user.role.role_privileges, function(value, key) {
              if (value.name === constants.PRIVILEGES.COMMISSION_READ) {
                vm.privileges.read = true;
              } else if (value.name === constants.PRIVILEGES.COMMISSION_PAYMENT) {
                vm.privileges.payment = true;
              }
            });
         }
      }

      function refresh() {
         vm.commissions = [];

         getIndex(vm.filtering);
      }

      function pageChanged() {
         vm.filtering.page = vm.pagination.currentPage;

         filter();
      };

      function filter() {
         $location.url(
            '/commission?search=' + vm.filtering.search +
            '&page=' + vm.filtering.page
         );
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.user')
      .controller('CommissionGuideModalController', CommissionGuideModalController);

   CommissionGuideModalController.$inject = [
      '$state',
      '$scope',
      '$rootScope',
      '$uibModalInstance',
      'RoleService',
      'constants',
      'validator',
      'requestHelper'
   ];

   function CommissionGuideModalController(
      $state,
      $scope,
      $rootScope,
      $uibModalInstance,
      constants,
      validator,
      requestHelper
   ) {
      var vm = this;

      // params
      vm.constants = constants;
      vm.guides    = [];

      // methods
      vm.cancel = cancel;

      function cancel() {
         $uibModalInstance.dismiss('cancel');
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.commission')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'commission.detail',
         config: {
            url: '/:commissionHashId',
            params: {'commission': null},
            templateUrl: 'app/commission/detail/detail.html',
            controllerAs: 'DetailCommissionController as vm',
            title: 'Commission Detail'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .controller('DetailCommissionController', DetailCommissionController);

   DetailCommissionController.$inject = [
      '$filter',
      '$state',
      '$stateParams',
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'UserService',
      'CommissionService',
      'globalState'
   ];

   /* @ngInject */
   function DetailCommissionController(
      $filter,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      UserService,
      CommissionService,
      globalState
   ) {
      var vm = this;

      // PARAMS
      vm.user        = UserService.loggedInUser;
      vm.commission  = $stateParams.commission;
      vm.constants   = constants;
      vm.globalState = globalState;

      vm.privileges = {
         read: false,
         payment: false
      }

      // HOOKS
      if (!vm.commission) {
         if ($stateParams.commissionHashId) {
            showCommission($stateParams.commissionHashId);
         } else {
            $state.go('commission.index');
         }
      }

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      $scope.$on(constants.BROADCAST.DETAIL_COMMISSION, function(event, args) {
         vm.commission = args.commission;
      });

      // METHODS
      vm.createCommissionPayment = createCommissionPayment;
      vm.editPayment             = editPayment;
      vm.payCommission           = payCommission;

      checkUserPrivileges();

      function createCommissionPayment() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/commission/detail/create-payment-modal/create-payment-modal.html',
            controller: 'CreateCommissionPaymentModalController',
            controllerAs: 'vm',
            resolve: {
               commissionDependent: function () {
                  return {
                     data: vm.commission
                  };
               }
            }
         });
      }

      function editPayment(payment) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/commission/detail/update-payment-modal/update-payment-modal.html',
            controller: 'UpdateCommissionPaymentModalController',
            controllerAs: 'vm',
            resolve: {
               commissionDependent: function () {
                  return {
                     data: vm.commission,
                     payment: payment
                  };
               }
            }
         });
      }

      function payCommission(payment, event) {

         SweetAlert.swal({
            title: 'Bayar Komisi?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Bayar',
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm) {
            if (isConfirm) {
               var today = new Date();
               var formattedDate = $filter('date')(today, 'yyyy-MM-dd');

               var parameters = {
                  commission_paid_at : formattedDate
               }

               CommissionService.payCommissionPayment(vm.commission.hash_id, payment.hash_id, parameters, function(status, data) {
                  if (status) {
                     SweetAlert.swal('Sukses', 'Komisi berhasil dibayarkan', 'success');
                     showCommission(vm.commission.hash_id);
                  } else {
                     validator.validateAlert(data);
                  }
               })
            }
         });
      }

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            payment: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(val, opt) {
               if (val.name === constants.PRIVILEGES.COMMISSION_READ) {
                  vm.privileges.read = true;
               } else if (val.name === constants.PRIVILEGES.COMMISSION_PAYMENT) {
                  vm.privileges.payment = true;
               }
            });
         }
      }

      function showCommission(commissionHashId) {
         CommissionService.showCommission(commissionHashId, function(status, data) {
            if (status) {
               vm.commission = data;
            } else {
               validator.validateAlert(data);
               $state.go('commission.index');
            }
         });
      }

      function payCommission(payment, event) {

         SweetAlert.swal({
            title: 'Bayar Komisi?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Bayar',
            cancelButtonText: 'Batalkan',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               var today = new Date();
               var formattedDate = $filter('date')(today, 'yyyy-MM-dd');

               var parameters = {
                  commission_paid_at : formattedDate
               }

               CommissionService.payCommissionPayment(vm.commission.hash_id, payment.hash_id, parameters, function(status, data) {
                  if (status) {
                     SweetAlert.swal('Sukses', 'Komisi berhasil dibayarkan', 'success');
                     showCommission(vm.commission.hash_id);
                  } else {
                     validator.validateAlert(data);
                  }
               })
            }
         });
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'amg.product',
         config: {
            url: '/product',
            templateUrl: 'app/amg/product/product.html',
            controllerAs: 'AmgProductController as vm',
            title: 'AMG Product'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('AmgProductController', AmgProductController);

   AmgProductController.$inject = [
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'AmgService',
      'UserService'
   ];

   /* @ngInject */
   function AmgProductController(
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      AmgService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.products  = [];
      vm.user      = UserService.loggedInUser;
      vm.constants = constants;

      vm.privileges = {
         read: false,
         create: false,
         pricing: false
      }

      vm.filtering = {
         search: ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function(){
         vm.user = UserService.loggedInUser;

         checkProductPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_AMG_PRODUCT, function(){
         getProducts();
      });

      // METHODS
      vm.refresh            = refresh;
      vm.editProduct        = editProduct;
      vm.createProduct      = createProduct;
      vm.deleteConfirmation = deleteConfirmation;

      getProducts();
      checkProductPrivileges();

      function getProducts() {
         AmgService.getProduct(null, function(status, data) {
            if (status) {
               vm.products  = data.result;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function checkProductPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            pricing: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.AMG_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.AMG_CREATE) {
                  vm.privileges.create = true;
               } else if (value.name === constants.PRIVILEGES.AMG_PRICING) {
                  vm.privileges.pricing = true;
               }
            });
         }
      }

      function editProduct(product) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/amg/product/update-modal/update-modal.html',
            controller: 'UpdateAmgProductModalController',
            controllerAs: 'vm',
            resolve: {
               productDependent: function () {
                  return {
                     product: product
                  };
               }
            }
         });
      }

      function createProduct() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/amg/product/create-modal/create-modal.html',
            controller: 'CreateAmgProductModalController',
            controllerAs: 'vm'
         });
      }

      function deleteConfirmation(product, event) {
         SweetAlert.swal({
           title: 'Hapus Product ' + product.name + '?',
           text: 'Product ' + product.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteProduct(product, event);
            }
         });
      }

      function deleteProduct(product, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         AmgService.deleteProduct(product.name, function(status, data) {
            if (status) {
               getProducts();
               SweetAlert.swal('Sukses', 'Product berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         getProducts();
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'amg.material',
         config: {
            url: '/material',
            templateUrl: 'app/amg/material/material.html',
            controllerAs: 'AmgMaterialController as vm',
            title: 'AMG Material'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.amg')
      .controller('AmgMaterialController', AmgMaterialController);

   AmgMaterialController.$inject = [
      '$scope',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert',
      'AmgService',
      'UserService'
   ];

   /* @ngInject */
   function AmgMaterialController(
      $scope,
      $uibModal,
      constants,
      validator,
      SweetAlert,
      AmgService,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.materials  = [];
      vm.user       = UserService.loggedInUser;
      vm.constants  = constants;
      vm.bulkUpdate = false;

      vm.privileges = {
         read: false,
         create: false,
         pricing: false
      }

      vm.filtering = {
         search: ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function(){
         vm.user = UserService.loggedInUser;

         checkMaterialPrivileges();
      });

      $scope.$on(constants.BROADCAST.INDEX_AMG_MATERIAL, function(){
         getMaterials();
      });

      // METHODS
      vm.refresh            = refresh;
      vm.editMaterial       = editMaterial;
      vm.createMaterial     = createMaterial;
      vm.deleteConfirmation = deleteConfirmation;
      vm.toggleBulk         = toggleBulk;
      vm.saveBulk           = saveBulk;

      getMaterials();
      checkMaterialPrivileges();

      function toggleBulk(event) {
         var element = $(event.currentTarget);

         if (!vm.bulkUpdate) {
            vm.bulkUpdate = true;

            element.removeClass('btn-primary').addClass('btn-danger');
            element.html('<i class="fa fa-times"></i> Cancel Bulk Update');
         } else {
            vm.bulkUpdate = false;

            element.removeClass('btn-danger').addClass('btn-primary');
            element.html('<i class="fa fa-pencil"></i> Bulk Update');
         }
      }

      function saveBulk(event) {
         $('#toggle-bulk').prop('disabled', true);
         $('#save-bulk').prop('disabled', true).html('Saving all changes...');

         var materials = []

         angular.forEach(vm.materials, function(value, key){
            var material = {
               material_name: value.name,
               spot_price: value.spot_price,
               import_price: value.import_price
            }

            materials.push(material);
         });

         AmgService.bulkMaterial({materials: materials}, function(status, data) {
            $('#toggle-bulk').prop('disabled', false);
            $('#save-bulk').prop('disabled', true).html('<i class="fa fa-save"></i> Save All Changes');

            $('#toggle-bulk').removeClass('btn-danger').addClass('btn-primary');
            $('#toggle-bulk').html('<i class="fa fa-pencil"></i> Bulk Update');

            if (status) {
               getMaterials();
               vm.bulkUpdate = false;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function getMaterials() {
         AmgService.getMaterial(null, function(status, data) {
            if (status) {
               vm.materials  = data.result;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function checkMaterialPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            pricing: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(value, key) {
               if (value.name === constants.PRIVILEGES.AMG_READ) {
                  vm.privileges.read = true;
               } else if (value.name === constants.PRIVILEGES.AMG_CREATE) {
                  vm.privileges.create = true;
               } else if (value.name === constants.PRIVILEGES.AMG_PRICING) {
                  vm.privileges.pricing = true;
               }
            });
         }
      }

      function editMaterial(material) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/amg/material/update-modal/update-modal.html',
            controller: 'UpdateAmgMaterialModalController',
            controllerAs: 'vm',
            resolve: {
               materialDependent: function () {
                  return {
                     material: material
                  };
               }
            }
         });
      }

      function createMaterial() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/amg/material/create-modal/create-modal.html',
            controller: 'CreateAmgMaterialModalController',
            controllerAs: 'vm'
         });
      }

      function deleteConfirmation(material, event) {
         SweetAlert.swal({
           title: 'Hapus Material ' + material.name + '?',
           text: 'Material ' + material.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteMaterial(material, event);
            }
         });
      }

      function deleteMaterial(material, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         AmgService.deleteMaterial(material.name, function(status, data) {
            if (status) {
               getMaterials();
               SweetAlert.swal('Sukses', 'Product berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         getMaterials();
      }
   }
})();

(function () {
  'use strict';

  angular.module('app.account', []);
})();

(function() {
   'use strict';

   angular
      .module('app.account')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'account.profile',
         config: {
            url: '/profile',
            templateUrl: 'app/account/profile/profile.html',
            controllerAs: 'AccountProfileController as vm',
            title: 'Profile'
         }
      }];
   }
})();

(function() {
	'use-strict';

	angular
		.module('app.account')
		.controller('AccountProfileController', AccountProfileController);

	AccountProfileController.$inject = [
		'$scope',
		'constants',
		'UserService'
	];

	function AccountProfileController(
		$scope,
		constants,
		UserService
	) {
		var vm = this;

		// PARAMS
		vm.user = UserService.loggedInUser;

		// HOOKS
		$scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
			vm.user = UserService.loggedInUser;
		});

		// METHODS
	}
})();
(function() {
   'use strict';

   angular
      .module('app.account')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'account.change-password',
         config: {
            url: '/change-password',
            templateUrl: 'app/account/change-password/change-password.html',
            controllerAs: 'AccountChangePasswordController as vm',
            title: 'Change Password'
         }
      }];
   }
})();

(function() {
	'use-strict';

	angular
		.module('app.account')
		.controller('AccountChangePasswordController', AccountChangePasswordController);

	AccountChangePasswordController.$inject = [
		'$scope',
		'SweetAlert',
		'validator',
		'UserService'
	];

	/* @ngInject */
	function AccountChangePasswordController(
		$scope,
		SweetAlert,
		validator,
		UserService
	) {
		var vm = this;

		// PARAMS
		vm.data = {};

		// HOOKS

		// METHODS
		vm.updateConfirmation = updateConfirmation;

		function updateConfirmation() {
			SweetAlert.swal({
				title: 'Ubah password?',
				text: 'Password anda yang sekarang akan berubah, pastikan login berikutnya menggunakan password yang baru.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Update',
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true
			}, function(isConfirm){
				if (isConfirm) {
					updatePassword();
				}
			});
		}

		function updatePassword() {
			UserService.changePassword(vm.data, function(status, data) {
				if (status) {
					vm.data = {};
					
					SweetAlert.swal('Sukses', 'Password anda berhasil dirubah!', 'success');
				} else {
					validator.validateAlert(data);
				}
			});
		}
	}
})();
(function () {
  'use strict';

  angular.module('app.widgets', []);
})();

(function() {
   'use strict';

   angular
      .module('app.widgets')
      .directive('sideNavigation', sideNavigation);

   /**
    * sideNavigation - Directive for run metsiMenu on sidebar navigation
    */

   sideNavigation.$inject = ['$timeout'];

   /* @ngInject */
   function sideNavigation($timeout) {
      var directive = {
         link: link,
         restrict: "A"
      }
      return directive;

      function link(scope, element) {
         // Call the metsiMenu plugin and plug it to sidebar navigation
         $timeout(function() {
            element.metisMenu();
         });
      }

   }

})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
	   .directive('ngPaginator', ngPaginator);

	function ngPaginator() {
		var directive = {
	      restrict: "A",
	      scope: true,
	      template: '<ul uib-pagination first-text="Halaman Awal" last-text="Halaman Akhir" direction-links="false" total-items="vm.pagination.totalItems" items-per-page="vm.pagination.itemsPerPage" ng-model="vm.pagination.currentPage" class="pagination-sm" boundary-links="true" force-ellipses="true" ng-change="vm.pageChanged()" max-size="5" boundary-links="true" force-ellipses="true"></ul>'
	   }

	   return directive;
	}
})();
(function() {
   'use strict';
   /**
    * pageTitle - Directive for set Page title - mata title
    */
   angular
      .module('app.widgets')
      .directive('pageTitle', pageTitle);

   pageTitle.$inject = ['$rootScope', '$timeout'];

   /* @ngInject */
   function pageTitle($rootScope, $timeout) {
      var directive = {
         link: link,
         restrict: "A"
      }

      return directive;

      function link(scope, element) {
         var listener = function(event, toState) {
            // Default title - load on Dashboard 1
            var title = 'Innapack | Admin';
            // Create your own title pattern
            if (toState && toState.title) title = 'Innapack | ' + toState.title;
            $timeout(function() {
               element.text(title);
            });
         };

         var rootScop = $rootScope;

         rootScop.$on('$stateChangeStart', listener);
      }
   }
})();
(function() {
   'use strict';

   angular
      .module('app.widgets')
      .directive('minimalizaSidebar', minimalizaSidebar)
      .controller('minimalizaSidebarController', minimalizaSidebarController);

   /**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */

   minimalizaSidebar.$inject = ['$timeout'];

   /* @ngInject */
   function minimalizaSidebar($timeout) {
      var directive = {
         restrict: "A",
         controller: minimalizaSidebarController,
         template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>'
      }

      return directive;
   }

   minimalizaSidebarController.$inject = ['$scope', '$timeout'];

   function minimalizaSidebarController($scope, $timeout) {

      $scope.minimalize = minimalize;

      function minimalize() {
         $("body").toggleClass("mini-navbar");
         
         if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            $('#side-menu').hide();
            // For smoothly turn on menu
            $timeout(
               function() {
                  $('#side-menu').fadeIn(400);
               }, 200);
         } else if ($('body').hasClass('fixed-sidebar')) {
            $('#side-menu').hide();
            $timeout(
               function() {
                  $('#side-menu').fadeIn(400);
               }, 100);
         } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            $('#side-menu').removeAttr('style');
         }
      }
   }

})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
		.directive('customOnChange', customOnChange);

	/**
    * custom-on-change
    * widget for trigger change event on file input
    */

    // customOnChange.$inject = ['$scope'];

    function customOnChange() {
        return {
            scope:{
                customOnChange:"&"
            },
            link:function($scope, $element, $attrs){
                $element.on("change",function(event){
                    $scope.customOnChange({$event: event})
                })
                $scope.$on("$destroy",function(){
                    $element.off();
                });
            }
        };
    }
})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
	   	.directive('icheck', icheck);

	icheck.$inject = ['$timeout'];

	function icheck($timeout) {
		var directive = {
         	link: link,
         	require: 'ngModel',
         	restrict: "A"
      	}

      	return directive;

    	function link($scope, element, $attrs, ngModel) {
         	return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
      	}
	}
})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
		.directive('fooRepeatDone', fooRepeatDone);

	/**
    * fooRepeatDone
    * refresh footable after all data loaded
    */
    function fooRepeatDone() {
        return function($scope, element) {
            if ($scope.$last) { // all are rendered
                $('.table').trigger('footable_redraw');
            }
        }
    }
})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
		.directive('fileModel', fileModel);

	/**
    * ngConfirmClick
    * widget for click confirmation before trigger a function
    */

    fileModel.$inject = ['$parse'];

    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                
                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });

                    scope.fileChanged();
                });
            }
        };
    }
})();
(function(){
	'use strict';

	angular
		.module('app.widgets')
		.directive('ngConfirmClick', ngConfirmClick);

	/**
    * ngConfirmClick
    * widget for click confirmation before trigger a function
    */
   function ngConfirmClick() {
   	return {
            link: function (scope, element, attr) {
                var msg = attr.ngConfirmClick || "Are you sure?";
                var clickAction = attr.confirmedClick;
                element.bind('click',function (event) {
                    if ( window.confirm(msg) ) {
                        scope.$eval(clickAction)
                    }
                });
            }
        };
   }
})();
(function() {
   'use strict';

   angular
      .module('app.user')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'user',
         config: {
            abstract: true,
            url: '/user',
            templateUrl: 'app/user/user.html'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.setting')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'setting',
         config: {
            abstract: true,
            url: '/setting',
            templateUrl: 'app/setting/setting.html'
         }
      }];
   }
})();

(function () {
  'use strict';

  angular
    .module('app.service', []);

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('CommissionService', CommissionService);

   CommissionService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function CommissionService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getCommission           = getCommission;
      this.showCommission          = showCommission;
      this.createCommissionPayment = createCommissionPayment;
      this.updateCommissionPayment = updateCommissionPayment;
      this.payCommissionPayment    = payCommissionPayment;

      function getCommission(parameters, callback) {
         httpRequest.request('/commission', constants.METHOD.GET, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function showCommission(hashId, callback) {
         httpRequest.request('/commission/' + hashId, constants.METHOD.GET)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createCommissionPayment(commissionHashId, parameters, callback) {
         httpRequest.request('/commission/' + commissionHashId + '/commission-payment', constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateCommissionPayment(commissionHashId, commissionPaymentHashId, parameters, callback) {
         httpRequest.request('/commission/' + commissionHashId + '/commission-payment/' + commissionPaymentHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function payCommissionPayment(commissionHashId, commissionPaymentHashId, parameters, callback) {
         httpRequest.request('/commission/' + commissionHashId + '/commission-payment/' + commissionPaymentHashId + '/pay', constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('UserService', UserService);

   UserService.$inject = [
      '$rootScope',
      '$state',
      'base64',
      'httpRequest',
      'constants'
   ];

   function UserService(
      $rootScope,
      $state, 
      base64, 
      httpRequest, 
      constants
   ) {
      this.loggedInUser    = null;
      this.setLoggedInUser = setLoggedInUser;
      this.loginUser       = loginUser;
      this.getUsers        = getUsers;
      this.showUser        = showUser;
      this.showDetailUser  = showDetailUser;
      this.create          = create;
      this.update          = update;
      this.uploadImage     = uploadImage;
      this.logout          = logout;
      this.changeStatus    = changeStatus;
      this.resetPassword    = resetPassword;
      this.changePassword  = changePassword;

      function setLoggedInUser(user) {
         this.loggedInUser = user;
         $rootScope.$broadcast(constants.BROADCAST.LOGGED_IN_USER);
      }

      function loginUser(parameters, callback) {
         var headers = [];
         headers['Authorization'] = base64.encode(parameters.email + ':' + parameters.password);

         httpRequest.request('/login', constants.METHOD.POST, null, headers, false)
            .success(function(data) {
               var authorization_header = data.session;
               window.localStorage.setItem(constants.AUTHORIZATION_ADMIN_HEADER, authorization_header);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function getUsers(parameters, callback) {
         httpRequest.request('/user', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function create(parameters, callback) {
         httpRequest.request('/user', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function update(parameters, userHashId, callback) {
         httpRequest.request('/user/' + userHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function uploadImage(parameters, userHashId, callback) {
         httpRequest.request('/user/' + userHashId + '/upload/profile-picture' , constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function showUser(parameters, callback) {
         httpRequest.request('/profile', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function showDetailUser(hashId, callback) {
         httpRequest.request('/user/' + hashId, constants.METHOD.GET)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function logout() {
         httpRequest.request('/logout', constants.METHOD.POST)
            .success(function() {
               window.localStorage.clear();
               
               $state.go('login', {}, {
                  location: 'replace'
               });
            });
      }

      function changeStatus(userHashId, parameters, callback) {
         httpRequest.request('/user/' + userHashId + '/active-status', constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function resetPassword(userHashId, callback) {
         httpRequest.request('/user/' + userHashId + '/reset-password', constants.METHOD.POST)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function changePassword(parameters, callback) {
         httpRequest.request('/change-password', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('TransportService', TransportService);

   TransportService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function TransportService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getTransport    = getTransport;
      this.storeTransport  = storeTransport;
      this.updateTransport = updateTransport;
      this.removeTransport = removeTransport;

      function getTransport(parameters, callback) {
         httpRequest.request('/transport', constants.METHOD.GET, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function storeTransport(parameters, callback) {
         httpRequest.request('/transport', constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateTransport(hashId, parameters, callback) {
         httpRequest.request('/transport/' + hashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function removeTransport(hashId, callback) {
         httpRequest.request('/transport/' + hashId, constants.METHOD.DELETE)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
	'use-strict';

	angular
		.module('app.service')
		.service('SettingService', SettingService);

	SettingService.$inject = [
		'$rootScope',
		'$state',
		'base64',
		'httpRequest',
		'constants'
	];

	function SettingService(
		$rootScope,
		Sstate,
		base64,
		httpRequest,
		constants
	) {
		// PARAMS

		// METHODS
		this.getCommission    = getCommission;
		this.storeCommission  = storeCommission;
		this.updateCommission = updateCommission;
		this.removeCommission = removeCommission;

		this.getQuotationSettings   = getQuotationSettings;
		this.updateQuotationSetting = updateQuotationSetting;

		this.getMaterialSettings   = getMaterialSettings;
		this.updateMaterialSetting = updateMaterialSetting;

		this.getCommissionTimeline    = getCommissionTimeline;
		this.storeCommissionTimeline  = storeCommissionTimeline;
		this.updateCommissionTimeline = updateCommissionTimeline;
		this.removeCommissionTimeline = removeCommissionTimeline;

		this.showQuotationSetting = showQuotationSetting;

		function showQuotationSetting(id, callback) {
			httpRequest.request('/quotation-setting/'+id, constants.METHOD.GET)
				.success(function(data) {
					callback(true, data);
				})
				.error(function(data) {
						callback(false, data);
				});
		}

		function getCommission(parameters, callback) {
	         httpRequest.request('/commission-setting', constants.METHOD.GET, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function storeCommission(parameters, callback) {
	         httpRequest.request('/commission-setting', constants.METHOD.POST, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function updateCommission(hashId, parameters, callback) {
	         httpRequest.request('/commission-setting/' + hashId, constants.METHOD.PATCH, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function removeCommission(hashId, callback) {
	         httpRequest.request('/commission-setting/' + hashId, constants.METHOD.DELETE)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }


	      function getCommissionTimeline(parameters, callback) {
	         httpRequest.request('/commission-timeline-setting', constants.METHOD.GET, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function storeCommissionTimeline(parameters, callback) {
	         httpRequest.request('/commission-timeline-setting', constants.METHOD.POST, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function updateCommissionTimeline(hashId, parameters, callback) {
	         httpRequest.request('/commission-timeline-setting/' + hashId, constants.METHOD.PATCH, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }
	      function removeCommissionTimeline(hashId, callback) {
	         httpRequest.request('/commission-timeline-setting/' + hashId, constants.METHOD.DELETE)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	      }

		function getQuotationSettings(parameters, callback) {
         	httpRequest.request('/quotation-setting', constants.METHOD.GET, parameters)
            	.success(function(data) {
              		callback(true, data);
            	})
            	.error(function(data) {
               		callback(false, data);
            	});
      	}
      	function updateQuotationSetting(code, parameters, callback) {
	         httpRequest.request('/quotation-setting/' + code, constants.METHOD.PATCH, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	    }

	    function getMaterialSettings(parameters, callback) {
         	httpRequest.request('/material/constant', constants.METHOD.GET, parameters)
            	.success(function(data) {
              		callback(true, data);
            	})
            	.error(function(data) {
               		callback(false, data);
            	});
      	}
      	function updateMaterialSetting(code, parameters, callback) {
	         httpRequest.request('/material/constant/' + code, constants.METHOD.PATCH, parameters)
	            .success(function(data) {
	              callback(true, data);
	            })
	            .error(function(data) {
	               callback(false, data);
	            });
	    }
	}
})();
(function() {
   'use strict';

   angular
      .module('app.service')
      .service('RoleService', RoleService);

   RoleService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function RoleService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params
      this.roles      = [];
      this.privileges = [];

      // Methods
      this.getRoles = getRoles;
      this.setRoles = setRoles;
      this.indexing = indexing;

      this.getPrivileges = getPrivileges;
      this.setPrivileges = setPrivileges;

      this.createRole = createRole;
      this.updateRole = updateRole;
      this.deleteRole = deleteRole;

      function setRoles(roles) {
         this.roles = roles;
         
         $rootScope.$broadcast(constants.BROADCAST.INDEX_ROLE);
      }

      function getRoles(parameters, callback) {
         httpRequest.request('/role', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function indexing() {
         var that = this;

         this.getRoles(null, function(status, data){
            if (status) {
               that.setRoles(data.data);
            }
         });
      }

      function setPrivileges(privileges) {
         this.privileges = privileges;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_PRIVILEGE);
      }

      function getPrivileges(parameters, callback) {
         httpRequest.request('/role-privilege', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });;
      }

      function createRole(parameters, callback) {
         var that = this;

         httpRequest.request('/role', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing();
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });;
      }

      function updateRole(parameters, roleHashId, callback) {
         var that = this;

         httpRequest.request('/role/' + roleHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
              that.indexing();
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });;
      }

      function deleteRole(roleHashId, callback) {
         var that = this;
         httpRequest.request('/role/' + roleHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing();
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });;
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('ReferralService', ReferralService);

   ReferralService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function ReferralService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getReferral    = getReferral;
      this.showReferral   = showReferral;
      this.storeReferral  = storeReferral;
      this.updateReferral = updateReferral;
      this.removeReferral = removeReferral;
      this.payCommission  = payCommission;

      function getReferral(parameters, callback) {
         httpRequest.request('/referral', constants.METHOD.GET, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function showReferral(hashId, callback) {
         httpRequest.request('/referral/' + hashId, constants.METHOD.GET)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function storeReferral(parameters, callback) {
         httpRequest.request('/referral', constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateReferral(hashId, parameters, callback) {
         httpRequest.request('/referral/' + hashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function removeReferral(hashId, callback) {
         httpRequest.request('/referral/' + hashId, constants.METHOD.DELETE)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function payCommission(referralHashId, commissionHashId, parameters, callback) {
         httpRequest.request('/referral/' + referralHashId + '/referral-commission/' + commissionHashId, constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('QuotationTermService', QuotationTermService);

   QuotationTermService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function QuotationTermService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getQuotationTerm    = getQuotationTerm;
      this.storeQuotationTerm  = storeQuotationTerm;
      this.updateQuotationTerm = updateQuotationTerm;
      this.removeQuotationTerm = removeQuotationTerm;

      function getQuotationTerm(parameters, callback) {
         httpRequest.request('/quotation-term-template', constants.METHOD.GET, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function storeQuotationTerm(parameters, callback) {
         httpRequest.request('/quotation-term-template', constants.METHOD.POST, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateQuotationTerm(hashId, parameters, callback) {
         httpRequest.request('/quotation-term-template/' + hashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function removeQuotationTerm(hashId, callback) {
         httpRequest.request('/quotation-term-template/' + hashId, constants.METHOD.DELETE)
            .success(function(data) {
              callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('QuotationService', QuotationService);

   QuotationService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function QuotationService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getQuotations                  = getQuotations;
      this.showQuotation                  = showQuotation;
      this.storeQuotation                 = storeQuotation;
      this.updateQuotation                = updateQuotation;
      this.deleteQuotation                = deleteQuotation;
      this.submitQuotation                = submitQuotation;
      this.rejectQuotation                = rejectQuotation;
      this.approveQuotation               = approveQuotation;
      this.quotationSubmitPO              = quotationSubmitPO;
      this.quotationApprovePO             = quotationApprovePO;
      this.quotationSubmitPOConfirmation  = quotationSubmitPOConfirmation;
      this.quotationApprovePOConfirmation = quotationApprovePOConfirmation;
      this.quotationRejectPO              = quotationRejectPO;
      this.saveQuotation                  = saveQuotation;
      this.createProduct                  = createProduct;
      this.createQuotationShortCut        = createQuotationShortCut;
      this.downloadQuotation              = downloadQuotation;
      this.downloadPOConfirmation         = downloadPOConfirmation;

      function getQuotations(parameters, callback) {
         httpRequest.request('/quotation', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function showQuotation(quotationHashId, callback) {
         httpRequest.request('/quotation/' + quotationHashId, constants.METHOD.GET)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function storeQuotation(parameters, callback) {
         httpRequest.request('/quotation', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateQuotation(hashId, parameters, callback) {
         httpRequest.request('/quotation/' + hashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteQuotation(hashId, callback) {
         httpRequest.request('/quotation/' + hashId, constants.METHOD.DELETE)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function submitQuotation(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/submit', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function approveQuotation(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/approve', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function rejectQuotation(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/reject', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function quotationSubmitPO(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/submit-purchase-order', constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function quotationApprovePO(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/approve-purchase-order', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function quotationSubmitPOConfirmation(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/submit-purchase-order-confirmation', constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function quotationApprovePOConfirmation(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/approve-purchase-order-confirmation', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function quotationRejectPO(hashId, parameters, callback) {
         httpRequest.request('/quotation/'+hashId+'/reject-purchase-order', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createProduct(parameters, quotationHashId, callback) {
         httpRequest.request('/marketing/quotation/' + quotationHashId + '/product', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function saveQuotation(parameters, quotationHashId, callback) {
         httpRequest.request('/marketing/quotation/' + quotationHashId + '/save', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createQuotationShortCut(parameters, callback) {
         httpRequest.request('/marketing/quotation/store-all', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function downloadQuotation(hashId, callback) {
         httpRequest.request('/quotation/'+hashId+'/download/quotation', constants.METHOD.POST)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function downloadPOConfirmation(hashId, callback) {
         httpRequest.request('/quotation/'+hashId+'/download/purchase-order-confirmation', constants.METHOD.POST)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('MaterialService', MaterialService);

   MaterialService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function MaterialService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params
      this.materialInk        = [];
      this.materialPrinting   = [];
      this.materialLaminating = [];
      this.materialSlitting   = [];
      this.materialPacking    = [];
      this.materialConstant   = [];

      // Methods
      this.indexing = indexing;

      this.setMaterialInk        = setMaterialInk;
      this.setMaterialPrinting   = setMaterialPrinting;
      this.setMaterialLaminating = setMaterialLaminating;
      this.setMaterialSlitting   = setMaterialSlitting;
      this.setMaterialPacking    = setMaterialPacking;
      this.setMaterialConstant   = setMaterialConstant;

      this.getMaterialInk        = getMaterialInk;
      this.getMaterialPrinting   = getMaterialPrinting;
      this.getMaterialLaminating = getMaterialLaminating;
      this.getMaterialSlitting   = getMaterialSlitting;
      this.getMaterialPacking    = getMaterialPacking;
      this.getMaterialConstant   = getMaterialConstant;
      this.getMaterialBulkUpdate = getMaterialBulkUpdate;

      this.createMaterialInk        = createMaterialInk;
      this.createMaterialPrinting   = createMaterialPrinting;
      this.createMaterialLaminating = createMaterialLaminating;
      this.createMaterialSlitting   = createMaterialSlitting;
      this.createMaterialPacking    = createMaterialPacking;

      this.updateMaterialInk        = updateMaterialInk;
      this.updateMaterialPrinting   = updateMaterialPrinting;
      this.updateMaterialLaminating = updateMaterialLaminating;
      this.updateMaterialSlitting   = updateMaterialSlitting;
      this.updateMaterialPacking    = updateMaterialPacking;
      this.updateMaterialConstant   = updateMaterialConstant;
      this.updateMaterialBulkUpdate = updateMaterialBulkUpdate;

      this.deleteMaterialInk        = deleteMaterialInk;
      this.deleteMaterialPrinting   = deleteMaterialPrinting;
      this.deleteMaterialLaminating = deleteMaterialLaminating;
      this.deleteMaterialSlitting   = deleteMaterialSlitting;
      this.deleteMaterialPacking    = deleteMaterialPacking;

      function indexing(type) {
         var that = this;

         if (type === constants.MATERIAL_TYPE.INK) {
            this.getMaterialInk(null, function(status, response){
               if (status) {
                  that.setMaterialInk(response);
               }
            });
         } else if (type === constants.MATERIAL_TYPE.PRINTING) {
            this.getMaterialPrinting(null, function(status, response){
               if (status) {
                  that.setMaterialPrinting(response);
               }
            });
         } else if (type === constants.MATERIAL_TYPE.LAMINATING) {
            this.getMaterialLaminating(null, function(status, response){
               if (status) {
                  that.setMaterialLaminating(response);
               }
            });
         } else if (type === constants.MATERIAL_TYPE.SLITTING) {
            this.getMaterialSlitting(null, function(status, response){
               if (status) {
                  that.setMaterialSlitting(response);
               }
            });
         } else if (type === constants.MATERIAL_TYPE.PACKING) {
            this.getMaterialPacking(null, function(status, response){
               if (status) {
                  that.setMaterialPacking(response);
               }
            });
         }
      }

      function setMaterialInk(materials) {
         this.materialInk = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_INK);
      }
      function setMaterialPrinting(materials) {
         this.materialPrinting = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_PRINTING);
      }
      function setMaterialLaminating(materials) {
         this.materialLaminating = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_LAMINATING);
      }
      function setMaterialSlitting(materials) {
         this.materialSlitting = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_SLITTING);
      }
      function setMaterialPacking(materials) {
         this.materialPacking = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_PACKING);
      }
      function setMaterialConstant(materials) {
         this.materialConstant = materials;

         $rootScope.$broadcast(constants.BROADCAST.INDEX_MATERIAL_CONSTANT);
      }

      function getMaterialInk(parameters, callback) {
         httpRequest.request('/material/ink', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialPrinting(parameters, callback) {
         httpRequest.request('/material/printing', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialLaminating(parameters, callback) {
         httpRequest.request('/material/laminating', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialSlitting(parameters, callback) {
         httpRequest.request('/material/slitting', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialPacking(parameters, callback) {
         httpRequest.request('/material/packing', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialConstant(callback) {
         httpRequest.request('/material/constant', constants.METHOD.GET)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function getMaterialBulkUpdate(callback) {
         httpRequest.request('/material/pricing', constants.METHOD.GET)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createMaterialInk(parameters, callback) {
         var that = this;

         httpRequest.request('/material/ink', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.INK);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function createMaterialPrinting(parameters, callback) {
         var that = this;

         httpRequest.request('/material/printing', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PRINTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function createMaterialLaminating(parameters, callback) {
         var that = this;

         httpRequest.request('/material/laminating', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.LAMINATING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function createMaterialSlitting(parameters, callback) {
         var that = this;

         httpRequest.request('/material/slitting', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.SLITTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function createMaterialPacking(parameters, callback) {
         var that = this;

         httpRequest.request('/material/packing', constants.METHOD.POST, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PACKING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateMaterialInk(parameters, materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/ink/' + materialHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.INK);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialPrinting(parameters, materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/printing/' + materialHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PRINTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialLaminating(parameters, materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/laminating/' + materialHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.LAMINATING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialSlitting(parameters, materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/slitting/' + materialHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.SLITTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialPacking(parameters, materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/packing/' + materialHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PACKING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialConstant(type, parameters, callback) {
         httpRequest.request('/material/constant/' + type, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function updateMaterialBulkUpdate(parameters, callback) {
         httpRequest.request('/material/pricing', constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteMaterialInk(materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/ink/' + materialHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.INK);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function deleteMaterialPrinting(materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/printing/' + materialHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PRINTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function deleteMaterialLaminating(materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/laminating/' + materialHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.LAMINATING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function deleteMaterialSlitting(materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/slitting/' + materialHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.SLITTING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function deleteMaterialPacking(materialHashId, callback) {
         var that = this;

         httpRequest.request('/material/packing/' + materialHashId, constants.METHOD.DELETE)
            .success(function(data) {
               that.indexing(constants.MATERIAL_TYPE.PACKING);
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('CustomerService', CustomerService);

   CustomerService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function CustomerService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getCustomers = getCustomers;
      this.show         = show;
      this.create       = create;
      this.update       = update;
      this.changeStatus = changeStatus;

      this.upload       = upload;
      this.uploadIdCard = uploadIdCard;

      this.updateImportantPerson = updateImportantPerson;
      this.createImportantPerson = createImportantPerson;
      this.deleteImportantPerson = deleteImportantPerson;

      this.createProduct = createProduct;
      this.deleteProduct = deleteProduct;

      this.createImage = createImage;
      this.updateImage = updateImage;
      this.deleteImage = deleteImage;

      this.createAddress = createAddress;
      this.updateAddress = updateAddress;
      this.deleteAddress = deleteAddress;

      this.submit   = submit;
      this.approve  = approve;
      this.reject   = reject;
      this.reassign = reassign;

      function getCustomers(parameters, callback) {
         httpRequest.request('/customer', constants.METHOD.GET, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function show(customerHashId, callback) {
         httpRequest.request('/customer/' + customerHashId, constants.METHOD.GET)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function create(parameters, callback) {
         httpRequest.request('/customer', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function update(parameters, customerHashId, callback) {
         httpRequest.request('/customer/' + customerHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function changeStatus(hashId, parameters, callback) {
         httpRequest.request('/customer/' + hashId + '/active-status', constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function upload(parameters, customerHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/upload' , constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function uploadIdCard(parameters, customerHashId, importantPersonHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/important-person/' + importantPersonHashId + '/upload' , constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateImportantPerson(parameters, customerHashId, importantPersonHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/important-person/' + importantPersonHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createImportantPerson(parameters, customerHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/important-person', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteImportantPerson(customerHashId, importantPersonHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/important-person/' + importantPersonHashId, constants.METHOD.DELETE)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createProduct(parameters, customerHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/product', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteProduct(customerHashId, productHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/product/' + productHashId, constants.METHOD.DELETE)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createImage(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/image', constants.METHOD.POST, parameters, undefined, undefined, true)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateImage(customerHashId, imageHashId, isImage, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/image/' + imageHashId, constants.METHOD.POST, parameters, undefined, undefined, isImage)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteImage(customerHashId, imageHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/image/' + imageHashId, constants.METHOD.DELETE)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function createAddress(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/address', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function updateAddress(customerHashId, addressHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/address/' + addressHashId, constants.METHOD.PATCH, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function deleteAddress(customerHashId, addressHashId, callback) {
         httpRequest.request('/customer/' + customerHashId + '/address/' + addressHashId, constants.METHOD.DELETE)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }

      function submit(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/submit', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function approve(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/approve', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function reject(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/reject', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
      function reassign(customerHashId, parameters, callback) {
         httpRequest.request('/customer/' + customerHashId + '/reassign-sales', constants.METHOD.POST, parameters)
            .success(function(data) {
               callback(true, data);
            })
            .error(function(data) {
               callback(false, data);
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.service')
      .service('AmgService', AmgService);

   AmgService.$inject = [
      '$state', 
      'base64', 
      'httpRequest', 
      'constants',
      '$rootScope'
   ];

   function AmgService(
      $state, 
      base64, 
      httpRequest, 
      constants,
      $rootScope
   ) {
      // Params

      // Methods
      this.getMaterial    = getMaterial;
      this.createMaterial = createMaterial;
      this.deleteMaterial = deleteMaterial;
      this.bulkMaterial   = bulkMaterial;

      this.getProduct    = getProduct;
      this.createProduct = createProduct;
      this.deleteProduct = deleteProduct;

      function getMaterial(parameters, callback) {
         httpRequest.request('/amg/material', constants.METHOD.GET, parameters)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK)
                  callback(true, data);
               else
                  callback(false, data);
            });
      }
      function createMaterial(parameters, callback) {
         httpRequest.request('/amg/material', constants.METHOD.POST, parameters)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK) {
                  callback(true, data);
               } else {
                  callback(false, data);
               }
            });
      }
      function bulkMaterial(parameters, callback) {
         httpRequest.request('/amg/material/pricing', constants.METHOD.POST, parameters)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK) {
                  callback(true, data);
               } else {
                  callback(false, data);
               }
            });
      }
      function deleteMaterial(materialName, callback) {
         httpRequest.request('/amg/material/' + materialName, constants.METHOD.DELETE)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK) {
                  callback(true, data);
               } else {
                  callback(false, data);
               }
            });
      }

       function getProduct(parameters, callback) {
         httpRequest.request('/amg/product', constants.METHOD.GET, parameters)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK)
                  callback(true, data);
               else
                  callback(false, data);
            });
      }
      function createProduct(parameters, callback) {
         httpRequest.request('/amg/product', constants.METHOD.POST, parameters)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK) {
                  callback(true, data);
               } else {
                  callback(false, data);
               }
            });
      }
      function deleteProduct(productName, callback) {
         httpRequest.request('/amg/product/' + productName, constants.METHOD.DELETE)
            .success(function(data) {
               if (data.status == constants.RESPONSE.OK) {
                  callback(true, data);
               } else {
                  callback(false, data);
               }
            });
      }
   }

})();

(function() {
   'use strict';

   angular
      .module('app.role')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [
      {
         state: 'role',
         config: {
            url: '/role?search',
            templateUrl: 'app/role/role.html',
            controllerAs: 'RoleController as vm',
            title: 'Role'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.role')
      .controller('RoleController', RoleController);

   RoleController.$inject = [
      '$location',
      '$stateParams',
      '$scope',
      'RoleService',
      'UserService',
      '$uibModal',
      'constants',
      'validator',
      'SweetAlert'
   ];

   /* @ngInject */
   function RoleController(
      $location,
      $stateParams,
      $scope,
      RoleService,
      UserService,
      $uibModal,
      constants,
      validator,
      SweetAlert
   ) {
      var vm = this;

      // PARAMS
      vm.roles     = RoleService.roles;
      vm.user      = UserService.loggedInUser;
      vm.constants = constants;

      vm.filtering = {
         search: $stateParams.search ? $stateParams.search : ''
      };

      // HOOKS
      $scope.$on(constants.BROADCAST.INDEX_ROLE, function() {
         vm.roles = RoleService.roles;
      });

      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;

         checkUserPrivileges();
      });

      // METHODS
      vm.refresh                = refresh;
      vm.getRoles               = getRoles;
      vm.editRole               = editRole;
      vm.createRole             = createRole;
      vm.deleteRoleConfirmation = deleteRoleConfirmation;
      vm.filter                 = filter;
      vm.showGuide              = showGuide;

      checkUserPrivileges();

      function checkUserPrivileges() {
         vm.privileges = {
            read: false,
            create: false,
            update: false,
            delete: false
         }
      
         if (vm.user && vm.user.role) {
            var privileges = vm.user.role.role_privileges;

            angular.forEach(privileges, function(val, opt) {
               if (val.name === constants.PRIVILEGES.ROLE_READ) {
                  vm.privileges.read = true;
               } else if (val.name === constants.PRIVILEGES.ROLE_CREATE) {
                  vm.privileges.create = true;
               } else if(val.name === constants.PRIVILEGES.ROLE_UPDATE) {
                  vm.privileges.update = true;
               } else if(val.name === constants.PRIVILEGES.ROLE_DELETE) {
                  vm.privileges.delete = true;
               }
            });
         }
      }

      function getRoles(params) {
         RoleService.getRoles(params, function(status, data) {
            if (status) {
               vm.roles = data.data;
            } else {
               validator.validateAlert(data);
            }
         });
      }

      function editRole(role) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/role/update-modal/update-modal.html',
            controller: 'UpdateRoleModalController',
            controllerAs: 'vm',
            resolve: {
               roleDependent: function () {
                  return {
                     role: role
                  };
               }
            }
         });
      }

      function createRole(user) {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/role/create-modal/create-modal.html',
            controller: 'CreateRoleModalController',
            controllerAs: 'vm'
         });
      }

      function showGuide() {
         $uibModal.open({
            animation: true,
            templateUrl: 'app/role/guide-modal/guide-modal.html',
            controller: 'RoleGuideModalController',
            controllerAs: 'vm'
         });
      }

      function deleteRoleConfirmation(role, event) {
         SweetAlert.swal({
           title: 'Hapus Role ' + role.name + '?',
           text: 'Role ' + role.name + ' akan dihapus dari database!',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: constants.COLOR.DANGER,
           confirmButtonText: "Mengerti, lanjutkan!",
           cancelButtonText: 'Batalkan',
           closeOnConfirm: false,
           showLoaderOnConfirm: true,
         },
         function(isConfirm){
            if (isConfirm) {
               deleteRole(role, event);
            }
         });
      }

      function deleteRole(role, event) {
         var button = $(event.target);

         button.closest('tr').find('button').prop('disabled', true);
         button.html('<i class="fa fa-spin fa-spinner"></i> Menghapus...');

         RoleService.deleteRole(role.hash_id, function(status, data) {
            if (status) {
               getRoles(vm.filtering);
               SweetAlert.swal('Sukses', 'Role berhasil dihapus!', 'success');
            } else {
               validator.validateAlert(data);
            }

            button.closest('tr').find('button').prop('disabled', false);
            button.html('<i class="fa fa-trash"></i> Hapus');
         });
      }

      function refresh() {
         vm.roles  = [];

         getRoles(vm.filtering);
      }

      function filter() {
         $location.url('/role?search=' + vm.filtering.search);
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('app.referral')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'referral',
         config: {
            abstract: true,
            url: '/referral',
            templateUrl: 'app/referral/referral.html'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.quotation')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'quotation',
         config: {
            abstract: true,
            url: '/quotation',
            templateUrl: 'app/quotation/quotation.html'
         }
      }];
   }
})();

(function () {
  'use strict';

  angular.module('app.pricing', []);
})();

(function() {
	'use strict';

	angular
	.module('app.pricing')
	.run(appRun);

	appRun.$inject = ['routerHelper'];

	/* @ngInject */
	function appRun(routerHelper) {
		routerHelper.configureStates(getStates());
	}

	function getStates() {
		return [{
			state: 'pricing',
			config: {
				url: '/pricing',
				templateUrl: 'app/pricing/pricing.html',
				controllerAs: 'PricingController as vm',
				title: 'Pricing'
			}
		}];
	}
})();

(function() {
	'use-strict';

	angular
	.module('app.pricing')
	.controller('PricingController', PricingController);

	PricingController.$inject = [
	'$rootScope',
	'$scope',
	'SweetAlert',
	'constants',
	'validator',
	'requestHelper',
	'MaterialService',
	'globalState',
	'UserService'
	];

	function PricingController(
		$rootScope,
		$scope,
		SweetAlert,
		constants,
		validator,
		requestHelper,
		MaterialService,
		globalState,
		UserService
		) {
		var vm = this;

		// PARAMS
		vm.toggleUpdate    = false;
		vm.constants       = constants;
		vm.user            = UserService.loggedInUser;
		vm.materials       = [];
		vm.clonedMaterials = [];
		vm.data            = {};

		vm.privileges = {
			read: false,
			update: false
		}

		// HOOKS
		$scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
			vm.user = UserService.loggedInUser;

			checkPricingPrivileges();
		});

		// METHODS
		vm.setTime = globalState.setTime;
		vm.storeConfirmation = storeConfirmation;
		vm.toggleEdit        = toggleEdit;

		getMaterial();
		checkPricingPrivileges();

		function getMaterial() {
			MaterialService.getMaterialBulkUpdate(function(status, data) {
				if (status) {
					vm.materials       = angular.copy(data);
					vm.clonedMaterials = angular.copy(data);
				} else {
					validator.validateAlert(data);
				}
			});
		}
		
		function checkPricingPrivileges() {
			vm.privileges = {
				read: false,
				update: false
			}
		
			if (vm.user && vm.user.role) {
				var privileges = vm.user.role.role_privileges;

				$.each(privileges, function(index, val) {
					if (val.name === constants.PRIVILEGES.MATERIAL_PRICING) {
						vm.privileges.read   = true;
						vm.privileges.update = true;
					}
				});
			}
		}

		function storeConfirmation() {
			SweetAlert.swal({
				title: 'Ubah semua harga material?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: "Simpan Perubahan",
				cancelButtonText: 'Batalkan',
				closeOnConfirm: false,
				showLoaderOnConfirm: true,
			},
			function(isConfirm){
				if (isConfirm) {
					store();
				}
			});
		}

		function store() {
			var materials = {
				material_constant: [],
				printing_material: [],
				laminating_material: [],
				printing_ink: [],
				slitting_material: [],
				packing_material: []
			};

			angular.forEach(vm.materials, function(data, key) {
				if (key === constants.PRICING_TYPE.MATERIAL_CONSTANT) {
					angular.forEach(data, function(value, keyValue) {
						materials.material_constant.push({
							code: value.code,
							value: value.material_constant_histories.conversion.value
						});
					})
				} else {
					angular.forEach(data, function(value, keyValue) {
						materials[key].push({
							hash_id: value.hash_id,
							price: value[key + '_prices'].conversion.price
						});
					});
				}
			});

			MaterialService.updateMaterialBulkUpdate(materials, function(status, data) {
				if (status) {
					vm.toggleUpdate = false;

					SweetAlert.swal('Sukses', 'Perubahan berhasil disimpan!', 'success');
					getMaterial();
				} else {
					validator.validateAlert(data);
				}
			});
		}

		function toggleEdit(event) {
			var today   = new Date();
			var element = $(event.currentTarget);

			if(vm.toggleUpdate) {
				vm.toggleUpdate = false;

				$('form').find('input').prop('disabled', true);

				if (today.getDay() === constants.PRICING_DAY) {
					getMaterial();
				}
			} else {
				vm.toggleUpdate = true;

				$('form').find('input').prop('disabled', false);

				if (today.getDay() === constants.PRICING_DAY) {
					angular.forEach(vm.materials, function(value, key) {
						angular.forEach(value, function(value2, key2) {
							value2.price = '';
						})
					});
				}
			}
		}
	}
})();
(function() {
   'use strict';

   angular
      .module('app.material')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'material',
         config: {
            abstract: true,
            url: '/material',
            templateUrl: 'app/material/material.html'
         }
      }];
   }
})();

(function () {
  'use strict';

  angular.module('app.login', []);
})();

(function() {
   'use strict';

   angular
      .module('app.login')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'login',
         config: {
            url: '/login',
            templateUrl: "app/login/login.html",
            controllerAs: 'LoginController as vm',
            title: 'login',
            data: {
               pageTitle: 'Login',
               specialClass: 'gray-bg',
               isLogin: true
            }
         }
      }];
   }
})();

(function () {
  'use strict';

  angular
    .module('app.login')
    .controller('LoginController', LoginController);

  LoginController.$inject = [
    '$state',
    'UserService',
    'validator',
    'requestHelper'
  ];

  function LoginController(
    $state, 
    UserService,
    validator,
    requestHelper
  ) {
    /*jshint validthis: true */
    var vm = this;

    // Params
    vm.data = {}
    vm.year = new Date();

    // Methods
    vm.login = login;

    function login(event) {
      requestHelper.before(event, 'Login');

      UserService.loginUser(vm.data, function (status, data) {
        if (status) {
          UserService.setLoggedInUser(data.user);
          $state.go('dashboard');
        } else {
          validator.validateAlert(data);
        }

        requestHelper.after(event, 'Login');

      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.layout', ['app.core']);
})();

(function () {
  'use strict';

  angular
    .module('app.layout')
    .controller('ShellController', ShellController);

  ShellController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    'constants',
    'UserService',
    'RoleService',
    'MaterialService',
    'validator'
  ];

  function ShellController(
    $rootScope,
    $scope,
    $state,
    constants,
    UserService,
    RoleService,
    MaterialService,
    validator
  ) {
    /*jshint validthis: true */
    var vm = this;

    // params
    vm.user         = UserService.loggedInUser;
    vm.year         = new Date();
    vm.isPricingDay = false;

    vm.privileges = {
      user: false,
      customer: false,
      quotation: false,
      role: false,
      material: false,
      materialPricing: false,
      setting: false,
      amgRead: false,
      amgCreate: false,
      amgPricing: false,
      referral: false,
      commission: false
    }

    // HOOKS
    $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
      vm.user = UserService.loggedInUser;

      checkTabPrivileges();
    });
   

    // methods
    vm.logout = logout;

    activate();

    function activate() {
      if (window.localStorage.getItem(constants.AUTHORIZATION_ADMIN_HEADER) === null) {
         UserService.logout();
         // $urlRouterProvider.otherwise('login');
         $state.go('login');
      } else {
        UserService.showUser(null, function(status, data) {
            if (status) {
              UserService.setLoggedInUser(data);

              checkTabPrivileges();
              checkPricingDay();

              var state = $state.current;
              
              $state.go(state.name);
            } else {
              $state.go('login');
              UserService.logout();
              validator.validateAlert(data);
            }
        });
      }
    }

    function checkPricingDay() {
      var today = new Date();

      if (today.getDay() === constants.PRICING_DAY) {
        vm.isPricingDay = true;
      }
    }

    function checkTabPrivileges() {
      vm.privileges = {
        user: false,
        customer: false,
        quotation: false,
        role: false,
        material: false,
        materialPricing: false,
        setting: false,
        amgRead: false,
        amgCreate: false,
        amgPricing: false,
        referral: false,
        commission: false
      }

      if (vm.user && vm.user.role) {
        var privileges = vm.user.role.role_privileges;

        if (vm.user.role.name === constants.ROLE.SUPER_ADMIN) {
          vm.privileges.role          = true;
          vm.privileges.setting       = true;
          vm.privileges.amgRead       = true;
          vm.privileges.amgCreate     = true;
          vm.privileges.amgPricing    = true;
          vm.privileges.referral      = true;

          generateAdminData();
        }

        if (vm.user.role.name === 'AMGAdmin') {
          vm.privileges.amgRead    = true;
          vm.privileges.amgCreate  = true;
          vm.privileges.amgPricing = true;
        } else if (vm.user.role.name === 'AMGPurchasing') {
          vm.privileges.amgRead    = true;
          vm.privileges.amgCreate  = false;
          vm.privileges.amgPricing = true;
        } else if (vm.user.role.name === 'AMGSales') {
          vm.privileges.amgRead    = true;
          vm.privileges.amgCreate  = true;
          vm.privileges.amgPricing = false;
        }

        $.each(privileges, function(index, val) {
          if (val.name === constants.PRIVILEGES.USER_READ) {
            vm.privileges.user = true;
          } else if(val.name === constants.PRIVILEGES.CUSTOMER_READ) {
            vm.privileges.customer = true;
          } else if(val.name === constants.PRIVILEGES.MATERIAL_READ) {
            generateMaterialData();
          } else if(val.name === constants.PRIVILEGES.MATERIAL_ADMIN) {
            vm.privileges.material = true;

            generateMaterialData();
          } else if(val.name === constants.PRIVILEGES.QUOTATION_READ) {
            vm.privileges.quotation = true;
          } else if(val.name === constants.PRIVILEGES.MATERIAL_PRICING) {
            vm.privileges.materialPricing = true;
          } else if(val.name === constants.PRIVILEGES.COMMISSION_READ) {
            vm.privileges.commission = true;
          }
          //  else if(val.name === constants.PRIVILEGES.AMG_READ) {
          //   vm.privileges.amgRead = true;
          // } else if(val.name === constants.PRIVILEGES.AMG_CREATE) {
          //   vm.privileges.amgCreate = true;
          // } else if(val.name === constants.PRIVILEGES.AMG_PRICING) {
          //   vm.privileges.amgPricing = true;
          // }
        });
      
      }
    }

    function generateAdminData() {
      // Generate data roles
      RoleService.getRoles(null, function(status, response) {
        if (status) {
          RoleService.setRoles(response.data);
        } else {
          validator.validateAlert(response);
        }
      });

      // Generate data privileges
      RoleService.getPrivileges(null, function(status, data) {
        if (status) {
          RoleService.setPrivileges(data);
        } else {
          validator.validateAlert(data);
        }
      });

      // Generate data material constants
      MaterialService.getMaterialConstant(function(status, data) {
        if (status) {
          MaterialService.setMaterialConstant(data.result);
        } else {
          validator.validateAlert(data);
        }
      });
    }

    function generateMaterialData() {
      // Generate data materials
      MaterialService.getMaterialInk(null, function(status, response) {
        if (status) {
          MaterialService.setMaterialInk(response);
        } else {
          validator.validateAlert(response);
        }
      });
      MaterialService.getMaterialPrinting(null, function(status, response) {
        if (status) {
          MaterialService.setMaterialPrinting(response);
        } else {
          validator.validateAlert(response);
        }
      });
      MaterialService.getMaterialLaminating(null, function(status, response) {
        if (status) {
          MaterialService.setMaterialLaminating(response);
        } else {
          validator.validateAlert(response);
        }
      });
      MaterialService.getMaterialSlitting(null, function(status, response) {
        if (status) {
          MaterialService.setMaterialSlitting(response);
        } else {
          validator.validateAlert(response);
        }
      });
      MaterialService.getMaterialPacking(null, function(status, response) {
        if (status) {
          MaterialService.setMaterialPacking(response);
        } else {
          validator.validateAlert(response);
        }
      });
    }

    function logout() {
      UserService.logout();
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.dashboard', []);
})();

(function() {
   'use strict';

   angular
      .module('app.dashboard')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'dashboard',
         config: {
            url: '/',
            templateUrl: 'app/dashboard/dashboard.html',
            controllerAs: 'DashboardController as vm',
            title: 'Dashboard'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.dashboard')
      .controller('DashboardController', DashboardController);

   DashboardController.$inject = [
      '$scope',
      'constants',
      'UserService'
   ];

   function DashboardController(
      $scope,
      constants,
      UserService
   ) {
      var vm = this;

      // PARAMS
      vm.user = UserService.loggedInUser;

      // HOOKS
      $scope.$on(constants.BROADCAST.LOGGED_IN_USER, function() {
         vm.user = UserService.loggedInUser;
      });

      // METHODS
   }
})();

(function() {
   'use strict';

   angular
      .module('app.customer')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'customer',
         config: {
            abstract: true,
            url: '/customer',
            templateUrl: 'app/customer/customer.html'
         }
      }];
   }
})();

(function () {
  'use strict';

  angular.module('app.core', [
    /*
     * Angular modules
     */
    'ui.router',

    /*
     * Our reusable cross app code modules
     */
    'app.blocks',
    'app.service',
    'app.widgets',
    /*
     * 3rd Party modules
     */

    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'ui.bootstrap',
    'oc.lazyLoad',
    'ui.footable',
    'ui.select',
    'angular.filter',
    'oitozero.ngSweetAlert',
    'datePicker',
    'summernote',
    'jsonFormatter',
    'multiStepForm',
    'NgSwitchery'
  ]);
})();

(function() {
  "use strict";

  angular.module("app.core").constant("constants", constants());

  function constants() {
    var DEBUG = false;
    var LOCALHOST = false;

    var SERVER_URL = "https://tim-api.flexypack.com/api";

    if (DEBUG) {
      SERVER_URL = "https://dev.innapack.com/api";
      if (LOCALHOST) {
        SERVER_URL = "http://localhost/innapack/public/api";
      }
    }

    var consts = {
      API_URL: SERVER_URL,

      COLOR: {
        DANGER: "#ED5565"
      },

      METHOD: {
        GET: "GET",
        POST: "POST",
        PATCH: "PATCH",
        DELETE: "DELETE"
      },

      ROLE: {
        SUPER_ADMIN: "Super Admin",
        SALES: "Sales",
        SALES_MANAGER: "Sales Manager",
        PURCHASING: "Purchasing",
        FINANCE: "Finance",
        PPIC: "PPIC",
        WAREHOUSE: "Warehouse",
        PRODUCTION: "Production"
      },

      PRICING_DAY: 3,

      PRIVILEGES: {
        USER_READ: "user.read",
        USER_CREATE: "user.create",
        USER_UPDATE: "user.update",

        ROLE_READ: "role.read",
        ROLE_CREATE: "role.create",
        ROLE_UPDATE: "role.update",
        ROLE_DELETE: "role.delete",

        CUSTOMER_READ: "customer.read",
        CUSTOMER_CREATE: "customer.create",
        CUSTOMER_UPDATE: "customer.update",
        CUSTOMER_SUBMIT: "customer.submit",
        CUSTOMER_ADMIN: "customer.admin",

        MATERIAL_READ: "material.read",
        MATERIAL_ADMIN: "material.admin",
        MATERIAL_PRICING: "material.pricing",

        QUOTATION_READ: "quotation.read",
        QUOTATION_CREATE: "quotation.create",
        QUOTATION_UPDATE: "quotation.update",
        QUOTATION_DELETE: "quotation.delete",
        QUOTATION_SUBMIT: "quotation.submit",
        QUOTATION_APPROVE_QUOTATION: "quotation.approve.quotation",
        QUOTATION_APPROVE_PO: "quotation.approve.po",

        COMMISSION_READ: "commission.read",
        COMMISSION_PAYMENT: "commission.commission-payment",

        REFERRAL_READ: "referral.read",
        REFERRAL_ADMIN: "referral.admin",

        COMMISSION_SETTING_READ: "commission-setting.read",
        COMMISSION_SETTING_ADMIN: "commission-setting.admin",
        COMMISSION_TIMELINE_SETTING_READ: "commission-timeline.read",
        COMMISSION_TIMELINE_SETTING_ADMIN: "commission-timeline.admin",

        QUOTATION_TERM_TEMPLATE_READ: "quotation-term-template.read",
        QUOTATION_TERM_TEMPLATE_ADMIN: "quotation-term-template.admin",

        TRANSPORT_READ: "transport.read",
        TRANSPORT_ADMIN: "transport.admin",

        AMG_READ: "amg.read",
        AMG_CREATE: "amg.create",
        AMG_PRICING: "amg.pricing"
      },

      BROADCAST: {
        INDEX_ROLE: "INDEX_ROLE",
        INDEX_PRIVILEGE: "INDEX_PRIVILEGE",

        LOGGED_IN_USER: "LOGGED_IN_USER",
        INDEX_USER: "INDEX_USER",
        DETAIL_USER: "DETAIL_USER",

        INDEX_CUSTOMER: "INDEX_CUSTOMER",
        DETAIL_CUSTOMER: "DETAIL_CUSTOMER",

        INDEX_MATERIAL_INK: "INDEX_MATERIAL_INK",
        INDEX_MATERIAL_PRINTING: "INDEX_MATERIAL_PRINTING",
        INDEX_MATERIAL_LAMINATING: "INDEX_MATERIAL_LAMINATING",
        INDEX_MATERIAL_SLITTING: "INDEX_MATERIAL_SLITTING",
        INDEX_MATERIAL_PACKING: "INDEX_MATERIAL_PACKING",
        INDEX_MATERIAL_CONSTANT: "INDEX_MATERIAL_CONSTANT",

        INDEX_QUOTATION: "INDEX_QUOTATION",
        DETAIL_QUOTATION: "DETAIL_QUOTATION",
        ADD_MATERIAL_LAMINATING_QUOTATION: "ADD_MATERIAL_LAMINATING_QUOTATION",
        ADD_MATERIAL_SLITTING_QUOTATION: "ADD_MATERIAL_SLITTING_QUOTATION",

        CHOOSE_CUSTOMER: "CHOOSE_CUSTOMER",
        SAVE_QUOTATION_SUCCESS: "SAVE_QUOTATION_SUCCESS",

        INDEX_AMG_PRODUCT: "INDEX_AMG_PRODUCT",
        INDEX_AMG_MATERIAL: "INDEX_AMG_MATERIAL",

        INDEX_REFERRAL: "INDEX_REFERRAL",
        DETAIL_REFERRAL: "DETAIL_REFERRAL",
        INDEX_TRANSPORT: "INDEX_TRANSPORT",
        INDEX_QUOTATION_TERM: "INDEX_QUOTATION_TERM",

        INDEX_COMMISSION: "INDEX_COMMISSION",
        DETAIL_COMMISSION: "DETAIL_COMMISSION",

        INDEX_SETTING_COMMISSION: "INDEX_SETTING_COMMISSION",
        INDEX_SETTING_COMMISSION_TIMELINE: "INDEX_SETTING_COMMISSION_TIMELINE",
        INDEX_QUOTATION_SETTING: "INDEX_QUOTATION_SETTING",
        INDEX_MATERIALSETTING: "INDEX_MATERIAL_SETTING"
      },

      AUTHORIZATION_ADMIN_HEADER: "AUTHORIZATION_ADMIN_HEADER",

      RESPONSE: {
        OK: "OK",
        VALIDATION_ERROR: "VALIDATION_ERROR",
        ERROR_LOGIN: "ERROR_LOGIN"
      },

      QUOTATION_STATUS: {
        DRAFT: "Draft",
        SUBMITTED: "Submitted",
        REJECTED: "Rejected",
        APPROVED: "Approved",
        PO_SUBMITTED: "PO Submitted",
        PO_APPROVED: "PO Approved",
        PO_CONFIRMED: "PO Confirmed",
        PO_REJECTED: "PO Rejected",
        DONE: "Done"
      },

      GENDER: {
        MALE: "male",
        FEMALE: "female"
      },

      MARITAL_STATUS: {
        MARRIED: "married",
        SINGLE: "single"
      },

      UNIT_TYPE: {
        WIDTH: "mm",
        LENGTH: "m",
        SLITTING_LENGTH: "m",
        THICKNESS: "micron",
        HARDENER: "g/cm2",
        ADHESIVE: "g/cm2",
        SOLVENT: "g/cm2",
        HARDENER_THICKNESS: "%",
        ADHESIVE_THICKNESS: "%",
        SOLVENT_THICKNESS: "%",
        HARDENER_DENSITY: "g/cm3",
        ADHESIVE_DENSITY: "g/cm3",
        SOLVENT_DENSITY: "g/cm3",
        MATERIAL_INK_WEIGHT: "g/m2",
        MATERIAL_PADDING: "mm",
        MATERIAL_DENSITY: "g/cm3",
        PERCENTAGE: "%"
      },

      CUSTOMER_TYPE: {
        PT: "PT",
        CV: "CV",
        UD: "UD",
        INDIVIDUAL: "Individual",
        PARTNERSHIP: "Partnership",
        ETC: "Etc"
      },

      CUSTOMER_PRODUCT_TYPE: {
        CATEGORY: "Category",
        BRAND: "Brand"
      },

      CUSTOMER_UPLOAD_TYPE: {
        LOGO: "Logo",
        NPWP: "NPWP",
        DEED: "Deed Of Incorporation",
        LAST_DEED: "Last Deed",
        ID_CARD: "id_card",
        IMAGE: "image"
      },

      CUSTOMER_ADDRESS_TYPE: {
        OFFICE: "Office",
        FACTORY: "Factory"
      },

      CUSTOMER_TOP: {
        PREPAID: "Prepaid",
        CASH_BEFORE_DELIVERY: "Cash Before Delivery",
        GIRO: "Giro",
        CHEQUE: "Cheque",
        DP_AND_TERMS: "DP & Terms of Payment",
        TERMS: "Terms of Payment"
      },

      CUSTOMER_STATUS: {
        DRAFT: "Draft",
        SUBMITTED: "Submitted",
        UPDATED: "Updated",
        REJECTED: "Rejected",
        APPROVED: "Approved"
      },

      MATERIAL_TYPE: {
        INK: "ink",
        PRINTING: "printing",
        LAMINATING: "laminating",
        SLITTING: "slitting",
        PACKING: "packing"
      },

      MATERIAL_PRINTING_TYPE: {
        INK: "ink",
        MATERIAL: "material"
      },

      MATERIAL_SLITTING_TYPE: {
        PAPER_CORE: "paper_core"
      },

      MATERIAL_CONSTANT_TYPE: {
        VALUE: "value",
        PRICE: "price",
        RATIO: "ratio"
      },

      CUSTOMER_RANK: {
        GOLD: "gold",
        PLATINUM: "platinum",
        SILVER: "silver"
      },

      PRICING_TYPE: {
        PRINTING_MATERIAL: "printing_material",
        PRINTING_INK: "printing_ink",
        LAMINATING_MATERIAL: "laminating_material",
        SLITTING_MATERIAL: "slitting_material",
        PACKING_MATERIAL: "packing_material",
        MATERIAL_CONSTANT: "material_constant"
      }
    };

    return consts;
  }
})();

(function() {
   'use strict';

   angular.module('app.core')
      .value('config', config)
      .config(configure)
      .run(runConfig);

   var config = {
      appErrorPrefix: '[NG-Modular Error] ', //Configure the exceptionHandler decorator
      appTitle: 'Innapack',
      version: '1.0'
   };

   runConfig.$inject = ['$rootScope', '$state'];

   // MARKED - masih kepake?
   function runConfig($rootScope, $state) {
      $rootScope.$state = $state;
   }

   configure.$inject = ['$urlRouterProvider', 'constants'];

   function configure($urlRouterProvider) {
        $urlRouterProvider.otherwise('/dashboard');
   }
})();

(function() {
   'use strict';

   angular
      .module('app.commission')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'commission',
         config: {
            abstract: true,
            url: '/commission',
            templateUrl: 'app/commission/commission.html'
         }
      }];
   }
})();

(function() {
	'use strict';

	angular.module('app.blocks', [
		'ui.router'	
	]);

})();
(function() {
  "use strict";

  angular.module("app.blocks").factory("validator", validator);

  validator.$inject = ["$uibModal", "constants", "SweetAlert"];

  function validator($uibModal, constants, SweetAlert) {
    var service = {
      validateAlert: validateAlert
    };

    return service;

    function validateAlert(errorData) {
      var title = "";
      var template = "";

      if (errorData.status === 422) {
        title = "Error Validasi";
        console.log(errorData.data.errors);

        if (Object.keys(errorData.data.errors).length > 1) {
          template += '<ul style="text-align:left">';
          for (var key in errorData.data.errors) {
            var value = errorData.data.errors[key];
            value.forEach(function(item) {
              console.log(item);
              template += "<li>" + item + "</li>";
            });
          }
          template += "</ul>";
        } else {
          for (var key in errorData.data.errors) {
            var value = errorData.data.errors[key];
            value.forEach(function(item) {
              template += item;
            });
          }
        }
      } else {
        switch (errorData.status) {
          case 400:
            // Bad Request
            title = "Bad Request";
            template = errorData.data.message;
            break;
          case 401:
            // Unauthorized
            title = "Unauthorized";
            template = errorData.data.message;
            break;
          case 403:
            // Forbidden
            title = "Forbidden";
            template = errorData.data.message;
            break;
          case 404:
            // Not Found
            title = "Not Found";
            template = errorData.data.message;
            break;
          default:
            title = "Unknown Error";
            template =
              "Sepertinya ada masalah, coba hubungi developer sekarang!";
        }
      }


      swal.close();
      setTimeout(function(){ 
        SweetAlert.swal({
          title: title,
          html: true,
          text: template,
          type: "error"
        });
      }, 500, title, template);
    }
  }
})();

(function() {
   'use strict';

   angular.module('app.blocks')
      .provider('routerHelper', routerHelperProvider);

   routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
   /* @ngInject */
   function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
      /* jshint validthis:true */
      var config = {
         docTitle: undefined,
         resolveAlways: {}
      };

      if (!(window.history && window.history.pushState)) {
         window.location.hash = '/';
      }

      $locationProvider.html5Mode(true);

      this.configure = function(cfg) {
         angular.extend(config, cfg);
      };

      this.$get = RouterHelper;
      RouterHelper.$inject = ['$rootScope', '$state'];
      /* @ngInject */
      function RouterHelper($rootScope, $state) {
         var handlingStateChangeError = false;
         var hasOtherwise = false;
         var stateCounts = {
            errors: 0,
            changes: 0
         };

         var service = {
            configureStates: configureStates,
            getStates: getStates,
            stateCounts: stateCounts
         };

         init();

         return service;

         ///////////////

         function configureStates(states, otherwisePath) {
            states.forEach(function(state) {
               state.config.resolve =
                  angular.extend(state.config.resolve || {}, config.resolveAlways);
               $stateProvider.state(state.state, state.config);
            });
            if (otherwisePath && !hasOtherwise) {
               hasOtherwise = true;
               $urlRouterProvider.otherwise(otherwisePath);
            }
         }

         function handleRoutingErrors() {
            // Route cancellation:
            // On routing error, go to the dashboard.
            // Provide an exit clause if it tries to do it twice.
            $rootScope.$on('$stateChangeError',
               function(event, toState, toParams, fromState, fromParams, error) {
                  if (handlingStateChangeError) {
                     return;
                  }
                  stateCounts.errors++;
                  handlingStateChangeError = true;
                  var destination = (toState &&
                        (toState.title || toState.name || toState.loadedTemplateUrl)) ||
                     'unknown target';
                  var msg = 'Error routing to ' + destination + '. ' +
                     (error.data || '') + '. <br/>' + (error.statusText || '') +
                     ': ' + (error.status || '');
                  $state.go('/');
               }
            );
         }

         function init() {
            handleRoutingErrors();
            updateDocTitle();
         }

         function getStates() {
            return $state.get();
         }

         function updateDocTitle() {
            $rootScope.$on('$stateChangeSuccess',
               function(event, toState, toParams, fromState, fromParams) {
                  stateCounts.changes++;
                  handlingStateChangeError = false;
                  var title = config.docTitle + ' ' + (toState.title || '');
                  $rootScope.title = title; // data bind to <title>
               }
            );
         }
      }
   }
})();
(function() {
   'use strict';

   angular.module('app.blocks')
      .factory('requestHelper', requestHelper);

   /**
    * Contain helper functions for manipulating DOM 
    * before and after ajax request
    */
   function requestHelper() {

      var service = {
         before: before,
         after: after
      }

      return service;

      /**
       * Show button loader before and after request.
       *
       * Simply change the button icon into spinner before ajax request
       * and return back into original icon after ajax request.
       *
       * @private
       * @param  {Object} event
       * @param  {Boolean} isDisabled
       * @param  {String} text
       */
      function handle(event, isDisabled, text) {
        var form         = $(event.target);
        var submitButton = form.find('button[type=submit]');

        var loadingIcon = '<i class="fa fa-spin fa-spinner"></i> ' + text + '...';

        var text = isDisabled ? loadingIcon : text;

        form.find('button').prop('disabled', isDisabled);
        submitButton.html(text);
      }

      /**
       * @param  {Object} event
       * @param  {String} text
       */
      function before(event, text) { 

         handle(event, true, text);
      }

      /**
       * @param  {Object} event
       * @param  {String} text
       */
      function after(event, text) {
         
         handle(event, false, text);
      }
   }
})();
(function() {
    'use strict';

    angular.module('app.blocks')
        .factory('httpRequest', httpRequest);

    httpRequest.$inject = [
        '$q',
        '$http',
        '$state',
        'constants',
        'SweetAlert'
    ];

    /* @ngInject */
    function httpRequest(
        $q,
        $http,
        $state,
        constants,
        SweetAlert
    ) {
        var service = {
            request: request
        }

        return service;

        function request(url, METHOD, parameters, headers, withCredential, isFileUpload) {
            headers = typeof headers !== 'undefined' ? headers : {};
            withCredential = typeof withCredential !== 'undefined' ? withCredential : true;

            if (!("Authorization" in headers) && withCredential) {
                headers['Authorization'] = window.localStorage.getItem(constants.AUTHORIZATION_ADMIN_HEADER);
            }

            var deferred = $q.defer();
            var promise = deferred.promise;

            url = constants.API_URL + url;

            var response = null;
            if (METHOD == constants.METHOD.GET) {
                // Hack so that array parameters will not be treated as json
                // https://stackoverflow.com/q/19957858
                if (parameters) {
                    url = url+'?'+$.param(parameters);
                }
                response = $http.get(url, {
                    // params: parameters,
                    headers: headers
                });
            } else if (METHOD == constants.METHOD.POST) {
                if (isFileUpload) {
                    headers['Content-Type'] = undefined;
                }

                response = $http.post(url, parameters, {
                    headers: headers
                });
            } else if (METHOD == constants.METHOD.PATCH) {
                response = $http.patch(url, parameters, {
                    headers: headers
                });
            } else if (METHOD == constants.METHOD.DELETE) {
                response = $http.delete(url, {
                    headers: headers
                });
            }

            response.success(function(data) {
                deferred.resolve(data);
            });

            response.error(function(data, status) {
                deferred.reject({status: status, data: data});
            });

            promise.success = function(fn) {
                promise.then(fn);
                return promise;
            }
            promise.error = function(fn) {
                promise.then(null, fn);
                return promise;
            }

            return promise;
        }
    }
})();
(function() {
   'use strict';

   angular.module('app.blocks')
      .factory('globalState', globalState);

   function globalState() {
      var service = {
         setTime: setTime,
         removeNullData: removeNullData,
         encBool: encBool,
         decBool: decBool
      }

      return service;

      function setTime(collectionDate) {
         // var date = new Date(collectionDate);
         
         // Fix for date in Safari
         // https://stackoverflow.com/a/5646753
         if (collectionDate) {
            var date = new Date(collectionDate.replace(/-/g, "/"));
            return date;
         }
      }

      function removeNullData(data) {
         angular.forEach(data, function(value, key){
            if (value === null) {
               delete data[key];
            }
         });

         return data;
      }

      function encBool(data) {
         if (data) {
            return true;
         } else {
            return false;
         }
      }

      function decBool(data) {
         if (data) {
            return 1;
         } else {
            return 0;
         }
      }
   }
})();
(function() {
   'use strict';

   angular.module('app.blocks')
      .factory('base64', base64);

   base64.$inject = ['SweetAlert'];

   function base64(SweetAlert) {
      var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
      var servicce = {
         encode: encode,
         decode: decode,
         dataURItoBlob: dataURItoBlob
      };

      return servicce;

      function encode(input) {
         var output = "";
         var chr1, chr2, chr3 = "";
         var enc1, enc2, enc3, enc4 = "";
         var i = 0;

         do {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
               enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
               enc4 = 64;
            }

            output = output +
               keyStr.charAt(enc1) +
               keyStr.charAt(enc2) +
               keyStr.charAt(enc3) +
               keyStr.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
         } while (i < input.length);

         return output;
      }

      function decode(input) {
         var output = "";
         var chr1, chr2, chr3 = "";
         var enc1, enc2, enc3, enc4 = "";
         var i = 0;

         // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
         var base64test = /[^A-Za-z0-9\+\/\=]/g;
         if (base64test.exec(input)) {

            SweetAlert.swal('error', "Terdapat karakter base64 yang salah di teks input.\n" +
               "Karakter base64 yang benar adalah A-Z, a-z, 0-9, '+', '/',dan '='\n" +
               "Expect errors pada decoding.");
         }
         input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

         do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
               output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
               output = output + String.fromCharCode(chr3);
            }

            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";

         } while (i < input.length);

         return output;
      }

      function dataURItoBlob(dataURI) {
         // convert base64/URLEncoded data component to raw binary data held in a string
         var byteString = atob(dataURI.split(',')[1]);
         var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

         var ab = new ArrayBuffer(byteString.length);
         var ia = new Uint8Array(ab);
         for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
         }

         var bb = new Blob([ab], {
            "type": mimeString
         });
         return bb;
      }
   }
})();
(function() {
   'use strict';

   angular
      .module('app.amg')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'amg',
         config: {
            abstract: true,
            url: '/amg',
            templateUrl: 'app/amg/amg.html'
         }
      }];
   }
})();

(function() {
   'use strict';

   angular
      .module('app.account')
      .run(appRun);

   appRun.$inject = ['routerHelper'];

   /* @ngInject */
   function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
   }

   function getStates() {
      return [{
         state: 'account',
         config: {
            abstract: true,
            url: '/account',
            templateUrl: 'app/account/account.html'
         }
      }];
   }
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function($timeout) {

   // Full height of sidebar
   function fix_height() {
      var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
      angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

      var navbarHeigh = angular.element('nav.navbar-default').height();
      var wrapperHeigh = angular.element('#page-wrapper').height();

      if (navbarHeigh > wrapperHeigh) {
         angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
      }

      if (navbarHeigh < wrapperHeigh) {
         angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
      }

      if (angular.element('body').hasClass('fixed-nav')) {
         if (navbarHeigh > wrapperHeigh) {
            angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
         } else {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
         }
      }
   }

   angular.element(window).bind("load resize scroll", function() {
      if (!angular.element("body").hasClass('body-small')) {
         fix_height();
      }
   });

   // Move right sidebar top after scroll
   angular.element(window).scroll(function() {
      if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
         angular.element('#right-sidebar').addClass('sidebar-top');
      } else {
         angular.element('#right-sidebar').removeClass('sidebar-top');
      }
   });

   $timeout(function() {
      fix_height();
   });

   // Minimalize menu when screen is less than 768px
   angular.element(window).bind("load resize", function() {
      if (angular.element(document).width() < 769) {
         angular.element('body').addClass('body-small')
      } else {
         angular.element('body').removeClass('body-small')
      }
   })

});
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu"
    ],
    "ERANAMES": [
      "Sebelum Masehi",
      "M"
    ],
    "ERAS": [
      "SM",
      "M"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ],
    "SHORTDAY": [
      "Min",
      "Sen",
      "Sel",
      "Rab",
      "Kam",
      "Jum",
      "Sab"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agt",
      "Sep",
      "Okt",
      "Nov",
      "Des"
    ],
    "STANDALONEMONTH": [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, dd MMMM y",
    "longDate": "d MMMM y",
    "medium": "d MMM y HH.mm.ss",
    "mediumDate": "d MMM y",
    "mediumTime": "HH.mm.ss",
    "short": "dd/MM/yy HH.mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH.mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "Rp",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "in",
  "localeID": "in",
  "pluralCat": function(n, opt_precision) {  return PLURAL_CATEGORY.OTHER;}
});
}]);
(function() {
	'use strict';

	angular
		.module('app', [
			'app.core',
			'app.layout',
			'app.login',
			'app.dashboard',
			'app.user',
			'app.customer',
			'app.role',
			'app.material',
			'app.quotation',
			'app.setting',
			'app.account',
			'app.pricing',
			'app.amg',
			'app.referral',
			'app.commission'
		]);
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/account.html","<div ui-view=\"\"></div>");
$templateCache.put("app/amg/amg.html","<div ui-view=\"\"></div>");
$templateCache.put("app/commission/commission.html","<div ui-view=\"\"></div>");
$templateCache.put("app/customer/customer.html","<div ui-view=\"\"></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DashboardController as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Welcome {{ vm.user.name }}</h1><small>Halaman ini masih dalam pengembangan, bila ada kebutuhan silahkan hubungi developer</small></div></div></div></div>");
$templateCache.put("app/layout/error.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{ error.title }}</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\">{{ error.template }}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button></div></div>");
$templateCache.put("app/layout/footer.html","<div class=\"footer\"><div><strong>Copyright</strong> <a href=\"https://innapack.com\">Innapack.com</a> &copy; {{ vm.year | date:\"yyyy\" }} | Untuk bantuan, hubungi Denny 0813-1093-8387 atau email ke <a href=\"hello@innapack.com\">hello@innapack.com</a>.</div></div>");
$templateCache.put("app/layout/header.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div></nav></div>");
$templateCache.put("app/layout/shell.html","<div id=\"wrapper\" data-ng-controller=\"ShellController as vm\"><div ng-if=\"$state.current.data.isLogin\"><div ui-view=\"\"></div></div><div ng-if=\"!$state.current.data.isLogin\"><div ng-include=\"\'app/layout/sidebar.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg\"><div ng-include=\"\'app/layout/header.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/layout/footer.html\'\"></div></div></div></div>");
$templateCache.put("app/layout/sidebar.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><span><div class=\"profile-img-circle\" style=\"background-image: url({{ vm.user.image_url ? vm.user.image_url : \'assets/images/logo/logo.png\' }})\"></div></span> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{vm.user.name | ucfirst}}</strong></span> <span class=\"text-muted text-xs block\">{{ vm.user.role.name | ucfirst }} <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"account.profile\">Profile</a></li><li><a ui-sref=\"account.change-password\">Ubah Password</a></li><li class=\"divider\"></li><li><a ng-click=\"vm.logout()\">Logout</a></li></ul></div></li><li ng-class=\"{active: $state.includes(\'dashboard\')}\"><a ui-sref=\"dashboard\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">Dashboard</span></a></li><li ng-class=\"{active: $state.includes(\'user\')}\" ng-show=\"vm.privileges.user\"><a ui-sref=\"user.index\"><i class=\"fa fa fa-user-circle-o\"></i> <span class=\"nav-label\">User</span></a></li><li ng-class=\"{active: $state.includes(\'role\')}\" ng-show=\"vm.privileges.role\"><a ui-sref=\"role\"><i class=\"fa fa-id-card\"></i> <span class=\"nav-label\">Role</span></a></li><li ng-class=\"{active: $state.includes(\'material\')}\" ng-show=\"vm.privileges.material\"><a href=\"\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">Material</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'material\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"material.ink\">Printing Ink</a></li><li ui-sref-active=\"active\"><a ui-sref=\"material.printing\">Printing Film</a></li><li ui-sref-active=\"active\"><a ui-sref=\"material.laminating\">Laminating Film</a></li><li ui-sref-active=\"active\"><a ui-sref=\"material.slitting\">Slitting</a></li><li ui-sref-active=\"active\"><a ui-sref=\"material.packing\">Packing</a></li></ul></li><li ng-class=\"{active: $state.includes(\'pricing\')}\" ng-show=\"vm.privileges.materialPricing\"><a ui-sref=\"pricing\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Pricing</span> <span class=\"label label-danger pull-right\" ng-show=\"vm.isPricingDay\">Update</span></a></li><li ng-class=\"{active: $state.includes(\'customer\')}\" ng-show=\"vm.privileges.customer\"><a ui-sref=\"customer.index({sort_name: \'desc\'})\"><i class=\"fa fa-briefcase\"></i> <span class=\"nav-label\">Customer</span></a></li><li ng-class=\"{active: $state.includes(\'referral\')}\" ng-show=\"vm.privileges.referral\"><a ui-sref=\"referral.index({sort_referralsCreatedAt: \'desc\', sort_referralsIsActive: \'desc\'})\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Referral</span></a></li><li ng-class=\"{active: $state.includes(\'quotation\')}\" ng-show=\"vm.privileges.quotation\"><a ui-sref=\"quotation.index({sort_quotationInformationsCreatedAt: \'desc\', sort_quotationInformationsStatus: \'desc\'})\"><i class=\"fa fa fa-archive\"></i> <span class=\"nav-label\">Quotation</span></a></li><li ng-class=\"{active: $state.includes(\'commission\')}\" ng-show=\"vm.privileges.commission\"><a ui-sref=\"commission.index\"><i class=\"fa fa-percent\"></i> <span class=\"nav-label\">Commission</span></a></li><li ng-class=\"{active: $state.includes(\'setting\')}\" ng-show=\"vm.privileges.setting\"><a href=\"\"><i class=\"fa fa-cog\"></i> <span class=\"nav-label\">Settings</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'setting\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"setting.material\">Material Settings</a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting.quotationTermTemplate({sort_quotationTermTemplatesCreatedAt: \'desc\'})\">Quotation Term Templates</a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting.commission({sort_minGrossProfitPercentage: \'asc\'})\">Commission Settings</a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting.commission-timeline({sort_minDaysLate: \'asc\'})\">Commission Timeline Settings</a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting.transport({sort_transportTypesCreatedAt: \'desc\'})\">Transport Settings</a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting.quotation\">Quotation Settings</a></li></ul></li><li ng-class=\"{active: $state.includes(\'amg\')}\" ng-show=\"vm.privileges.amgRead || vm.privileges.amgCreate || vm.privileges.amgPricing\"><a href=\"\"><i class=\"fa fa-font\"></i> <span class=\"nav-label\">AMG</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'amg\')}\"><li ng-show=\"vm.privileges.amgCreate\" ui-sref-active=\"active\"><a ui-sref=\"amg.product\">Product</a></li><li ng-show=\"vm.privileges.amgPricing\" ui-sref-active=\"active\"><a ui-sref=\"amg.material\">Material</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/login/login.html","<div class=\"text-center\" data-ng-controller=\"LoginController as vm\"><div><h1 class=\"logo-name\">Innapack</h1></div><div class=\"middle-box loginscreen animated fadeInDown\"><h3>Welcome to Innapack CRM</h3><p>Hubungi <a href=\"mailto:hello@innapack.com\">hello@innapack.com</a> jika tidak memiliki akun atau lupa password.</p><form class=\"m-t\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" ng-model=\"vm.data.email\" placeholder=\"Username\" required=\"\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.data.password\" placeholder=\"Password\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Login</button></form><p class=\"m-t\">Copyright <small><a target=\"_blank\" href=\"https://innapack.com\">Innapack.com</a> &copy; {{ vm.year | date:\"yyyy\"}}</small></p></div></div>");
$templateCache.put("app/material/material.html","<div ui-view=\"\"></div>");
$templateCache.put("app/pricing/pricing.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"PricingController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-lg-12 tabs-container\"><form class=\"form-horizontal\" ng-submit=\"vm.storeConfirmation()\"><div class=\"m-b-md clearfix\" ng-if=\"vm.privileges.update\"><button type=\"button\" class=\"btn btn-warning pull-right\" ng-click=\"vm.toggleEdit($event)\"><span ng-if=\"vm.toggleUpdate\">Batal</span> <span ng-if=\"!vm.toggleUpdate\">Ubah Harga</span></button></div><div class=\"ibox float-e-margins\" ng-repeat=\"(key, materials) in vm.materials\"><div ng-if=\"key !== \'material_constant\'\"><div class=\"ibox-title\"><h2 style=\"text-transform: capitalize;\">{{ key.replace(\'_\', \' \') }}</h2></div><div class=\"ibox-content\"><div class=\"row\"><div ng-repeat=\"(materialKey, material) in materials\" class=\"col-md-6\" style=\"margin-bottom: 15px;\"><div class=\"form-group\"><label class=\"col-md-4 fotm-control\">{{ material.name }}</label><div class=\"col-md-8\"><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input disabled=\"\" placeholder=\"{{ vm.clonedMaterials[key][materialKey][key + \'_prices\'].conversion.price }}\" type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm.materials[key][materialKey][key + \'_prices\'].conversion.price\" required=\"\"> <span class=\"input-group-addon\"><strong>/ {{ vm.clonedMaterials[key][materialKey][key + \'_prices\'].conversion.price_unit_name }}</strong></span></div></div><div class=\"col-md-12\" style=\"margin-top: 10px;\"><span class=\"text-muted\">Last updated:</span><strong>{{ vm.setTime(material[key + \'_prices\'].updated_at) | date:\'d MMMM yyyy HH:mm\' }}</strong></div></div></div></div></div></div><div ng-if=\"key == \'material_constant\'\"><div class=\"ibox-title\"><h2 style=\"text-transform: capitalize;\">{{ key.replace(\'_\', \' \') }}</h2></div><div class=\"ibox-content\"><div class=\"row\"><div ng-repeat=\"(materialKey, material) in materials\" class=\"col-md-6\"><div class=\"form-group\"><label class=\"col-md-4 fotm-control\">[{{ material.position || \'-\' }}] {{ material.name }}</label><div class=\"col-md-8\"><div class=\"input-group\"><span class=\"input-group-addon\"><span ng-if=\"material.type === vm.constants.MATERIAL_CONSTANT_TYPE.PRICE\">Rp</span> <span ng-if=\"material.type === vm.constants.MATERIAL_CONSTANT_TYPE.RATIO\">Rasio</span> <span ng-if=\"material.type === vm.constants.MATERIAL_CONSTANT_TYPE.VALUE\">Value</span></span> <input disabled=\"\" placeholder=\"{{ vm.clonedMaterials[key][materialKey].material_constant_histories.conversion.value }}\" type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm.materials[key][materialKey].material_constant_histories.conversion.value\" required=\"\"> <span class=\"input-group-addon\"><strong><span ng-if=\"material.type === vm.constants.MATERIAL_CONSTANT_TYPE.PRICE\">/</span> {{ vm.clonedMaterials[key][materialKey].material_constant_histories.conversion.unit_name }}</strong></span></div></div><div class=\"col-md-12\" style=\"margin-top: 10px;\"><span class=\"text-muted\">Last updated:</span><strong>{{ vm.setTime(material.material_constant_histories.updated_at) | date:\'d MMMM yyyy HH:mm\' }}</strong></div></div></div></div></div></div></div><div class=\"m-b-md\" ng-if=\"vm.privileges.update && vm.toggleUpdate\"><button type=\"submit\" class=\"btn btn-block btn-primary\">Simpan semua perubahan harga</button></div></form></div></div></div>");
$templateCache.put("app/quotation/quotation.html","<div ui-view=\"\"></div>");
$templateCache.put("app/referral/referral.html","<div ui-view=\"\"></div>");
$templateCache.put("app/role/role.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"RoleController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Role Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createRole()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat Role</a></div><h2>Role</h2></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-7\" data-sort-ignore=\"true\">Privileges</th><th class=\"col-xs-3\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"role in vm.roles\" foo-repeat-done=\"\"><td>{{ role.name || \'-\' }}</td><td><span class=\"label m-r-xs m-b-xs\" style=\"display: inline-block;\" ng-repeat=\"privilege in role.role_privileges\">{{ privilege.name }}</span></td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline m-r-xs\" ng-click=\"vm.editRole(role)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a ng-if=\"role.is_deletable && vm.privileges.delete\" class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteRoleConfirmation(role, $event)\"><i class=\"fa fa-trash\"></i> Hapus</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/setting/setting.html","<div ui-view=\"\"></div>");
$templateCache.put("app/user/user.html","<div ui-view=\"\"></div>");
$templateCache.put("app/account/change-password/change-password.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"AccountChangePasswordController as vm\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>Ubah Password</h2></div><div class=\"ibox-content\"><form class=\"form-horizontal\" ng-submit=\"vm.updateConfirmation()\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Password lama</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.data.current_password\" required=\"\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Password Baru</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.data.new_password\" required=\"\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Konfirmasi Password Baru</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.data.new_password_confirmation\" required=\"\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-8\"><button class=\"btn btn-primary btn-block\" type=\"submit\">Simpan Perubahan</button></div></div></form></div></div></div>");
$templateCache.put("app/account/profile/profile.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"AccountProfileController as vm\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h2>Profile Image</h2></div><div><div class=\"ibox-content no-padding border-left-right\"><img alt=\"image\" class=\"img-responsive\" src=\"{{ vm.user.image_url ? vm.user.image_url : \'assets/images/logo/logo.png\' }}\"></div></div></div></div><div class=\"col-md-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h2>Profile Details</h2></div><div class=\"ibox-content\"><h1>{{ vm.user.name | ucfirst }}</h1><p><strong>NIP:</strong> <span>{{ vm.user.employee_card_number || \'-\' }}</span></p><p><strong>NIK:</strong> <span>{{ vm.user.id_card_number || \'-\' }}</span></p><p><strong>Jenis Kelamin:</strong> <span>{{ vm.user.gender || \'-\' }}</span></p><p><strong>Status:</strong> <span>{{ vm.user.marital_status || \'-\' }}</span></p><p><strong>Tgl. Lahir:</strong> <span>{{ vm.user.birth_date || \'-\' }}</span></p><p><strong>Email:</strong> <span>{{ vm.user.email || \'-\' }}</span></p><p><strong>Phone 1:</strong> <span>{{ vm.user.phone || \'-\' }}</span></p><p><strong>Phone 2:</strong> <span>{{ vm.user.phone_2 || \'-\' }}</span></p><p><strong>Address:</strong> <span>{{ vm.user.address || \'-\' }}</span></p></div></div></div></div></div>");
$templateCache.put("app/amg/material/material.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"AmgMaterialController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title clearfix\" ng-if=\"vm.privileges.pricing\"><div class=\"pull-right\"><button class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\" ng-disabled=\"vm.bulkUpdate\"><i class=\"fa fa-refresh\"></i> Muat Ulang</button> <button class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.create\" ng-disabled=\"vm.bulkUpdate\"><i class=\"fa fa-plus\"></i> Buat Material Baru</button> <a id=\"toggle-bulk\" class=\"btn btn-w-m btn-primary\" ng-click=\"vm.toggleBulk($event)\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-pencil\"></i> Bulk Update</a></div><h2>AMG Material</h2></div><div class=\"ibox-content\"><div class=\"table-responsive\"><a id=\"save-bulk\" class=\"btn btn-w-m btn-primary\" ng-click=\"vm.saveBulk($event)\" ng-if=\"vm.privileges.create && vm.bulkUpdate\"><i class=\"fa fa-save\"></i> Save All Changes</a><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-4\">Nama</th><th class=\"col-xs-3\">Spot Price</th><th class=\"col-xs-3\">Import Price</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials track by $index\" foo-repeat-done=\"\"><td><div ng-if=\"!vm.bulkUpdate\">{{ material.name || \'-\' }}</div><div ng-if=\"vm.bulkUpdate\"><input type=\"text\" ng-model=\"material.name\" class=\"form-control\" required=\"\"></div></td><td><div ng-if=\"!vm.bulkUpdate\">{{ material.spot_price | currency:\'Rp \':0 }}</div><div ng-if=\"vm.bulkUpdate\"><input type=\"number\" min=\"0\" ng-model=\"material.spot_price\" class=\"form-control\" required=\"\"></div></td><td><div ng-if=\"!vm.bulkUpdate\">{{ material.import_price | currency:\'Rp \':0 }}</div><div ng-if=\"vm.bulkUpdate\"><input type=\"number\" min=\"0\" ng-model=\"material.import_price\" class=\"form-control\" required=\"\"></div></td><td class=\"text-center\"><button class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.create\" ng-disabled=\"vm.bulkUpdate\"><i class=\"fa fa-pencil\"></i> Ubah</button> <button class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteConfirmation(material, $event)\" ng-if=\"vm.privileges.create\" ng-disabled=\"vm.bulkUpdate\"><i class=\"fa fa-trash\"></i> Hapus</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/amg/product/product.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"AmgProductController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title clearfix\" ng-if=\"vm.privileges.read\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createProduct()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat Product Baru</a></div><h2>AMG Product</h2></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-5\">Nama</th><th class=\"col-xs-2\">Spot Price</th><th class=\"col-xs-2\">Import Price</th><th class=\"col-xs-3\"></th><th data-hide=\"all\"><span>Inner Percentage</span></th><th data-hide=\"all\"><span>Middle Percentage</span></th><th data-hide=\"all\"><span>Outer Percentage</span></th><th data-hide=\"all\"><span>Materials</span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products\" foo-repeat-done=\"\"><td>{{ product.name || \'-\' }}</td><td>{{ product.spot_price | currency:\'Rp \':0 }}</td><td>{{ product.import_price | currency:\'Rp \':0 }}</td><td class=\"text-center\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editProduct(product)\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteConfirmation(product, $event)\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-trash\"></i> Hapus</a></td><td>{{ product.inner_percentage }}%</td><td>{{ product.middle_percentage }}%</td><td>{{ product.outer_percentage }}%</td><td><span class=\"label m-r-xs m-b-xs\" style=\"display: inline-block;\" ng-repeat=\"material in product.materials\">{{ material.name | ucfirst }} <strong style=\"color: #1ab394\">({{ material.pivot.extruder_type }})</strong></span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/commission/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DetailCommissionController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"></div><h2>Commission Detail</h2></div><div class=\"ibox-content\"><div class=\"row m-t-md\"><div class=\"col-md-6\"><dl class=\"dl-horizontal\"><dt>Quotation #:</dt><dd><a ui-sref=\"quotation.detail({\'quotationHashId\': vm.commission.quotation.hash_id, \'quotation\': vm.commission.quotation})\">{{vm.commission.quotation.quotation_revision_number || \'-\'}}</a></dd><dt>Customer:</dt><dd><a ui-sref=\"customer.detail({\'customerHashId\': vm.commission.customer.hash_id, \'customer\': vm.commission.customer})\">{{ vm.commission.quotation.customer.name || \'-\'}}</a></dd><dt>Sales:</dt><dd>{{ vm.commission.user.name || \'-\'}}</dd><dt>Created Date:</dt><dd>{{ vm.globalState.setTime(vm.commission.created_at) | date:\'d MMMM yyyy\' }}</dd><dt>Terms of Payment:</dt><dd>{{ vm.commission.term_of_payment }}</dd><dt ng-if=\"(vm.commission.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.commission.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.commission.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.commission.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\">Jangka Waktu Pembayaran:</dt><dd>{{ vm.commission.days_of_payable }} hari</dd></dl></div><div class=\"col-md-6\"><dl class=\"dl-horizontal\"><dt>Total Price:</dt><dd>{{vm.commission.total_price | currency:\'Rp \':0}}</dd><dt>Total Invoice Amount:</dt><dd>{{vm.commission.total_invoice_amount | currency:\'Rp \':0}}</dd><dt>Total Paid:</dt><dd>{{vm.commission.total_paid | currency:\'Rp \':0}}</dd><dt>Commission Percentage:</dt><dd>{{vm.commission.conversion.commission_percentage || \'-\'}}%</dd><dt>Max Possible Commission:</dt><dd>{{vm.commission.total_max_possible_commission | currency:\'Rp \':0}}</dd><dt>Total Paid Commission:</dt><dd>{{vm.commission.total_paid_commission | currency:\'Rp \':0}}</dd></dl></div></div></div></div></div></div><div class=\"ibox\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title\"><div class=\"pull-right\"><a ng-click=\"vm.createCommissionPayment()\" class=\"btn btn-outline btn-xs btn-success\" ng-if=\"vm.privileges.payment\"><i class=\"fa fa-plus\"></i> Tambah Commission Payment</a></div><h5>Commission Payment</h5></div><div class=\"ibox-content\" ng-show=\"vm.commission.commission_payments.length\"><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\">Komisi</th><th data-sort-ignore=\"true\">Invoice Number</th><th data-sort-ignore=\"true\">Invoice Amount</th><th data-sort-ignore=\"true\">Invoice Date</th><th data-sort-ignore=\"true\">Customer Paid Date</th><th data-sort-ignore=\"true\">Description</th><th data-sort-ignore=\"true\">Tanggal Dibuat</th><th data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"payment in vm.commission.commission_payments\" \"=\"\"><td>{{ payment.commission_amount | currency:\'Rp \':0 }} ({{ payment.commission_percentage_multiplier * 100 }}%)<p ng-if=\"payment.commission_paid_at\"><span class=\"label label-danger\">Komisi sudah dibayar pada <strong>{{ vm.globalState.setTime(payment.commission_paid_at) | date:\'d MMMM yyyy\' }}.</strong></span></p></td><td>{{ payment.invoice_number || \'-\' }}</td><td>{{ payment.invoice_amount | currency:\'Rp \':0 }}</td><td>{{ vm.globalState.setTime(payment.invoice_date) | date:\'d MMMM yyyy\' }}</td><td>{{ vm.globalState.setTime(payment.paid_at) | date:\'d MMMM yyyy\' || \'-\' }} <span class=\"text-danger\" ng-if=\"payment.days_late > 0\"><b>(Telat {{ payment.days_late }} hari!)</b></span></td><td>{{ payment.description || \'-\' }}</td><td>{{ vm.globalState.setTime(payment.created_at) | date:\'d MMMM yyyy\' }}</td><td class=\"text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.payCommission(payment, $event)\" ng-if=\"vm.privileges.payment && !payment.commission_paid_at && payment.paid_at\"><i class=\"fa fa-plus\"></i> Bayar Komisi</a> <a class=\"btn btn-xs btn-success btn-outline\" ng-click=\"vm.editPayment(payment, $event)\" ng-if=\"vm.privileges.payment\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.commission.commission_payments.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Commission Payment tidak ditemukan.</h4></div></div></div>");
$templateCache.put("app/commission/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Commissions Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk melihat komisi Anda. Anda dapat melihat pesanan-pesanan yang akan memberikan komisi Anda. Tagihkan Customer Anda bila belum dibayar. Finance akan mengatur pembuatan invoice dan pembayaran yang Anda dapat lihat dengan cara mengklik detail Commission tersebut.<hr><h3>Finance</h3>Mohon input invoice setiap kali adanya pembuatan invoice supaya Sales dapat melihat dan menagih bila sudah waktunya.<hr><h3>Sales</h3>Anda dapat melihat semua komisi anda disini. Silahkan tagih Customer anda bila sudah waktunya. Komisi Anda dapat berkurang tergantung dari telatnya pembayaran dari Customer.<hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/commission/index/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"CommissionController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Commissions Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a></div><h2>Commissions</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th>Quotation #</th><th>Customer</th><th ng-if=\"vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN\">Sales</th><th>Total Price</th><th>Commission</th><th>Paid Commission</th><th class=\"col-xs-3\">Tanggal</th></tr></thead><tbody><tr ng-repeat=\"commission in vm.commissions\" ng-click=\"vm.showDetail(commission)\"><td ng-click=\"$event.stopPropagation();\"><a ui-sref=\"quotation.detail({\'quotationHashId\': commission.quotation.hash_id, \'quotation\': commission.quotation})\"><strong><i>{{ commission.quotation.quotation_revision_number }}</i></strong></a></td><td ng-click=\"$event.stopPropagation();\"><a ui-sref=\"customer.detail({\'customerHashId\': commission.quotation.customer.hash_id, \'customer\': commission.quotation.customer})\">{{ commission.quotation.customer.name }}</a></td><td ng-if=\"vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN\">{{ commission.user.name }}</td><td>{{ commission.total_price | currency:\'Rp \':0 }}</td><td>{{ commission.total_max_possible_commission | currency:\'Rp \':0 }}</td><td>{{ commission.total_paid_commission | currency:\'Rp \':0 }}</td><td>{{ vm.globalState.setTime(commission.created_at) | date:\'d MMMM yyyy HH:mm\' }}</td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">10GB of <strong>250GB</strong> Free.</div><div><strong>Copyright</strong> Example Company &copy; 2015-2016</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">Example menu<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a href=\"\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">Main page</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.minor\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">Minor page</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"Search for something...\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/components/modals/error.html","<div class=\"inmodal\"><div class=\"modal-header\"><strong>{{ error.title }}</strong> <small class=\"font-bold\"></small></div><div class=\"modal-body\" ng-bind-html=\"error.template\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button></div></div>");
$templateCache.put("app/customer/approve-modal/approve-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.approve($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Approve Customer</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Term of Payment <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.term_of_payment\" required=\"\"><option value=\"\">- Pilih Term -</option><option value=\"{{ vm.constants.CUSTOMER_TOP.PREPAID }}\">Prepaid</option><option value=\"{{ vm.constants.CUSTOMER_TOP.CASH_BEFORE_DELIVERY }}\">Cash Before Delivery</option><option value=\"{{ vm.constants.CUSTOMER_TOP.GIRO }}\">Giro</option><option value=\"{{ vm.constants.CUSTOMER_TOP.CHEQUE }}\">Cheque</option><option value=\"{{ vm.constants.CUSTOMER_TOP.DP_AND_TERMS }}\">DP & Terms</option><option value=\"{{ vm.constants.CUSTOMER_TOP.TERMS }}\">Terms</option></select></div><div class=\"form-group\" ng-if=\"vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS\"><label>Credit Limit <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm.data.credit_limit\" required=\"\"></div></div><div class=\"form-group\"><label>Jangka Waktu Pembayaran (Hari)</label> <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.days_of_payable\"></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-check\"></i> Approve</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DetailCustomerController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-success\" ng-click=\"vm.editCustomer()\" ng-if=\"vm.privileges.update && (vm.privileges.admin || vm.customer.status !== vm.constants.CUSTOMER_STATUS.APPROVED)\"><i class=\"fa fa-pencil\"></i> Update Customer</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.reassignCustomer()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-repeat\"></i> Reassign Customer</a></div><h2>Customer Detail</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"m-b-md\"><div class=\"profile-image text-center\"><div class=\"m-b-xs\" style=\"display: inline-block; width: 100px; height: 100px;\"><img src=\"{{vm.customer.logo_url ? vm.customer.logo_url : \'assets/images/logo/logo.png\'}}\" style=\"height: 100%; width: 100%; object-fit: contain\"></div><button class=\"btn btn-xs btn-outline btn-primary\" type=\"button\" ng-click=\"vm.uploadImage(vm.constants.CUSTOMER_UPLOAD_TYPE.LOGO)\" ng-if=\"vm.privileges.update\"><span ng-if=\"vm.customer.image\"><i class=\"fa fa-pencil\"></i> Ubah Logo</span> <span ng-if=\"!vm.customer.image\"><i class=\"fa fa-plus\"></i> Unggah Logo</span></button></div><div class=\"profile-info\"><div class=\"\"><div><span class=\"label\" ng-class=\"{ \'label-primary\': vm.customer.status === vm.constants.CUSTOMER_STATUS.APPROVED, \'label-info\': vm.customer.status === vm.constants.CUSTOMER_STATUS.SUBMITTED, \'label-warning\': vm.customer.status === vm.constants.CUSTOMER_STATUS.DRAFT, \'label-danger\': vm.customer.status === vm.constants.CUSTOMER_STATUS.REJECTED }\">{{ vm.customer.status }}</span><h1 class=\"no-margins\">{{vm.customer.name}}</h1><h2>{{vm.customer.email}}</h2><h3>{{vm.customer.phone}} {{vm.customer.phone_2}}</h3></div></div></div></div></div><div class=\"col-md-6\" ng-if=\"vm.customer.sales\"><div class=\"well p-xs m-b-none clearfix\"><img src=\"{{vm.customer.sales.image_url}}\" ng-if=\"vm.customer.sales.image_url\" class=\"img-responsive pull-right\" style=\"width: 50px\"><h2>Sales for this Customer</h2><h4>{{ vm.customer.sales.name | ucfirst }} <span ng-if=\"vm.customer.sales.role\">({{ vm.customer.sales.role.name }})</span></h4><p>Email: {{ vm.customer.sales.email || \'-\' }}</p><p ng-if=\"vm.customer.sales.phone || vm.customer.sales.phone_2\">Phone: <span class=\"label label-default\" ng-if=\"vm.customer.sales.phone\">{{ vm.customer.sales.phone }}</span> <span class=\"label label-default\" ng-if=\"vm.customer.sales.phone_2\">| {{ vm.customer.sales.phone_2 }}</span></p></div></div></div><div class=\"m-t-md\"><table class=\"table\"><tbody><tr><td width=\"35%\"><strong>#ID:</strong></td><td>{{ vm.customer.hash_id || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Customer Code:</strong></td><td>{{ vm.customer.code || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Nama Purchaser:</strong></td><td>{{vm.customer.purchaser_name || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>HP Purchaser:</strong></td><td>{{vm.customer.purchaser_phone || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Nama QC:</strong></td><td>{{vm.customer.qc_name || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>HP QC:</strong></td><td>{{vm.customer.qc_phone || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Nama Kepala Produksi:</strong></td><td>{{vm.customer.production_head_name || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>HP Kepala Produksi:</strong></td><td>{{vm.customer.production_head_phone || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Tipe:</strong></td><td>{{ vm.customer.type || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Fax:</strong></td><td>{{vm.customer.fax || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Deskripsi:</strong></td><td>{{vm.customer.description || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Projection Revenue (per bulan):</strong></td><td>{{vm.customer.projection_revenue | currency:\'Rp \':0}}</td></tr><tr><td width=\"35%\"><strong>Nomor NPWP:</strong></td><td>{{vm.customer.npwp_number || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Alamat NPWP/Quotation:</strong></td><td>{{vm.customer.npwp_address || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>No. Akta:</strong></td><td>{{vm.customer.deed_of_incorporation || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Tanggal Akta:</strong></td><td>{{ vm.globalState.setTime(vm.customer.deed_of_incorporation_date) | date:\'d MMMM yyyy\' }}</td></tr><tr><td width=\"35%\"><strong>Nomor Akta Terakhir:</strong></td><td>{{vm.customer.last_deed || \'-\'}}</td></tr><tr><td width=\"35%\"><strong>Tanggal Akta Terakhir:</strong></td><td>{{ vm.globalState.setTime(vm.customer.last_deed_date) | date:\'d MMMM yyyy\' }}</td></tr><tr\"><td width=\"35%\"><strong>Term of Payment:</strong></td><td>{{vm.customer.term_of_payment || \'-\'}}</td><tr ng-if=\"(vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\"><td width=\"35%\"><strong>Jangka Waktu Pembayaran (Hari):</strong></td><td>{{vm.customer.days_of_payable || \'-\'}}</td></tr><tr ng-if=\"(vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\"><td width=\"35%\"><strong>Credit Limit:</strong></td><td>{{vm.customer.credit_limit | currency:\'Rp \':0}} <span ng-if=\"vm.customer.outstanding_credit > 0\">(Outstanding credit: {{ vm.customer.outstanding_credit | currency:\'Rp \':0 }})</span></td></tr></tr\"></tbody></table></div><div class=\"row m-t-md\"><div class=\"col-md-12 clearfix\"><div ng-if=\"vm.customer.npwp_image_url\" class=\"m-r-md pull-left\"><strong>NPWP</strong> <a class=\"img-thumbnail\" ng-click=\"vm.showImage(vm.customer, vm.customer.npwp_image_url, vm.constants.CUSTOMER_UPLOAD_TYPE.NPWP, true, false)\" style=\"background-image: url({{vm.customer.npwp_image_url}}); width: 150px; height: 100px\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div><div ng-if=\"vm.privileges.update && !vm.customer.npwp_image_url\" class=\"m-r-md pull-left\"><strong>NPWP</strong> <a ng-click=\"vm.uploadImage(vm.constants.CUSTOMER_UPLOAD_TYPE.NPWP)\" class=\"img-thumbnail text-center\" ng-if=\"vm.privileges.update\" style=\"width: 150px; height: 100px; line-height: 100px; background-color: rgba(0,0,0,.5); color: white\"><i class=\"fa fa-plus\"></i> Unggah</a></div><div ng-if=\"vm.customer.deed_of_incorporation_image_url\" class=\"m-r-md pull-left\"><strong>Akta Perusahaan</strong> <a class=\"img-thumbnail\" ng-click=\"vm.showImage(vm.customer, vm.customer.deed_of_incorporation_image_url, vm.constants.CUSTOMER_UPLOAD_TYPE.DEED, true, false)\" style=\"background-image: url({{vm.customer.deed_of_incorporation_image_url}}); width: 150px; height: 100px\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div><div ng-if=\"vm.privileges.update && !vm.customer.deed_of_incorporation_image_url\" class=\"m-r-md pull-left\"><strong>Akta Perusahaan</strong> <a ng-click=\"vm.uploadImage(vm.constants.CUSTOMER_UPLOAD_TYPE.DEED)\" class=\"img-thumbnail text-center\" ng-if=\"vm.privileges.update\" style=\"width: 150px; height: 100px; line-height: 100px; background-color: rgba(0,0,0,.5); color: white\"><i class=\"fa fa-plus\"></i> Unggah</a></div><div ng-if=\"vm.customer.last_deed_image_url\" class=\"m-r-md pull-left\"><strong>Akta Terakhir</strong> <a class=\"img-thumbnail\" ng-click=\"vm.showImage(vm.customer, vm.customer.last_deed_image_url, vm.constants.CUSTOMER_UPLOAD_TYPE.LAST_DEED, true, false)\" style=\"background-image: url({{vm.customer.last_deed_image_url}}); width: 150px; height: 100px\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div><div ng-if=\"vm.privileges.update && !vm.customer.last_deed_image_url\" class=\"m-r-md pull-left\"><strong>Akta Terakhir</strong> <a ng-click=\"vm.uploadImage(vm.constants.CUSTOMER_UPLOAD_TYPE.LAST_DEED)\" class=\"img-thumbnail text-center\" ng-if=\"vm.privileges.update\" style=\"width: 150px; height: 100px; line-height: 100px; background-color: rgba(0,0,0,.5); color: white\"><i class=\"fa fa-plus\"></i> Unggah</a></div></div></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"pull-right\"><a ng-click=\"vm.createAddress()\" class=\"btn btn-outline btn-xs btn-success\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-plus\"></i> Tambah Alamat</a></div><h5>Alamat Customer</h5></div><div class=\"ibox-content\" ng-repeat=\"address in vm.customer.customer_addresses\" ng-show=\"vm.customer.customer_addresses.length\"><div class=\"row\"><div class=\"col-xs-11\"><span class=\"label label-info m-r-xs\" ng-if=\"address.is_billing_address\">Billing</span> <span class=\"label label-success m-r-xs\">{{address.type}}</span> {{ address.address }}</div><div class=\"col-xs-1 text-center\"><a ng-click=\"vm.editAddress(address)\" class=\"btn btn-outline btn-xs btn-primary m-r-xs\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-pencil\"></i></a> <a ng-click=\"vm.deleteAddressConfirmation(address)\" class=\"btn btn-outline btn-xs btn-danger\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-trash\"></i></a></div></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.customer.customer_addresses.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Alamat tidak ditemukan.</h4></div></div><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"pull-right\"><a ng-click=\"vm.createImage()\" class=\"btn btn-outline btn-xs btn-success\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-plus\"></i> Unggah Gambar</a></div><h5>Customer Images</h5></div><div class=\"ibox-content\" ng-show=\"vm.customer.customer_images.length\"><div class=\"row\"><div class=\"col-md-2 m-b-md\" ng-repeat=\"image in vm.customer.customer_images\"><a class=\"img-thumbnail\" ng-click=\"vm.showImage(image, image.image_url, vm.constants.CUSTOMER_UPLOAD_TYPE.IMAGE, false, true)\" style=\"background-image: url({{image.image_url}});\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.customer.customer_images.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Gambar tidak ditemukan.</h4></div></div><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"pull-right\"><a class=\"btn btn-outline btn-xs btn-success\" ng-click=\"vm.addImportantPerson()\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-plus\"></i> Tambah Important Person</a></div><h5>Important Persons</h5></div><div class=\"ibox-content\" ng-show=\"vm.customer.customer_important_persons.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-4\">Nama</th><th class=\"col-xs-3\">Posisi</th><th class=\"col-xs-3\">No. ID Card</th><th class=\"col-xs-1\">ID Card</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"importantPerson in vm.customer.customer_important_persons\"><td style=\"vertical-align: middle\"><i ng-if=\"importantPerson.is_key_person\" class=\"fa fa-key text-warning m-r-xs\" title=\"Key Person\"></i> {{ importantPerson.name || \'-\'}}</td><td style=\"vertical-align: middle\">{{ importantPerson.position || \'-\'}}</td><td style=\"vertical-align: middle\">{{ importantPerson.id_card_number || \'-\'}}</td><td style=\"vertical-align: middle\"><a ng-if=\"importantPerson.id_card_image_url\" class=\"img-thumbnail small-thumbnail\" ng-click=\"vm.showImage(vm.customer, importantPerson.id_card_image_url, vm.constants.CUSTOMER_UPLOAD_TYPE.ID_CARD, true, false, importantPerson)\" style=\"background-image: url({{importantPerson.id_card_image_url}}); width: 50px; height: 50px; vertical-align: middle\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a> <button ng-click=\"vm.uploadImage(vm.constants.CUSTOMER_UPLOAD_TYPE.ID_CARD, importantPerson)\" class=\"btn btn-xs btn-outline btn-warning\" ng-if=\"!importantPerson.id_card_image_url && vm.privileges.update\"><i class=\"fa fa-plus\"></i> ID Card</button></td><td><button class=\"btn btn-outline btn-primary btn-xs btn-block\" ng-click=\"vm.editImportantPerson(importantPerson)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-outline btn-danger btn-xs btn-block\" ng-click=\"vm.deleteImportantPersonConfirmation(importantPerson, $event)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.customer.customer_important_persons.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Important person tidak ditemukan.</h4></div></div><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"pull-right\"><a class=\"btn btn-outline btn-xs btn-success\" ng-click=\"vm.addProduct()\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-plus\"></i> Tambah Produk</a></div><h5>Produk</h5></div><div class=\"ibox-content\" ng-show=\"vm.customer.customer_products.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-2\">Tipe</th><th class=\"col-xs-8\">Nama</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"product in vm.customer.customer_products\"><td style=\"vertical-align: middle\"><span class=\"label label-info\">{{ product.type || \'-\'}}</span></td><td style=\"vertical-align: middle\">{{ product.name || \'-\'}}</td><td class=\"text-right\"><button class=\"btn btn-xs btn-outline btn-danger\" ng-click=\"vm.deleteProductConfirmation(product, $event)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.customer.customer_products.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Produk tidak ditemukan.</h4></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>Status History</h5></div><div class=\"ibox-content\" ng-show=\"vm.customer.discussions.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-3\">Tanggal</th><th class=\"col-xs-2\">Status</th><th class=\"col-xs-3\">User</th><th class=\"col-xs-4\">Deskripsi</th></tr></thead><tbody><tr ng-repeat=\"discussion in vm.customer.discussions\"><td>{{ vm.globalState.setTime(discussion.created_at) | date:\'d MMMM yyyy hh:mm a\' }}</td><td><span class=\"label\" ng-class=\"{ \'label-primary\': discussion.status === vm.constants.CUSTOMER_STATUS.APPROVED, \'label-info\': discussion.status === vm.constants.CUSTOMER_STATUS.SUBMITTED, \'label-warning\': discussion.status === vm.constants.CUSTOMER_STATUS.DRAFT, \'label-danger\': discussion.status === vm.constants.CUSTOMER_STATUS.REJECTED }\">{{ discussion.status | ucfirst }}</span></td><td><p class=\"m-b-xs\"><strong>{{ discussion.user.name }}</strong></p><small class=\"text-muted\">{{ discussion.user.role.name }}</small></td><td>{{ discussion.description || \'-\' }}</td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.customer.discussions.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Discussion tidak ditemukan.</h4></div></div></div>");
$templateCache.put("app/customer/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Customer Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur Customer.<hr><h3>Proses</h3><hr><h3>Sales</h3>Anda dapat request untuk membuat Customer. Bila Customer sudah diapprove, mohon minta bantuan Admin untuk mengubah datanya.<hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/customer/index/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"IndexCustomerController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Customer Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createCustomer()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat Customer</a></div><h2>Customer</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control\" ng-change=\"vm.filter()\" ng-model=\"vm.filtering.filter.type\"><option value=\"\">- Tipe -</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PT }}\">PT</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.CV }}\">CV</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.UD }}\">UD</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.INDIVIDUAL }}\">Individual</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PARTNERSHIP }}\">Partnership</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.ETC }}\">Lainnya</option></select></div><div class=\"col-md-9\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover table-clickable\"><thead><tr><th class=\"col-xs-1\">Activate</th><th class=\"col-xs-1\">Tipe</th><th class=\"col-xs-3\" ng-click=\"vm.sortName(vm.filtering.sort.name)\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort.name === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort.name === \'asc\'\"></i> Nama</th><th class=\"col-xs-3\">Nomor NPWP</th><th class=\"col-xs-1 text-center\">Status</th><th class=\"col-xs-3\"></th></tr></thead><tbody><tr ng-repeat=\"customer in vm.customers\" ng-click=\"vm.showCustomer(customer)\"><td><div ng-if=\"vm.privileges.admin\" ng-click=\"$event.stopPropagation()\"><input ng-click=\"vm.toggleActive(customer, $event)\" type=\"checkbox\" class=\"ios8-switch ios8-switch-lg\" id=\"checkbox-{{ customer.hash_id }}\" ng-checked=\"customer.is_active\" ng-disabled=\"customer.status !== vm.constants.CUSTOMER_STATUS.APPROVED\"> <label for=\"checkbox-{{ customer.hash_id }}\"></label></div><div ng-if=\"!vm.privileges.admin\"><span ng-if=\"customer.is_active\"><span class=\"label label-primary\">Active</span></span> <span ng-if=\"!customer.is_active\"><span class=\"label label-default\">Inactive</span></span></div></td><td>{{ customer.type }}</td><td>{{ customer.name || \'-\' }}</td><td>{{ customer.npwp_number || \'-\' }}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"{\'label-default\': customer.status === vm.constants.CUSTOMER_STATUS.DRAFT, \'label-primary\': customer.status === vm.constants.CUSTOMER_STATUS.APPROVED, \'label-warning\': customer.status === vm.constants.CUSTOMER_STATUS.SUBMITTED, \'label-danger\': customer.status === vm.constants.CUSTOMER_STATUS.REJECTED}\">{{ (customer.status | ucfirst) || \'-\' }}</span></td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-info btn-outline\" ng-click=\"vm.submitCustomerConfirmation(customer); $event.stopPropagation();\" ng-if=\"vm.privileges.submit && (customer.status === vm.constants.CUSTOMER_STATUS.DRAFT || customer.status === vm.constants.CUSTOMER_STATUS.REJECTED)\"><i class=\"fa fa-arrow-circle-right\"></i> Submit</a> <a class=\"btn btn-xs btn-primary btn-outline\" ng-click=\"vm.approve(customer); $event.stopPropagation();\" ng-if=\"vm.privileges.admin && (customer.status === vm.constants.CUSTOMER_STATUS.SUBMITTED || customer.status === vm.constants.CUSTOMER_STATUS.UPDATED)\"><i class=\"fa fa-check\"></i> Approve</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.rejectCustomerConfirmation(customer); $event.stopPropagation();\" ng-if=\"vm.privileges.admin && (customer.status === vm.constants.CUSTOMER_STATUS.SUBMITTED || customer.status === vm.constants.CUSTOMER_STATUS.UPDATED)\"><i class=\"fa fa-times\"></i> Reject</a> <a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editCustomer(customer); $event.stopPropagation();\" ng-if=\"(vm.privileges.update && customer.status !== vm.constants.CUSTOMER_STATUS.APPROVED) || vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/material/ink/ink.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialInkController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title clearfix\" ng-if=\"vm.privileges.admin\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Printing Ink Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Material</a></div><h2>Material Printing Ink</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-1\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Usage /m<sup>2</sup></th><th class=\"col-xs-1\" data-sort-ignore=\"true\">Solvent</th><th class=\"col-xs-1\" data-sort-ignore=\"true\">Hardener</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Surface Density</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Harga</th><th class=\"col-xs-1\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\" foo-repeat-done=\"\"><td><strong><i>{{ material.hash_id }}</i></strong></td><td>{{ material.name || \'-\' }}</td><td>{{ material.conversion.usage_per_m2 | number }} {{ material.conversion.usage_per_m2_unit_name }}</td><td>{{ material.conversion.solvent | number }} {{ material.conversion.solvent_unit_name }}</td><td>{{ material.conversion.hardener | number }} {{ material.conversion.hardener_unit_name }}</td><td>{{ (material.conversion.surface_density) || \'-\' }} {{ material.conversion.surface_density_unit_name || \'-\' }}</td><td>{{ material.printing_ink_prices.conversion.price | currency:\'Rp \':0 }} / {{ material.printing_ink_prices.conversion.price_unit_name }}</td><td class=\"text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/material/laminating/laminating.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialLaminatingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.admin\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Laminating Material Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Material</a></div><h2>Material Laminating</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\">#ID</th><th class=\"col-xs-5\" data-sort-ignore=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Density</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Harga</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\" foo-repeat-done=\"\"><td><strong><i>{{ material.hash_id }}</i></strong></td><td><p>{{ material.name || \'-\' }}</p><div class=\"row\"><div class=\"col-md-6\"><p><small><strong>Solvent Density:</strong>{{ material.conversion.solvent_density | number }} {{material.conversion.solvent_density_unit_name}}</small><br><small><strong>Hardener Density:</strong>{{ material.conversion.hardener_density | number }} {{material.conversion.hardener_density_unit_name}}</small><br><small><strong>Adhesive Density:</strong>{{ material.conversion.adhesive_density | number }} {{material.conversion.adhesive_density_unit_name}}</small></p></div><div class=\"col-md-6\"><p><small><strong>Solvent Thickness:</strong>{{ material.conversion.solvent_thickness | number }} {{material.conversion.solvent_thickness_unit_name}}</small><br><small><strong>Hardener Thickness:</strong>{{ material.conversion.hardener_thickness | number }} {{material.conversion.hardener_thickness_unit_name}}</small><br><small><strong>Adhesive Thickness:</strong>{{ material.conversion.adhesive_thickness | number }} {{material.conversion.adhesive_thickness_unit_name}}</small></p></div></div></td><td>{{ (material.conversion.density | number) || \'-\' }} {{ material.conversion.density_unit_name || \'\' }}</td><td>{{ material.laminating_material_prices.conversion.price | currency:\'Rp \':0 }} / {{ material.laminating_material_prices.conversion.price_unit_name }}</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/material/packing/packing.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialPackingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.admin\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Packing Material Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Material</a></div><h2>Material Packing</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-4\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">Required</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Harga</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\" foo-repeat-done=\"\"><td><strong><i>{{ material.hash_id }}</i></strong></td><td>{{ material.name || \'-\' }}</td><td><span class=\"label label-primary\" ng-if=\"material.is_required\">Required</span> <span class=\"label label-default\" ng-if=\"!material.is_required\">Not Required</span></td><td>{{ material.packing_material_prices.conversion.price | currency:\'Rp \':0 }} / {{ material.packing_material_prices.conversion.price_unit_name }}</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/material/printing/printing.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialPrintingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title clearfix\" ng-if=\"vm.privileges.admin\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Printing Material Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Material</a></div><h2>Material Printing Film</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-4\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Density</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Harga</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\" foo-repeat-done=\"\"><td><strong><i>{{ material.hash_id }}</i></strong></td><td>{{ material.name || \'-\' }}</td><td>{{ (material.conversion.density | number) || \'-\' }} {{ material.conversion.density_unit_name || \'-\' }}</td><td>{{ material.printing_material_prices.conversion.price | currency:\'Rp \':0 }} / {{ material.printing_material_prices.conversion.price_unit_name }}</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/material/slitting/slitting.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialSlittingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.admin\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Slitting Material Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createMaterial()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Material</a></div><h2>Material Slitting</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-4\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Length</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Harga</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\" foo-repeat-done=\"\"><td><strong><i>{{ material.hash_id }}</i></strong></td><td>{{ material.name || \'-\' }}</td><td>{{ (material.conversion.length | number) || \'-\' }} {{ material.conversion.length_unit_name || \'-\' }}</td><td>{{ material.slitting_material_prices.conversion.price | currency:\'Rp \':0 }} / {{ material.slitting_material_prices.conversion.price_unit_name }}</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterial(material)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/quotation/create/create.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"CreateQuotationController as vm\"><div class=\"row\" ng-if=\"vm.privileges.create\"><div class=\"col-sm-7\"><div class=\"ibox\"><form ng-submit=\"vm.createProduct($event)\"><div class=\"ibox-title\"><h2>Tambah Produk</h2></div><div class=\"ibox-content\"><div><div class=\"form-group\"><label>Nama Produk <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm._createProduct.name\" required=\"\"></div><div class=\"form-group\"><label>Lebar <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.width\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.WIDTH }}</span></div></div><div class=\"form-group\"><label>Slitting Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_materials[0].slitting_length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SLITTING_LENGTH }}</span></div></div><div class=\"form-group\"><label>Total Panjang Order <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.LENGTH }}</span></div></div><div class=\"form-group\"><label>Tebal <span class=\"text-danger\">*</span></label><br><small>Akan diisi otomatis saat mengisi Printing Material dan Laminating Material.</small><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.thickness\" disabled=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.THICKNESS }}</span></div></div><div class=\"form-group\"><label>Printing Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.printing_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Laminating Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.laminating_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Slitting Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Printing Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.printing_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Laminating Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.laminating_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Slitting Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Notes Tambahan</label> <textarea cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"vm._createProduct.notes\"></textarea></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_printing\"><span></span> Material Printing</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_printing\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Material</label><ui-select ng-model=\"vm._createProduct.printing_material.material\" theme=\"bootstrap\" title=\"Pilih Material...\" on-select=\"vm.materialPrintingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"material in vm.materialPrinting | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Ketebalan Material</label><div class=\"input-group\"><input ng-change=\"vm.fillThickness()\" class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm._createProduct.printing_material.thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.THICKNESS }}</span></div></div></div></div><div class=\"form-group\"><label>Tambah Warna</label><ui-select multiple=\"\" ng-model=\"vm._createProduct.inks_name\" theme=\"bootstrap\" sortable=\"true\" ng-change=\"vm.inkOnChange($item)\"><ui-select-match placeholder=\"Pilih Warna...\">{{ $item.name }}</ui-select-match><ui-select-choices repeat=\"material in vm.materialInk | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_laminating\"><span></span> Material Laminating</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_laminating\"><div class=\"form-group\"><a class=\"btn btn-default\" ng-click=\"vm.addLaminatingMaterial()\"><i class=\"fa fa-plus\"></i> Tambah material</a></div><div ng-show=\"vm._createProduct.laminating_materials | isEmpty\"><small class=\"text-info\"><i class=\"fa fa-info-circle\"></i> Silahkan menambahkan material dengan mengklik tombol diatas.</small></div><div class=\"form-group m-b-xs\" ng-repeat=\"material in vm._createProduct.laminating_materials\" ng-hide=\"vm._createProduct.laminating_materials | isEmpty\"><p><a class=\"text-danger\" ng-click=\"vm.removeLaminatingMaterial(material)\"><i class=\"fa fa-trash\"></i></a> <strong>{{ material.material.name || \'-\' }} <small>(Thickness: <span class=\"text-info\">{{ material.thickness | number }}{{ vm.constants.UNIT_TYPE.THICKNESS }}</span> | Adhesive Usage /m<sup>2</sup>: <span class=\"text-info\">{{ material.adhesive_usage_per_m2 }} gram</span>)</small></strong></p></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_slitting\" disabled=\"\"><span></span> Material Slitting</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_slitting\"><div class=\"form-group\"><div class=\"clearfix\"><button ng-if=\"vm._createProduct.slitting_materials[0].hash_id\" class=\"btn btn-link pull-right text-danger\" type=\"button\" ng-click=\"vm.resetSlitting()\" style=\"color: red\">Batal</button> <label>Material</label></div><ui-select ng-model=\"vm._createProduct.slitting_materials[0].hash_id\" theme=\"bootstrap\" title=\"Pilih Material...\" on-select=\"vm.materialSlittingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{$select.selected.name}}</ui-select-match><ui-select-choices refresh=\"vm.getReferral($select.search)\" refresh-delay=\"300\" repeat=\"material.hash_id as material in vm.materialSlitting | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_packing\" disabled=\"\"><span></span> Material Packing</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_packing\"><div class=\"form-group\"><label>Optional Material</label><ui-select multiple=\"\" ng-model=\"vm._createProduct.packing_materials_name\" theme=\"bootstrap\" sortable=\"true\" on-select=\"vm.materialPackingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{ $item.name }}</ui-select-match><ui-select-choices repeat=\"material in vm.materialPacking | filter:{is_required:0} | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><i class=\"text-danger\">*Required materials:</i> <span class=\"label label-defaull m-r-xs\" ng-repeat=\"requiredMaterialPacking in vm.requiredMaterialPacking\">{{requiredMaterialPacking.name}}</span></div></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_bag_making\"><span></span> Bag Making</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_bag_making\"><div class=\"form-group\"><label>Length</label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.bag_length\"> <span class=\"input-group-addon\">mm</span></div></div><div class=\"form-group\"><label>Width</label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.bag_width\"> <span class=\"input-group-addon\">mm</span></div></div><div class=\"form-group\"><label>Overhead Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.bag_overhead_cost\"></div></div><div class=\"form-group\"><label>Bag Making Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /bag</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.price_per_bag\"></div></div></div></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.is_cylinder\"><span></span> Is Cylinder</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.is_cylinder\"><div class=\"form-group\"><label>Cylinder Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.cylinder_cost\"></div></div></div></div></div><div class=\"ibox-footer clearfix\"><div id=\"editProduct\" class=\"hidden\"><button ng-click=\"vm.cancelEditProduct()\" class=\"btn btn-warning pull-right m-l-xs\" type=\"button\" id=\"cancelUpdateProductButton\">Batal</button> <button ng-click=\"vm.saveEditProduct($event)\" class=\"btn btn-primary pull-right m-l-xs\" type=\"button\" id=\"saveUpdateProductButton\">Simpan perubahan produk</button></div><button class=\"btn btn-primary pull-right\" type=\"submit\" id=\"addProductButton\">Tambahkan Produk</button></div></div></form></div></div><div class=\"col-sm-5\"><form ng-submit=\"vm.createQuotation()\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>Buat Quotation Baru</h2></div><div class=\"ibox-content\"><div ng-show=\"vm.data.quotation_products | isEmpty\" class=\"text-center\"><h4 class=\"text-danger\"><i class=\"fa fa-warning\"></i> Belum ada produk untuk quotation ini!</h4><p>Silahkan tambahkan produk baru pada form yang disediakan.</p></div><div ng-hide=\"vm.data.quotation_products | isEmpty\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\">Produk yang telah ditambahkan:</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\"></th><th data-hide=\"all\">Quantity</th><th data-hide=\"all\">Width</th><th data-hide=\"all\">Total Order Length</th><th data-hide=\"all\">Printing Waste</th><th data-hide=\"all\">Laminating Waste</th><th data-hide=\"all\">Slitting Waste</th><th data-hide=\"all\">Printing Overhead Cost</th><th data-hide=\"all\">Laminating Overhead Cost</th><th data-hide=\"all\">Slitting Overhead Cost</th><th data-hide=\"all\">Notes</th><th data-hide=\"all\">Material Printing</th><th data-hide=\"all\">Inks</th><th data-hide=\"all\">Material Laminating</th><th data-hide=\"all\">Material Slitting</th><th data-hide=\"all\">Material Packing</th><th data-hide=\"all\">Bag Width</th><th data-hide=\"all\">Bag Length</th><th data-hide=\"all\">Bag Overhead Cost</th><th data-hide=\"all\">Bag Making Cost</th><th data-hide=\"all\">Cylinder</th><th data-hide=\"all\">Cylinder Cost</th></tr></thead><tbody><tr ng-repeat=\"product in vm.data.quotation_products\" foo-repeat-done=\"\"><td><strong><i>{{ product.name || \'-\' }}</i></strong></td><td class=\"text-right\"><a ng-click=\"vm.editProduct(product, $index); $event.preventDefault()\" class=\"text-primary\"><i class=\"fa fa-pencil\"></i></a> <a ng-click=\"vm.removeProductConfirmation(product, $index); $event.preventDefault()\" class=\"text-danger\"><i class=\"fa fa-trash\"></i></a></td><td>{{ product.quantity | number }}</td><td>{{ product.width | number }} {{ vm.constants.UNIT_TYPE.WIDTH }}</td><td>{{ product.length | number }} {{ vm.constants.UNIT_TYPE.LENGTH }}</td><td>{{ product.printing_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>{{ product.laminating_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>{{ product.slitting_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>Rp {{ product.printing_overhead_cost | number }}</td><td>Rp {{ product.laminating_overhead_cost | number }}</td><td>Rp {{ product.slitting_overhead_cost | number }}</td><td>{{ product.notes || \'-\' }}</td><td><div ng-show=\"product.need_printing\">{{ product.printing_material.material.name || \'-\' }} {{ product.printing_material.thickness }}{{ vm.constants.UNIT_TYPE.THICKNESS }}</div><div ng-hide=\"product.need_printing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><div ng-show=\"product.need_printing\"><span class=\"label m-r-xs m-b-xs\" ng-repeat=\"ink in product.inks_name\">{{ ink.name }}</span></div><div ng-hide=\"product.need_printing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><p class=\"m-b-md\" ng-repeat=\"material in product.laminating_materials\" ng-show=\"product.need_laminating\"><strong class=\"text-muted\"><i>{{ material.material.name || \'-\' }} (<small class=\"text-info\">{{ material.thickness | number }}{{ vm.constants.UNIT_TYPE.THICKNESS }} | {{material.adhesive_usage_per_m2}} gram</small>)</i></strong></p><div ng-hide=\"product.need_laminating\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><p class=\"m-b-md\" ng-repeat=\"material in product.slitting_materials\" ng-show=\"product.need_slitting\"><strong class=\"text-muted\"><i>{{ material.material.name || \'-\' }} ({{ material.slitting_length | number }}{{ vm.constants.UNIT_TYPE.SLITTING_LENGTH }})</i></strong></p><div ng-hide=\"product.need_slitting\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><span class=\"label m-r-xs m-b-xs\" ng-repeat=\"material in product.packing_materials_name\" ng-show=\"product.need_packing\">{{ material.name || \'-\' }}</span><div ng-hide=\"product.need_packing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td>{{(product.bag_width || 0) | number}} mm</td><td>{{(product.bag_length || 0) | number}} mm</td><td>Rp {{(product.bag_overhead_cost || 0) | number}} /m <sup>2</sup></td><td>Rp {{(product.price_per_bag || 0) | number}} /bag</td><td>{{ product.is_cylinder ? \'With Cylinder\' : \'-\' }}</td><td>Rp {{(product.cylinder_cost || 0) | number}} /m <sup>2</sup></td></tr></tbody></table></div></div><div class=\"ibox-content\"><label>PPN 10% <span class=\"text-danger\">*</span></label><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.taxable\"><span></span> Include PPN</label></div><hr><div class=\"form-group\"><label>Pilih Referral <span class=\"text-danger\">*</span></label><br><small>Dapatkan kode referral dari admin.</small><ui-select ng-model=\"vm.data.referral_hash_id\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik kode referral\"><strong>{{ $select.selected.code }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getReferral($select.search)\" refresh-delay=\"300\" repeat=\"referral.hash_id as referral in vm.referrals | filter: {code: $select.search}\"><p><strong ng-bind-html=\"referral.code | highlight: $select.search\"></strong></p></ui-select-choices></ui-select></div><hr><div class=\"form-group\"><label>Pilih Transport <span class=\"text-danger\">*</span></label><ui-select ng-model=\"vm.data.transport_type_hash_id\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik tipe transport\"><strong>{{ $select.selected.name }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getTransport($select.search)\" refresh-delay=\"300\" repeat=\"transport.hash_id as transport in vm.transports\"><div><strong ng-bind-html=\"transport.name | highlight: $select.search\"></strong><div ng-if=\"transport.hash_id !== null\"><small ng-bind-html=\"transport.transport_type_fees.price_per_kg | currency:\'Rp \':0 | highlight: $select.search\"></small> <small>/kg</small></div></div></ui-select-choices></ui-select><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.transport_cost_in_product\"><span></span> Include biaya transport dalam produk.</label></div></div><hr><div class=\"form-group\" ng-hide=\"vm.requiredTerms | isEmpty\"><label>Required Terms</label><br><small>Terms ini diharuskan di setiap Quotation.</small><div class=\"m-b-xs\" ng-repeat=\"term in vm.requiredTerms\"><p><small><i><span class=\"text-danger\">*</span> {{ term.description || \'-\' }}</i></small></p></div></div><div class=\"form-group\"><label>Optional Terms</label><br><small>Tambahkan terms optional untuk Quotation ini.</small><div class=\"form-group\"><div class=\"m-b-xs\" ng-repeat=\"term in vm.optionalTerms\" ng-hide=\"vm.optionalTerms | isEmpty\"><p><a class=\"text-danger\" ng-click=\"vm.removeTerm(term)\"><i class=\"fa fa-trash\"></i></a> <small><i>{{ term.description || \'-\' }}</i></small></p></div><button type=\"button\" ng-click=\"vm.addTerm()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Tambah Term</button> <button type=\"button\" ng-click=\"vm.addCustomTerm()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Tambah Custom Term</button></div></div></div><div class=\"ibox-footer text-center\"><button class=\"btn btn-primary btn-block\" type=\"submit\" ng-disabled=\"!vm.data.quotation_products.length\">Simpan Quotation</button></div></div></form></div></div></div>");
$templateCache.put("app/quotation/customer-modal/customer-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.submit($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Submit Quotation</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Pilih Customer</label><ui-select ng-model=\"vm.data.customer_hash_id\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik nama customer\"><strong>{{ $select.selected.name }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getCustomer($select.search)\" refresh-delay=\"300\" repeat=\"customer.hash_id as customer in vm.customers\"><p><strong ng-bind-html=\"customer.name | highlight: $select.search\"></strong><br><small ng-bind-html=\"customer.email | highlight: $select.search\"></small></p></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Submit</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DetailQuotationController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><button ng-if=\"vm.privileges.submit && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.DRAFT\" class=\"btn btn-success m-r-xs\" ng-click=\"vm.submit();$event.stopPropagation();\">Submit</button><button ng-if=\"vm.privileges.approveQuotation && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.SUBMITTED\" class=\"btn btn-primary m-r-xs\" ng-click=\"vm.approve();$event.stopPropagation();\">Approve</button><button ng-if=\"vm.privileges.approveQuotation && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.SUBMITTED\" class=\"btn btn-warning m-r-xs\" ng-click=\"vm.reject();$event.stopPropagation();\">Reject</button><button ng-if=\"vm.privileges.submit && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.APPROVED\" class=\"btn btn-q-poSubmitted m-r-xs\" ng-click=\"vm.linkToPo();$event.stopPropagation();\">Submit PO</button><button ng-if=\"vm.privileges.approvePO && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_SUBMITTED\" class=\"btn btn-q-poApproved m-r-xs\" ng-click=\"vm.approvePO();$event.stopPropagation();\">Approve PO</button><button ng-if=\"vm.privileges.submit && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_APPROVED\" class=\"btn btn-q-poConfirmed m-r-xs\" ng-click=\"vm.submitPOCOnfirmation();$event.stopPropagation();\">Submit PO Confirmation</button><button ng-if=\"vm.privileges.approvePO && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_CONFIRMED\" class=\"btn btn-q-done m-r-xs\" ng-click=\"vm.approvePOCOnfirmation();$event.stopPropagation();\">Approve PO Confirmation</button><button ng-if=\"vm.privileges.approvePO && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && (vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_SUBMITTED || vm.quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_CONFIRMED)\" class=\"btn btn-q-rejected m-r-xs\" ng-click=\"vm.rejectPO();$event.stopPropagation();\">Reject PO</button><button ng-if=\"vm.privileges.update && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_SUBMITTED &&vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_APPROVED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_CONFIRMED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_REJECTED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.DONE\" class=\"btn btn-default m-r-xs\" ng-click=\"vm.editQuotation();$event.stopPropagation();\">Ubah</button><button class=\"btn btn-danger m-r-xs\" ng-click=\"vm.deleteQuotation();$event.stopPropagation();\" ng-if=\"(vm.privileges.delete || vm.user.hash_id === quotation.user.hash_id) && quotation.quotation_informations.status == vm.constants.QUOTATION_STATUS.DRAFT\">Hapus</button></div><h2>Quotation Detail</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-7\"><p><strong>Quotation #:</strong> {{ vm.quotation.quotation_revision_number }}</p><p ng-if=\"vm.quotation.user\"><strong>Dibuat oleh:</strong> {{ vm.quotation.user.name }}</p><p><strong>Tanggal dibuat:</strong> {{ vm.globalState.setTime(vm.quotation.created_at) | date:\'d MMMM yyyy\' }}</p><p><strong>Status:</strong> {{ vm.quotation.quotation_informations.status }}</p><p><strong>Subtotal Price:</strong> {{ vm.quotation.quotation_informations.subtotal_price | currency:\'Rp \':0 }}</p><p><strong>Adjusted Price:</strong> {{ vm.quotation.quotation_informations.adjusted_price | currency:\'Rp \':0 }} <span ng-if=\"vm.quotation.quotation_informations.adjusted_price > 0 || vm.quotation.quotation_informations.adjusted_price_in_product\">(Include dalam produk)</span></p><p><strong>Net Subtotal Price:</strong> {{ vm.quotation.quotation_informations.net_subtotal_price | currency:\'Rp \':0 }}</p><p><strong>Transport Cost:</strong> {{ vm.quotation.quotation_informations.transport_cost | currency:\'Rp \':0 }} <span ng-if=\"vm.quotation.quotation_informations.transport_cost_in_product\">(Include dalam produk)</span></p><p><strong>PPN:</strong> {{ vm.quotation.quotation_informations.tax_cost | currency:\'Rp \':0 }}</p><p><strong>Original Price:</strong> {{ vm.quotation.quotation_informations.original_price | currency:\'Rp \':0 }}</p><p><strong>Total Price:</strong> {{ vm.quotation.quotation_informations.total_price | currency:\'Rp \':0 }}</p><p><strong>GP %:</strong> {{ vm.quotation.quotation_informations.net_gross_profit_percentage * 100 | number:2 }}% <span ng-if=\"vm.privileges.approveQuotation\">({{ vm.quotation.quotation_informations.net_gross_profit | currency:\'Rp \':0 }})</span></p><p><strong>Komisi:</strong> {{ vm.quotation.quotation_informations.possible_commission.commission | currency:\'Rp \':0 }} ({{ vm.quotation.quotation_informations.possible_commission.commission_percentage | number:2 }}%)</p><p><strong>Terms:</strong><ul><li ng-repeat=\"term in vm.quotation.quotation_informations.quotation_terms\">{{ term.description }}</li></ul></p></div><div class=\"col-md-5\"><div class=\"well p-xs m-b-none clearfix\" ng-if=\"vm.quotation.customer\"><h2>Customer</h2><h4><a ui-sref=\"customer.detail({\'customerHashId\': vm.quotation.customer.hash_id, \'customer\': vm.quotation.customer})\">{{ vm.quotation.customer.name }}, {{ vm.quotation.customer.type }}</a></h4><p><strong>Address:</strong> {{ vm.quotation.customer.npwp_address || \'-\' }}</p><p><strong>Phone:</strong> {{ vm.quotation.customer.phone || \'-\' }}</p><p><strong>Purchaser Name:</strong> {{ vm.quotation.customer.purchaser_name || \'-\' }}</p><div class=\"alert\" ng-class=\"{ \'alert-info\': (vm.quotation.quotation_informations.total_price + vm.quotation.customer.outstanding_credit) <= vm.quotation.customer.credit_limit , \'alert-danger\': (vm.quotation.quotation_informations.total_price + vm.quotation.customer.outstanding_credit) > vm.quotation.customer.credit_limit }\"><p><strong>Term of Payment:</strong> {{ vm.quotation.customer.term_of_payment }}</p><p ng-if=\"(vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\"><strong>Jangka Waktu Pembayaran:</strong> {{ vm.quotation.customer.days_of_payable }} hari</p><p ng-if=\"(vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\"><strong>Credit Limit:</strong> {{ vm.quotation.customer.credit_limit | currency:\'Rp \':0 }}</p><p ng-if=\"(vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.quotation.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS)\"><strong>Current Outstanding Credit:</strong> {{ vm.quotation.customer.outstanding_credit | currency:\'Rp \':0 }}</p><div ng-if=\"(vm.quotation.quotation_informations.total_price + vm.quotation.customer.outstanding_credit) > vm.quotation.customer.credit_limit\"><hr><strong>QUOTATION INI AKAN MELEBIHI BATAS CREDIT LIMIT CUSTOMER!</strong></div></div></div><br><button class=\"btn btn-default btn-block\" ng-click=\"vm.downloadQuotation($event)\" ng-disabled=\"vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.APPROVED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_SUBMITTED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_APPROVED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_CONFIRMED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_REJECTED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.DONE\"><i class=\"fa fa-download\"></i> Download Quotation</button> <button class=\"btn btn-default btn-block\" ng-click=\"vm.downloadPOConfirmation($event)\" ng-disabled=\"vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_CONFIRMED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_APPROVED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_REJECTED && vm.quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.DONE\"><i class=\"fa fa-download\"></i> Download PO Confirmation</button></div></div><div class=\"clearfix m-t-lg\"><div class=\"m-r-md pull-left\" ng-if=\"vm.quotation.purchase_order_image_url\"><p><strong>PO #: <b>{{ vm.quotation.purchase_order_number }}</b></strong></p><a class=\"img-thumbnail\" ng-click=\"vm.showImage(vm.quotation.purchase_order_image_url, \'PO\')\" style=\"background-image: url({{vm.quotation.purchase_order_image_url}}); width: 150px; height: 100px\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div><div class=\"m-r-md pull-left\" ng-if=\"vm.quotation.purchase_order_pdf_url\"><p><strong>PO #: <b>{{ vm.quotation.purchase_order_number }}</b></strong></p><a href=\"{{ vm.quotation.purchase_order_pdf_url }}\">{{vm.quotation.purchase_order_pdf_url}}</a></div><div class=\"m-r-md pull-left\" ng-if=\"vm.quotation.signed_purchase_order_confirmation_image_url\"><p><strong>PO Confirmation</strong></p><a class=\"img-thumbnail\" ng-click=\"vm.showImage(vm.quotation.signed_purchase_order_confirmation_image_url, \'PO Confirmation\')\" style=\"background-image: url({{vm.quotation.signed_purchase_order_confirmation_image_url}}); width: 150px; height: 100px\"><span class=\"mask\"><i class=\"fa fa-search\"></i></span></a></div><div class=\"m-r-md pull-left\" ng-if=\"vm.quotation.signed_purchase_order_confirmation_pdf_url\"><p><strong>PO Confirmation</strong></p><a href=\"{{ vm.quotation.signed_purchase_order_confirmation_pdf_url }}\">{{vm.quotation.signed_purchase_order_confirmation_pdf_url}}</a></div></div><hr><div class=\"table-responsive\"><table class=\"table table-striped table-hover table-clickable\"><thead><tr><th>No #</th><th>Item</th><th ng-if=\"vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN\">Detail</th><th>Harga per KG (kg)</th><th>Harga per M (meter)</th><th>Harga per Roll (roll)</th><th>Total Harga</th></tr></thead><tbody><tr ng-repeat=\"product in vm.quotation.quotation_informations.quotation_products\"><td>{{ $index + 1 }}</td><td>{{ product.name || \'-\' }}</td><td><span ng-bind-html=\"product.description\"></span></td><td>{{ product.conversion.price_per_kg | currency:\'Rp \':0 }} ({{ product.conversion.weight | number:2 }} KG)</td><td>{{ product.conversion.price_per_m | currency:\'Rp \':0 }} ({{ product.conversion.length }} M)</td><td>{{ product.conversion.price_per_roll | currency:\'Rp \':0 }} ({{ product.conversion.roll }} Roll)</td><td>{{ product.net_total_price | currency:\'Rp \':0 }}</td></tr><tr ng-if=\"vm.quotation.quotation_informations.adjusted_price < 0 && !vm.quotation.quotation_informations.adjusted_price_in_product\"><td colspan=\"5\"></td><td style=\"text-align:right\"><b>DISCOUNT</b></td><td style=\"text-align:center\">{{ vm.quotation.quotation_informations.adjusted_price | currency:\'Rp \':0 }}</td></tr><tr ng-if=\"vm.quotation.quotation_informations.transport_cost != 0 && !vm.quotation.quotation_informations.transport_cost_in_product\"><td colspan=\"5\"></td><td style=\"text-align:right\"><b>TRANSPORT ({{ vm.quotation.quotation_informations.transport_type.name || \'-\' }})</b></td><td style=\"text-align:center\">{{ vm.quotation.quotation_informations.transport_cost | currency:\'Rp \':0 }}</td></tr><tr ng-if=\"vm.quotation.quotation_informations.tax_cost != 0\"><td colspan=\"5\"></td><td style=\"text-align:right\"><b>PPN ({{ vm.quotation.quotation_informations.tax_percentage * 100 }}%)</b></td><td style=\"text-align:center\">{{ vm.quotation.quotation_informations.tax_cost | currency:\'Rp \':0 }}</td></tr><tr><td colspan=\"5\"></td><td style=\"text-align:right\"><b>TOTAL</b></td><td style=\"text-align:center\">{{ vm.quotation.quotation_informations.total_price | currency:\'Rp \':0 }}</td></tr></tbody></table></div></div></div></div><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Status History</h5></div><div class=\"ibox-content\" ng-show=\"vm.quotation.discussions.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-3\">Tanggal</th><th class=\"col-xs-2\">Status</th><th class=\"col-xs-3\">User</th><th class=\"col-xs-4\">Deskripsi</th></tr></thead><tbody><tr ng-repeat=\"discussion in vm.quotation.discussions\"><td>{{ vm.globalState.setTime(discussion.created_at) | date:\'d MMMM yyyy hh:mm a\' }}</td><td><span class=\"label\" ng-class=\"{ \'label-primary\': discussion.status === vm.constants.QUOTATION_STATUS.APPROVED, \'label-info\': discussion.status === vm.constants.QUOTATION_STATUS.SUBMITTED, \'label-warning\': discussion.status === vm.constants.QUOTATION_STATUS.DRAFT, \'label-danger\': discussion.status === vm.constants.QUOTATION_STATUS.REJECTED, \'label-default\': discussion.status === vm.constants.QUOTATION_STATUS.DONE }\">{{ discussion.status | ucfirst }}</span></td><td><p class=\"m-b-xs\"><strong>{{ discussion.user.name }}</strong></p><small class=\"text-muted\">{{ discussion.user.role.name }}</small></td><td>{{ discussion.description || \'-\' }}</td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.quotation.discussions.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Discussion tidak ditemukan.</h4></div></div></div></div></div>");
$templateCache.put("app/quotation/download-po-confirmation/download-po-confirmation.html","<div class=\"inmodal\"><form ng-submit=\"vm.download($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Download PO Confirmation</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Pilih Unit Produk</label><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"kg\"> KG</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"m\"> Meter</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"roll\"> Roll</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"pcs\"> Pcs</label></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Download</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/download-quotation/download-quotation.html","<div class=\"inmodal\"><form ng-submit=\"vm.download($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Download Quotation</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Pilih Unit Produk</label><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"kg\"> KG</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"m\"> Meter</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"roll\"> Roll</label></div><div><label><input type=\"radio\" ng-model=\"vm.data.type\" value=\"pcs\"> Pcs</label></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Download</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Quotation Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk membuat Quotation.<hr><h3>Proses</h3><hr><h3>Sales</h3>Anda dapat request untuk membuat Customer. Bila Customer sudah diapprove, mohon minta bantuan Admin untuk mengubah datanya.<hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/quotation/index/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"IndexQuotationController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Quotation Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createQuotation()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat Quotation</a></div><h2>Quotation</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-4\"><select class=\"form-control\" ng-change=\"vm.filter()\" ng-model=\"vm.filtering.filter.status\"><option value=\"\">- Status -</option><option value=\"{{ vm.constants.QUOTATION_STATUS.DRAFT }}\">Draft</option><option value=\"{{ vm.constants.QUOTATION_STATUS.SUBMITTED }}\">Submitted</option><option value=\"{{ vm.constants.QUOTATION_STATUS.REJECTED }}\">Rejected</option><option value=\"{{ vm.constants.QUOTATION_STATUS.APPROVED }}\">Approved</option><option value=\"{{ vm.constants.QUOTATION_STATUS.PO_SUBMITTED }}\">PO Submitted</option><option value=\"{{ vm.constants.QUOTATION_STATUS.PO_APPROVED }}\">PO Approved</option><option value=\"{{ vm.constants.QUOTATION_STATUS.PO_CONFIRMED }}\">PO Confirmed</option><option value=\"{{ vm.constants.QUOTATION_STATUS.PO_REJECTED }}\">PO Rejected</option><option value=\"{{ vm.constants.QUOTATION_STATUS.DONE }}\">Done</option></select></div><div class=\"col-md-8\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover table-clickable\"><thead><tr><th>Quotation #</th><th>Customer</th><th ng-if=\"vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN\">Sales</th><th>Harga</th><th>Komisi</th><th class=\"col-xs-2 text-center\" ng-click=\"vm.sortStatus(vm.filtering.sort[\'quotation_informations.status\'])\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort[\'quotation_informations.status\'] === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort[\'quotation_informations.status\'] === \'asc\'\"></i> Status</th><th colspan=\"2\" ng-click=\"vm.sortDate(vm.filtering.sort[\'quotation_informations.created_at\'])\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort[\'quotation_informations.created_at\'] === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort[\'quotation_informations.created_at\'] === \'asc\'\"></i> Tanggal Dibuat</th></tr></thead><tbody><tr ng-repeat=\"quotation in vm.quotations\" ng-click=\"vm.showQuotation(quotation)\"><td><strong><i>{{ quotation.quotation_revision_number || \'-\' }}</i></strong></td><td><div ng-if=\"quotation.customer\"><a ui-sref=\"customer.detail({\'customerHashId\': quotation.customer.hash_id, \'customer\': quotation.customer})\">{{ quotation.customer.name }}</a></div><div ng-if=\"!quotation.customer\">-</div></td><td><div ng-if=\"quotation.user && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN\">{{ quotation.user.name }}</div></td><td>{{ quotation.quotation_informations.total_price | currency:\'Rp \':0 }}</td><td>{{ quotation.quotation_informations.possible_commission.commission | currency:\'Rp \':0 }} ({{ quotation.quotation_informations.possible_commission.commission_percentage }}%)</td><td class=\"text-center\"><span class=\"label\" ng-class=\"{ \'label-q-draft\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.DRAFT, \'label-q-submitted\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.SUBMITTED, \'label-q-rejected\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.REJECTED || quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_REJECTED, \'label-q-approved\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.APPROVED, \'label-q-poSubmitted\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_SUBMITTED, \'label-q-poApproved\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_APPROVED, \'label-q-poConfirmed\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_CONFIRMED, \'label-q-done\': quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.DONE }\">{{ quotation.quotation_informations.status || \'-\' }}</span></td><td>{{ vm.setTime(quotation.created_at) | date:\'d MMMM yyyy\' }}</td><td class=\"text-right\"><button ng-if=\"vm.privileges.submit && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.DRAFT\" class=\"btn btn-outline btn-q-submitted btn-xs m-r-xs\" ng-click=\"vm.submit(quotation);$event.stopPropagation();\">Submit</button><button ng-if=\"vm.privileges.approveQuotation && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.SUBMITTED\" class=\"btn btn-outline btn-q-approved btn-xs m-r-xs\" ng-click=\"vm.approve(quotation);$event.stopPropagation();\">Approve</button><button ng-if=\"vm.privileges.approveQuotation && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.SUBMITTED\" class=\"btn btn-outline btn-q-rejected btn-xs m-r-xs\" ng-click=\"vm.reject(quotation);$event.stopPropagation();\">Reject</button><button ng-if=\"quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.APPROVED\" class=\"btn btn-outline btn-q-poSubmitted btn-xs m-r-xs\" ng-click=\"vm.linkToPo(quotation);$event.stopPropagation();\">Submit PO</button><button ng-if=\"vm.privileges.submit && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_SUBMITTED\" class=\"btn btn-outline btn-q-poApproved btn-xs m-r-xs\" ng-click=\"vm.approvePO(quotation);$event.stopPropagation();\">Approve PO</button><button ng-if=\"vm.privileges.submit && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_APPROVED\" class=\"btn btn-outline btn-q-poConfirmed btn-xs m-r-xs\" ng-click=\"vm.submitPOCOnfirmation(quotation);$event.stopPropagation();\">Submit PO Confirmation</button><button ng-if=\"vm.privileges.approvePO && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_CONFIRMED\" class=\"btn btn-outline btn-q-done btn-xs m-r-xs\" ng-click=\"vm.approvePOCOnfirmation(quotation);$event.stopPropagation();\">Approve PO Confirmation</button><button ng-if=\"vm.privileges.approvePO && vm.user.role.name === vm.constants.ROLE.SUPER_ADMIN && (quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_SUBMITTED || quotation.quotation_informations.status === vm.constants.QUOTATION_STATUS.PO_CONFIRMED)\" class=\"btn btn-outline btn-q-rejected btn-xs m-r-xs\" ng-click=\"vm.rejectPO(quotation);$event.stopPropagation();\">Reject PO</button><button ng-if=\"vm.privileges.update && quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_SUBMITTED && quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_APPROVED && quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_CONFIRMED && quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.PO_REJECTED && quotation.quotation_informations.status !== vm.constants.QUOTATION_STATUS.DONE\" class=\"btn btn-outline btn-default btn-xs m-r-xs\" ng-click=\"vm.editQuotation(quotation);$event.stopPropagation();\">Ubah</button><button class=\"btn btn-outline btn-danger btn-xs\" ng-click=\"vm.deleteQuotation(quotation);$event.stopPropagation();\" ng-if=\"(vm.privileges.delete || vm.user.hash_id === quotation.user.hash_id) && quotation.quotation_informations.status == vm.constants.QUOTATION_STATUS.DRAFT\">Hapus</button></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/quotation/link-to-po/link-to-po.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center poImage-container\"></div><div class=\"form-group\"><label>Pilih File PO (Gambar/PDF)</label> <input class=\"form-control\" type=\"file\" file-model=\"poFile\"></div><div class=\"form-group\"><label>Nomor PO</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.poNumber\" required=\"\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/submit-po-confirmation/submit-po-confirmation.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center poImage-container\"></div><div class=\"form-group\"><label>Pilih File PO Confirmation (Gambar/PDF)</label> <input class=\"form-control\" type=\"file\" file-model=\"poFile\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/update/update.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"UpdateQuotationController as vm\"><div class=\"row\" ng-if=\"vm.privileges.update\"><div class=\"col-sm-7\"><div class=\"ibox\"><form ng-submit=\"vm.createProduct($event)\"><div class=\"ibox-title\"><h2>Tambah Produk</h2></div><div class=\"ibox-content\" ng-if=\"vm.quotation\"><div><div class=\"form-group\"><label>Nama Product <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm._createProduct.name\" required=\"\"></div><div class=\"form-group\"><label>Lebar <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.width\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.WIDTH }}</span></div></div><div class=\"form-group\"><label>Slitting Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_materials[0].slitting_length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SLITTING_LENGTH }}</span></div></div><div class=\"form-group\"><label>Total Panjang Order <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.LENGTH }}</span></div></div><div class=\"form-group\"><label>Printing Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.printing_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Laminating Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.laminating_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Slitting Waste <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_waste\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.PERCENTAGE }}</span></div></div><div class=\"form-group\"><label>Printing Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.printing_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Laminating Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.laminating_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Slitting Overhead Cost <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.slitting_overhead_cost\" required=\"\"></div></div><div class=\"form-group\"><label>Notes Tambahan</label> <textarea cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"vm._createProduct.notes\"></textarea></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_printing\"><span></span> Material Printing</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_printing\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Material</label><ui-select ng-model=\"vm._createProduct.printing_material.material\" theme=\"bootstrap\" title=\"Pilih Material...\" on-select=\"vm.materialPrintingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"material in vm.materialPrinting | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Ketebalan Material</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm._createProduct.printing_material.thickness\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.THICKNESS }}</span></div></div></div></div><div class=\"form-group\"><label>Tambah Warna</label><ui-select multiple=\"\" ng-model=\"vm._createProduct.inks_name\" theme=\"bootstrap\" sortable=\"true\" ng-change=\"vm.inkOnChange($item)\"><ui-select-match placeholder=\"Pilih Warna...\">{{ $item.name }}</ui-select-match><ui-select-choices repeat=\"material in vm.materialInk | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_laminating\"><span></span> Material Laminating</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_laminating\"><div class=\"form-group\"><a class=\"btn btn-default\" ng-click=\"vm.addLaminatingMaterial()\"><i class=\"fa fa-plus\"></i> Tambah material</a></div><div ng-show=\"vm._createProduct.laminating_materials | isEmpty\"><small class=\"text-info\"><i class=\"fa fa-info-circle\"></i> Silahkan menambahkan material dengan mengklik tombol diatas.</small></div><div class=\"form-group m-b-xs\" ng-repeat=\"material in vm._createProduct.laminating_materials\" ng-hide=\"vm._createProduct.laminating_materials | isEmpty\"><p><a class=\"text-danger\" ng-click=\"vm.removeLaminatingMaterial(material)\"><i class=\"fa fa-trash\"></i></a> <strong>{{ material.material.name || \'-\' }} <small>(Thickness: <span class=\"text-info\">{{ material.thickness | number }}{{ vm.constants.UNIT_TYPE.THICKNESS }}</span> | Adhesive Usage /m<sup>2</sup>: <span class=\"text-info\">{{ material.adhesive_usage_per_m2 }} gram</span>)</small></strong></p></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_slitting\" disabled=\"\"><span></span> Material Slitting</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_slitting\"><div class=\"form-group\"><div class=\"clearfix\"><button ng-if=\"vm._createProduct.slitting_materials[0].hash_id\" class=\"btn btn-link pull-right text-danger\" type=\"button\" ng-click=\"vm.resetSlitting()\" style=\"color: red\">Batal</button> <label>Material</label></div><ui-select ng-model=\"vm._createProduct.slitting_materials[0].hash_id\" theme=\"bootstrap\" title=\"Pilih Material...\" on-select=\"vm.materialSlittingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{$select.selected.name}}</ui-select-match><ui-select-choices refresh=\"vm.getReferral($select.search)\" refresh-delay=\"300\" repeat=\"material.hash_id as material in vm.materialSlitting | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"hr-line-dashed\"></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_packing\" disabled=\"\"><span></span> Material Packing</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_packing\"><div class=\"form-group\"><label>Optional Material</label><ui-select multiple=\"\" ng-model=\"vm._createProduct.packing_materials_name\" theme=\"bootstrap\" sortable=\"true\" on-select=\"vm.materialPackingOnChange($item)\"><ui-select-match placeholder=\"Pilih Material...\">{{ $item.name }}</ui-select-match><ui-select-choices repeat=\"material in vm.materialPacking | filter:{is_required:0} | filter: {name: $select.search}\"><div ng-bind-html=\"material.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><i class=\"text-danger\">*Required materials:</i> <span class=\"label label-defaull m-r-xs\" ng-repeat=\"requiredMaterialPacking in vm.requiredMaterialPacking\">{{requiredMaterialPacking.name}}</span></div></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.need_bag_making\"><span></span> Bag Making</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.need_bag_making\"><div class=\"form-group\"><label>Length</label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.bag_length\"> <span class=\"input-group-addon\">mm</span></div></div><div class=\"form-group\"><label>Width</label><div class=\"input-group\"><input type=\"number\" min=\"0\" step=\"any\" class=\"form-control\" ng-model=\"vm._createProduct.bag_width\"> <span class=\"input-group-addon\">mm</span></div></div><div class=\"form-group\"><label>Overhead Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.bag_overhead_cost\"></div></div><div class=\"form-group\"><label>Bag Making Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /bag</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.price_per_bag\"></div></div></div></div><div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm._createProduct.is_cylinder\"><span></span> Is Cylinder</label></div><div class=\"well m-t-xs\" ng-if=\"vm._createProduct.is_cylinder\"><div class=\"form-group\"><label>Cylinder Cost</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp /m <sup>2</sup></span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm._createProduct.cylinder_cost\"></div></div></div></div></div><div class=\"ibox-footer clearfix\"><div id=\"editProduct\" class=\"hidden\"><button ng-click=\"vm.cancelEditProduct()\" class=\"btn btn-warning pull-right m-l-xs\" type=\"button\" id=\"cancelUpdateProductButton\">Batal</button> <button ng-click=\"vm.saveEditProduct($event)\" class=\"btn btn-primary pull-right m-l-xs\" type=\"button\" id=\"saveUpdateProductButton\">Simpan perubahan produk</button></div><button class=\"btn btn-primary pull-right\" type=\"submit\" id=\"addProductButton\">Tambahkan Produk</button></div></div></form></div></div><div class=\"col-sm-5\"><form ng-submit=\"vm.updateQuotation()\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>Update Quotation</h2></div><div class=\"ibox-content\"><div ng-show=\"vm.data.quotation_products | isEmpty\" class=\"text-center\"><h4 class=\"text-danger\"><i class=\"fa fa-warning\"></i> Belum ada produk untuk quotation ini!</h4><p>Silahkan tambahkan produk baru pada form yang disediakan.</p></div><div ng-hide=\"vm.data.quotation_products | isEmpty\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\">Produk yang telah ditambahkan:</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\"></th><th data-hide=\"all\">Quantity</th><th data-hide=\"all\">Width</th><th data-hide=\"all\">Total Order Length</th><th data-hide=\"all\">Printing Waste</th><th data-hide=\"all\">Laminating Waste</th><th data-hide=\"all\">Slitting Waste</th><th data-hide=\"all\">Printing Overhead Cost</th><th data-hide=\"all\">Laminating Overhead Cost</th><th data-hide=\"all\">Slitting Overhead Cost</th><th data-hide=\"all\">Deskripsi</th><th data-hide=\"all\">Material Printing</th><th data-hide=\"all\">Inks</th><th data-hide=\"all\">Material Laminating</th><th data-hide=\"all\">Material Slitting</th><th data-hide=\"all\">Material Packing</th><th data-hide=\"all\">Bag Width</th><th data-hide=\"all\">Bag Length</th><th data-hide=\"all\">Bag Overhead Cost</th><th data-hide=\"all\">Bag Making Cost</th><th data-hide=\"all\">Cylinder</th><th data-hide=\"all\">Cylinder Cost</th></tr></thead><tbody><tr ng-repeat=\"product in vm.data.quotation_products\" foo-repeat-done=\"\"><td><strong><i>{{ product.name || \'-\' }} ({{ product.total_price | currency:\'Rp \':0 }})</i></strong></td><td class=\"text-right\"><a ng-click=\"vm.editProduct(product, $index); $event.preventDefault()\" class=\"text-primary\"><i class=\"fa fa-pencil\"></i></a> <a ng-click=\"vm.removeProductConfirmation(product, $index); $event.preventDefault()\" class=\"text-danger\"><i class=\"fa fa-trash\"></i></a></td><td>{{ product.quantity | number }}</td><td>{{ product.width | number }} {{ vm.constants.UNIT_TYPE.WIDTH }}</td><td>{{ product.length | number }} {{ vm.constants.UNIT_TYPE.LENGTH }}</td><td>{{ product.printing_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>{{ product.laminating_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>{{ product.slitting_waste | number }} {{ vm.constants.UNIT_TYPE.PERCENTAGE }}</td><td>Rp {{ product.printing_overhead_cost | number }}</td><td>Rp {{ product.laminating_overhead_cost | number }}</td><td>Rp {{ product.slitting_overhead_cost | number }}</td><td>{{ product.notes || \'-\' }}</td><td><div ng-show=\"product.need_printing\">{{ product.printing_material.material.name || \'-\' }} {{ product.printing_material.thickness }}{{ vm.constants.UNIT_TYPE.THICKNESS }}</div><div ng-hide=\"product.need_printing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><div ng-show=\"product.need_printing\"><span class=\"label m-r-xs m-b-xs\" ng-repeat=\"ink in product.inks_name\">{{ ink.name }}</span></div><div ng-hide=\"product.need_printing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><p class=\"m-b-md\" ng-repeat=\"material in product.laminating_materials\" ng-show=\"product.need_laminating\"><strong class=\"text-muted\"><i>{{ material.material.name || \'-\' }} (<small class=\"text-info\">{{ material.thickness | number }}{{ vm.constants.UNIT_TYPE.THICKNESS }} | {{material.adhesive_usage_per_m2}} gram</small>)</i></strong></p><div ng-hide=\"product.need_laminating\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><p class=\"m-b-md\" ng-repeat=\"material in product.slitting_materials\" ng-show=\"product.need_slitting\"><strong class=\"text-muted\"><i>{{ material.material.name || \'-\' }} ({{ material.slitting_length | number }}{{ vm.constants.UNIT_TYPE.SLITTING_LENGTH }})</i></strong></p><div ng-hide=\"product.need_slitting\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td><span class=\"label m-r-xs m-b-xs\" ng-repeat=\"material in product.packing_materials_name\" ng-show=\"product.need_packing\">{{ material.name || \'-\' }}</span><div ng-hide=\"product.need_packing\" class=\"text-muted\"><i>Data tidak tersedia</i></div></td><td>{{(product.bag_width || 0) | number}} mm</td><td>{{(product.bag_length || 0) | number}} mm</td><td>Rp {{(product.bag_overhead_cost || 0) | number}} /m <sup>2</sup></td><td>Rp {{(product.price_per_bag || 0) | number}} /bag</td><td>{{ product.is_cylinder ? \'With Cylinder\' : \'-\' }}</td><td>Rp {{(product.cylinder_cost || 0) | number}} /m <sup>2</sup></td></tr></tbody></table></div></div><div class=\"ibox-content\" ng-if=\"vm.quotation\"><label>PPN 10% <span class=\"text-danger\">*</span></label><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.taxable\"><span></span> Include PPN</label></div><hr><div class=\"form-group\"><label>Pilih Referral <span class=\"text-danger\">*</span></label><br><small>Dapatkan kode referral dari admin.</small><ui-select ng-model=\"vm.referral\" theme=\"bootstrap\" on-select=\"vm.referralOnSelect($select.selected)\"><ui-select-match placeholder=\"Ketik kode referral\"><strong>{{ $select.selected.code }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getReferral($select.search)\" refresh-delay=\"300\" repeat=\"referral in vm.referrals | filter: {code: $select.search}\"><p><strong ng-bind-html=\"referral.code | highlight: $select.search\"></strong></p></ui-select-choices></ui-select></div><hr><div class=\"form-group\"><label>Pilih Transport <span class=\"text-danger\">*</span></label><ui-select ng-model=\"vm.data.transport_type_hash_id\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik tipe transport\"><strong>{{ $select.selected.name }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getTransport($select.search)\" refresh-delay=\"300\" repeat=\"transport.hash_id as transport in vm.transports\"><div><strong ng-bind-html=\"transport.name | highlight: $select.search\"></strong><div ng-if=\"transport.hash_id !== null\"><small ng-bind-html=\"transport.transport_type_fees.price_per_kg | currency:\'Rp \':0 | highlight: $select.search\"></small> <small>/kg</small></div></div></ui-select-choices></ui-select><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.transport_cost_in_product\"><span></span> Include biaya transport dalam produk.</label></div></div><hr><div class=\"form-group\"><label>Terms</label><div class=\"form-group\"><div class=\"m-b-xs\" ng-repeat=\"term in vm.data.quotation_terms\" ng-hide=\"vm.data.quotation_terms | isEmpty\"><p><a class=\"text-danger\" ng-click=\"vm.removeTerm(term)\" ng-if=\"!term.is_required\"><i class=\"fa fa-trash\"></i></a> <small><i><span class=\"text-danger\" ng-if=\"term.is_required\">*</span> {{ term.description || \'-\' }}</i></small></p></div><button type=\"button\" ng-click=\"vm.addTerm()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Tambah Term</button> <button type=\"button\" ng-click=\"vm.addCustomTerm()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Tambah Custom Term</button></div></div><hr><div class=\"form-group\"><label>Requested Selling Price</label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"vm.data.requested_price\"></div><br><small class=\"text-muted\"><span class=\"text-danger\">*</span>Original Selling Price: <span class=\"text-danger\">{{ vm.quotation.quotation_informations.original_price | currency:\'Rp \':0 }}</span></small><br><small>&nbsp;&nbsp; <span class=\"text-danger\">* Field ini hanya berubah dengan benar bila sudah di Simpan karena kalkulasi terjadi di server.</span></small><br><small class=\"text-muted\"><span class=\"text-danger\">*</span>% Adjustment from Original Selling Price: <span class=\"text-danger\" ng-if=\"vm.data.requested_price\">{{ (vm.quotation.quotation_informations.original_price - vm.data.requested_price) / vm.quotation.quotation_informations.original_price * 100 * -1 | number:2 || \'-\' }}%</span></small><br><small>&nbsp;&nbsp; <span class=\"text-danger\">* Field ini hanya berubah dengan benar bila sudah di Simpan karena kalkulasi terjadi di server.</span></small><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.adjusted_price_in_product\"><span></span> Include perubahan biaya dalam produk (hanya untuk discount, bila harga lebih mahal maka akan otomatis dimasukan ke dalam harga produk).</label></div></div></div><div class=\"ibox-footer text-center\" ng-if=\"vm.quotation\"><button class=\"btn btn-primary btn-block\" type=\"submit\" ng-disabled=\"!vm.data.quotation_products.length\">Simpan Quotation</button></div></div></form></div></div></div>");
$templateCache.put("app/quotation/view-image-modal/view-image-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{ vm.title }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center image-container\"><img src=\"{{ vm.image }}\" class=\"m-b-xs\" style=\"max-width: 100%; display: inline-block;\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/referral/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Referral Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Persentase Komisi <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.data.commission_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Email</label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.data.email\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Telepon</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.phone\"></div></div></div><div class=\"form-group\"><label>Alamat</label> <textarea cols=\"30\" rows=\"10\" class=\"form-control\" ng-model=\"vm.data.address\"></textarea></div><div class=\"form-group\"><label>Deskripsi</label> <textarea cols=\"30\" rows=\"10\" class=\"form-control\" ng-model=\"vm.data.description\"></textarea></div><div class=\"form-group\"><label>Nama Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_name\"></div><div class=\"form-group\"><label>Nama Akun Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_account_name\"></div><div class=\"form-group\"><label>Nomor Akun Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_account_number\"></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_active\"><span></span> Aktif</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/referral/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DetailReferralController as vm\"><div class=\"row\" ng-if=\"vm.privileges.read\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"></div><h2>Referral Detail</h2></div><div class=\"ibox-content\"><div class=\"row m-t-md\"><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt>Code:</dt><dd>{{vm.referral.code || \'-\'}}</dd><dt>Name:</dt><dd>{{vm.referral.name || \'-\'}}</dd><dt>Email:</dt><dd>{{ vm.referral.email || \'-\'}}</dd><dt>Phone:</dt><dd>{{ vm.referral.phone || \'-\'}}</dd><dt>Address:</dt><dd>{{ vm.referral.address || \'-\' }}</dd><dt>Description:</dt><dd>{{ vm.referral.description || \'-\' }}</dd></dl></div><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt>Bank:</dt><dd>{{vm.referral.bank_name || \'-\'}}</dd><dt>Nama Rekening:</dt><dd>{{vm.referral.bank_account_name || \'-\'}}</dd><dt>Nomor Rekening:</dt><dd>{{vm.referral.bank_account_number || \'-\'}}</dd><dt>Commission Percentage:</dt><dd>{{vm.referral.conversion.commission_percentage}}%</dd><dt>Pending Commission:</dt><dd>{{vm.referral.pending_referral_commission | number}}</dd></dl></div></div></div></div></div></div><div class=\"ibox\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title\"><h5>Referral Commission</h5></div><div class=\"ibox-content\" ng-show=\"vm.referral.referral_commissions.length\"><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\">Tanggal</th><th data-sort-ignore=\"true\">Total Price</th><th data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"commission in vm.referral.referral_commissions\" \"=\"\"><td>{{ vm.globalState.setTime(commission.created_at) | date:\'d MMMM yyyy hh:mm a\' }}</td><td>{{ commission.total_price | currency:\'Rp \':0 }}</td><td><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.payReferralCommission(commission, $event)\" ng-if=\"vm.privileges.admin && !commission.commission_paid_at\"><i class=\"fa fa-pencil\"></i> Bayar Komisi</a> <span ng-if=\"commission.commission_paid_at\">Dibayarkan pada <strong>{{ vm.globalState.setTime(commission.commission_paid_at) | date:\'d MMMM yyyy\' }}</strong></span></td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.referral.referral_commissions.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Referral Commission tidak ditemukan.</h4></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>Status History</h5></div><div class=\"ibox-content\" ng-show=\"vm.user.discussions.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-3\">Tanggal</th><th class=\"col-xs-2\">Status</th><th class=\"col-xs-3\">User</th><th class=\"col-xs-4\">Deskripsi</th></tr></thead><tbody><tr ng-repeat=\"discussion in vm.user.discussions\"><td>{{ vm.globalState.setTime(discussion.created_at) | date:\'d MMMM yyyy hh:mm a\' }}</td><td><span class=\"label\" ng-class=\"{ \'label-primary\': discussion.status === vm.constants.CUSTOMER_STATUS.APPROVED, \'label-info\': discussion.status === vm.constants.CUSTOMER_STATUS.SUBMITTED, \'label-warning\': discussion.status === vm.constants.CUSTOMER_STATUS.DRAFT, \'label-danger\': discussion.status === vm.constants.CUSTOMER_STATUS.REJECTED }\">{{ discussion.status | ucfirst }}</span></td><td><p class=\"m-b-xs\"><strong>{{ discussion.user.name }}</strong></p><small class=\"text-muted\">{{ discussion.user.role.name }}</small></td><td>{{ discussion.description || \'-\' }}</td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.user.discussions.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Discussion tidak ditemukan.</h4></div></div></div>");
$templateCache.put("app/referral/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Referral Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur Referral. Referral adalah seseorang sales dari tempat lain yang membawa order ke perusahaan ini.<hr><h3>Referral</h3><ul><li>Nama: Nama referral</li><li>Commission Percentage: Jumlah komisi yang akan didapatkan dari total order.</li><li>Aktif: Hanya referral yang aktif yang dapat dipilih di pembuatan Quotation.</li></ul><hr><h3>Referral Commission</h3><ul><li>Bila ada order/quotation yang sudah status \'Done\', maka akan ada outstanding untuk membayar komisi terhadap referral ini. Klik referral untuk melihat detail informasinya.</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/referral/index/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"ReferralController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Referral Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createReferral()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat Referral</a></div><h2>Referral</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-2\"><select class=\"form-control\" ng-change=\"vm.filter()\" ng-model=\"vm.filtering.filter.is_active\"><option value=\"\">- Status -</option><option value=\"1\">Aktif</option><option value=\"0\">Tidak Aktif</option></select></div><div class=\"col-md-10\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">Code</th><th class=\"col-xs-3\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\" ng-click=\"vm.sortStatus(vm.filtering.sort[\'referrals.is_active\'])\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort[\'referrals.is_active\'] === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort[\'referrals.is_active\'] === \'asc\'\"></i> Status</th><th class=\"col-xs-3\" data-sort-ignore=\"true\" ng-click=\"vm.sortDate(vm.filtering.sort[\'referrals.created_at\'])\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort[\'referrals.created_at\'] === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort[\'referrals.created_at\'] === \'asc\'\"></i> Tanggal Dibuat</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"referral in vm.referrals\" ng-click=\"vm.showDetail(referral)\"><td><strong><i>{{ referral.hash_id }}</i></strong></td><td><strong><i>{{ referral.code }}</i></strong></td><td>{{ referral.name || \'-\' }}</td><td><span ng-if=\"referral.is_active\"><span class=\"label label-primary\">Active</span></span> <span ng-if=\"!referral.is_active\"><span class=\"label label-default\">Inactive</span></span></td><td>{{ vm.globalState.setTime(referral.created_at) | date:\'d MMMM yyyy HH:mm\' }}</td><td class=\"col-xs-4 text-center\" ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editReferral(referral)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteReferralConfirmation(referral, $event)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-trash-o\"></i> Hapus</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/referral/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Referral</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Persentase Komisi <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.data.commission_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Email</label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.data.email\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Telepon</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.phone\"></div></div></div><div class=\"form-group\"><label>Alamat</label> <textarea cols=\"30\" rows=\"10\" class=\"form-control\" ng-model=\"vm.data.address\"></textarea></div><div class=\"form-group\"><label>Deskripsi</label> <textarea cols=\"30\" rows=\"10\" class=\"form-control\" ng-model=\"vm.data.description\"></textarea></div><div class=\"form-group\"><label>Nama Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_name\"></div><div class=\"form-group\"><label>Nama Akun Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_account_name\"></div><div class=\"form-group\"><label>Nomor Akun Bank</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.bank_account_number\"></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_active\"><span></span> Aktif</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/role/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Buat Role Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Privileges</label><ui-select multiple=\"\" ng-model=\"vm.data.role_privileges\" sortable=\"true\" close-on-select=\"false\"><ui-select-match placeholder=\"Pilih privilege\"><strong>{{ $item.name }}</strong></ui-select-match><ui-select-choices repeat=\"privilege in vm.privileges | filter: $select.search\"><strong ng-bind-html=\"privilege.name | highlight: $select.search\"></strong></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/role/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Role Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3><ul><li>Sebagai default, beberapa Role tidak dapat didelete karena akan ada dependency terhadap produk ini.</li><li>Role Super Admin akan bisa melakukan apa saja termasuk <b>privilege</b> yang tidak dilist dalam Role tersebut.</li><li>Untuk membuat Role baru, silahkan berikan nama, tambahkan <b>privilege</b> (keterangan ada di bawah), dan assign Role tersebut ke module User.</li></ul><hr><h3>Privilege List</h3><table class=\"table\"><thead><tr><th>Nama</th><th>Deskripsi</th></tr></thead><tbody><tr ng-repeat=\"guide in vm.guides\"><td><strong>{{guide.name}}</strong></td><td>{{guide.description}}</td></tr></tbody></table></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/role/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Role</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Privileges</label><ui-select multiple=\"\" ng-model=\"vm.data.role_privileges\" sortable=\"true\" close-on-select=\"false\"><ui-select-match placeholder=\"Pilih privilege\"><strong>{{ $item.name }}</strong></ui-select-match><ui-select-choices repeat=\"privilege in vm.privileges | filter: $select.search\"><strong ng-bind-html=\"privilege.name | highlight: $select.search\"></strong></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/commission/commission.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"CommissionSettingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Commission Settings Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.create()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Commission Setting</a></div><h2>Commission Settings</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\" ng-click=\"vm.sortMinGrossProfitPercentage(vm.filtering.sort.min_gross_profit_percentage)\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort.min_gross_profit_percentage === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort.min_gross_profit_percentage === \'asc\'\"></i> Min Gross Profit Percentage</th><th data-sort-ignore=\"true\" data-toggle=\"true\">Commission Percentage</th><th data-sort-ignore=\"true\">Commission Referral Percentage</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"commission in vm.commissions\" foo-repeat-done=\"\"><td>{{ commission.conversion.min_gross_profit_percentage }}%</td><td>{{ commission.conversion.commission_percentage }}%</td><td>{{ commission.conversion.commission_referral_percentage }}%</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.edit(commission)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteConfirmation(commission, $event)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-trash-o\"></i> Hapus</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/setting/commission-timeline/commission-timeline.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"CommissionTimelineSettingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Commission Timeline Settings Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.create()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Commission Timeline Setting</a></div><h2>Commission Timeline Settings</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\" ng-click=\"vm.sortMinDaysLate(vm.filtering.sort.min_days_late)\"><i class=\"fa fa-angle-down\" ng-if=\"vm.filtering.sort.min_days_late === \'desc\'\"></i> <i class=\"fa fa-angle-up\" ng-if=\"vm.filtering.sort.min_days_late === \'asc\'\"></i> Min Days Late</th><th data-sort-ignore=\"true\" data-toggle=\"true\">Commission Percentage Multiplier</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"commission in vm.commissions\" foo-repeat-done=\"\"><td>{{ commission.min_days_late }} Hari</td><td>{{ commission.conversion.commission_percentage_multiplier }}%</td><td class=\"text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.edit(commission)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteConfirmation(commission, $event)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-trash-o\"></i> Hapus</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/setting/material/material-setting.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"MaterialSettingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a></div><h2>Material Settings</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\">Name</th><th data-sort-ignore=\"true\" data-toggle=\"true\">Code</th><th data-sort-ignore=\"true\" data-toggle=\"true\">Tipe</th><th data-sort-ignore=\"true\">Value</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"setting in vm.settings\" foo-repeat-done=\"\"><td>{{ setting.name }}</td><td>{{ setting.code }}</td><td>{{ setting.type }}</td><td><div ng-if=\"setting.type === \'price\'\">{{ setting.material_constant_histories.conversion.value | currency:\'Rp \':0 }} /{{setting.material_constant_histories.conversion.unit_name}}</div><div ng-if=\"setting.type === \'ratio\'\">{{ setting.material_constant_histories.conversion.value | number }}{{setting.material_constant_histories.conversion.unit_name}}</div></td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editMaterialSetting(setting)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/setting/quotation/quotation-setting.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"QuotationSettingController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a></div><h2>Quotation Settings</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th data-sort-ignore=\"true\" data-toggle=\"true\">Code</th><th data-sort-ignore=\"true\">Value</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"setting in vm.settings\" foo-repeat-done=\"\"><td>{{ setting.code }}</td><td>{{ setting.quotation_setting_histories.value }}</td><td class=\"col-xs-4 text-right\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editQuotationSetting(setting)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/setting/quotation-term/quotation-term.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"QuotationTermController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Quotation Term Tempaltes Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createQuotationTerm()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Quotation Term</a></div><h2>Quotation Term Templates</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-4\"><select class=\"form-control\" ng-model=\"vm.filtering.filter.is_required\" ng-change=\"vm.filter()\"><option value=\"\">- Requirement -</option><option value=\"1\">Required</option><option value=\"0\">Not Required</option></select></div><div class=\"col-md-8\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search.description\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-3\" data-sort-ignore=\"true\" data-toggle=\"true\">Deskripsi</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Required</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"quotationTerm in vm.quotationTerms\" foo-repeat-done=\"\"><td><strong><i>{{ quotationTerm.hash_id }}</i></strong></td><td>{{ quotationTerm.description || \'-\' }}</td><td><span class=\"label label-primary\" ng-if=\"quotationTerm.is_required\">Required</span> <span class=\"label label-default\" ng-if=\"!quotationTerm.is_required\">Not Required</span></td><td class=\"col-xs-4 text-center\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editQuotationTerm(quotationTerm)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteQuotationTermConfirmation(quotationTerm, $event)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-trash-o\"></i> Hapus</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/setting/transport/transport.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"TransportController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> Transport Settings Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createTransport()\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-plus\"></i> Buat Transport</a></div><h2>Transport Settings</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-2\" data-sort-ignore=\"true\" data-toggle=\"true\">#ID</th><th class=\"col-xs-3\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Price</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"transport in vm.transports\" foo-repeat-done=\"\"><td><strong><i>{{ transport.hash_id }}</i></strong></td><td>{{ transport.name || \'-\' }}</td><td>{{ transport.transport_type_fees.price_per_kg | currency:\'Rp \':0 }} / kg</td><td class=\"col-xs-4 text-center\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editTransport(transport)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-pencil\"></i> Ubah</a> <a class=\"btn btn-xs btn-danger btn-outline\" ng-click=\"vm.deleteTransportConfirmation(transport, $event)\" ng-if=\"vm.privileges.admin\"><i class=\"fa fa-trash-o\"></i> Hapus</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/user/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah User Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Email <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.data.email\" required=\"\"></div><div class=\"form-group\"><label>Role <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.role\" required=\"\"><option value=\"\">- Pilih Role -</option><option ng-repeat=\"role in vm.roles\" value=\"{{ role.hash_id }}\">{{ role.name }}</option></select></div><div class=\"form-group\"><label>Nomor ID Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.id_card_number\"></div><div class=\"form-group\"><label>Nomor Employee Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.employee_card_number\"></div><div class=\"form-group\"><label>Jenis Kelamin <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.gender\" required=\"\"><option value=\"\">- Pilih Jenis Kelamin -</option><option value=\"{{ vm.constants.GENDER.MALE }}\">Pria</option><option value=\"{{ vm.constants.GENDER.FEMALE }}\">Wanita</option></select></div><div class=\"form-group\"><label>Status</label><select class=\"form-control\" ng-model=\"vm.data.marital_status\"><option value=\"\">- Pilih Status -</option><option value=\"{{ vm.constants.MARITAL_STATUS.MARRIED }}\">Menikah</option><option value=\"{{ vm.constants.MARITAL_STATUS.SINGLE }}\">Lajang</option></select></div><div class=\"form-group\"><label>Tanggal Lahir</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.data.birth_date\" date-change=\"birthDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><label>Nomor Telepon</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.phone\"></div><div class=\"form-group\"><label>Alamat</label> <textarea class=\"form-control\" ng-model=\"vm.data.address\" cols=\"30\" rows=\"10\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/user/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"DetailUserController as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><button class=\"btn btn-default m-r-xs\" ng-click=\"vm.resetPassword();$event.stopPropagation();\">Reset Password</button></div><h2>User Detail</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"m-b-md\"><div class=\"profile-image text-center\"><div class=\"m-b-xs\" style=\"display: inline-block; width: 100px; height: 100px;\"><img src=\"{{vm.user.image_url ? vm.user.image_url : \'assets/images/logo/logo.png\'}}\" style=\"height: 100%; width: 100%; object-fit: contain\"></div><button class=\"btn btn-xs btn-outline btn-primary\" type=\"button\" ng-click=\"vm.uploadImage()\"><span ng-if=\"vm.user.image_url\"><i class=\"fa fa-pencil\"></i> Ubah Gambar</span> <span ng-if=\"!vm.user.image_url\"><i class=\"fa fa-plus\"></i> Unggah Gambar</span></button></div><div class=\"profile-info\"><div class=\"\"><div><span class=\"label label-default\">{{ vm.user.role.name }}</span><h1 class=\"no-margins\">{{vm.user.name}}</h1><h2>{{vm.user.email}}</h2><h3>{{vm.user.phone}} {{vm.user.phone_2}}</h3></div></div></div></div></div></div><div class=\"row m-t-md\"><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt>Nomor ID Card:</dt><dd>{{vm.user.id_card_number || \'-\'}}</dd><dt>Nomor Employee Card:</dt><dd>{{ vm.user.employee_card_number || \'-\'}}</dd><dt>Tanggal Lahir:</dt><dd>{{ vm.user.birth_date | date:\'d MMMM yyyy\'}}</dd></dl></div><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt>Gender:</dt><dd>{{vm.user.gender || \'-\'}}</dd><dt>Marital Status:</dt><dd>{{vm.user.marital_status || \'-\'}}</dd><dt>Alamat:</dt><dd>{{vm.user.address || \'-\'}}</dd></dl></div></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>Status History</h5></div><div class=\"ibox-content\" ng-show=\"vm.user.discussions.length\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr><th class=\"col-xs-3\">Tanggal</th><th class=\"col-xs-2\">Status</th><th class=\"col-xs-3\">User</th><th class=\"col-xs-4\">Deskripsi</th></tr></thead><tbody><tr ng-repeat=\"discussion in vm.user.discussions\"><td>{{ vm.globalState.setTime(discussion.created_at) | date:\'d MMMM yyyy hh:mm a\' }}</td><td><span class=\"label\" ng-class=\"{ \'label-primary\': discussion.status === vm.constants.CUSTOMER_STATUS.APPROVED, \'label-info\': discussion.status === vm.constants.CUSTOMER_STATUS.SUBMITTED, \'label-warning\': discussion.status === vm.constants.CUSTOMER_STATUS.DRAFT, \'label-danger\': discussion.status === vm.constants.CUSTOMER_STATUS.REJECTED }\">{{ discussion.status | ucfirst }}</span></td><td><p class=\"m-b-xs\"><strong>{{ discussion.user.name }}</strong></p><small class=\"text-muted\">{{ discussion.user.role.name }}</small></td><td>{{ discussion.description || \'-\' }}</td></tr></tbody></table></div></div><div class=\"ibox-content text-center\" ng-hide=\"vm.user.discussions.length\"><h4 class=\"text-muted\"><i class=\"fa fa-search\"></i> Status History tidak ditemukan.</h4></div></div></div>");
$templateCache.put("app/user/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">User Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk manage User atau karyawan yang akan menggunakan app ini.<hr><h3>Buat User</h3><ul><li>Data login seperti email dan password akan diemail ke email yang didaftarkan.</li><li>Anda bisa ubah password tersebut di halaman profil Anda</li></ul><hr><h3>Unggah/Update Profile Picture / Gambar</h3><ul><li>Klik salah satu user, klik <b>Ubah/Unggah Gambar</b>.</li></ul><hr><h3>Activate/Deactivate</h3><ul><li>Bila Anda perlu menon-aktifkan User atau karyawan, cukup klik tombol <b>Activate</b> slider untuk mematikan (bulatnya ada dikiri dan warnanya jadi putih, bukan hijau)</li><li>Untuk User yang non-aktif, User tersebut tidak dapat login ke aplikasi ini.</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/user/index/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\" data-ng-controller=\"UserController as vm\"><div class=\"row\"><div class=\"col-lg-12 tabs-container\"><div class=\"ibox float-e-margins\" ng-if=\"vm.privileges.read\"><div class=\"ibox-title clearfix\"><div class=\"pull-right\"><a class=\"btn btn-w-m btn-default\" ng-click=\"vm.showGuide()\"><i class=\"fa fa-book\"></i> User Guide</a> <a class=\"btn btn-w-m btn-info\" ng-click=\"vm.refresh()\"><i class=\"fa fa-refresh\"></i> Muat Ulang</a> <a class=\"btn btn-w-m btn-success\" ng-click=\"vm.createUser()\" ng-if=\"vm.privileges.create\"><i class=\"fa fa-plus\"></i> Buat User</a></div><h2>User</h2></div><div class=\"ibox-content\"><div class=\"m-b-lg\"><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control\" ng-change=\"vm.filter()\" ng-model=\"vm.filtering.filter.gender\"><option value=\"\">- Jenis Kelamin -</option><option value=\"{{ vm.constants.GENDER.MALE }}\">Pria</option><option value=\"{{ vm.constants.GENDER.FEMALE }}\">Wanita</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-change=\"vm.filter()\" ng-model=\"vm.filtering.filter.role\"><option value=\"\">- Role -</option><option ng-repeat=\"role in vm.roles\" value=\"{{ role.name }}\">{{ role.name }}</option></select></div><div class=\"col-md-6\"><form ng-submit=\"vm.filter()\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input type=\"text\" ng-model=\"vm.filtering.search\" class=\"form-control\" placeholder=\"Cari...\"></div></form></div></div></div><div class=\"table-responsive\"><table class=\"footable table table-hover toggle-arrow-tiny\" data-page-navigation=\".paginationyanggaada\"><thead><tr><th class=\"col-xs-1\" data-sort-ignore=\"true\">Activate</th><th class=\"col-xs-2\" data-sort-ignore=\"true\">Role</th><th class=\"col-xs-7\" data-sort-ignore=\"true\" data-toggle=\"true\">Nama</th><th class=\"col-xs-2\" data-sort-ignore=\"true\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" ng-click=\"vm.showUser(user)\"><td ng-click=\"$event.stopPropagation()\"><input ng-click=\"vm.changeUserStatus(user, $event)\" type=\"checkbox\" class=\"ios8-switch ios8-switch-lg\" id=\"checkbox-{{ user.hash_id }}\" ng-checked=\"user.is_active\"> <label for=\"checkbox-{{ user.hash_id }}\"></label></td><td>{{ user.role.name || \'-\' }}</td><td>{{ user.name || \'-\' }}</td><td class=\"col-xs-4 text-right\" ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-xs btn-warning btn-outline\" ng-click=\"vm.editUser(user)\" ng-if=\"vm.privileges.update\"><i class=\"fa fa-pencil\"></i> Ubah</a></td></tr></tbody></table></div><div class=\"text-center\" ng-paginator=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/user/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data User</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.user.name\" required=\"\"></div><div class=\"form-group\"><label>Email <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.user.email\" required=\"\"></div><div class=\"form-group\"><label>Role <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.user.role.hash_id\" required=\"\"><option value=\"\">- Pilih Role -</option><option ng-repeat=\"role in vm.roles\" value=\"{{ role.hash_id }}\">{{ role.name }}</option></select></div><div class=\"form-group\"><label>Nomor ID Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.user.id_card_number\"></div><div class=\"form-group\"><label>Nomor Employee Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.user.employee_card_number\"></div><div class=\"form-group\"><label>Jenis Kelamin <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.user.gender\" required=\"\"><option value=\"\">- Pilih Jenis Kelamin -</option><option value=\"{{ vm.constants.GENDER.MALE }}\">Pria</option><option value=\"{{ vm.constants.GENDER.FEMALE }}\">Wanita</option></select></div><div class=\"form-group\"><label>Status</label><select class=\"form-control\" ng-model=\"vm.user.marital_status\"><option value=\"\">- Pilih Status -</option><option value=\"{{ vm.constants.MARITAL_STATUS.MARRIED }}\">Menikah</option><option value=\"{{ vm.constants.MARITAL_STATUS.SINGLE }}\">Lajang</option></select></div><div class=\"form-group\"><label>Tanggal Lahir</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.user.birth_date\" date-change=\"birthDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><label>Nomor Telepon</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.user.phone\"></div><div class=\"form-group\"><label>Alamat</label> <textarea class=\"form-control\" ng-model=\"vm.user.address\" cols=\"30\" rows=\"10\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/user/upload-modal/upload-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center image-container\"><img ng-if=\"vm.user.image\" src=\"{{ vm.user.image }}\" class=\"m-b-xs\" style=\"max-width: 100%; display: inline-block;\"></div><div class=\"form-group\"><label>Pilih Gambar</label> <input class=\"form-control\" type=\"file\" file-model=\"myFile\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/amg/material/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Buat Material Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Spot Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.spot_price\" required=\"\"></div></div><div class=\"form-group\"><label>Import Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.import_price\" required=\"\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/amg/material/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Buat Material Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.material.name\" required=\"\"></div><div class=\"form-group\"><label>Spot Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.material.spot_price\" required=\"\"></div></div><div class=\"form-group\"><label>Import Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.material.import_price\" required=\"\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/amg/product/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Buat Product Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Profit Margin <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.profit_margin\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Inner Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.data.inner_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Middle Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.data.middle_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Outer Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.data.outer_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"form-group\"><label>Inner Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'inner\')\"><i class=\"fa fa-plus\"></i> Tambah inner material</button><div id=\"inner-material-wrapper\"></div></div><div class=\"form-group\"><label>Middle Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'middle\')\"><i class=\"fa fa-plus\"></i> Tambah middle material</button><div id=\"middle-material-wrapper\"></div></div><div class=\"form-group\"><label>Outer Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'outer\')\"><i class=\"fa fa-plus\"></i> Tambah outer material</button><div id=\"outer-material-wrapper\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/amg/product/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Buat Product Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.product.name\" required=\"\"></div><div class=\"form-group\"><label>Profit Margin <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" ng-model=\"vm.product.profit_margin\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Inner Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.product.inner_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Middle Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.product.middle_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Outer Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" max=\"100\" min=\"0\" step=\"any\" ng-model=\"vm.product.outer_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div></div><div class=\"form-group\"><label>Inner Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'inner\')\"><i class=\"fa fa-plus\"></i> Tambah inner material</button><div id=\"inner-material-wrapper\"><div class=\"material-form\" ng-repeat=\"inner_material in vm.product.inner_materials track by $index\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><select class=\"form-control\" required=\"\" ng-model=\"vm.product.inner_materials[$index].material_name\"><option value=\"\">-Pilih Material-</option><option value=\"{{ material.name }}\" ng-repeat=\"material in vm.materials\">{{ material.name }}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input ng-model=\"vm.product.inner_materials[$index].percentage\" required=\"\" placeholder=\"Percentage\" type=\"number\" min=\"0\" max=\"100\" step=\"any\" class=\"form-control\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><button class=\"btn btn-danger\" ng-click=\"vm.removeMaterial($event)\"><i class=\"fa fa-times\"></i> Batal</button></div></div></div></div></div></div><div class=\"form-group\"><label>Middle Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'middle\')\"><i class=\"fa fa-plus\"></i> Tambah middle material</button><div id=\"middle-material-wrapper\"><div class=\"material-form\" ng-repeat=\"middle_material in vm.product.middle_materials track by $index\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><select class=\"form-control\" required=\"\" ng-model=\"vm.product.middle_materials[$index].material_name\"><option value=\"\">-Pilih Material-</option><option value=\"{{ material.name }}\" ng-repeat=\"material in vm.materials\">{{ material.name }}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input ng-model=\"vm.product.middle_materials[$index].percentage\" required=\"\" placeholder=\"Percentage\" type=\"number\" min=\"0\" max=\"100\" step=\"any\" class=\"form-control\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><button class=\"btn btn-danger\" ng-click=\"vm.removeMaterial($event)\"><i class=\"fa fa-times\"></i> Batal</button></div></div></div></div></div></div><div class=\"form-group\"><label>Outer Materials <span class=\"text-danger\">*</span></label><br><button ng-disabled=\"vm.loader\" class=\"m-b-xs btn btn-white\" ng-click=\"vm.addMaterial($event, \'outer\')\"><i class=\"fa fa-plus\"></i> Tambah outer material</button><div id=\"outer-material-wrapper\"><div class=\"material-form\" ng-repeat=\"outer_material in vm.product.outer_materials track by $index\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><select class=\"form-control\" required=\"\" ng-model=\"vm.product.outer_materials[$index].material_name\"><option value=\"\">-Pilih Material-</option><option value=\"{{ material.name }}\" ng-repeat=\"material in vm.materials\">{{ material.name }}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input ng-model=\"vm.product.outer_materials[$index].percentage\" required=\"\" placeholder=\"Percentage\" type=\"number\" min=\"0\" max=\"100\" step=\"any\" class=\"form-control\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><button class=\"btn btn-danger\" ng-click=\"vm.removeMaterial($event)\"><i class=\"fa fa-times\"></i> Batal</button></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></div></form></div>");
$templateCache.put("app/commission/detail/create-payment-modal/create-payment-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Commission Payment</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Invoice Number <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.invoice_number\" required=\"\"></div><div class=\"form-group\"><label>Invoice Amount <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm.data.invoice_amount\" required=\"\"></div></div><div class=\"form-group\"><label>Invoice Date <span class=\"text-danger\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" id=\"invoiceDate\" date-time=\"\" ng-model=\"vm.data.invoice_date\" date-change=\"invoiceDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.isCustomerPaidDate\"><span></span> Customer Paid Date</label></div><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" id=\"paidDate\" date-time=\"\" ng-model=\"vm.data.paid_at\" date-change=\"paidDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\" ng-disabled=\"!vm.isCustomerPaidDate\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><label>Description</label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.data.description\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/commission/detail/update-payment-modal/update-payment-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Commission Payment</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Invoice Number <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.invoice_number\" required=\"\"></div><div class=\"form-group\"><label>Invoice Amount <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm.data.invoice_amount\" required=\"\"></div></div><div class=\"form-group\"><label>Invoice Date <span class=\"text-danger\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" id=\"invoiceDate\" date-time=\"\" ng-model=\"vm.data.invoice_date\" date-change=\"invoiceDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.isCustomerPaidDate\"><span></span> Customer Paid Date</label></div><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" id=\"paidDate\" date-time=\"\" ng-model=\"vm.data.paid_at\" date-change=\"paidDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\" ng-disabled=\"!vm.isCustomerPaidDate\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group\"><label>Description</label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.data.description\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/create-address-modal/create-address-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Alamat</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Alamat</label> <textarea ng-model=\"vm.data.address\" class=\"form-control\" cols=\"30\" rows=\"10\" required=\"\"></textarea></div><div class=\"form-group\"><label>Tipe</label><select class=\"form-control\" ng-model=\"vm.data.type\" required=\"\"><option value=\"\">- Pilih Tipe -</option><option value=\"{{ vm.constants.CUSTOMER_ADDRESS_TYPE.OFFICE }}\">Office</option><option value=\"{{ vm.constants.CUSTOMER_ADDRESS_TYPE.FACTORY }}\">Factory</option></select></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_billing_address\"><span></span> Billing Address</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/create-image-modal/create-image-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Customer Image</h4></div><form ng-submit=\"vm.createImageConfirmation($event)\" enctype=\"multipart/form-data\"><div class=\"modal-body\"><p class=\"image-container\"><img class=\"img-responsive\" src=\"{{ vm.image.image_url }}\"></p><div class=\"form-group\"><label>Pilih Gambar</label> <input required=\"\" class=\"form-control\" type=\"file\" file-model=\"myFile\"></div><div class=\"form-group\"><label>Deskripsi</label> <textarea class=\"form-control\" cols=\"30\" rows=\"10\" ng-model=\"vm.image.description\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/customer-image-modal/customer-image-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Customer Image</h4></div><div ng-show=\"!vm.isEditable\"><div class=\"modal-body\"><p><img class=\"img-responsive\" src=\"{{ vm.image_url }}\"></p><p ng-if=\"vm.type == vm.constants.CUSTOMER_UPLOAD_TYPE.IMAGE\"><strong>Deskripsi:</strong><br>{{ vm.data.description || \'-\' }}</p></div><div class=\"modal-footer\"><button ng-if=\"vm.isEditButton && vm.privileges.update\" ng-click=\"vm.editImage()\" type=\"button\" class=\"btn btn-info\"><i class=\"fa fa-pencil\"></i> Ubah</button> <button ng-if=\"vm.isRemoveButton && vm.privileges.update\" ng-click=\"vm.deleteImageConfirmation()\" type=\"button\" class=\"btn btn-danger\"><i class=\"fa fa-trash\"></i> Hapus</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div><div ng-show=\"vm.isEditable\"><form ng-submit=\"vm.updateImageConfirmation($event)\" enctype=\"multipart/form-data\"><div class=\"modal-body\"><p class=\"image-container\"><img class=\"img-responsive\" src=\"{{ vm.image_url }}\"></p><div class=\"form-group\"><label>Pilih Gambar</label> <input class=\"form-control\" type=\"file\" file-model=\"myFile\"></div><div class=\"form-group\" ng-if=\"vm.type === vm.constants.CUSTOMER_UPLOAD_TYPE.IMAGE\"><label>Deskripsi</label> <textarea class=\"form-control\" cols=\"30\" rows=\"10\" ng-model=\"vm.data.description\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancelEdit()\">Batal</button></div></form></div></div>");
$templateCache.put("app/customer/detail/edit-rank-modal/edit-rank-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.updateRank()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Rank Customer</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Rank</label><select class=\"form-control\"><option value=\"{{ vm.constants.CUSTOMER_RANK.GOLD }}\">Gold</option><option value=\"{{ vm.constants.CUSTOMER_RANK.SILVER }}\">Silver</option><option value=\"{{ vm.constants.CUSTOMER_RANK.PLATINUM }}\">Platinum</option></select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/rank-history-modal/rank-history-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">History Rank</h4></div><div class=\"modal-body\"><p>27 Desember 2005 from <strong>GOLD</strong> to <strong>PLATINUM</strong></p><div class=\"hr-line-dashed\"></div><p>26 Desember 2005 from <strong>SILVER</strong> to <strong>GOLD</strong></p><div class=\"hr-line-dashed\"></div><p>25 Desember 2005 from <strong>PLATINUM</strong> to <strong>SILVER</strong></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/customer/detail/reassign-customer-modal/reassign-customer-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.save($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Reassign Customer</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Pilih Sales</label><ui-select ng-model=\"vm.user\" theme=\"bootstrap\" required=\"\"><ui-select-match placeholder=\"Ketik nama sales\"><strong>{{ $select.selected.name }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getUser($select.search)\" refresh-delay=\"300\" repeat=\"user in vm.users\"><p><strong ng-bind-html=\"user.name | highlight: $select.search\"></strong><br><small ng-bind-html=\"user.email | highlight: $select.search\"></small></p></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Simpan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/update-address-modal/update-address-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Alamat</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Alamat</label> <textarea ng-model=\"vm.address.address\" class=\"form-control\" cols=\"30\" rows=\"10\" required=\"\"></textarea></div><div class=\"form-group\"><label>Tipe</label><select class=\"form-control\" ng-model=\"vm.address.type\" required=\"\"><option value=\"\">- Pilih Tipe -</option><option value=\"{{ vm.constants.CUSTOMER_ADDRESS_TYPE.OFFICE }}\">Office</option><option value=\"{{ vm.constants.CUSTOMER_ADDRESS_TYPE.FACTORY }}\">Factory</option></select></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.address.is_billing_address\"><span></span> Billing Address</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/upload-modal/upload-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar {{ vm.title }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center image-container\"><img src=\"{{ vm.image }}\" class=\"m-b-xs\" style=\"max-width: 100%; display: inline-block;\"></div><div class=\"form-group\"><label>Pilih Gambar</label> <input class=\"form-control\" type=\"file\" file-model=\"myFile\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/index/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Customer Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label>Tipe</label> <span class=\"text-danger\">*</span><select class=\"form-control\" ng-model=\"vm.customer.type\" required=\"\"><option value=\"\">- Pilih -</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PT }}\">PT</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.CV }}\">CV</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.UD }}\">UD</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.INDIVIDUAL }}\">Individual</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PARTNERSHIP }}\">Partnership</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.ETC }}\">Lainnya</option></select></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label>Nama Perusahaan <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.name\" required=\"\"></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label>Email <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.customer.email\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Nomor NPWP <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.npwp_number\" required=\"\"></div></div></div><div class=\"form-group\"><label>Alamat NPWP/Quotation <span class=\"text-danger\">*</span></label><br><small>Alamat ini akan dicatat di dalam Quotation.</small> <textarea class=\"form-control\" ng-model=\"vm.customer.npwp_address\" cols=\"30\" rows=\"5\" required=\"\" placeholder=\"Jl. Raya Rangkasbitung KM 10, Ds. Majasari, Kec. Jawitan\"></textarea></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Akta Perusahaan</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.deed_of_incorporation\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Tanggal Akta Perusahaan</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.customer.deed_of_incorporation_date\" date-change=\"deedOfIncorporationDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Akta Perusahaan Terakhir</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.last_deed\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Tanggal Akta Perusahaan Terakhir</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.customer.last_deed_date\" date-change=\"lastDeedDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Telepon <span class=\"text-danger\">*</span></label><br><small>Nomor Telepon ini akan dicatat di dalam Quotation.</small> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.phone\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Telepon 2</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.phone_2\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Nomor Fax <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.fax\" required=\"\"></div></div></div><div class=\"form-group\"><label>Deskripsi</label> <textarea class=\"form-control\" ng-model=\"vm.customer.description\" cols=\"30\" rows=\"5\"></textarea></div><hr><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama Purchaser <span class=\"text-danger\">*</span></label><br><small>Masukkan Bpk/Ibu karena akan dicatat di dalam Quotation.</small> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.purchaser_name\" required=\"\" placeholder=\"Bpk/Ibu\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP Purchaser</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.purchaser_phone\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama QC</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.qc_name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP QC</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.qc_phone\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama Kepala Produksi</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.production_head_name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP Kepala Produksi</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.production_head_phone\"></div></div></div><hr><div class=\"form-group\"><label>Projection Revenue (per bulan)</label> <input class=\"form-control\" type=\"number\" ng-model=\"vm.customer.projection_revenue\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/index/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Customer</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label>Tipe</label> <span class=\"text-danger\">*</span><select class=\"form-control\" ng-model=\"vm.customer.type\" required=\"\"><option value=\"\">- Pilih -</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PT }}\">PT</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.CV }}\">CV</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.UD }}\">UD</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.INDIVIDUAL }}\">Individual</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.PARTNERSHIP }}\">Partnership</option><option value=\"{{ vm.constants.CUSTOMER_TYPE.ETC }}\">Lainnya</option></select></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label>Nama Perusahaan <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.name\" required=\"\"></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label>Email <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"vm.customer.email\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Nomor NPWP <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.npwp_number\"></div></div></div><div class=\"form-group\"><label>Alamat NPWP/Quotation</label><br><small>Alamat ini akan dicatat di dalam Quotation.</small> <textarea class=\"form-control\" ng-model=\"vm.customer.npwp_address\" cols=\"30\" rows=\"5\" placeholder=\"Jl. Raya Rangkasbitung KM 10, Ds. Majasari, Kec. Jawitan\"></textarea></div><div ng-if=\"vm.privileges.admin\"><hr><h2>Admin</h2><div class=\"form-group\"><label>Term of Payment <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.customer.term_of_payment\" required=\"\"><option value=\"\">- Pilih Term -</option><option value=\"{{ vm.constants.CUSTOMER_TOP.PREPAID }}\">Prepaid</option><option value=\"{{ vm.constants.CUSTOMER_TOP.CASH_BEFORE_DELIVERY }}\">Cash Before Delivery</option><option value=\"{{ vm.constants.CUSTOMER_TOP.GIRO }}\">Giro</option><option value=\"{{ vm.constants.CUSTOMER_TOP.CHEQUE }}\">Cheque</option><option value=\"{{ vm.constants.CUSTOMER_TOP.DP_AND_TERMS }}\">DP & Terms</option><option value=\"{{ vm.constants.CUSTOMER_TOP.TERMS }}\">Terms</option></select></div><div class=\"row\" ng-if=\"vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.GIRO || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.CHEQUE || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.DP_AND_TERMS || vm.customer.term_of_payment === vm.constants.CUSTOMER_TOP.TERMS\"><div class=\"col-md-8\"><div class=\"form-group\"><label>Jangka Waktu Pembayaran (Hari)</label> <input class=\"form-control\" type=\"number\" ng-model=\"vm.customer.days_of_payable\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Credit Limit <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"vm.customer.credit_limit\" required=\"\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Akta Perusahaan</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.deed_of_incorporation\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Tanggal Akta Perusahaan</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.customer.deed_of_incorporation_date\" date-change=\"deedOfIncorporationDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Akta Perusahaan Terakhir</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.last_deed\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Tanggal Akta Perusahaan Terakhir</label><div class=\"input-group date\"><input type=\"text\" class=\"form-control\" date-time=\"\" ng-model=\"vm.customer.last_deed_date\" date-change=\"lastDeedDateChanged\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"D MMM YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Telepon <span class=\"text-danger\">*</span></label><br><small>Nomor Telepon ini akan dicatat di dalam Quotation.</small> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.phone\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Nomor Telepon 2</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.phone_2\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Nomor Fax <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.fax\" required=\"\"></div></div></div><div class=\"form-group\"><label>Deskripsi</label> <textarea class=\"form-control\" ng-model=\"vm.customer.description\" cols=\"30\" rows=\"5\"></textarea></div><hr><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama Purchaser <span class=\"text-danger\">*</span></label><br><small>Masukkan Bpk/Ibu karena akan dicatat di dalam Quotation.</small> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.purchaser_name\" required=\"\" placeholder=\"Bpk/Ibu\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP Purchaser</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.purchaser_phone\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama QC</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.qc_name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP QC</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.qc_phone\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama Kepala Produksi</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.production_head_name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>HP Kepala Produksi</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.customer.production_head_phone\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Projection Revenue (per bulan)</label> <input class=\"form-control\" type=\"number\" ng-model=\"vm.customer.projection_revenue\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/ink/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><label>Usage /m<sup>2</sup> <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.usage_per_m2\" required=\"\"> <span class=\"input-group-addon\">gram</span></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Surface Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.surface_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_INK_WEIGHT }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Solvent</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.solvent\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_THICKNESS }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Hardener</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.hardener\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_THICKNESS }}</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/ink/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Printing Ink Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk menambahkan Printing Ink Material.<hr><h3>Buat Printing Ink</h3><ul><li>Nama: Masukan nama Ink (contoh: Biru).</li><li>Surface Density: g/m2</li><li>Price: Harga per kg</li><li>Solvent: Rasio bahan campuran (%)</li><li>Hardener: Rasio bahan campuran (%)</li><li>Usage /m<sup>2</sup>: Penggunaan tinta dalam g/m<sup>2</sup></li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/material/ink/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Material</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><label>Usage /m<sup>2</sup> <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.usage_per_m2\" required=\"\"> <span class=\"input-group-addon\">gram</span></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Surface Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.surface_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_INK_WEIGHT }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Solvent</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.solvent\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_THICKNESS }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Hardener</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.hardener\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_THICKNESS }}</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/laminating/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Laminating Film</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_DENSITY }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Solvent Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.solvent_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_DENSITY }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Hardener Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.hardener_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_DENSITY }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Adhesive Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.adhesive_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.ADHESIVE_DENSITY }}</span></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Solvent Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.solvent_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_THICKNESS }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Hardener Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.hardener_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_THICKNESS }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Adhesive Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.adhesive_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.ADHESIVE_THICKNESS }}</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/laminating/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Laminating Material Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk menambahkan Laminating Material.<hr><h3>Buat Laminating Material</h3><ul><li>Nama: Masukan nama Material (contoh: LLDPE).</li><li>Density: g/cm3</li><li>Price: Harga per kg</li><li>Bahan campuran (Adhesive, Solvent, Hardener) dalam thickness (%) & Density (g/cm3)</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/material/laminating/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Material</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_DENSITY }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Solvent Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.solvent_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_DENSITY }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Hardener Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.hardener_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_DENSITY }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Adhesive Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"any\" ng-model=\"vm.data.adhesive_density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.ADHESIVE_DENSITY }}</span></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Solvent Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.solvent_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.SOLVENT_THICKNESS }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Hardener Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.hardener_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.HARDENER_THICKNESS }}</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Adhesive Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.adhesive_thickness\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.ADHESIVE_THICKNESS }}</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/packing/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Packing</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div><div class=\"form-group\"><label>KG per Price (Contoh: Palett dihitung per 500kg) <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.kg_per_price\" required=\"\"> <span class=\"input-group-addon\">kg</span></div></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_required\"><span></span> Required</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/packing/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Packing Material Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk menambahkan Packing Material.<hr><h3>Buat Packing Material</h3><ul><li>Nama: Masukan nama Material (contoh: Box).</li><li>Required: Bila bahan ini Required, maka semua Quotation mengharuskan adanya material ini.</li><li>Price: Harga per [KG per price]</li><li>KG per price: Harga dalam unit berapa kg. Jumlah unit akan di round up. Contoh kalau KG per price = 500, dan total berat pemesanan 600, maka Price * 2 (bukan 1.2)</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/material/packing/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Material</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"form-group\"><label>Price <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div><div class=\"form-group\"><label>KG per Price (Contoh: Palett dihitung per 500kg) <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.kg_per_price\" required=\"\"> <span class=\"input-group-addon\">kg</span></div></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_required\"><span></span> Required</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/printing/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Printing Film</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_DENSITY }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/printing/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Printing Material Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk menambahkan Printing Material.<hr><h3>Buat Printing Material</h3><ul><li>Nama: Masukan nama Material (contoh: LLDPE).</li><li>Density: g/cm3</li><li>Price: Harga per kg</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/material/printing/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Material</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Density <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.density\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.MATERIAL_DENSITY }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/slitting/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Slitting</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.LENGTH }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per unit<span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"text\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/material/slitting/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Slitting Material Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk menambahkan Slitting Material.<hr><h3>Buat Slitting Material</h3><ul><li>Nama: Masukan nama Material (contoh: Paper Core 3\" 2.05m).</li><li>Length: Panjang material.</li><li>Price: Harga per unit.</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/material/slitting/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Material</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.data.length\" required=\"\"> <span class=\"input-group-addon\">{{ vm.constants.UNIT_TYPE.LENGTH }}</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price per unit <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rp</span> <input class=\"form-control\" type=\"text\" min=\"0\" ng-model=\"vm.data.price\" required=\"\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/create/custom-term-modal/custom-term-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Term</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Term <span class=\"text-danger\">*</span></label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.term\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/create/laminating-material-modal/laminating-material-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Laminating</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Material <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.material\" required=\"\"><option value=\"\">- Pilih Material -</option><option value=\"{{material}}\" ng-repeat=\"material in vm.materialLaminating\">{{material.name}}</option></select></div><div class=\"form-group\"><label>Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.thickness\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">{{vm.constants.UNIT_TYPE.THICKNESS}}</span></div></div><div class=\"form-group\"><label>Adhesive Usage /m<sup>2</sup> <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.adhesive_usage_per_m2\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">gram</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/create/slitting-material-modal/slitting-material-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Slitting</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Material <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.material\" required=\"\"><option value=\"\">- Pilih Material -</option><option value=\"{{material}}\" ng-repeat=\"material in vm.materialSlitting\">{{material.name}}</option></select></div><div class=\"form-group\"><label>Slitting Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.slitting_length\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">{{vm.constants.UNIT_TYPE.SLITTING_LENGTH}}</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/create/term-modal/term-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Term</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Term <span class=\"text-danger\">*</span></label><ui-select ng-model=\"vm.term\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik deskripsi term\"><strong>{{ $select.selected.description | truncate: 60: \'...\' }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getTerm($select.search)\" refresh-delay=\"300\" repeat=\"term in vm.terms\"><p style=\"white-space: initial\" ng-bind-html=\"term.description | highlight: $select.search\"></p></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/update/custom-term-modal/custom-term-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Term</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Term <span class=\"text-danger\">*</span></label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.term\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/update/laminating-material-modal/laminating-material-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Laminating</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Material <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.material\" required=\"\"><option value=\"\">- Pilih Material -</option><option value=\"{{material}}\" ng-repeat=\"material in vm.materialLaminating\">{{material.name}}</option></select></div><div class=\"form-group\"><label>Thickness <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.thickness\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">{{vm.constants.UNIT_TYPE.THICKNESS}}</span></div></div><div class=\"form-group\"><label>Adhesive Usage /m<sup>2</sup> <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.adhesive_usage_per_m2\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">gram</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/update/slitting-material-modal/slitting-material-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Material Slitting</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Material <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"vm.data.material\" required=\"\"><option value=\"\">- Pilih Material -</option><option value=\"{{material}}\" ng-repeat=\"material in vm.materialSlitting\">{{material.name}}</option></select></div><div class=\"form-group\"><label>Slitting Length <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input ng-model=\"vm.data.slitting_length\" min=\"0\" step=\"any\" type=\"number\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">{{vm.constants.UNIT_TYPE.SLITTING_LENGTH}}</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/quotation/update/term-modal/term-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.add()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Term</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Term <span class=\"text-danger\">*</span></label><ui-select ng-model=\"vm.term\" theme=\"bootstrap\"><ui-select-match placeholder=\"Ketik deskripsi term\"><strong>{{ $select.selected.description | truncate: 60: \'...\' }}</strong></ui-select-match><ui-select-choices refresh=\"vm.getTerm($select.search)\" refresh-delay=\"300\" repeat=\"term in vm.terms\"><p style=\"white-space: initial\" ng-bind-html=\"term.description | highlight: $select.search\"></p></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\">Tambahkan</button> <button class=\"btn btn-white\" type=\"button\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/referral/detail/upload-modal/upload-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center image-container\"><img ng-if=\"vm.user.image_url\" src=\"{{ vm.user.image_url }}\" class=\"m-b-xs\" style=\"max-width: 100%; display: inline-block;\"></div><div class=\"form-group\"><label>Pilih Gambar</label> <input class=\"form-control\" type=\"file\" file-model=\"myFile\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/commission/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Commission Setting Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Min Gross Profit Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.min_gross_profit_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div><div class=\"form-group\"><label>Commission Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div><div class=\"form-group\"><label>Commission Referral Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_referral_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/commission/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Commission Settings Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur Commission.<hr><h3>Commission Setting</h3><ul><li>Min Gross Profit Percentage: Gross Profit Percentage untuk mendapatkan komisi ini.</li><li>Commission Percentage: Jumlah komisi yang akan didapatkan dari total order.</li><li>Commission Referral Percentage: Jumlah komisi yang akan didapatkan dari total order <b>bila ada Referral.</b></li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/setting/commission/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Commission Setting</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Min Gross Profit Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.min_gross_profit_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div><div class=\"form-group\"><label>Commission Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div><div class=\"form-group\"><label>Commission Referral Percentage <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_referral_percentage\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/commission-timeline/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Commission Timeline Setting Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Min Days Late <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.data.min_days_late\" required=\"\"> <span class=\"input-group-addon\">Day</span></div></div><div class=\"form-group\"><label>Commission Percentage Multiplier <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_percentage_multiplier\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/commission-timeline/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Commission Timeline Settings Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur Commission Timeline <b>(bila adanya telat bayar)</b>.<hr><h3>Commission Timeline Setting</h3><ul><li>Min Days Late: Minimum hari telat untuk mendapatkan penalty ini.</li><li>Commission Percentage Multiplier: Jumlah penalty dari komisinya. <b>Kalau angka ini diatas 100%, maka akan menjadi penambahan bukan pengurangan!</b></li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/setting/commission-timeline/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Commission Timeline Setting</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Min Days Late <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.data.min_days_late\" required=\"\"> <span class=\"input-group-addon\">Day</span></div></div><div class=\"form-group\"><label>Commission Percentage Multiplier <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.commission_percentage_multiplier\" required=\"\"> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/material/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Material Setting</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Value <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\" ng-if=\"vm.setting.type === \'price\'\">Rp</span> <input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.value\" required=\"\"> <span class=\"input-group-addon\" ng-if=\"vm.setting.type === \'price\'\">/{{vm.setting.material_constant_histories.conversion.unit_name}}</span> <span class=\"input-group-addon\" ng-if=\"vm.setting.type === \'ratio\'\">%</span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/quotation/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Quotation Setting</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Value <span class=\"text-danger\">*</span></label> <input type=\"number\" class=\"form-control\" step=\"any\" min=\"0\" ng-model=\"vm.data.value\" required=\"\"></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/quotation-term/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Quotation Term Template</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Deskripsi <span class=\"text-danger\">*</span></label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.data.description\" required=\"\"></textarea></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_required\"><span></span> Required</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/quotation-term/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Quotation Term Templates Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur Quotation Term Templates, dimana ada beberapa Terms yang <b>Required</b> untuk setiap Quotation baru, atau juga ada template yang dapat dipilih secara <b>Optional</b>.<hr><h3>Quotation Term Template</h3><ul><li>Deskripsi: Term ini.</li><li>Required: Apakah term ini diharuskan di setiap Quotation?</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/setting/quotation-term/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Quotation Term</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"form-group\"><label>Deskripsi <span class=\"text-danger\">*</span></label> <textarea class=\"form-control\" cols=\"30\" rows=\"5\" ng-model=\"vm.data.description\" required=\"\"></textarea></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_required\"><span></span> Required</label></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/transport/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Transport Baru</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price /kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.data.price_per_kg\" required=\"\"> <span class=\"input-group-addon\">/kg</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/setting/transport/guide-modal/guide-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Transport Settings Guide</h4></div><div class=\"modal-body\"><h3>Overview</h3>Gunakan fitur ini untuk mengatur setting Transport.<hr><h3>Quotation Term Template</h3><ul><li>Nama: Nama transport (e.g. Jakarta).</li><li>Harga: Harga per kg.</li></ul><hr></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Tutup</button></div></div>");
$templateCache.put("app/setting/transport/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Transport</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Nama <span class=\"text-danger\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Price /kg <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.data.price_per_kg\" required=\"\"> <span class=\"input-group-addon\">/kg</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/user/detail/upload-modal/upload-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.upload($event)\" enctype=\"multipart/form-data\"><div class=\"modal-header\"><h4 class=\"modal-title\">Unggah Gambar</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"text-center image-container\"><img ng-if=\"vm.user.image_url\" src=\"{{ vm.user.image_url }}\" class=\"m-b-xs\" style=\"max-width: 100%; display: inline-block;\"></div><div class=\"form-group\"><label>Pilih Gambar</label> <input class=\"form-control\" type=\"file\" file-model=\"myFile\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/important-person/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Important Person</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label>Nama</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\"></div><div class=\"form-group\"><label>Jabatan</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.position\"></div><div class=\"form-group\"><label>Nomor ID Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.id_card_number\"></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.is_key_person\"><span></span> Key Person</label></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/product/create-modal/create-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.create($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Tambah Product</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label>Nama</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\"></div><div class=\"form-group\"><label>Tipe</label><select class=\"form-control\" ng-model=\"vm.data.type\"><option value=\"{{vm.constants.CUSTOMER_PRODUCT_TYPE.BRAND}}\">Brand</option><option value=\"{{vm.constants.CUSTOMER_PRODUCT_TYPE.CATEGORY}}\">Category</option></select></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");
$templateCache.put("app/customer/detail/important-person/update-modal/update-modal.html","<div class=\"inmodal\"><form ng-submit=\"vm.update($event)\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ubah Data Important Person</h4><small class=\"font-bold\"></small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label>Nama</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.importantPerson.name\"></div><div class=\"form-group\"><label>Jabatan</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.importantPerson.position\"></div><div class=\"form-group\"><label>Nomor ID Card</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.importantPerson.id_card_number\"></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.importantPerson.is_key_person\"><span></span> Key Person</label></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\"><i class=\"fa fa-save\"></i> Simpan</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Batal</button></div></form></div>");}]);